/*! For license information please see vendor.js.LICENSE.txt */
(() => {
  const t = {
    65: (t, e, i) => {
      let n, s;
      (function (r, o) {
        if (true)
          !((n = [i(542), i(914)]),
          (s = function (t, e) {
            return o(r, t, e);
          }.apply(e, n)),
          s !== void 0 && (t.exports = s));
      })(window, function t(e, i, n) {
        'use strict';
        i.createMethods.push('_createLazyload');
        const s = i.prototype;
        s._createLazyload = function () {
          this.on('select', this.lazyLoad);
        };
        s.lazyLoad = function () {
          const t = this.options.lazyLoad;
          if (!t) return;
          const e = typeof t == 'number' ? t : 0;
          const i = this.getAdjacentCellElements(e);
          let n = [];
          i.forEach(function (t) {
            const e = r(t);
            n = n.concat(e);
          });
          n.forEach(function (t) {
            new o(t, this);
          }, this);
        };
        function r(t) {
          if (t.nodeName == 'IMG') {
            const e = t.getAttribute('data-flickity-lazyload');
            const i = t.getAttribute('data-flickity-lazyload-src');
            const s = t.getAttribute('data-flickity-lazyload-srcset');
            if (e || i || s) return [t];
          }
          const r =
            'img[data-flickity-lazyload], ' +
            'img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]';
          const o = t.querySelectorAll(r);
          return n.makeArray(o);
        }
        function o(t, e) {
          this.img = t;
          this.flickity = e;
          this.load();
        }
        o.prototype.handleEvent = n.handleEvent;
        o.prototype.load = function () {
          this.img.addEventListener('load', this);
          this.img.addEventListener('error', this);
          const t =
            this.img.getAttribute('data-flickity-lazyload') ||
            this.img.getAttribute('data-flickity-lazyload-src');
          const e = this.img.getAttribute('data-flickity-lazyload-srcset');
          this.img.src = t;
          if (e) this.img.setAttribute('srcset', e);
          this.img.removeAttribute('data-flickity-lazyload');
          this.img.removeAttribute('data-flickity-lazyload-src');
          this.img.removeAttribute('data-flickity-lazyload-srcset');
        };
        o.prototype.onload = function (t) {
          this.complete(t, 'flickity-lazyloaded');
        };
        o.prototype.onerror = function (t) {
          this.complete(t, 'flickity-lazyerror');
        };
        o.prototype.complete = function (t, e) {
          this.img.removeEventListener('load', this);
          this.img.removeEventListener('error', this);
          const i = this.flickity.getParentCell(this.img);
          const n = i && i.element;
          this.flickity.cellSizeChange(n);
          this.img.classList.add(e);
          this.flickity.dispatchEvent('lazyLoad', t, n);
        };
        i.LazyLoader = o;
        return i;
      });
    },
    136: function (t, e, i) {
      let n, s;
      (function (r, o) {
        if (true)
          !((n = o),
          (s = typeof n === 'function' ? n.call(e, i, e, t) : n),
          s !== void 0 && (t.exports = s));
      })(typeof window != 'undefined' ? window : this, function () {
        'use strict';
        function t() {}
        const e = t.prototype;
        e.on = function (t, e) {
          if (!t || !e) return;
          const i = (this._events = this._events || {});
          const n = (i[t] = i[t] || []);
          if (n.indexOf(e) == -1) n.push(e);
          return this;
        };
        e.once = function (t, e) {
          if (!t || !e) return;
          this.on(t, e);
          const i = (this._onceEvents = this._onceEvents || {});
          const n = (i[t] = i[t] || {});
          n[e] = true;
          return this;
        };
        e.off = function (t, e) {
          const i = this._events && this._events[t];
          if (!i || !i.length) return;
          const n = i.indexOf(e);
          if (n != -1) i.splice(n, 1);
          return this;
        };
        e.emitEvent = function (t, e) {
          let i = this._events && this._events[t];
          if (!i || !i.length) return;
          i = i.slice(0);
          e = e || [];
          const n = this._onceEvents && this._onceEvents[t];
          for (let s = 0; s < i.length; s++) {
            const r = i[s];
            const o = n && n[r];
            if (o) {
              this.off(t, r);
              delete n[r];
            }
            r.apply(this, e);
          }
          return this;
        };
        e.allOff = function () {
          delete this._events;
          delete this._onceEvents;
        };
        return t;
      });
    },
    229: (t, e, i) => {
      let n, s;
      (function (r, o) {
        'use strict';
        if (true)
          !((n = o),
          (s = typeof n === 'function' ? n.call(e, i, e, t) : n),
          s !== void 0 && (t.exports = s));
      })(window, function t() {
        'use strict';
        const e = (function () {
          const t = window.Element.prototype;
          if (t.matches) return 'matches';
          if (t.matchesSelector) return 'matchesSelector';
          const e = ['webkit', 'moz', 'ms', 'o'];
          for (let i = 0; i < e.length; i++) {
            const n = e[i];
            const s = n + 'MatchesSelector';
            if (t[s]) return s;
          }
        })();
        return function t(i, n) {
          return i[e](n);
        };
      });
    },
    236: (t, e, i) => {
      let n, s;
      (function (r, o) {
        if (true)
          !((n = [i(878)]),
          (s = function (t) {
            return o(r, t);
          }.apply(e, n)),
          s !== void 0 && (t.exports = s));
      })(window, function t(e, i) {
        'use strict';
        function n() {}
        const s = (n.prototype = Object.create(i.prototype));
        s.bindHandles = function () {
          this._bindHandles(true);
        };
        s.unbindHandles = function () {
          this._bindHandles(false);
        };
        s._bindHandles = function (t) {
          t = t === void 0 ? true : t;
          const i = t ? 'addEventListener' : 'removeEventListener';
          const n = t ? this._touchActionValue : '';
          for (let s = 0; s < this.handles.length; s++) {
            const r = this.handles[s];
            this._bindStartEvent(r, t);
            r[i]('click', this);
            if (e.PointerEvent) r.style.touchAction = n;
          }
        };
        s._touchActionValue = 'none';
        s.pointerDown = function (t, e) {
          const i = this.okayPointerDown(t);
          if (!i) return;
          this.pointerDownPointer = { pageX: e.pageX, pageY: e.pageY };
          t.preventDefault();
          this.pointerDownBlur();
          this._bindPostStartEvents(t);
          this.emitEvent('pointerDown', [t, e]);
        };
        const r = { TEXTAREA: true, INPUT: true, SELECT: true, OPTION: true };
        const o = {
          radio: true,
          checkbox: true,
          button: true,
          submit: true,
          image: true,
          file: true,
        };
        s.okayPointerDown = function (t) {
          const e = r[t.target.nodeName];
          const i = o[t.target.type];
          const n = !e || i;
          if (!n) this._pointerReset();
          return n;
        };
        s.pointerDownBlur = function () {
          const t = document.activeElement;
          const e = t && t.blur && t != document.body;
          if (e) t.blur();
        };
        s.pointerMove = function (t, e) {
          const i = this._dragPointerMove(t, e);
          this.emitEvent('pointerMove', [t, e, i]);
          this._dragMove(t, e, i);
        };
        s._dragPointerMove = function (t, e) {
          const i = {
            x: e.pageX - this.pointerDownPointer.pageX,
            y: e.pageY - this.pointerDownPointer.pageY,
          };
          if (!this.isDragging && this.hasDragStarted(i)) this._dragStart(t, e);
          return i;
        };
        s.hasDragStarted = function (t) {
          return Math.abs(t.x) > 3 || Math.abs(t.y) > 3;
        };
        s.pointerUp = function (t, e) {
          this.emitEvent('pointerUp', [t, e]);
          this._dragPointerUp(t, e);
        };
        s._dragPointerUp = function (t, e) {
          if (this.isDragging) this._dragEnd(t, e);
          else this._staticClick(t, e);
        };
        s._dragStart = function (t, e) {
          this.isDragging = true;
          this.isPreventingClicks = true;
          this.dragStart(t, e);
        };
        s.dragStart = function (t, e) {
          this.emitEvent('dragStart', [t, e]);
        };
        s._dragMove = function (t, e, i) {
          if (!this.isDragging) return;
          this.dragMove(t, e, i);
        };
        s.dragMove = function (t, e, i) {
          t.preventDefault();
          this.emitEvent('dragMove', [t, e, i]);
        };
        s._dragEnd = function (t, e) {
          this.isDragging = false;
          setTimeout(
            function () {
              delete this.isPreventingClicks;
            }.bind(this)
          );
          this.dragEnd(t, e);
        };
        s.dragEnd = function (t, e) {
          this.emitEvent('dragEnd', [t, e]);
        };
        s.onclick = function (t) {
          if (this.isPreventingClicks) t.preventDefault();
        };
        s._staticClick = function (t, e) {
          if (this.isIgnoringMouseUp && t.type == 'mouseup') return;
          this.staticClick(t, e);
          if (t.type != 'mouseup') {
            this.isIgnoringMouseUp = true;
            setTimeout(
              function () {
                delete this.isIgnoringMouseUp;
              }.bind(this),
              400
            );
          }
        };
        s.staticClick = function (t, e) {
          this.emitEvent('staticClick', [t, e]);
        };
        n.getPointerPoint = i.getPointerPoint;
        return n;
      });
    },
    338: (t, e, i) => {
      let n, s;
      (function (r, o) {
        if (true)
          !((n = o),
          (s = typeof n === 'function' ? n.call(e, i, e, t) : n),
          s !== void 0 && (t.exports = s));
      })(window, function t() {
        'use strict';
        function e(t) {
          this.parent = t;
          this.isOriginLeft = t.originSide == 'left';
          this.cells = [];
          this.outerWidth = 0;
          this.height = 0;
        }
        const i = e.prototype;
        i.addCell = function (t) {
          this.cells.push(t);
          this.outerWidth += t.size.outerWidth;
          this.height = Math.max(t.size.outerHeight, this.height);
          if (this.cells.length == 1) {
            this.x = t.x;
            const e = this.isOriginLeft ? 'marginLeft' : 'marginRight';
            this.firstMargin = t.size[e];
          }
        };
        i.updateTarget = function () {
          const t = this.isOriginLeft ? 'marginRight' : 'marginLeft';
          const e = this.getLastCell();
          const i = e ? e.size[t] : 0;
          const n = this.outerWidth - (this.firstMargin + i);
          this.target = this.x + this.firstMargin + n * this.parent.cellAlign;
        };
        i.getLastCell = function () {
          return this.cells[this.cells.length - 1];
        };
        i.select = function () {
          this.cells.forEach(function (t) {
            t.select();
          });
        };
        i.unselect = function () {
          this.cells.forEach(function (t) {
            t.unselect();
          });
        };
        i.getCellElements = function () {
          return this.cells.map(function (t) {
            return t.element;
          });
        };
        return e;
      });
    },
    359: (t, e, i) => {
      let n, s;
      (function (r, o) {
        if (true)
          !((n = [i(784)]),
          (s = function (t) {
            return o(r, t);
          }.apply(e, n)),
          s !== void 0 && (t.exports = s));
      })(window, function t(e, i) {
        'use strict';
        function n(t, e) {
          this.element = t;
          this.parent = e;
          this.create();
        }
        const s = n.prototype;
        s.create = function () {
          this.element.style.position = 'absolute';
          this.element.setAttribute('aria-hidden', 'true');
          this.x = 0;
          this.shift = 0;
          this.element.style[this.parent.originSide] = 0;
        };
        s.destroy = function () {
          this.unselect();
          this.element.style.position = '';
          const t = this.parent.originSide;
          this.element.style[t] = '';
          this.element.style.transform = '';
          this.element.removeAttribute('aria-hidden');
        };
        s.getSize = function () {
          this.size = i(this.element);
        };
        s.setPosition = function (t) {
          this.x = t;
          this.updateTarget();
          this.renderPosition(t);
        };
        s.updateTarget = s.setDefaultTarget = function () {
          const t = this.parent.originSide == 'left' ? 'marginLeft' : 'marginRight';
          this.target = this.x + this.size[t] + this.size.width * this.parent.cellAlign;
        };
        s.renderPosition = function (t) {
          const e = this.parent.originSide === 'left' ? 1 : -1;
          const i = this.parent.options.percentPosition
            ? t * e * (this.parent.size.innerWidth / this.size.width)
            : t * e;
          this.element.style.transform = 'translateX(' + this.parent.getPositionValue(i) + ')';
        };
        s.select = function () {
          this.element.classList.add('is-selected');
          this.element.removeAttribute('aria-hidden');
        };
        s.unselect = function () {
          this.element.classList.remove('is-selected');
          this.element.setAttribute('aria-hidden', 'true');
        };
        s.wrapShift = function (t) {
          this.shift = t;
          this.renderPosition(this.x + this.parent.slideableWidth * t);
        };
        s.remove = function () {
          this.element.parentNode.removeChild(this.element);
        };
        return n;
      });
    },
    488: (t, e, i) => {
      let n, s, r;
      (function (o, a) {
        if (true)
          !((s = [i(575), i(914)]),
          (n = a),
          (r = typeof n === 'function' ? n.apply(e, s) : n),
          r !== void 0 && (t.exports = r));
      })(window, function t(e, i) {
        'use strict';
        e.createMethods.push('_createAsNavFor');
        const n = e.prototype;
        n._createAsNavFor = function () {
          this.on('activate', this.activateAsNavFor);
          this.on('deactivate', this.deactivateAsNavFor);
          this.on('destroy', this.destroyAsNavFor);
          const t = this.options.asNavFor;
          if (!t) return;
          const e = this;
          setTimeout(function i() {
            e.setNavCompanion(t);
          });
        };
        n.setNavCompanion = function (t) {
          t = i.getQueryElement(t);
          const n = e.data(t);
          if (!n || n == this) return;
          this.navCompanion = n;
          const s = this;
          this.onNavCompanionSelect = function () {
            s.navCompanionSelect();
          };
          n.on('select', this.onNavCompanionSelect);
          this.on('staticClick', this.onNavStaticClick);
          this.navCompanionSelect(true);
        };
        n.navCompanionSelect = function (t) {
          if (!this.navCompanion) return;
          const e = this.navCompanion.selectedCells[0];
          const i = this.navCompanion.cells.indexOf(e);
          const n = i + this.navCompanion.selectedCells.length - 1;
          const r = Math.floor(s(i, n, this.navCompanion.cellAlign));
          this.selectCell(r, false, t);
          this.removeNavSelectedElements();
          if (r >= this.cells.length) return;
          const o = this.cells.slice(i, n + 1);
          this.navSelectedElements = o.map(function (t) {
            return t.element;
          });
          this.changeNavSelectedClass('add');
        };
        function s(t, e, i) {
          return (e - t) * i + t;
        }
        n.changeNavSelectedClass = function (t) {
          this.navSelectedElements.forEach(function (e) {
            e.classList[t]('is-nav-selected');
          });
        };
        n.activateAsNavFor = function () {
          this.navCompanionSelect(true);
        };
        n.removeNavSelectedElements = function () {
          if (!this.navSelectedElements) return;
          this.changeNavSelectedClass('remove');
          delete this.navSelectedElements;
        };
        n.onNavStaticClick = function (t, e, i, n) {
          if (typeof n == 'number') this.navCompanion.selectCell(n);
        };
        n.deactivateAsNavFor = function () {
          this.removeNavSelectedElements();
        };
        n.destroyAsNavFor = function () {
          if (!this.navCompanion) return;
          this.navCompanion.off('select', this.onNavCompanionSelect);
          this.off('staticClick', this.onNavStaticClick);
          delete this.navCompanion;
        };
        return e;
      });
    },
    501: () => {
      __loadjs = (function () {
        let t = function () {},
          e = {},
          i = {},
          n = {};
        function s(t, e) {
          if (t) {
            const s = n[t];
            if (((i[t] = e), s)) for (; s.length; ) (s[0](t, e), s.splice(0, 1));
          }
        }
        function r(e, i) {
          (e.call && (e = { success: e }), i.length ? (e.error || t)(i) : (e.success || t)(e));
        }
        function o(e, i, n, s) {
          let r,
            a,
            l = document,
            c = n.async,
            h = (n.numRetries || 0) + 1,
            u = n.before || t,
            d = e.replace(/[\?|#].*$/, ''),
            f = e.replace(/^(css|img)!/, '');
          ((s = s || 0),
            /(^css!|\.css$)/.test(d)
              ? (((a = l.createElement('link')).rel = 'stylesheet'),
                (a.href = f),
                (r = 'hideFocus' in a) &&
                  a.relList &&
                  ((r = 0), (a.rel = 'preload'), (a.as = 'style')))
              : /(^img!|\.(png|gif|jpg|svg|webp)$)/.test(d)
                ? ((a = l.createElement('img')).src = f)
                : (((a = l.createElement('script')).src = e), (a.async = void 0 === c || c)),
            !(a.onload =
              a.onerror =
              a.onbeforeload =
                function (t) {
                  let l = t.type[0];
                  if (r)
                    try {
                      a.sheet.cssText.length || (l = 'e');
                    } catch (t) {
                      18 != t.code && (l = 'e');
                    }
                  if ('e' == l) {
                    if ((s += 1) < h) return o(e, i, n, s);
                  } else if ('preload' == a.rel && 'style' == a.as) return (a.rel = 'stylesheet');
                  i(e, l, t.defaultPrevented);
                }) !== u(e, a) && l.head.appendChild(a));
        }
        function a(t, i, n) {
          let a, l;
          if ((i && i.trim && (a = i), (l = (a ? n : i) || {}), a)) {
            if (a in e) throw 'LoadJS';
            e[a] = !0;
          }
          function c(e, i) {
            !(function (t, e, i) {
              let n,
                s,
                r = (t = t.push ? t : [t]).length,
                a = r,
                l = [];
              for (
                n = function (t, i, n) {
                  if (('e' == i && l.push(t), 'b' == i)) {
                    if (!n) return;
                    l.push(t);
                  }
                  --r || e(l);
                },
                  s = 0;
                s < a;
                s++
              )
                o(t[s], n, i);
            })(
              t,
              function (t) {
                (r(l, t), e && r({ success: e, error: i }, t), s(a, t));
              },
              l
            );
          }
          if (l.returnPromise) return new Promise(c);
          c();
        }
        return (
          (a.ready = function (t, e) {
            return (
              (function (t, e) {
                t = t.push ? t : [t];
                let s,
                  r,
                  o,
                  a = [],
                  l = t.length,
                  c = l;
                for (
                  s = function (t, i) {
                    (i.length && a.push(t), --c || e(a));
                  };
                  l--;
                )
                  ((r = t[l]), (o = i[r]) ? s(r, o) : (n[r] = n[r] || []).push(s));
              })(t, function (t) {
                r(e, t);
              }),
              a
            );
          }),
          (a.done = function (t) {
            s(t, []);
          }),
          (a.reset = function () {
            ((e = {}), (i = {}), (n = {}));
          }),
          (a.isDefined = function (t) {
            return t in e;
          }),
          a
        );
      })();
    },
    515: (t, e, i) => {
      let n, s;
      (function (r, o) {
        if (true)
          !((n = [i(542), i(878), i(914)]),
          (s = function (t, e, i) {
            return o(r, t, e, i);
          }.apply(e, n)),
          s !== void 0 && (t.exports = s));
      })(window, function t(e, i, n, s) {
        'use strict';
        const r = 'http://www.w3.org/2000/svg';
        function o(t, e) {
          this.direction = t;
          this.parent = e;
          this._create();
        }
        o.prototype = Object.create(n.prototype);
        o.prototype._create = function () {
          this.isEnabled = true;
          this.isPrevious = this.direction == -1;
          const t = this.parent.options.rightToLeft ? 1 : -1;
          this.isLeft = this.direction == t;
          const e = (this.element = document.createElement('button'));
          e.className = 'flickity-button flickity-prev-next-button';
          e.className += this.isPrevious ? ' previous' : ' next';
          e.setAttribute('type', 'button');
          this.disable();
          e.setAttribute('aria-label', this.isPrevious ? 'Previous' : 'Next');
          const i = this.createSVG();
          e.appendChild(i);
          this.parent.on('select', this.update.bind(this));
          this.on('pointerDown', this.parent.childUIPointerDown.bind(this.parent));
        };
        o.prototype.activate = function () {
          this.bindStartEvent(this.element);
          this.element.addEventListener('click', this);
          this.parent.element.appendChild(this.element);
        };
        o.prototype.deactivate = function () {
          this.parent.element.removeChild(this.element);
          this.unbindStartEvent(this.element);
          this.element.removeEventListener('click', this);
        };
        o.prototype.createSVG = function () {
          const t = document.createElementNS(r, 'svg');
          t.setAttribute('class', 'flickity-button-icon');
          t.setAttribute('viewBox', '0 0 100 100');
          const e = document.createElementNS(r, 'path');
          const i = a(this.parent.options.arrowShape);
          e.setAttribute('d', i);
          e.setAttribute('class', 'arrow');
          if (!this.isLeft) e.setAttribute('transform', 'translate(100, 100) rotate(180) ');
          t.appendChild(e);
          return t;
        };
        function a(t) {
          if (typeof t == 'string') return t;
          return (
            'M ' +
            t.x0 +
            ',50' +
            ' L ' +
            t.x1 +
            ',' +
            (t.y1 + 50) +
            ' L ' +
            t.x2 +
            ',' +
            (t.y2 + 50) +
            ' L ' +
            t.x3 +
            ',50 ' +
            ' L ' +
            t.x2 +
            ',' +
            (50 - t.y2) +
            ' L ' +
            t.x1 +
            ',' +
            (50 - t.y1) +
            ' Z'
          );
        }
        o.prototype.handleEvent = s.handleEvent;
        o.prototype.onclick = function () {
          if (!this.isEnabled) return;
          this.parent.uiChange();
          const t = this.isPrevious ? 'previous' : 'next';
          this.parent[t]();
        };
        o.prototype.enable = function () {
          if (this.isEnabled) return;
          this.element.disabled = false;
          this.isEnabled = true;
        };
        o.prototype.disable = function () {
          if (!this.isEnabled) return;
          this.element.disabled = true;
          this.isEnabled = false;
        };
        o.prototype.update = function () {
          const t = this.parent.slides;
          if (this.parent.options.wrapAround && t.length > 1) {
            this.enable();
            return;
          }
          const e = t.length ? t.length - 1 : 0;
          const i = this.isPrevious ? 0 : e;
          const n = this.parent.selectedIndex == i ? 'disable' : 'enable';
          this[n]();
        };
        o.prototype.destroy = function () {
          this.deactivate();
          this.allOff();
        };
        s.extend(i.defaults, {
          prevNextButtons: true,
          arrowShape: { x0: 10, x1: 60, y1: 50, x2: 70, y2: 40, x3: 30 },
        });
        i.createMethods.push('_createPrevNextButtons');
        const l = i.prototype;
        l._createPrevNextButtons = function () {
          if (!this.options.prevNextButtons) return;
          this.prevButton = new o(-1, this);
          this.nextButton = new o(1, this);
          this.on('activate', this.activatePrevNextButtons);
        };
        l.activatePrevNextButtons = function () {
          this.prevButton.activate();
          this.nextButton.activate();
          this.on('deactivate', this.deactivatePrevNextButtons);
        };
        l.deactivatePrevNextButtons = function () {
          this.prevButton.deactivate();
          this.nextButton.deactivate();
          this.off('deactivate', this.deactivatePrevNextButtons);
        };
        i.PrevNextButton = o;
        return i;
      });
    },
    519: function (t, e, i) {
      let n, s, r;
      (function (o, a) {
        if (true)
          !((s = [i(575), i(914)]),
          (n = a),
          (r = typeof n === 'function' ? n.apply(e, s) : n),
          r !== void 0 && (t.exports = r));
      })(typeof window != 'undefined' ? window : this, function t(e, i) {
        e.createMethods.push('_sync');
        const n = e.prototype;
        n._sync = function () {
          this.syncers = {};
          const t = this.options.sync;
          this.on('destroy', this.unsyncAll);
          if (!t) return;
          setTimeout(() => {
            this.sync(t);
          });
        };
        n.sync = function (t) {
          t = i.getQueryElement(t);
          const n = e.data(t);
          if (!n) return;
          this._syncCompanion(n);
          n._syncCompanion(this);
        };
        n._syncCompanion = function (t) {
          const e = this;
          function i() {
            const i = e.selectedIndex;
            if (t.selectedIndex !== i) t.select(i);
          }
          this.on('select', i);
          this.syncers[t.guid] = { flickity: t, listener: i };
        };
        n.unsync = function (t) {
          t = i.getQueryElement(t);
          const n = e.data(t);
          this._unsync(n);
        };
        n._unsync = function (t) {
          if (!t) return;
          this._unsyncCompanion(t);
          t._unsyncCompanion(this);
        };
        n._unsyncCompanion = function (t) {
          const e = t.guid;
          const i = this.syncers[e];
          this.off('select', i.listener);
          delete this.syncers[e];
        };
        n.unsyncAll = function () {
          for (const t in this.syncers) {
            const e = this.syncers[t];
            this._unsync(e.flickity);
          }
        };
        return e;
      });
    },
    542: (t, e, i) => {
      let n, s;
      (function (r, o) {
        if (true)
          !((n = [i(136), i(784), i(914), i(359), i(338), i(816)]),
          (s = function (t, e, i, n, s, a) {
            return o(r, t, e, i, n, s, a);
          }.apply(e, n)),
          s !== void 0 && (t.exports = s));
        else var a;
      })(window, function t(e, i, n, s, r, o, a) {
        'use strict';
        let l = e.jQuery;
        const c = e.getComputedStyle;
        const h = e.console;
        function u(t, e) {
          t = s.makeArray(t);
          while (t.length) e.appendChild(t.shift());
        }
        let d = 0;
        const f = {};
        function p(t, e) {
          const i = s.getQueryElement(t);
          if (!i) {
            if (h) h.error('Bad element for Flickity: ' + (i || t));
            return;
          }
          this.element = i;
          if (this.element.flickityGUID) {
            const n = f[this.element.flickityGUID];
            if (n) n.option(e);
            return n;
          }
          if (l) this.$element = l(this.element);
          this.options = s.extend({}, this.constructor.defaults);
          this.option(e);
          this._create();
        }
        p.defaults = {
          accessibility: true,
          cellAlign: 'center',
          freeScrollFriction: 0.075,
          friction: 0.28,
          namespaceJQueryEvents: true,
          percentPosition: true,
          resize: true,
          selectedAttraction: 0.025,
          setGallerySize: true,
        };
        p.createMethods = [];
        const v = p.prototype;
        s.extend(v, i.prototype);
        v._create = function () {
          const t = (this.guid = ++d);
          this.element.flickityGUID = t;
          f[t] = this;
          this.selectedIndex = 0;
          this.restingFrames = 0;
          this.x = 0;
          this.velocity = 0;
          this.originSide = this.options.rightToLeft ? 'right' : 'left';
          this.viewport = document.createElement('div');
          this.viewport.className = 'flickity-viewport';
          this._createSlider();
          if (this.options.resize || this.options.watchCSS) e.addEventListener('resize', this);
          for (const i in this.options.on) {
            const n = this.options.on[i];
            this.on(i, n);
          }
          p.createMethods.forEach(function (t) {
            this[t]();
          }, this);
          if (this.options.watchCSS) this.watchCSS();
          else this.activate();
        };
        v.option = function (t) {
          s.extend(this.options, t);
        };
        v.activate = function () {
          if (this.isActive) return;
          this.isActive = true;
          this.element.classList.add('flickity-enabled');
          if (this.options.rightToLeft) this.element.classList.add('flickity-rtl');
          this.getSize();
          const t = this._filterFindCellElements(this.element.children);
          u(t, this.slider);
          this.viewport.appendChild(this.slider);
          this.element.appendChild(this.viewport);
          this.reloadCells();
          if (this.options.accessibility) {
            this.element.tabIndex = 0;
            this.element.addEventListener('keydown', this);
          }
          this.emitEvent('activate');
          this.selectInitialIndex();
          this.isInitActivated = true;
          this.dispatchEvent('ready');
        };
        v._createSlider = function () {
          const t = document.createElement('div');
          t.className = 'flickity-slider';
          t.style[this.originSide] = 0;
          this.slider = t;
        };
        v._filterFindCellElements = function (t) {
          return s.filterFindElements(t, this.options.cellSelector);
        };
        v.reloadCells = function () {
          this.cells = this._makeCells(this.slider.children);
          this.positionCells();
          this._getWrapShiftCells();
          this.setGallerySize();
        };
        v._makeCells = function (t) {
          const e = this._filterFindCellElements(t);
          const i = e.map(function (t) {
            return new r(t, this);
          }, this);
          return i;
        };
        v.getLastCell = function () {
          return this.cells[this.cells.length - 1];
        };
        v.getLastSlide = function () {
          return this.slides[this.slides.length - 1];
        };
        v.positionCells = function () {
          this._sizeCells(this.cells);
          this._positionCells(0);
        };
        v._positionCells = function (t) {
          t = t || 0;
          this.maxCellHeight = t ? this.maxCellHeight || 0 : 0;
          let e = 0;
          if (t > 0) {
            const i = this.cells[t - 1];
            e = i.x + i.size.outerWidth;
          }
          const n = this.cells.length;
          for (let s = t; s < n; s++) {
            const r = this.cells[s];
            r.setPosition(e);
            e += r.size.outerWidth;
            this.maxCellHeight = Math.max(r.size.outerHeight, this.maxCellHeight);
          }
          this.slideableWidth = e;
          this.updateSlides();
          this._containSlides();
          this.slidesWidth = n ? this.getLastSlide().target - this.slides[0].target : 0;
        };
        v._sizeCells = function (t) {
          t.forEach(function (t) {
            t.getSize();
          });
        };
        v.updateSlides = function () {
          this.slides = [];
          if (!this.cells.length) return;
          let t = new o(this);
          this.slides.push(t);
          const e = this.originSide == 'left';
          const i = e ? 'marginRight' : 'marginLeft';
          const n = this._getCanCellFit();
          this.cells.forEach(function (e, s) {
            if (!t.cells.length) {
              t.addCell(e);
              return;
            }
            const r = t.outerWidth - t.firstMargin + (e.size.outerWidth - e.size[i]);
            if (n.call(this, s, r)) t.addCell(e);
            else {
              t.updateTarget();
              t = new o(this);
              this.slides.push(t);
              t.addCell(e);
            }
          }, this);
          t.updateTarget();
          this.updateSelectedSlide();
        };
        v._getCanCellFit = function () {
          const t = this.options.groupCells;
          if (!t)
            return function () {
              return false;
            };
          else if (typeof t == 'number') {
            const e = parseInt(t, 10);
            return function (t) {
              return t % e !== 0;
            };
          }
          const i = typeof t == 'string' && t.match(/^(\d+)%$/);
          const n = i ? parseInt(i[1], 10) / 100 : 1;
          return function (t, e) {
            return e <= (this.size.innerWidth + 1) * n;
          };
        };
        v._init = v.reposition = function () {
          this.positionCells();
          this.positionSliderAtSelected();
        };
        v.getSize = function () {
          this.size = n(this.element);
          this.setCellAlign();
          this.cursorPosition = this.size.innerWidth * this.cellAlign;
        };
        const m = {
          center: { left: 0.5, right: 0.5 },
          left: { left: 0, right: 1 },
          right: { right: 0, left: 1 },
        };
        v.setCellAlign = function () {
          const t = m[this.options.cellAlign];
          this.cellAlign = t ? t[this.originSide] : this.options.cellAlign;
        };
        v.setGallerySize = function () {
          if (this.options.setGallerySize) {
            const t =
              this.options.adaptiveHeight && this.selectedSlide
                ? this.selectedSlide.height
                : this.maxCellHeight;
            this.viewport.style.height = t + 'px';
          }
        };
        v._getWrapShiftCells = function () {
          if (!this.options.wrapAround) return;
          this._unshiftCells(this.beforeShiftCells);
          this._unshiftCells(this.afterShiftCells);
          let t = this.cursorPosition;
          const e = this.cells.length - 1;
          this.beforeShiftCells = this._getGapCells(t, e, -1);
          t = this.size.innerWidth - this.cursorPosition;
          this.afterShiftCells = this._getGapCells(t, 0, 1);
        };
        v._getGapCells = function (t, e, i) {
          const n = [];
          while (t > 0) {
            const s = this.cells[e];
            if (!s) break;
            n.push(s);
            e += i;
            t -= s.size.outerWidth;
          }
          return n;
        };
        v._containSlides = function () {
          if (!this.options.contain || this.options.wrapAround || !this.cells.length) return;
          const t = this.options.rightToLeft;
          const e = t ? 'marginRight' : 'marginLeft';
          const i = t ? 'marginLeft' : 'marginRight';
          const n = this.slideableWidth - this.getLastCell().size[i];
          const s = n < this.size.innerWidth;
          const r = this.cursorPosition + this.cells[0].size[e];
          const o = n - this.size.innerWidth * (1 - this.cellAlign);
          this.slides.forEach(function (t) {
            if (s) t.target = n * this.cellAlign;
            else {
              t.target = Math.max(t.target, r);
              t.target = Math.min(t.target, o);
            }
          }, this);
        };
        v.dispatchEvent = function (t, e, i) {
          const n = e ? [e].concat(i) : i;
          this.emitEvent(t, n);
          if (l && this.$element) {
            t += this.options.namespaceJQueryEvents ? '.flickity' : '';
            let s = t;
            if (e) {
              const r = new l.Event(e);
              r.type = t;
              s = r;
            }
            this.$element.trigger(s, i);
          }
        };
        v.select = function (t, e, i) {
          if (!this.isActive) return;
          t = parseInt(t, 10);
          this._wrapSelect(t);
          if (this.options.wrapAround || e) t = s.modulo(t, this.slides.length);
          if (!this.slides[t]) return;
          const n = this.selectedIndex;
          this.selectedIndex = t;
          this.updateSelectedSlide();
          if (i) this.positionSliderAtSelected();
          else this.startAnimation();
          if (this.options.adaptiveHeight) this.setGallerySize();
          this.dispatchEvent('select', null, [t]);
          if (t != n) this.dispatchEvent('change', null, [t]);
          this.dispatchEvent('cellSelect');
        };
        v._wrapSelect = function (t) {
          const e = this.slides.length;
          const i = this.options.wrapAround && e > 1;
          if (!i) return t;
          const n = s.modulo(t, e);
          const r = Math.abs(n - this.selectedIndex);
          const o = Math.abs(n + e - this.selectedIndex);
          const a = Math.abs(n - e - this.selectedIndex);
          if (!this.isDragSelect && o < r) t += e;
          else if (!this.isDragSelect && a < r) t -= e;
          if (t < 0) this.x -= this.slideableWidth;
          else if (t >= e) this.x += this.slideableWidth;
        };
        v.previous = function (t, e) {
          this.select(this.selectedIndex - 1, t, e);
        };
        v.next = function (t, e) {
          this.select(this.selectedIndex + 1, t, e);
        };
        v.updateSelectedSlide = function () {
          const t = this.slides[this.selectedIndex];
          if (!t) return;
          this.unselectSelectedSlide();
          this.selectedSlide = t;
          t.select();
          this.selectedCells = t.cells;
          this.selectedElements = t.getCellElements();
          this.selectedCell = t.cells[0];
          this.selectedElement = this.selectedElements[0];
        };
        v.unselectSelectedSlide = function () {
          if (this.selectedSlide) this.selectedSlide.unselect();
        };
        v.selectInitialIndex = function () {
          const t = this.options.initialIndex;
          if (this.isInitActivated) {
            this.select(this.selectedIndex, false, true);
            return;
          }
          if (t && typeof t == 'string') {
            const e = this.queryCell(t);
            if (e) {
              this.selectCell(t, false, true);
              return;
            }
          }
          let i = 0;
          if (t && this.slides[t]) i = t;
          this.select(i, false, true);
        };
        v.selectCell = function (t, e, i) {
          const n = this.queryCell(t);
          if (!n) return;
          const s = this.getCellSlideIndex(n);
          this.select(s, e, i);
        };
        v.getCellSlideIndex = function (t) {
          for (let e = 0; e < this.slides.length; e++) {
            const i = this.slides[e];
            const n = i.cells.indexOf(t);
            if (n != -1) return e;
          }
        };
        v.getCell = function (t) {
          for (let e = 0; e < this.cells.length; e++) {
            const i = this.cells[e];
            if (i.element == t) return i;
          }
        };
        v.getCells = function (t) {
          t = s.makeArray(t);
          const e = [];
          t.forEach(function (t) {
            const i = this.getCell(t);
            if (i) e.push(i);
          }, this);
          return e;
        };
        v.getCellElements = function () {
          return this.cells.map(function (t) {
            return t.element;
          });
        };
        v.getParentCell = function (t) {
          const e = this.getCell(t);
          if (e) return e;
          t = s.getParent(t, '.flickity-slider > *');
          return this.getCell(t);
        };
        v.getAdjacentCellElements = function (t, e) {
          if (!t) return this.selectedSlide.getCellElements();
          e = e === void 0 ? this.selectedIndex : e;
          const i = this.slides.length;
          if (1 + t * 2 >= i) return this.getCellElements();
          let n = [];
          for (let r = e - t; r <= e + t; r++) {
            const o = this.options.wrapAround ? s.modulo(r, i) : r;
            const a = this.slides[o];
            if (a) n = n.concat(a.getCellElements());
          }
          return n;
        };
        v.queryCell = function (t) {
          if (typeof t == 'number') return this.cells[t];
          if (typeof t == 'string') {
            if (t.match(/^[#.]?[\d/]/)) return;
            t = this.element.querySelector(t);
          }
          return this.getCell(t);
        };
        v.uiChange = function () {
          this.emitEvent('uiChange');
        };
        v.childUIPointerDown = function (t) {
          if (t.type != 'touchstart') t.preventDefault();
          this.focus();
        };
        v.onresize = function () {
          this.watchCSS();
          this.resize();
        };
        s.debounceMethod(p, 'onresize', 150);
        v.resize = function () {
          if (!this.isActive || this.isAnimating || this.isDragging) return;
          this.getSize();
          if (this.options.wrapAround) this.x = s.modulo(this.x, this.slideableWidth);
          this.positionCells();
          this._getWrapShiftCells();
          this.setGallerySize();
          this.emitEvent('resize');
          const t = this.selectedElements && this.selectedElements[0];
          this.selectCell(t, false, true);
        };
        v.watchCSS = function () {
          const t = this.options.watchCSS;
          if (!t) return;
          const e = c(this.element, ':after').content;
          if (e.indexOf('flickity') != -1) this.activate();
          else this.deactivate();
        };
        v.onkeydown = function (t) {
          const e = document.activeElement && document.activeElement != this.element;
          if (!this.options.accessibility || e) return;
          const i = p.keyboardHandlers[t.keyCode];
          if (i) i.call(this);
        };
        p.keyboardHandlers = {
          37: function () {
            const t = this.options.rightToLeft ? 'next' : 'previous';
            this.uiChange();
            this[t]();
          },
          39: function () {
            const t = this.options.rightToLeft ? 'previous' : 'next';
            this.uiChange();
            this[t]();
          },
        };
        v.focus = function () {
          const t = e.pageYOffset;
          this.element.focus({ preventScroll: true });
          if (e.pageYOffset != t) e.scrollTo(e.pageXOffset, t);
        };
        v.deactivate = function () {
          if (!this.isActive) return;
          this.element.classList.remove('flickity-enabled');
          this.element.classList.remove('flickity-rtl');
          this.unselectSelectedSlide();
          this.cells.forEach(function (t) {
            t.destroy();
          });
          this.element.removeChild(this.viewport);
          u(this.slider.children, this.element);
          if (this.options.accessibility) {
            this.element.removeAttribute('tabIndex');
            this.element.removeEventListener('keydown', this);
          }
          this.isActive = false;
          this.emitEvent('deactivate');
        };
        v.destroy = function () {
          this.deactivate();
          e.removeEventListener('resize', this);
          this.allOff();
          this.emitEvent('destroy');
          if (l && this.$element) l.removeData(this.element, 'flickity');
          delete this.element.flickityGUID;
          delete f[this.guid];
        };
        s.extend(v, a);
        p.data = function (t) {
          t = s.getQueryElement(t);
          const e = t && t.flickityGUID;
          return e && f[e];
        };
        s.htmlInit(p, 'flickity');
        if (l && l.bridget) l.bridget('flickity', p);
        p.setJQuery = function (t) {
          l = t;
        };
        p.Cell = r;
        p.Slide = o;
        return p;
      });
    },
    549: (t, e, i) => {
      let n, s;
      (function (r, o) {
        if (true)
          !((n = [i(542), i(878), i(914)]),
          (s = function (t, e, i) {
            return o(r, t, e, i);
          }.apply(e, n)),
          s !== void 0 && (t.exports = s));
      })(window, function t(e, i, n, s) {
        'use strict';
        function r(t) {
          this.parent = t;
          this._create();
        }
        r.prototype = Object.create(n.prototype);
        r.prototype._create = function () {
          this.holder = document.createElement('ol');
          this.holder.className = 'flickity-page-dots';
          this.dots = [];
          this.handleClick = this.onClick.bind(this);
          this.on('pointerDown', this.parent.childUIPointerDown.bind(this.parent));
        };
        r.prototype.activate = function () {
          this.setDots();
          this.holder.addEventListener('click', this.handleClick);
          this.bindStartEvent(this.holder);
          this.parent.element.appendChild(this.holder);
        };
        r.prototype.deactivate = function () {
          this.holder.removeEventListener('click', this.handleClick);
          this.unbindStartEvent(this.holder);
          this.parent.element.removeChild(this.holder);
        };
        r.prototype.setDots = function () {
          const t = this.parent.slides.length - this.dots.length;
          if (t > 0) this.addDots(t);
          else if (t < 0) this.removeDots(-t);
        };
        r.prototype.addDots = function (t) {
          const e = document.createDocumentFragment();
          const i = [];
          const n = this.dots.length;
          const s = n + t;
          for (let r = n; r < s; r++) {
            const o = document.createElement('li');
            o.className = 'dot';
            o.setAttribute('aria-label', 'Page dot ' + (r + 1));
            e.appendChild(o);
            i.push(o);
          }
          this.holder.appendChild(e);
          this.dots = this.dots.concat(i);
        };
        r.prototype.removeDots = function (t) {
          const e = this.dots.splice(this.dots.length - t, t);
          e.forEach(function (t) {
            this.holder.removeChild(t);
          }, this);
        };
        r.prototype.updateSelected = function () {
          if (this.selectedDot) {
            this.selectedDot.className = 'dot';
            this.selectedDot.removeAttribute('aria-current');
          }
          if (!this.dots.length) return;
          this.selectedDot = this.dots[this.parent.selectedIndex];
          this.selectedDot.className = 'dot is-selected';
          this.selectedDot.setAttribute('aria-current', 'step');
        };
        r.prototype.onTap = r.prototype.onClick = function (t) {
          const e = t.target;
          if (e.nodeName != 'LI') return;
          this.parent.uiChange();
          const i = this.dots.indexOf(e);
          this.parent.select(i);
        };
        r.prototype.destroy = function () {
          this.deactivate();
          this.allOff();
        };
        i.PageDots = r;
        s.extend(i.defaults, { pageDots: true });
        i.createMethods.push('_createPageDots');
        const o = i.prototype;
        o._createPageDots = function () {
          if (!this.options.pageDots) return;
          this.pageDots = new r(this);
          this.on('activate', this.activatePageDots);
          this.on('select', this.updateSelectedPageDots);
          this.on('cellChange', this.updatePageDots);
          this.on('resize', this.updatePageDots);
          this.on('deactivate', this.deactivatePageDots);
        };
        o.activatePageDots = function () {
          this.pageDots.activate();
        };
        o.updateSelectedPageDots = function () {
          this.pageDots.updateSelected();
        };
        o.updatePageDots = function () {
          this.pageDots.setDots();
        };
        o.deactivatePageDots = function () {
          this.pageDots.deactivate();
        };
        i.PageDots = r;
        return i;
      });
    },
    572: function (t) {
      !(function (e, i) {
        true ? (t.exports = i()) : 0;
      })(this, function () {
        return (() => {
          'use strict';
          var t = {
              d: (e, i) => {
                for (const n in i)
                  t.o(i, n) &&
                    !t.o(e, n) &&
                    Object.defineProperty(e, n, { enumerable: !0, get: i[n] });
              },
              o: (t, e) => Object.prototype.hasOwnProperty.call(t, e),
              r: (t) => {
                ('undefined' != typeof Symbol &&
                  Symbol.toStringTag &&
                  Object.defineProperty(t, Symbol.toStringTag, { value: 'Module' }),
                  Object.defineProperty(t, '__esModule', { value: !0 }));
              },
            },
            e = {};
          function i(t, e) {
            for (let i = 0; i < e.length; i++) {
              const n = e[i];
              ((n.enumerable = n.enumerable || !1),
                (n.configurable = !0),
                'value' in n && (n.writable = !0),
                Object.defineProperty(t, n.key, n));
            }
          }
          function n(t, e, n) {
            return (
              e && i(t.prototype, e),
              n && i(t, n),
              Object.defineProperty(t, 'prototype', { writable: !1 }),
              t
            );
          }
          function s(t, e) {
            if (!(t instanceof e)) throw new TypeError('Cannot call a class as a function');
          }
          function r(t, e, i) {
            return (
              e in t
                ? Object.defineProperty(t, e, {
                    value: i,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (t[e] = i),
              t
            );
          }
          (t.r(e), t.d(e, { default: () => a }));
          var o = {
              overlay: null,
              thickness: '3px',
              color: 'gray',
              startDuration: 1e3,
              finishDuration: 300,
            },
            a = n(function t() {
              const e = this,
                i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : document.body,
                n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              (s(this, t),
                r(this, 'setLoadingData', function () {
                  const t = e.target,
                    i = e.options,
                    n = i.startDuration,
                    s = i.finishDuration,
                    r = i.thickness,
                    o = i.color;
                  (t.style.setProperty('--al-thickness', ' '.concat(r)),
                    t.style.setProperty('--al-color', ' '.concat(o)),
                    t.style.setProperty('--al-start-duration', ' '.concat(n, 'ms')),
                    t.style.setProperty('--al-finish-duration', ' '.concat(s, 'ms')));
                }),
                r(this, 'start', function () {
                  (e.target.classList.add('al-loading-bar', 'start', 'loading'),
                    e.overlay && e.overlay.classList.add('al-loading-overlay', 'overlay-show'));
                }),
                r(this, 'finish', function () {
                  const t =
                      arguments.length > 0 && void 0 !== arguments[0]
                        ? arguments[0]
                        : function () {},
                    i = e.target,
                    n = e.overlay,
                    s = e.cleanUp,
                    r = e.options.finishDuration,
                    o = window.getComputedStyle(i, ':before').width;
                  (i.style.setProperty('--al-end-width', o),
                    i.classList.add('loaded'),
                    i.classList.remove('loading'),
                    window.requestAnimationFrame(function () {
                      (i.classList.add('finished'),
                        e.overlay && n.classList.remove('overlay-show'));
                    }),
                    setTimeout(s, 2 * r),
                    setTimeout(t, r));
                }),
                r(this, 'cleanUp', function () {
                  (e.target.classList.remove('al-loading-bar', 'start', 'loaded', 'finished'),
                    e.overlay && e.overlay.classList.remove('al-loading-overlay'));
                }),
                (this.options = Object.assign({}, o, n)),
                (this.target = i),
                (this.overlay = this.options.overlay),
                this.setLoadingData());
            });
          return e;
        })();
      });
    },
    575: (t, e, i) => {
      let n, s, r;
      (function (o, a) {
        if (true)
          !((s = [i(542), i(793), i(515), i(549), i(762), i(958), i(65)]),
          (n = a),
          (r = typeof n === 'function' ? n.apply(e, s) : n),
          r !== void 0 && (t.exports = r));
      })(window, function t(e) {
        return e;
      });
    },
    691: () => {
      (function () {
        'use strict';
        const t = function (t, e) {
          const i = function t(e) {
            for (let i = 0, s = e.length; i < s; i++) n(e[i]);
          };
          var n = function t(e) {
            const i = e.target,
              n = e.attributeName,
              s = e.oldValue;
            i.attributeChangedCallback(n, s, i.getAttribute(n));
          };
          return function (s, r) {
            const o = s.constructor.observedAttributes;
            if (o)
              t(r).then(function () {
                new e(i).observe(s, {
                  attributes: true,
                  attributeOldValue: true,
                  attributeFilter: o,
                });
                for (let t = 0, r = o.length; t < r; t++)
                  if (s.hasAttribute(o[t])) n({ target: s, attributeName: o[t], oldValue: null });
              });
            return s;
          };
        };
        function e(t, e) {
          if (!t) return;
          if (typeof t === 'string') return i(t, e);
          let n = Object.prototype.toString.call(t).slice(8, -1);
          if (n === 'Object' && t.constructor) n = t.constructor.name;
          if (n === 'Map' || n === 'Set') return Array.from(t);
          if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
            return i(t, e);
        }
        function i(t, e) {
          if (e == null || e > t.length) e = t.length;
          for (var i = 0, n = new Array(e); i < e; i++) n[i] = t[i];
          return n;
        }
        function n(t, i) {
          let n = (typeof Symbol !== 'undefined' && t[Symbol.iterator]) || t['@@iterator'];
          if (!n) {
            if (Array.isArray(t) || (n = e(t)) || (i && t && typeof t.length === 'number')) {
              if (n) t = n;
              let s = 0;
              const r = function () {};
              return {
                s: r,
                n: function () {
                  if (s >= t.length) return { done: true };
                  return { done: false, value: t[s++] };
                },
                e: function (t) {
                  throw t;
                },
                f: r,
              };
            }
            throw new TypeError(
              'Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
            );
          }
          let o = true,
            a = false,
            l;
          return {
            s: function () {
              n = n.call(t);
            },
            n: function () {
              const t = n.next();
              o = t.done;
              return t;
            },
            e: function (t) {
              a = true;
              l = t;
            },
            f: function () {
              try {
                if (!o && n.return != null) n.return();
              } finally {
                if (a) throw l;
              }
            },
          };
        }
        const s = true,
          r = false,
          o = 'querySelectorAll';
        const a = function t(e) {
          const i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : document;
          const a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : MutationObserver;
          const l = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ['*'];
          const c = function t(i, r, a, l, c, h) {
            let u = n(i),
              d;
            try {
              for (u.s(); !(d = u.n()).done; ) {
                const f = d.value;
                if (h || o in f) {
                  if (c) {
                    if (!a.has(f)) {
                      a.add(f);
                      l['delete'](f);
                      e(f, c);
                    }
                  } else if (!l.has(f)) {
                    l.add(f);
                    a['delete'](f);
                    e(f, c);
                  }
                  if (!h) t(f[o](r), r, a, l, c, s);
                }
              }
            } catch (t) {
              u.e(t);
            } finally {
              u.f();
            }
          };
          const h = new a(function (t) {
            if (l.length) {
              const e = l.join(',');
              const i = new Set(),
                o = new Set();
              let a = n(t),
                h;
              try {
                for (a.s(); !(h = a.n()).done; ) {
                  const u = h.value,
                    d = u.addedNodes,
                    f = u.removedNodes;
                  c(f, e, i, o, r, r);
                  c(d, e, i, o, s, r);
                }
              } catch (t) {
                a.e(t);
              } finally {
                a.f();
              }
            }
          });
          const u = h.observe;
          (h.observe = function (t) {
            return u.call(h, t, { subtree: s, childList: s });
          })(i);
          return h;
        };
        const l = 'querySelectorAll';
        const c = self,
          h = c.document,
          u = c.Element,
          d = c.MutationObserver,
          f = c.Set,
          p = c.WeakMap;
        const v = function t(e) {
          return l in e;
        };
        const m = [].filter;
        const g = function (t) {
          const e = new p();
          const i = function t(i) {
            for (let n = 0, s = i.length; n < s; n++) e['delete'](i[n]);
          };
          const n = function t() {
            const e = y.takeRecords();
            for (let i = 0, n = e.length; i < n; i++) {
              o(m.call(e[i].removedNodes, v), false);
              o(m.call(e[i].addedNodes, v), true);
            }
          };
          const s = function t(e) {
            return e.matches || e.webkitMatchesSelector || e.msMatchesSelector;
          };
          const r = function i(n, r) {
            let o;
            if (r) {
              for (var a, l = s(n), h = 0, u = c.length; h < u; h++)
                if (l.call(n, (a = c[h]))) {
                  if (!e.has(n)) e.set(n, new f());
                  o = e.get(n);
                  if (!o.has(a)) {
                    o.add(a);
                    t.handle(n, r, a);
                  }
                }
            } else if (e.has(n)) {
              o = e.get(n);
              e['delete'](n);
              o.forEach(function (e) {
                t.handle(n, r, e);
              });
            }
          };
          var o = function t(e) {
            const i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
            for (let n = 0, s = e.length; n < s; n++) r(e[n], i);
          };
          var c = t.query;
          const g = t.root || h;
          var y = a(r, g, d, c);
          const w = u.prototype.attachShadow;
          if (w)
            u.prototype.attachShadow = function (t) {
              const e = w.call(this, t);
              y.observe(e);
              return e;
            };
          if (c.length) o(g[l](c));
          return { drop: i, flush: n, observer: y, parse: o };
        };
        const y = self,
          w = y.document,
          b = y.Map,
          x = y.MutationObserver,
          _ = y.Object,
          S = y.Set,
          C = y.WeakMap,
          E = y.Element,
          P = y.HTMLElement,
          A = y.Node,
          T = y.Error,
          D = y.TypeError,
          L = y.Reflect;
        const O = _.defineProperty,
          I = _.keys,
          M = _.getOwnPropertyNames,
          k = _.setPrototypeOf;
        let z = !self.customElements;
        const F = function t(e) {
          const i = I(e);
          const n = [];
          const s = new S();
          const r = i.length;
          for (let o = 0; o < r; o++) {
            n[o] = e[i[o]];
            try {
              delete e[i[o]];
            } catch (t) {
              s.add(o);
            }
          }
          return function () {
            for (let t = 0; t < r; t++) s.has(t) || (e[i[t]] = n[t]);
          };
        };
        if (z) {
          const R = function t() {
            const e = this.constructor;
            if (!B.has(e)) throw new D('Illegal constructor');
            const i = B.get(e);
            if ($) return G($, i);
            const n = V.call(w, i);
            return G(k(n, e.prototype), i);
          };
          var V = w.createElement;
          var B = new b();
          const N = new b();
          const W = new b();
          const Z = new b();
          const H = [];
          const j = function t(e, i, n) {
            const s = W.get(n);
            if (i && !s.isPrototypeOf(e)) {
              const r = F(e);
              $ = k(e, s);
              try {
                new s.constructor();
              } finally {
                $ = null;
                r();
              }
            }
            const o = ''.concat(i ? '' : 'dis', 'connectedCallback');
            if (o in s) e[o]();
          };
          const U = g({ query: H, handle: j }),
            q = U.parse;
          var $ = null;
          const X = function t(e) {
            if (!N.has(e)) {
              let i,
                n = new Promise(function (t) {
                  i = t;
                });
              N.set(e, { $: n, _: i });
            }
            return N.get(e).$;
          };
          var G = t(X, x);
          self.customElements = {
            define: function t(e, i) {
              if (Z.has(e))
                throw new T('the name "'.concat(e, '" has already been used with this registry'));
              B.set(i, e);
              W.set(e, i.prototype);
              Z.set(e, i);
              H.push(e);
              X(e).then(function () {
                q(w.querySelectorAll(e));
              });
              N.get(e)._(i);
            },
            get: function t(e) {
              return Z.get(e);
            },
            whenDefined: X,
          };
          O((R.prototype = P.prototype), 'constructor', { value: R });
          self.HTMLElement = R;
          w.createElement = function (t, e) {
            const i = e && e.is;
            const n = i ? Z.get(i) : Z.get(t);
            return n ? new n() : V.call(w, t);
          };
          if (!('isConnected' in A.prototype))
            O(A.prototype, 'isConnected', {
              configurable: true,
              get: function t() {
                return !(
                  this.ownerDocument.compareDocumentPosition(this) &
                  this.DOCUMENT_POSITION_DISCONNECTED
                );
              },
            });
        } else {
          z = !self.customElements.get('extends-br');
          if (z)
            try {
              const K = function t() {
                return self.Reflect.construct(HTMLBRElement, [], t);
              };
              K.prototype = HTMLLIElement.prototype;
              const Y = 'extends-br';
              self.customElements.define('extends-br', K, { extends: 'br' });
              z = w.createElement('br', { is: Y }).outerHTML.indexOf(Y) < 0;
              const Q = self.customElements,
                J = Q.get,
                tt = Q.whenDefined;
              self.customElements.whenDefined = function (t) {
                const e = this;
                return tt.call(this, t).then(function (i) {
                  return i || J.call(e, t);
                });
              };
            } catch (t) {}
        }
        if (z) {
          const et = function t(e) {
            const i = ct.get(e);
            bt(i.querySelectorAll(this), e.isConnected);
          };
          const it = self.customElements;
          const nt = w.createElement;
          const st = it.define,
            rt = it.get,
            ot = it.upgrade;
          const at = L || {
              construct: function t(e) {
                return e.call(this);
              },
            },
            lt = at.construct;
          var ct = new C();
          const ht = new S();
          const ut = new b();
          const dt = new b();
          const ft = new b();
          const pt = new b();
          const vt = [];
          const mt = [];
          const gt = function t(e) {
            return pt.get(e) || rt.call(it, e);
          };
          const yt = function t(e, i, n) {
            const s = ft.get(n);
            if (i && !s.isPrototypeOf(e)) {
              const r = F(e);
              Pt = k(e, s);
              try {
                new s.constructor();
              } finally {
                Pt = null;
                r();
              }
            }
            const o = ''.concat(i ? '' : 'dis', 'connectedCallback');
            if (o in s) e[o]();
          };
          var wt = g({ query: mt, handle: yt }),
            bt = wt.parse;
          const xt = g({
              query: vt,
              handle: function t(e, i) {
                if (ct.has(e)) {
                  if (i) ht.add(e);
                  else ht['delete'](e);
                  if (mt.length) et.call(mt, e);
                }
              },
            }),
            _t = xt.parse;
          const St = E.prototype.attachShadow;
          if (St)
            E.prototype.attachShadow = function (t) {
              const e = St.call(this, t);
              ct.set(this, e);
              return e;
            };
          const Ct = function t(e) {
            if (!dt.has(e)) {
              let i,
                n = new Promise(function (t) {
                  i = t;
                });
              dt.set(e, { $: n, _: i });
            }
            return dt.get(e).$;
          };
          const Et = t(Ct, x);
          var Pt = null;
          M(self)
            .filter(function (t) {
              return /^HTML.*Element$/.test(t);
            })
            .forEach(function (t) {
              const e = self[t];
              function i() {
                const t = this.constructor;
                if (!ut.has(t)) throw new D('Illegal constructor');
                const i = ut.get(t),
                  n = i.is,
                  s = i.tag;
                if (n) {
                  if (Pt) return Et(Pt, n);
                  const r = nt.call(w, s);
                  r.setAttribute('is', n);
                  return Et(k(r, t.prototype), n);
                } else return lt.call(this, e, [], t);
              }
              O((i.prototype = e.prototype), 'constructor', { value: i });
              O(self, t, { value: i });
            });
          w.createElement = function (t, e) {
            const i = e && e.is;
            if (i) {
              const n = pt.get(i);
              if (n && ut.get(n).tag === t) return new n();
            }
            const s = nt.call(w, t);
            if (i) s.setAttribute('is', i);
            return s;
          };
          it.get = gt;
          it.whenDefined = Ct;
          it.upgrade = function (t) {
            const e = t.getAttribute('is');
            if (e) {
              const i = pt.get(e);
              if (i) {
                Et(k(t, i.prototype), e);
                return;
              }
            }
            ot.call(it, t);
          };
          it.define = function (t, e, i) {
            if (gt(t)) throw new T("'".concat(t, "' has already been defined as a custom element"));
            let n;
            const s = i && i['extends'];
            ut.set(e, s ? { is: t, tag: s } : { is: '', tag: t });
            if (s) {
              n = ''.concat(s, '[is="').concat(t, '"]');
              ft.set(n, e.prototype);
              pt.set(t, e);
              mt.push(n);
            } else {
              st.apply(it, arguments);
              vt.push((n = t));
            }
            Ct(t).then(function () {
              if (s) {
                bt(w.querySelectorAll(n));
                ht.forEach(et, [n]);
              } else _t(w.querySelectorAll(n));
            });
            dt.get(t)._(e);
          };
        }
      })();
    },
    715: () => {
      const t = (t) => {
        const e = document.querySelectorAll('[data-cart-count-number]');
        e &&
          e.forEach((e) => {
            const i = e.closest('[data-cart-count-bubble]');
            const n = e.dataset.type;
            if (n == 'drawer') e.textContent = t;
            else if (t < 100) e.textContent = t;
            else e.textContent = '99+';
            if (t === 0) i.classList.add('is-cart-empty');
            else i.classList.remove('is-cart-empty');
          });
      };
      const e = () =>
        fetch(`/cart.js`, {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json;' },
        }).then((t) => {
          if (!t.ok) throw t;
          return t.json();
        });
      window.FoxThemeCartHelpers = window.FoxThemeCartHelpers || {};
      window.FoxThemeCartHelpers = { updateCartCount: t, getState: e };
    },
    762: (t, e, i) => {
      let n, s;
      (function (r, o) {
        if (true)
          !((n = [i(136), i(914), i(542)]),
          (s = function (t, e, i) {
            return o(t, e, i);
          }.apply(e, n)),
          s !== void 0 && (t.exports = s));
      })(window, function t(e, i, n) {
        'use strict';
        function s(t) {
          this.parent = t;
          this.state = 'stopped';
          this.onVisibilityChange = this.visibilityChange.bind(this);
          this.onVisibilityPlay = this.visibilityPlay.bind(this);
        }
        s.prototype = Object.create(e.prototype);
        s.prototype.play = function () {
          if (this.state == 'playing') return;
          const t = document.hidden;
          if (t) {
            document.addEventListener('visibilitychange', this.onVisibilityPlay);
            return;
          }
          this.state = 'playing';
          document.addEventListener('visibilitychange', this.onVisibilityChange);
          this.tick();
        };
        s.prototype.tick = function () {
          if (this.state != 'playing') return;
          let t = this.parent.options.autoPlay;
          t = typeof t == 'number' ? t : 3e3;
          const e = this;
          this.clear();
          this.timeout = setTimeout(function () {
            e.parent.next(true);
            e.tick();
          }, t);
        };
        s.prototype.stop = function () {
          this.state = 'stopped';
          this.clear();
          document.removeEventListener('visibilitychange', this.onVisibilityChange);
        };
        s.prototype.clear = function () {
          clearTimeout(this.timeout);
        };
        s.prototype.pause = function () {
          if (this.state == 'playing') {
            this.state = 'paused';
            this.clear();
          }
        };
        s.prototype.unpause = function () {
          if (this.state == 'paused') this.play();
        };
        s.prototype.visibilityChange = function () {
          const t = document.hidden;
          this[t ? 'pause' : 'unpause']();
        };
        s.prototype.visibilityPlay = function () {
          this.play();
          document.removeEventListener('visibilitychange', this.onVisibilityPlay);
        };
        i.extend(n.defaults, { pauseAutoPlayOnHover: true });
        n.createMethods.push('_createPlayer');
        const r = n.prototype;
        r._createPlayer = function () {
          this.player = new s(this);
          this.on('activate', this.activatePlayer);
          this.on('uiChange', this.stopPlayer);
          this.on('pointerDown', this.stopPlayer);
          this.on('deactivate', this.deactivatePlayer);
        };
        r.activatePlayer = function () {
          if (!this.options.autoPlay) return;
          this.player.play();
          this.element.addEventListener('mouseenter', this);
        };
        r.playPlayer = function () {
          this.player.play();
        };
        r.stopPlayer = function () {
          this.player.stop();
        };
        r.pausePlayer = function () {
          this.player.pause();
        };
        r.unpausePlayer = function () {
          this.player.unpause();
        };
        r.deactivatePlayer = function () {
          this.player.stop();
          this.element.removeEventListener('mouseenter', this);
        };
        r.onmouseenter = function () {
          if (!this.options.pauseAutoPlayOnHover) return;
          this.player.pause();
          this.element.addEventListener('mouseleave', this);
        };
        r.onmouseleave = function () {
          this.player.unpause();
          this.element.removeEventListener('mouseleave', this);
        };
        n.Player = s;
        return n;
      });
    },
    784: (t, e, i) => {
      let n, s;
      (function (r, o) {
        if (true)
          !((n = o),
          (s = typeof n === 'function' ? n.call(e, i, e, t) : n),
          s !== void 0 && (t.exports = s));
      })(window, function t() {
        'use strict';
        function e(t) {
          const e = parseFloat(t);
          const i = t.indexOf('%') == -1 && !isNaN(e);
          return i && e;
        }
        function i() {}
        const n =
          typeof console == 'undefined'
            ? i
            : function (t) {
                void 0;
              };
        const s = [
          'paddingLeft',
          'paddingRight',
          'paddingTop',
          'paddingBottom',
          'marginLeft',
          'marginRight',
          'marginTop',
          'marginBottom',
          'borderLeftWidth',
          'borderRightWidth',
          'borderTopWidth',
          'borderBottomWidth',
        ];
        const r = s.length;
        function o() {
          const t = {
            width: 0,
            height: 0,
            innerWidth: 0,
            innerHeight: 0,
            outerWidth: 0,
            outerHeight: 0,
          };
          for (let e = 0; e < r; e++) {
            const i = s[e];
            t[i] = 0;
          }
          return t;
        }
        function a(t) {
          const e = getComputedStyle(t);
          if (!e)
            n(
              'Style returned ' +
                e +
                '. Are you running this code in a hidden iframe on Firefox? ' +
                'See https://bit.ly/getsizebug1'
            );
          return e;
        }
        let l = false;
        let c;
        function h() {
          if (l) return;
          l = true;
          const t = document.createElement('div');
          t.style.width = '200px';
          t.style.padding = '1px 2px 3px 4px';
          t.style.borderStyle = 'solid';
          t.style.borderWidth = '1px 2px 3px 4px';
          t.style.boxSizing = 'border-box';
          const i = document.body || document.documentElement;
          i.appendChild(t);
          const n = a(t);
          c = Math.round(e(n.width)) == 200;
          u.isBoxSizeOuter = c;
          i.removeChild(t);
        }
        function u(t) {
          h();
          if (typeof t == 'string') t = document.querySelector(t);
          if (!t || typeof t != 'object' || !t.nodeType) return;
          const i = a(t);
          if (i.display == 'none') return o();
          const n = {};
          n.width = t.offsetWidth;
          n.height = t.offsetHeight;
          const l = (n.isBorderBox = i.boxSizing == 'border-box');
          for (let u = 0; u < r; u++) {
            const d = s[u];
            const f = i[d];
            const p = parseFloat(f);
            n[d] = !isNaN(p) ? p : 0;
          }
          const v = n.paddingLeft + n.paddingRight;
          const m = n.paddingTop + n.paddingBottom;
          const g = n.marginLeft + n.marginRight;
          const y = n.marginTop + n.marginBottom;
          const w = n.borderLeftWidth + n.borderRightWidth;
          const b = n.borderTopWidth + n.borderBottomWidth;
          const x = l && c;
          const _ = e(i.width);
          if (_ !== false) n.width = _ + (x ? 0 : v + w);
          const S = e(i.height);
          if (S !== false) n.height = S + (x ? 0 : m + b);
          n.innerWidth = n.width - (v + w);
          n.innerHeight = n.height - (m + b);
          n.outerWidth = n.width + g;
          n.outerHeight = n.height + y;
          return n;
        }
        return u;
      });
    },
    793: (t, e, i) => {
      let n, s;
      (function (r, o) {
        if (true)
          !((n = [i(542), i(236), i(914)]),
          (s = function (t, e, i) {
            return o(r, t, e, i);
          }.apply(e, n)),
          s !== void 0 && (t.exports = s));
      })(window, function t(e, i, n, s) {
        'use strict';
        s.extend(i.defaults, { draggable: '>1', dragThreshold: 3 });
        i.createMethods.push('_createDrag');
        const r = i.prototype;
        s.extend(r, n.prototype);
        r._touchActionValue = 'pan-y';
        r._createDrag = function () {
          this.on('activate', this.onActivateDrag);
          this.on('uiChange', this._uiChangeDrag);
          this.on('deactivate', this.onDeactivateDrag);
          this.on('cellChange', this.updateDraggable);
        };
        r.onActivateDrag = function () {
          this.handles = [this.viewport];
          this.bindHandles();
          this.updateDraggable();
        };
        r.onDeactivateDrag = function () {
          this.unbindHandles();
          this.element.classList.remove('is-draggable');
        };
        r.updateDraggable = function () {
          if (this.options.draggable == '>1') this.isDraggable = this.slides.length > 1;
          else this.isDraggable = this.options.draggable;
          if (this.isDraggable) this.element.classList.add('is-draggable');
          else this.element.classList.remove('is-draggable');
        };
        r.bindDrag = function () {
          this.options.draggable = true;
          this.updateDraggable();
        };
        r.unbindDrag = function () {
          this.options.draggable = false;
          this.updateDraggable();
        };
        r._uiChangeDrag = function () {
          delete this.isFreeScrolling;
        };
        r.pointerDown = function (t, i) {
          if (!this.isDraggable) {
            this._pointerDownDefault(t, i);
            return;
          }
          const n = this.okayPointerDown(t);
          if (!n) return;
          this._pointerDownPreventDefault(t);
          this.pointerDownFocus(t);
          if (document.activeElement != this.element) this.pointerDownBlur();
          this.dragX = this.x;
          this.viewport.classList.add('is-pointer-down');
          this.pointerDownScroll = a();
          e.addEventListener('scroll', this);
          this._pointerDownDefault(t, i);
        };
        r._pointerDownDefault = function (t, e) {
          this.pointerDownPointer = { pageX: e.pageX, pageY: e.pageY };
          this._bindPostStartEvents(t);
          this.dispatchEvent('pointerDown', t, [e]);
        };
        const o = { INPUT: true, TEXTAREA: true, SELECT: true };
        r.pointerDownFocus = function (t) {
          const e = o[t.target.nodeName];
          if (!e) this.focus();
        };
        r._pointerDownPreventDefault = function (t) {
          const e = t.type == 'touchstart';
          const i = t.pointerType == 'touch';
          const n = o[t.target.nodeName];
          if (!e && !i && !n) t.preventDefault();
        };
        r.hasDragStarted = function (t) {
          return Math.abs(t.x) > this.options.dragThreshold;
        };
        r.pointerUp = function (t, e) {
          delete this.isTouchScrolling;
          this.viewport.classList.remove('is-pointer-down');
          this.dispatchEvent('pointerUp', t, [e]);
          this._dragPointerUp(t, e);
        };
        r.pointerDone = function () {
          e.removeEventListener('scroll', this);
          delete this.pointerDownScroll;
        };
        r.dragStart = function (t, i) {
          if (!this.isDraggable) return;
          this.dragStartPosition = this.x;
          this.startAnimation();
          e.removeEventListener('scroll', this);
          this.dispatchEvent('dragStart', t, [i]);
        };
        r.pointerMove = function (t, e) {
          const i = this._dragPointerMove(t, e);
          this.dispatchEvent('pointerMove', t, [e, i]);
          this._dragMove(t, e, i);
        };
        r.dragMove = function (t, e, i) {
          if (!this.isDraggable) return;
          t.preventDefault();
          this.previousDragX = this.dragX;
          const n = this.options.rightToLeft ? -1 : 1;
          if (this.options.wrapAround) i.x %= this.slideableWidth;
          let s = this.dragStartPosition + i.x * n;
          if (!this.options.wrapAround && this.slides.length) {
            const r = Math.max(-this.slides[0].target, this.dragStartPosition);
            s = s > r ? (s + r) * 0.5 : s;
            const o = Math.min(-this.getLastSlide().target, this.dragStartPosition);
            s = s < o ? (s + o) * 0.5 : s;
          }
          this.dragX = s;
          this.dragMoveTime = new Date();
          this.dispatchEvent('dragMove', t, [e, i]);
        };
        r.dragEnd = function (t, e) {
          if (!this.isDraggable) return;
          if (this.options.freeScroll) this.isFreeScrolling = true;
          let i = this.dragEndRestingSelect();
          if (this.options.freeScroll && !this.options.wrapAround) {
            const n = this.getRestingPosition();
            this.isFreeScrolling = -n > this.slides[0].target && -n < this.getLastSlide().target;
          } else if (!this.options.freeScroll && i == this.selectedIndex)
            i += this.dragEndBoostSelect();
          delete this.previousDragX;
          this.isDragSelect = this.options.wrapAround;
          this.select(i);
          delete this.isDragSelect;
          this.dispatchEvent('dragEnd', t, [e]);
        };
        r.dragEndRestingSelect = function () {
          const t = this.getRestingPosition();
          const e = Math.abs(this.getSlideDistance(-t, this.selectedIndex));
          const i = this._getClosestResting(t, e, 1);
          const n = this._getClosestResting(t, e, -1);
          const s = i.distance < n.distance ? i.index : n.index;
          return s;
        };
        r._getClosestResting = function (t, e, i) {
          let n = this.selectedIndex;
          let s = 1 / 0;
          const r =
            this.options.contain && !this.options.wrapAround
              ? function (t, e) {
                  return t <= e;
                }
              : function (t, e) {
                  return t < e;
                };
          while (r(e, s)) {
            n += i;
            s = e;
            e = this.getSlideDistance(-t, n);
            if (e === null) break;
            e = Math.abs(e);
          }
          return { distance: s, index: n - i };
        };
        r.getSlideDistance = function (t, e) {
          const i = this.slides.length;
          const n = this.options.wrapAround && i > 1;
          const r = n ? s.modulo(e, i) : e;
          const o = this.slides[r];
          if (!o) return null;
          const a = n ? this.slideableWidth * Math.floor(e / i) : 0;
          return t - (o.target + a);
        };
        r.dragEndBoostSelect = function () {
          if (
            this.previousDragX === void 0 ||
            !this.dragMoveTime ||
            new Date() - this.dragMoveTime > 100
          )
            return 0;
          const t = this.getSlideDistance(-this.dragX, this.selectedIndex);
          const e = this.previousDragX - this.dragX;
          if (t > 0 && e > 0) return 1;
          else if (t < 0 && e < 0) return -1;
          return 0;
        };
        r.staticClick = function (t, e) {
          const i = this.getParentCell(t.target);
          const n = i && i.element;
          const s = i && this.cells.indexOf(i);
          this.dispatchEvent('staticClick', t, [e, n, s]);
        };
        r.onscroll = function () {
          const t = a();
          const e = this.pointerDownScroll.x - t.x;
          const i = this.pointerDownScroll.y - t.y;
          if (Math.abs(e) > 3 || Math.abs(i) > 3) this._pointerDone();
        };
        function a() {
          return { x: e.pageXOffset, y: e.pageYOffset };
        }
        return i;
      });
    },
    816: (t, e, i) => {
      let n, s;
      (function (r, o) {
        if (true)
          !((n = [i(914)]),
          (s = function (t) {
            return o(r, t);
          }.apply(e, n)),
          s !== void 0 && (t.exports = s));
      })(window, function t(e, i) {
        'use strict';
        const n = {};
        n.startAnimation = function () {
          if (this.isAnimating) return;
          this.isAnimating = true;
          this.restingFrames = 0;
          this.animate();
        };
        n.animate = function () {
          this.applyDragForce();
          this.applySelectedAttraction();
          const t = this.x;
          this.integratePhysics();
          this.positionSlider();
          this.settle(t);
          if (this.isAnimating) {
            const e = this;
            requestAnimationFrame(function t() {
              e.animate();
            });
          }
        };
        n.positionSlider = function () {
          let t = this.x;
          if (this.options.wrapAround && this.cells.length > 1) {
            t = i.modulo(t, this.slideableWidth);
            t -= this.slideableWidth;
            this.shiftWrapCells(t);
          }
          this.setTranslateX(t, this.isAnimating);
          this.dispatchScrollEvent();
        };
        n.setTranslateX = function (t, e) {
          t += this.cursorPosition;
          t = this.options.rightToLeft ? -t : t;
          const i = this.getPositionValue(t);
          this.slider.style.transform = e ? 'translate3d(' + i + ',0,0)' : 'translateX(' + i + ')';
        };
        n.dispatchScrollEvent = function () {
          const t = this.slides[0];
          if (!t) return;
          const e = -this.x - t.target;
          const i = e / this.slidesWidth;
          this.dispatchEvent('scroll', null, [i, e]);
        };
        n.positionSliderAtSelected = function () {
          if (!this.cells.length) return;
          this.x = -this.selectedSlide.target;
          this.velocity = 0;
          this.positionSlider();
        };
        n.getPositionValue = function (t) {
          if (this.options.percentPosition)
            return Math.round((t / this.size.innerWidth) * 1e4) * 0.01 + '%';
          else return Math.round(t) + 'px';
        };
        n.settle = function (t) {
          const e = !this.isPointerDown && Math.round(this.x * 100) == Math.round(t * 100);
          if (e) this.restingFrames++;
          if (this.restingFrames > 2) {
            this.isAnimating = false;
            delete this.isFreeScrolling;
            this.positionSlider();
            this.dispatchEvent('settle', null, [this.selectedIndex]);
          }
        };
        n.shiftWrapCells = function (t) {
          const e = this.cursorPosition + t;
          this._shiftCells(this.beforeShiftCells, e, -1);
          const i = this.size.innerWidth - (t + this.slideableWidth + this.cursorPosition);
          this._shiftCells(this.afterShiftCells, i, 1);
        };
        n._shiftCells = function (t, e, i) {
          for (let n = 0; n < t.length; n++) {
            const s = t[n];
            const r = e > 0 ? i : 0;
            s.wrapShift(r);
            e -= s.size.outerWidth;
          }
        };
        n._unshiftCells = function (t) {
          if (!t || !t.length) return;
          for (let e = 0; e < t.length; e++) t[e].wrapShift(0);
        };
        n.integratePhysics = function () {
          this.x += this.velocity;
          this.velocity *= this.getFrictionFactor();
        };
        n.applyForce = function (t) {
          this.velocity += t;
        };
        n.getFrictionFactor = function () {
          return 1 - this.options[this.isFreeScrolling ? 'freeScrollFriction' : 'friction'];
        };
        n.getRestingPosition = function () {
          return this.x + this.velocity / (1 - this.getFrictionFactor());
        };
        n.applyDragForce = function () {
          if (!this.isDraggable || !this.isPointerDown) return;
          const t = this.dragX - this.x;
          const e = t - this.velocity;
          this.applyForce(e);
        };
        n.applySelectedAttraction = function () {
          const t = this.isDraggable && this.isPointerDown;
          if (t || this.isFreeScrolling || !this.slides.length) return;
          const e = this.selectedSlide.target * -1 - this.x;
          const i = e * this.options.selectedAttraction;
          this.applyForce(i);
        };
        return n;
      });
    },
    878: (t, e, i) => {
      let n, s;
      (function (r, o) {
        if (true)
          !((n = [i(136)]),
          (s = function (t) {
            return o(r, t);
          }.apply(e, n)),
          s !== void 0 && (t.exports = s));
      })(window, function t(e, i) {
        'use strict';
        function n() {}
        function s() {}
        const r = (s.prototype = Object.create(i.prototype));
        r.bindStartEvent = function (t) {
          this._bindStartEvent(t, true);
        };
        r.unbindStartEvent = function (t) {
          this._bindStartEvent(t, false);
        };
        r._bindStartEvent = function (t, i) {
          i = i === void 0 ? true : i;
          const n = i ? 'addEventListener' : 'removeEventListener';
          let s = 'mousedown';
          if ('ontouchstart' in e) s = 'touchstart';
          else if (e.PointerEvent) s = 'pointerdown';
          t[n](s, this);
        };
        r.handleEvent = function (t) {
          const e = 'on' + t.type;
          if (this[e]) this[e](t);
        };
        r.getTouch = function (t) {
          for (let e = 0; e < t.length; e++) {
            const i = t[e];
            if (i.identifier == this.pointerIdentifier) return i;
          }
        };
        r.onmousedown = function (t) {
          const e = t.button;
          if (e && e !== 0 && e !== 1) return;
          this._pointerDown(t, t);
        };
        r.ontouchstart = function (t) {
          this._pointerDown(t, t.changedTouches[0]);
        };
        r.onpointerdown = function (t) {
          this._pointerDown(t, t);
        };
        r._pointerDown = function (t, e) {
          if (t.button || this.isPointerDown) return;
          this.isPointerDown = true;
          this.pointerIdentifier = e.pointerId !== void 0 ? e.pointerId : e.identifier;
          this.pointerDown(t, e);
        };
        r.pointerDown = function (t, e) {
          this._bindPostStartEvents(t);
          this.emitEvent('pointerDown', [t, e]);
        };
        const o = {
          mousedown: ['mousemove', 'mouseup'],
          touchstart: ['touchmove', 'touchend', 'touchcancel'],
          pointerdown: ['pointermove', 'pointerup', 'pointercancel'],
        };
        r._bindPostStartEvents = function (t) {
          if (!t) return;
          const i = o[t.type];
          i.forEach(function (t) {
            e.addEventListener(t, this);
          }, this);
          this._boundPointerEvents = i;
        };
        r._unbindPostStartEvents = function () {
          if (!this._boundPointerEvents) return;
          this._boundPointerEvents.forEach(function (t) {
            e.removeEventListener(t, this);
          }, this);
          delete this._boundPointerEvents;
        };
        r.onmousemove = function (t) {
          this._pointerMove(t, t);
        };
        r.onpointermove = function (t) {
          if (t.pointerId == this.pointerIdentifier) this._pointerMove(t, t);
        };
        r.ontouchmove = function (t) {
          const e = this.getTouch(t.changedTouches);
          if (e) this._pointerMove(t, e);
        };
        r._pointerMove = function (t, e) {
          this.pointerMove(t, e);
        };
        r.pointerMove = function (t, e) {
          this.emitEvent('pointerMove', [t, e]);
        };
        r.onmouseup = function (t) {
          this._pointerUp(t, t);
        };
        r.onpointerup = function (t) {
          if (t.pointerId == this.pointerIdentifier) this._pointerUp(t, t);
        };
        r.ontouchend = function (t) {
          const e = this.getTouch(t.changedTouches);
          if (e) this._pointerUp(t, e);
        };
        r._pointerUp = function (t, e) {
          this._pointerDone();
          this.pointerUp(t, e);
        };
        r.pointerUp = function (t, e) {
          this.emitEvent('pointerUp', [t, e]);
        };
        r._pointerDone = function () {
          this._pointerReset();
          this._unbindPostStartEvents();
          this.pointerDone();
        };
        r._pointerReset = function () {
          this.isPointerDown = false;
          delete this.pointerIdentifier;
        };
        r.pointerDone = n;
        r.onpointercancel = function (t) {
          if (t.pointerId == this.pointerIdentifier) this._pointerCancel(t, t);
        };
        r.ontouchcancel = function (t) {
          const e = this.getTouch(t.changedTouches);
          if (e) this._pointerCancel(t, e);
        };
        r._pointerCancel = function (t, e) {
          this._pointerDone();
          this.pointerCancel(t, e);
        };
        r.pointerCancel = function (t, e) {
          this.emitEvent('pointerCancel', [t, e]);
        };
        s.getPointerPoint = function (t) {
          return { x: t.pageX, y: t.pageY };
        };
        return s;
      });
    },
    914: (t, e, i) => {
      let n, s;
      (function (r, o) {
        if (true)
          !((n = [i(229)]),
          (s = function (t) {
            return o(r, t);
          }.apply(e, n)),
          s !== void 0 && (t.exports = s));
      })(window, function t(e, i) {
        'use strict';
        const n = {};
        n.extend = function (t, e) {
          for (const i in e) t[i] = e[i];
          return t;
        };
        n.modulo = function (t, e) {
          return ((t % e) + e) % e;
        };
        const s = Array.prototype.slice;
        n.makeArray = function (t) {
          if (Array.isArray(t)) return t;
          if (t === null || t === void 0) return [];
          const e = typeof t == 'object' && typeof t.length == 'number';
          if (e) return s.call(t);
          return [t];
        };
        n.removeFrom = function (t, e) {
          const i = t.indexOf(e);
          if (i != -1) t.splice(i, 1);
        };
        n.getParent = function (t, e) {
          while (t.parentNode && t != document.body) {
            t = t.parentNode;
            if (i(t, e)) return t;
          }
        };
        n.getQueryElement = function (t) {
          if (typeof t == 'string') return document.querySelector(t);
          return t;
        };
        n.handleEvent = function (t) {
          const e = 'on' + t.type;
          if (this[e]) this[e](t);
        };
        n.filterFindElements = function (t, e) {
          t = n.makeArray(t);
          const s = [];
          t.forEach(function (t) {
            if (!(t instanceof HTMLElement)) return;
            if (!e) {
              s.push(t);
              return;
            }
            if (i(t, e)) s.push(t);
            const n = t.querySelectorAll(e);
            for (let r = 0; r < n.length; r++) s.push(n[r]);
          });
          return s;
        };
        n.debounceMethod = function (t, e, i) {
          i = i || 100;
          const n = t.prototype[e];
          const s = e + 'Timeout';
          t.prototype[e] = function () {
            const t = this[s];
            clearTimeout(t);
            const e = arguments;
            const r = this;
            this[s] = setTimeout(function () {
              n.apply(r, e);
              delete r[s];
            }, i);
          };
        };
        n.docReady = function (t) {
          const e = document.readyState;
          if (e == 'complete' || e == 'interactive') setTimeout(t);
          else document.addEventListener('DOMContentLoaded', t);
        };
        n.toDashed = function (t) {
          return t
            .replace(/(.)([A-Z])/g, function (t, e, i) {
              return e + '-' + i;
            })
            .toLowerCase();
        };
        const r = e.console;
        n.htmlInit = function (t, i) {
          n.docReady(function () {
            const s = n.toDashed(i);
            const o = 'data-' + s;
            const a = document.querySelectorAll('[' + o + ']');
            const l = document.querySelectorAll('.js-' + s);
            const c = n.makeArray(a).concat(n.makeArray(l));
            const h = o + '-options';
            const u = e.jQuery;
            c.forEach(function (e) {
              const n = e.getAttribute(o) || e.getAttribute(h);
              let s;
              try {
                s = n && JSON.parse(n);
              } catch (t) {
                if (r) r.error('Error parsing ' + o + ' on ' + e.className + ': ' + t);
                return;
              }
              const a = new t(e, s);
              if (u) u.data(e, i, a);
            });
          });
        };
        return n;
      });
    },
    954: function (t, e, i) {
      let n, s, r;
      (function (o, a) {
        if (true)
          !((s = [i(575), i(914)]),
          (n = a),
          (r = typeof n === 'function' ? n.apply(e, s) : n),
          r !== void 0 && (t.exports = r));
      })(this, function t(e, i) {
        const n = e.Slide;
        const s = n.prototype.updateTarget;
        n.prototype.updateTarget = function () {
          s.apply(this, arguments);
          if (!this.parent.options.fade) return;
          const t = this.target - this.x;
          const e = this.cells[0].x;
          this.cells.forEach(function (i) {
            const n = i.x - e - t;
            i.renderPosition(n);
          });
        };
        n.prototype.setOpacity = function (t) {
          this.cells.forEach(function (e) {
            e.element.style.opacity = t;
          });
        };
        const r = e.prototype;
        e.createMethods.push('_createFade');
        r._createFade = function () {
          this.fadeIndex = this.selectedIndex;
          this.prevSelectedIndex = this.selectedIndex;
          this.on('select', this.onSelectFade);
          this.on('dragEnd', this.onDragEndFade);
          this.on('settle', this.onSettleFade);
          this.on('activate', this.onActivateFade);
          this.on('deactivate', this.onDeactivateFade);
        };
        const o = r.updateSlides;
        r.updateSlides = function () {
          o.apply(this, arguments);
          if (!this.options.fade) return;
          this.slides.forEach(function (t, e) {
            const i = e == this.selectedIndex ? 1 : 0;
            t.setOpacity(i);
          }, this);
        };
        r.onSelectFade = function () {
          this.fadeIndex = Math.min(this.prevSelectedIndex, this.slides.length - 1);
          this.prevSelectedIndex = this.selectedIndex;
        };
        r.onSettleFade = function () {
          delete this.didDragEnd;
          if (!this.options.fade) return;
          this.selectedSlide.setOpacity(1);
          const t = this.slides[this.fadeIndex];
          if (t && this.fadeIndex != this.selectedIndex) this.slides[this.fadeIndex].setOpacity(0);
        };
        r.onDragEndFade = function () {
          this.didDragEnd = true;
        };
        r.onActivateFade = function () {
          if (this.options.fade) this.element.classList.add('is-fade');
        };
        r.onDeactivateFade = function () {
          if (!this.options.fade) return;
          this.element.classList.remove('is-fade');
          this.slides.forEach(function (t) {
            t.setOpacity('');
          });
        };
        const a = r.positionSlider;
        r.positionSlider = function () {
          if (!this.options.fade) {
            a.apply(this, arguments);
            return;
          }
          this.fadeSlides();
          this.dispatchScrollEvent();
        };
        const l = r.positionSliderAtSelected;
        r.positionSliderAtSelected = function () {
          if (this.options.fade) this.setTranslateX(0);
          l.apply(this, arguments);
        };
        r.fadeSlides = function () {
          if (this.slides.length < 2) return;
          const t = this.getFadeIndexes();
          const e = this.slides[t.a];
          const i = this.slides[t.b];
          const n = this.wrapDifference(e.target, i.target);
          let s = this.wrapDifference(e.target, -this.x);
          s /= n;
          e.setOpacity(1 - s);
          i.setOpacity(s);
          let r = t.a;
          if (this.isDragging) r = s > 0.5 ? t.a : t.b;
          const o =
            this.fadeHideIndex != void 0 &&
            this.fadeHideIndex != r &&
            this.fadeHideIndex != t.a &&
            this.fadeHideIndex != t.b;
          if (o) this.slides[this.fadeHideIndex].setOpacity(0);
          this.fadeHideIndex = r;
        };
        r.getFadeIndexes = function () {
          if (!this.isDragging && !this.didDragEnd)
            return { a: this.fadeIndex, b: this.selectedIndex };
          if (this.options.wrapAround) return this.getFadeDragWrapIndexes();
          else return this.getFadeDragLimitIndexes();
        };
        r.getFadeDragWrapIndexes = function () {
          const t = this.slides.map(function (t, e) {
            return this.getSlideDistance(-this.x, e);
          }, this);
          const e = t.map(function (t) {
            return Math.abs(t);
          });
          const n = Math.min.apply(Math, e);
          const s = e.indexOf(n);
          const r = t[s];
          const o = this.slides.length;
          const a = r >= 0 ? 1 : -1;
          return { a: s, b: i.modulo(s + a, o) };
        };
        r.getFadeDragLimitIndexes = function () {
          let t = 0;
          for (let e = 0; e < this.slides.length - 1; e++) {
            const i = this.slides[e];
            if (-this.x < i.target) break;
            t = e;
          }
          return { a: t, b: t + 1 };
        };
        r.wrapDifference = function (t, e) {
          let i = e - t;
          if (!this.options.wrapAround) return i;
          const n = i + this.slideableWidth;
          const s = i - this.slideableWidth;
          if (Math.abs(n) < Math.abs(i)) i = n;
          if (Math.abs(s) < Math.abs(i)) i = s;
          return i;
        };
        const c = r._getWrapShiftCells;
        r._getWrapShiftCells = function () {
          if (!this.options.fade) c.apply(this, arguments);
        };
        const h = r.shiftWrapCells;
        r.shiftWrapCells = function () {
          if (!this.options.fade) h.apply(this, arguments);
        };
        return e;
      });
    },
    958: (t, e, i) => {
      let n, s;
      (function (r, o) {
        if (true)
          !((n = [i(542), i(914)]),
          (s = function (t, e) {
            return o(r, t, e);
          }.apply(e, n)),
          s !== void 0 && (t.exports = s));
      })(window, function t(e, i, n) {
        'use strict';
        function s(t) {
          const e = document.createDocumentFragment();
          t.forEach(function (t) {
            e.appendChild(t.element);
          });
          return e;
        }
        const r = i.prototype;
        r.insert = function (t, e) {
          const i = this._makeCells(t);
          if (!i || !i.length) return;
          const n = this.cells.length;
          e = e === void 0 ? n : e;
          const r = s(i);
          const o = e == n;
          if (o) this.slider.appendChild(r);
          else {
            const a = this.cells[e].element;
            this.slider.insertBefore(r, a);
          }
          if (e === 0) this.cells = i.concat(this.cells);
          else if (o) this.cells = this.cells.concat(i);
          else {
            const l = this.cells.splice(e, n - e);
            this.cells = this.cells.concat(i).concat(l);
          }
          this._sizeCells(i);
          this.cellChange(e, true);
        };
        r.append = function (t) {
          this.insert(t, this.cells.length);
        };
        r.prepend = function (t) {
          this.insert(t, 0);
        };
        r.remove = function (t) {
          const e = this.getCells(t);
          if (!e || !e.length) return;
          let i = this.cells.length - 1;
          e.forEach(function (t) {
            t.remove();
            const e = this.cells.indexOf(t);
            i = Math.min(e, i);
            n.removeFrom(this.cells, t);
          }, this);
          this.cellChange(i, true);
        };
        r.cellSizeChange = function (t) {
          const e = this.getCell(t);
          if (!e) return;
          e.getSize();
          const i = this.cells.indexOf(e);
          this.cellChange(i);
        };
        r.cellChange = function (t, e) {
          const i = this.selectedElement;
          this._positionCells(t);
          this._getWrapShiftCells();
          this.setGallerySize();
          const n = this.getCell(i);
          if (n) this.selectedIndex = this.getCellSlideIndex(n);
          this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex);
          this.emitEvent('cellChange', [t]);
          this.select(this.selectedIndex);
          if (e) this.positionSliderAtSelected();
        };
        return i;
      });
    },
  };
  const e = {};
  function i(n) {
    const s = e[n];
    if (s !== void 0) return s.exports;
    const r = (e[n] = { exports: {} });
    t[n].call(r.exports, r, r.exports, i);
    return r.exports;
  }
  (() => {
    i.n = (t) => {
      const e = t && t.__esModule ? () => t['default'] : () => t;
      i.d(e, { a: e });
      return e;
    };
  })();
  (() => {
    i.d = (t, e) => {
      for (const n in e)
        if (i.o(e, n) && !i.o(t, n)) Object.defineProperty(t, n, { enumerable: true, get: e[n] });
    };
  })();
  (() => {
    i.o = (t, e) => Object.prototype.hasOwnProperty.call(t, e);
  })();
  const n = {};
  (() => {
    'use strict';
    const t = i(572);
    const e = i.n(t);
    const n = i(575);
    const s = i.n(n);
    const r = i(954);
    const o = i(488);
    const a = i(519);
    class l {
      constructor() {
        this.noti = null;
        this.removeTimeoutId = null;
        this.hideTimeoutId = null;
        this.transitionDuration = 300;
      }
      setNoti(t, e, i) {
        let n;
        if (t === 'warning')
          n = `<svg fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>`;
        else if (t === 'success')
          n = `<svg fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>`;
        this.noti = document.createElement('div');
        this.noti.classList.add('f-notification');
        this.noti.classList.add(t);
        if (i) this.noti.classList.add('f-notification--sticky');
        this.noti.innerHTML = `${n}<div class="ml-3">${e}</div>`;
      }
      show({
        target: t,
        type: e,
        message: i,
        method: n = 'after',
        last: s = 3e3,
        delay: r = 0,
        debug: o = false,
        sticky: a = false,
      }) {
        this.clearTimeout();
        this.removeNoti();
        this.setNoti(e, i, a);
        setTimeout(() => {
          t?.[n](this.noti);
          requestAnimationFrame(() => this.noti.classList.add('show'));
          if (!o)
            this.hideTimeoutId = setTimeout(() => {
              this.noti.classList.add('hide');
              this.removeTimeoutId = setTimeout(this.removeNoti, this.transitionDuration * 2);
            }, s);
        }, r);
      }
      handleClick = () => {
        clearTimeout(this.removeTimeoutId);
        this.noti.classList.add('f-hidden');
        setTimeout(this.removeNoti, this.transitionDuration * 2);
      };
      clearTimeout() {
        clearTimeout(this.removeTimeoutId);
        clearTimeout(this.hideTimeoutId);
      }
      removeNoti() {
        if (this.noti) this.noti.remove();
      }
    }
    class c {
      constructor() {
        this.events = {};
      }
      get evts() {
        return Object.keys(this.events);
      }
      subscribe(t, e) {
        this.events[t] = this.events[t] || [];
        this.events[t].push(e);
        return () => this.unSubscribe(t, e);
      }
      unSubscribe(t, e) {
        const i = this.events[t];
        if (i && Array.isArray(i))
          for (let t = 0; t < i.length; t++)
            if (i[t] === e) {
              i.splice(t, 1);
              break;
            }
      }
      emit(t, ...e) {
        void 0;
        void 0;
        void 0;
        (this.events[t] || []).forEach((t) => {
          t(...e);
        });
      }
    }
    const h = i(715);
    class u {
      constructor(t, e = {}) {
        if (!t) return;
        this.container = t;
        const { sliderOptions: i } = t.dataset;
        const n = i ? JSON.parse(i) : {};
        this.options = { ...n, ...e };
        this.reversedCellAlignInRTL();
        const { on: s = {}, onReady: r = () => {} } = e;
        this.settings = {
          cellAlign: FoxThemeSettings.isRTL ? 'right' : 'left',
          rightToLeft: FoxThemeSettings.isRTL,
          watchCSS: true,
          pageDots: false,
          autoPlay: false,
          prevNextButtons: false,
          wrapAround: false,
          pauseAutoPlayOnHover: false,
          arrowShape: { x0: 10, x1: 60, y1: 50, x2: 65, y2: 40, x3: 25 },
          freeScrollFriction: 0.01,
          ...this.options,
          on: {
            ...s,
            ready: () => {
              r();
              this._onInit();
            },
          },
        };
        this.init();
      }
      reversedCellAlignInRTL() {
        if (this.options.cellAlign && FoxThemeSettings.isRTL)
          switch (this.options.cellAlign) {
            case 'left':
              this.options.cellAlign = 'right';
              break;
            case 'right':
              this.options.cellAlign = 'left';
              break;
          }
      }
      init = () => {
        if (this.container) {
          this.container.classList.add('flickity-wrapper');
          if (this.settings.adaptiveHeight)
            this.container.classList.add('flickity-adaptive-height');
        }
        this.instance = new window.FoxTheme.Flickity(this.container, this.settings);
        if (this.settings.autoPlay)
          this.instance.on('pointerDown', () => {
            this.instance.playPlayer();
          });
      };
      calcArrowsPos = () => {
        const t = this.container && this.container.querySelector('.f-image');
        if (t) {
          let e = t.clientHeight;
          if (e === 0) e = '50%';
          this.container.style.setProperty('--arrows-offset-top', parseInt(e) / 2 + 'px');
          this.container.classList.add('flickity-button-initialized');
        }
      };
      _onInit = () => {
        const { prevNextButtons: t, pageDots: e } = this.options;
        const { calcButtonPosition: i } = this.container.dataset;
        if (t && i === 'true') {
          this.container && this.container.classList.add('flickity-with-nav');
          setTimeout(() => this.calcArrowsPos(), 500);
        }
        if (e) this.container && this.container.classList.add('flickity-with-dots');
        this.initialized = true;
      };
      destroy = () => {
        this.instance.destroy();
        this.initialized = false;
      };
    }
    function d(t) {
      return fetch('/products/' + t + '.js').then(function (t) {
        return t.json();
      });
    }
    function f(t, e) {
      g(t);
      if (typeof e !== 'number') throw new TypeError(e + ' is not a Number.');
      const i = t.variants.filter(function (t) {
        return t.id === e;
      });
      return i[0] || null;
    }
    function p(t, e) {
      g(t);
      const i = m(t, e);
      return v(t, i);
    }
    function v(t, e) {
      g(t);
      w(e);
      const i = t.variants.filter(function (t) {
        return e.every(function (e, i) {
          return t.options[i] === e;
        });
      });
      return i[0] || null;
    }
    function m(t, e) {
      g(t);
      y(e);
      const i = [];
      e.forEach(function (e) {
        for (let n = 0; n < t.options.length; n++)
          if (t.options[n].name.toLowerCase() === e.name.toLowerCase()) {
            i[n] = e.value;
            break;
          }
      });
      return i;
    }
    function g(t) {
      if (typeof t !== 'object') throw new TypeError(t + ' is not an object.');
      if (Object.keys(t).length === 0 && t.constructor === Object)
        throw new Error(t + ' is empty.');
    }
    function y(t) {
      if (!Array.isArray(t)) throw new TypeError(t + ' is not an array.');
      if (t.length === 0) return [];
      if (t[0].hasOwnProperty('name')) {
        if (typeof t[0].name !== 'string')
          throw new TypeError(
            'Invalid value type passed for name of option ' +
              t[0].name +
              '. Value should be string.'
          );
      } else throw new Error(t[0] + 'does not contain name key.');
    }
    function w(t) {
      if (Array.isArray(t) && typeof t[0] === 'object')
        throw new Error(t + 'is not a valid array of options.');
    }
    const b = i(501);
    class x {
      constructor(t) {
        this.confettiInterval = null;
        this.containerEl = null;
        this.confettiColors = ['#EF2964', '#00C09D', '#2D87B0', '#48485E', '#EFFF1D'];
        this.confettiAnimations = ['slow', 'medium', 'fast'];
        this.timeRun = 0;
        this.container = t;
        this.setupElement();
        this.render();
      }
      setupElement() {
        const t = document.createElement('div');
        const e = this.container.style.position;
        if (e !== 'relative' || e !== 'absolute') this.container.style.position = 'relative';
        t.classList.add('f-confetti-container');
        this.container.appendChild(t);
        this.containerEl = t;
      }
      stopConfetti() {
        clearInterval(this.confettiInterval);
        setTimeout(() => this.containerEl.remove(), 1500);
      }
      render() {
        this.confettiInterval = setInterval(() => {
          this.timeRun += 1;
          if (this.timeRun >= 160) this.stopConfetti();
          const t = document.createElement('div');
          const e = Math.floor(Math.random() * 3) + 7 + 'px';
          const i = this.confettiColors[Math.floor(Math.random() * this.confettiColors.length)];
          const n = Math.floor(Math.random() * this.container.offsetWidth) + 'px';
          const s =
            this.confettiAnimations[Math.floor(Math.random() * this.confettiAnimations.length)];
          t.classList.add('f-confetti', 'f-confetti--animation-' + s);
          t.style.left = n;
          t.style.width = e;
          t.style.height = e;
          t.style.backgroundColor = i;
          t.removeTimeout = setTimeout(function () {
            t.parentNode.removeChild(t);
          }, 3e3);
          this.containerEl.appendChild(t);
        }, 20);
      }
    }
    function _(t, e, i) {
      const n = document.createElement(e);
      if (t) n.className = t;
      if (i) i.appendChild(n);
      return n;
    }
    function S(t, e) {
      t.x = e.x;
      t.y = e.y;
      if (e.id !== void 0) t.id = e.id;
      return t;
    }
    function C(t) {
      t.x = Math.round(t.x);
      t.y = Math.round(t.y);
    }
    function E(t, e) {
      const i = Math.abs(t.x - e.x);
      const n = Math.abs(t.y - e.y);
      return Math.sqrt(i * i + n * n);
    }
    function P(t, e) {
      return t.x === e.x && t.y === e.y;
    }
    function A(t, e, i) {
      return Math.min(Math.max(t, e), i);
    }
    function T(t, e, i) {
      let n = `translate3d(${t}px,${e || 0}px,0)`;
      if (i !== void 0) n += ` scale3d(${i},${i},1)`;
      return n;
    }
    function D(t, e, i, n) {
      t.style.transform = T(e, i, n);
    }
    const L = 'cubic-bezier(.4,0,.22,1)';
    function O(t, e, i, n) {
      t.style.transition = e ? `${e} ${i}ms ${n || L}` : 'none';
    }
    function I(t, e, i) {
      t.style.width = typeof e === 'number' ? `${e}px` : e;
      t.style.height = typeof i === 'number' ? `${i}px` : i;
    }
    function M(t) {
      O(t);
    }
    function k(t) {
      if ('decode' in t) return t.decode().catch(() => {});
      if (t.complete) return Promise.resolve(t);
      return new Promise((e, i) => {
        t.onload = () => e(t);
        t.onerror = i;
      });
    }
    const z = { IDLE: 'idle', LOADING: 'loading', LOADED: 'loaded', ERROR: 'error' };
    function F(t) {
      return ('button' in t && t.button === 1) || t.ctrlKey || t.metaKey || t.altKey || t.shiftKey;
    }
    function R(t, e, i = document) {
      let n = [];
      if (t instanceof Element) n = [t];
      else if (t instanceof NodeList || Array.isArray(t)) n = Array.from(t);
      else {
        const s = typeof t === 'string' ? t : e;
        if (s) n = Array.from(i.querySelectorAll(s));
      }
      return n;
    }
    function V() {
      return !!(navigator.vendor && navigator.vendor.match(/apple/i));
    }
    let B = false;
    try {
      window.addEventListener(
        'test',
        null,
        Object.defineProperty({}, 'passive', {
          get: () => {
            B = true;
          },
        })
      );
    } catch (t) {}
    class N {
      constructor() {
        this._pool = [];
      }
      add(t, e, i, n) {
        this._toggleListener(t, e, i, n);
      }
      remove(t, e, i, n) {
        this._toggleListener(t, e, i, n, true);
      }
      removeAll() {
        this._pool.forEach((t) => {
          this._toggleListener(t.target, t.type, t.listener, t.passive, true, true);
        });
        this._pool = [];
      }
      _toggleListener(t, e, i, n, s, r) {
        if (!t) return;
        const o = s ? 'removeEventListener' : 'addEventListener';
        const a = e.split(' ');
        a.forEach((e) => {
          if (e) {
            if (!r)
              if (s)
                this._pool = this._pool.filter(
                  (n) => n.type !== e || n.listener !== i || n.target !== t
                );
              else this._pool.push({ target: t, type: e, listener: i, passive: n });
            const a = B ? { passive: n || false } : false;
            t[o](e, i, a);
          }
        });
      }
    }
    function W(t, e) {
      if (t.getViewportSizeFn) {
        const i = t.getViewportSizeFn(t, e);
        if (i) return i;
      }
      return { x: document.documentElement.clientWidth, y: window.innerHeight };
    }
    function Z(t, e, i, n, s) {
      let r = 0;
      if (e.paddingFn) r = e.paddingFn(i, n, s)[t];
      else if (e.padding) r = e.padding[t];
      else {
        const i = 'padding' + t[0].toUpperCase() + t.slice(1);
        if (e[i]) r = e[i];
      }
      return Number(r) || 0;
    }
    function H(t, e, i, n) {
      return {
        x: e.x - Z('left', t, e, i, n) - Z('right', t, e, i, n),
        y: e.y - Z('top', t, e, i, n) - Z('bottom', t, e, i, n),
      };
    }
    class j {
      constructor(t) {
        this.slide = t;
        this.currZoomLevel = 1;
        this.center = { x: 0, y: 0 };
        this.max = { x: 0, y: 0 };
        this.min = { x: 0, y: 0 };
      }
      update(t) {
        this.currZoomLevel = t;
        if (!this.slide.width) this.reset();
        else {
          this._updateAxis('x');
          this._updateAxis('y');
          this.slide.pswp.dispatch('calcBounds', { slide: this.slide });
        }
      }
      _updateAxis(t) {
        const { pswp: e } = this.slide;
        const i = this.slide[t === 'x' ? 'width' : 'height'] * this.currZoomLevel;
        const n = t === 'x' ? 'left' : 'top';
        const s = Z(n, e.options, e.viewportSize, this.slide.data, this.slide.index);
        const r = this.slide.panAreaSize[t];
        this.center[t] = Math.round((r - i) / 2) + s;
        this.max[t] = i > r ? Math.round(r - i) + s : this.center[t];
        this.min[t] = i > r ? s : this.center[t];
      }
      reset() {
        this.center.x = 0;
        this.center.y = 0;
        this.max.x = 0;
        this.max.y = 0;
        this.min.x = 0;
        this.min.y = 0;
      }
      correctPan(t, e) {
        return A(e, this.max[t], this.min[t]);
      }
    }
    const U = 4e3;
    class q {
      constructor(t, e, i, n) {
        this.pswp = n;
        this.options = t;
        this.itemData = e;
        this.index = i;
        this.panAreaSize = null;
        this.elementSize = null;
        this.fit = 1;
        this.fill = 1;
        this.vFill = 1;
        this.initial = 1;
        this.secondary = 1;
        this.max = 1;
        this.min = 1;
      }
      update(t, e, i) {
        const n = { x: t, y: e };
        this.elementSize = n;
        this.panAreaSize = i;
        const s = i.x / n.x;
        const r = i.y / n.y;
        this.fit = Math.min(1, s < r ? s : r);
        this.fill = Math.min(1, s > r ? s : r);
        this.vFill = Math.min(1, r);
        this.initial = this._getInitial();
        this.secondary = this._getSecondary();
        this.max = Math.max(this.initial, this.secondary, this._getMax());
        this.min = Math.min(this.fit, this.initial, this.secondary);
        if (this.pswp)
          this.pswp.dispatch('zoomLevelsUpdate', { zoomLevels: this, slideData: this.itemData });
      }
      _parseZoomLevelOption(t) {
        const e = t + 'ZoomLevel';
        const i = this.options[e];
        if (!i) return;
        if (typeof i === 'function') return i(this);
        if (i === 'fill') return this.fill;
        if (i === 'fit') return this.fit;
        return Number(i);
      }
      _getSecondary() {
        let t = this._parseZoomLevelOption('secondary');
        if (t) return t;
        t = Math.min(1, this.fit * 3);
        if (this.elementSize && t * this.elementSize.x > U) t = U / this.elementSize.x;
        return t;
      }
      _getInitial() {
        return this._parseZoomLevelOption('initial') || this.fit;
      }
      _getMax() {
        return this._parseZoomLevelOption('max') || Math.max(1, this.fit * 4);
      }
    }
    class $ {
      constructor(t, e, i) {
        this.data = t;
        this.index = e;
        this.pswp = i;
        this.isActive = e === i.currIndex;
        this.currentResolution = 0;
        this.panAreaSize = { x: 0, y: 0 };
        this.pan = { x: 0, y: 0 };
        this.isFirstSlide = this.isActive && !i.opener.isOpen;
        this.zoomLevels = new q(i.options, t, e, i);
        this.pswp.dispatch('gettingData', { slide: this, data: this.data, index: e });
        this.content = this.pswp.contentLoader.getContentBySlide(this);
        this.container = _('pswp__zoom-wrap', 'div');
        this.holderElement = null;
        this.currZoomLevel = 1;
        this.width = this.content.width;
        this.height = this.content.height;
        this.heavyAppended = false;
        this.bounds = new j(this);
        this.prevDisplayedWidth = -1;
        this.prevDisplayedHeight = -1;
        this.pswp.dispatch('slideInit', { slide: this });
      }
      setIsActive(t) {
        if (t && !this.isActive) this.activate();
        else if (!t && this.isActive) this.deactivate();
      }
      append(t) {
        this.holderElement = t;
        this.container.style.transformOrigin = '0 0';
        if (!this.data) return;
        this.calculateSize();
        this.load();
        this.updateContentSize();
        this.appendHeavy();
        this.holderElement.appendChild(this.container);
        this.zoomAndPanToInitial();
        this.pswp.dispatch('firstZoomPan', { slide: this });
        this.applyCurrentZoomPan();
        this.pswp.dispatch('afterSetContent', { slide: this });
        if (this.isActive) this.activate();
      }
      load() {
        this.content.load(false);
        this.pswp.dispatch('slideLoad', { slide: this });
      }
      appendHeavy() {
        const { pswp: t } = this;
        const e = true;
        if (
          this.heavyAppended ||
          !t.opener.isOpen ||
          t.mainScroll.isShifted() ||
          (!this.isActive && !e)
        )
          return;
        if (this.pswp.dispatch('appendHeavy', { slide: this }).defaultPrevented) return;
        this.heavyAppended = true;
        this.content.append();
        this.pswp.dispatch('appendHeavyContent', { slide: this });
      }
      activate() {
        this.isActive = true;
        this.appendHeavy();
        this.content.activate();
        this.pswp.dispatch('slideActivate', { slide: this });
      }
      deactivate() {
        this.isActive = false;
        this.content.deactivate();
        if (this.currZoomLevel !== this.zoomLevels.initial) this.calculateSize();
        this.currentResolution = 0;
        this.zoomAndPanToInitial();
        this.applyCurrentZoomPan();
        this.updateContentSize();
        this.pswp.dispatch('slideDeactivate', { slide: this });
      }
      destroy() {
        this.content.hasSlide = false;
        this.content.remove();
        this.container.remove();
        this.pswp.dispatch('slideDestroy', { slide: this });
      }
      resize() {
        if (this.currZoomLevel === this.zoomLevels.initial || !this.isActive) {
          this.calculateSize();
          this.currentResolution = 0;
          this.zoomAndPanToInitial();
          this.applyCurrentZoomPan();
          this.updateContentSize();
        } else {
          this.calculateSize();
          this.bounds.update(this.currZoomLevel);
          this.panTo(this.pan.x, this.pan.y);
        }
      }
      updateContentSize(t) {
        const e = this.currentResolution || this.zoomLevels.initial;
        if (!e) return;
        const i = Math.round(this.width * e) || this.pswp.viewportSize.x;
        const n = Math.round(this.height * e) || this.pswp.viewportSize.y;
        if (!this.sizeChanged(i, n) && !t) return;
        this.content.setDisplayedSize(i, n);
      }
      sizeChanged(t, e) {
        if (t !== this.prevDisplayedWidth || e !== this.prevDisplayedHeight) {
          this.prevDisplayedWidth = t;
          this.prevDisplayedHeight = e;
          return true;
        }
        return false;
      }
      getPlaceholderElement() {
        let t;
        return (t = this.content.placeholder) === null || t === void 0 ? void 0 : t.element;
      }
      zoomTo(t, e, i, n) {
        const { pswp: s } = this;
        if (!this.isZoomable() || s.mainScroll.isShifted()) return;
        s.dispatch('beforeZoomTo', { destZoomLevel: t, centerPoint: e, transitionDuration: i });
        s.animations.stopAllPan();
        const r = this.currZoomLevel;
        if (!n) t = A(t, this.zoomLevels.min, this.zoomLevels.max);
        this.setZoomLevel(t);
        this.pan.x = this.calculateZoomToPanOffset('x', e, r);
        this.pan.y = this.calculateZoomToPanOffset('y', e, r);
        C(this.pan);
        const o = () => {
          this._setResolution(t);
          this.applyCurrentZoomPan();
        };
        if (!i) o();
        else
          s.animations.startTransition({
            isPan: true,
            name: 'zoomTo',
            target: this.container,
            transform: this.getCurrentTransform(),
            onComplete: o,
            duration: i,
            easing: s.options.easing,
          });
      }
      toggleZoom(t) {
        this.zoomTo(
          this.currZoomLevel === this.zoomLevels.initial
            ? this.zoomLevels.secondary
            : this.zoomLevels.initial,
          t,
          this.pswp.options.zoomAnimationDuration
        );
      }
      setZoomLevel(t) {
        this.currZoomLevel = t;
        this.bounds.update(this.currZoomLevel);
      }
      calculateZoomToPanOffset(t, e, i) {
        const n = this.bounds.max[t] - this.bounds.min[t];
        if (n === 0) return this.bounds.center[t];
        if (!e) e = this.pswp.getViewportCenterPoint();
        if (!i) i = this.zoomLevels.initial;
        const s = this.currZoomLevel / i;
        return this.bounds.correctPan(t, (this.pan[t] - e[t]) * s + e[t]);
      }
      panTo(t, e) {
        this.pan.x = this.bounds.correctPan('x', t);
        this.pan.y = this.bounds.correctPan('y', e);
        this.applyCurrentZoomPan();
      }
      isPannable() {
        return Boolean(this.width) && this.currZoomLevel > this.zoomLevels.fit;
      }
      isZoomable() {
        return Boolean(this.width) && this.content.isZoomable();
      }
      applyCurrentZoomPan() {
        this._applyZoomTransform(this.pan.x, this.pan.y, this.currZoomLevel);
        if (this === this.pswp.currSlide) this.pswp.dispatch('zoomPanUpdate', { slide: this });
      }
      zoomAndPanToInitial() {
        this.currZoomLevel = this.zoomLevels.initial;
        this.bounds.update(this.currZoomLevel);
        S(this.pan, this.bounds.center);
        this.pswp.dispatch('initialZoomPan', { slide: this });
      }
      _applyZoomTransform(t, e, i) {
        i /= this.currentResolution || this.zoomLevels.initial;
        D(this.container, t, e, i);
      }
      calculateSize() {
        const { pswp: t } = this;
        S(this.panAreaSize, H(t.options, t.viewportSize, this.data, this.index));
        this.zoomLevels.update(this.width, this.height, this.panAreaSize);
        t.dispatch('calcSlideSize', { slide: this });
      }
      getCurrentTransform() {
        const t = this.currZoomLevel / (this.currentResolution || this.zoomLevels.initial);
        return T(this.pan.x, this.pan.y, t);
      }
      _setResolution(t) {
        if (t === this.currentResolution) return;
        this.currentResolution = t;
        this.updateContentSize();
        this.pswp.dispatch('resolutionChanged');
      }
    }
    const X = 0.35;
    const G = 0.6;
    const K = 0.4;
    const Y = 0.5;
    function Q(t, e) {
      return (t * e) / (1 - e);
    }
    class J {
      constructor(t) {
        this.gestures = t;
        this.pswp = t.pswp;
        this.startPan = { x: 0, y: 0 };
      }
      start() {
        if (this.pswp.currSlide) S(this.startPan, this.pswp.currSlide.pan);
        this.pswp.animations.stopAll();
      }
      change() {
        const { p1: t, prevP1: e, dragAxis: i } = this.gestures;
        const { currSlide: n } = this.pswp;
        if (
          i === 'y' &&
          this.pswp.options.closeOnVerticalDrag &&
          n &&
          n.currZoomLevel <= n.zoomLevels.fit &&
          !this.gestures.isMultitouch
        ) {
          const i = n.pan.y + (t.y - e.y);
          if (!this.pswp.dispatch('verticalDrag', { panY: i }).defaultPrevented) {
            this._setPanWithFriction('y', i, G);
            const t = 1 - Math.abs(this._getVerticalDragRatio(n.pan.y));
            this.pswp.applyBgOpacity(t);
            n.applyCurrentZoomPan();
          }
        } else {
          const t = this._panOrMoveMainScroll('x');
          if (!t) {
            this._panOrMoveMainScroll('y');
            if (n) {
              C(n.pan);
              n.applyCurrentZoomPan();
            }
          }
        }
      }
      end() {
        const { velocity: t } = this.gestures;
        const { mainScroll: e, currSlide: i } = this.pswp;
        let n = 0;
        this.pswp.animations.stopAll();
        if (e.isShifted()) {
          const i = e.x - e.getCurrSlideX();
          const s = i / this.pswp.viewportSize.x;
          if ((t.x < -Y && s < 0) || (t.x < 0.1 && s < -0.5)) {
            n = 1;
            t.x = Math.min(t.x, 0);
          } else if ((t.x > Y && s > 0) || (t.x > -0.1 && s > 0.5)) {
            n = -1;
            t.x = Math.max(t.x, 0);
          }
          e.moveIndexBy(n, true, t.x);
        }
        if ((i && i.currZoomLevel > i.zoomLevels.max) || this.gestures.isMultitouch)
          this.gestures.zoomLevels.correctZoomPan(true);
        else {
          this._finishPanGestureForAxis('x');
          this._finishPanGestureForAxis('y');
        }
      }
      _finishPanGestureForAxis(t) {
        const { velocity: e } = this.gestures;
        const { currSlide: i } = this.pswp;
        if (!i) return;
        const { pan: n, bounds: s } = i;
        const r = n[t];
        const o = this.pswp.bgOpacity < 1 && t === 'y';
        const a = 0.995;
        const l = r + Q(e[t], a);
        if (o) {
          const t = this._getVerticalDragRatio(r);
          const e = this._getVerticalDragRatio(l);
          if ((t < 0 && e < -K) || (t > 0 && e > K)) {
            this.pswp.close();
            return;
          }
        }
        const c = s.correctPan(t, l);
        if (r === c) return;
        const h = c === l ? 1 : 0.82;
        const u = this.pswp.bgOpacity;
        const d = c - r;
        this.pswp.animations.startSpring({
          name: 'panGesture' + t,
          isPan: true,
          start: r,
          end: c,
          velocity: e[t],
          dampingRatio: h,
          onUpdate: (e) => {
            if (o && this.pswp.bgOpacity < 1) {
              const t = 1 - (c - e) / d;
              this.pswp.applyBgOpacity(A(u + (1 - u) * t, 0, 1));
            }
            n[t] = Math.floor(e);
            i.applyCurrentZoomPan();
          },
        });
      }
      _panOrMoveMainScroll(t) {
        const { p1: e, dragAxis: i, prevP1: n, isMultitouch: s } = this.gestures;
        const { currSlide: r, mainScroll: o } = this.pswp;
        const a = e[t] - n[t];
        const l = o.x + a;
        if (!a || !r) return false;
        if (t === 'x' && !r.isPannable() && !s) {
          o.moveTo(l, true);
          return true;
        }
        const { bounds: c } = r;
        const h = r.pan[t] + a;
        if (this.pswp.options.allowPanToNext && i === 'x' && t === 'x' && !s) {
          const e = o.getCurrSlideX();
          const i = o.x - e;
          const n = a > 0;
          const s = !n;
          if (h > c.min[t] && n) {
            const e = c.min[t] <= this.startPan[t];
            if (e) {
              o.moveTo(l, true);
              return true;
            } else this._setPanWithFriction(t, h);
          } else if (h < c.max[t] && s) {
            const e = this.startPan[t] <= c.max[t];
            if (e) {
              o.moveTo(l, true);
              return true;
            } else this._setPanWithFriction(t, h);
          } else if (i !== 0) {
            if (i > 0) {
              o.moveTo(Math.max(l, e), true);
              return true;
            } else if (i < 0) {
              o.moveTo(Math.min(l, e), true);
              return true;
            }
          } else this._setPanWithFriction(t, h);
        } else if (t === 'y') {
          if (!o.isShifted() && c.min.y !== c.max.y) this._setPanWithFriction(t, h);
        } else this._setPanWithFriction(t, h);
        return false;
      }
      _getVerticalDragRatio(t) {
        let e, i;
        return (
          (t -
            ((e =
              (i = this.pswp.currSlide) === null || i === void 0 ? void 0 : i.bounds.center.y) !==
              null && e !== void 0
              ? e
              : 0)) /
          (this.pswp.viewportSize.y / 3)
        );
      }
      _setPanWithFriction(t, e, i) {
        const { currSlide: n } = this.pswp;
        if (!n) return;
        const { pan: s, bounds: r } = n;
        const o = r.correctPan(t, e);
        if (o !== e || i) {
          const n = Math.round(e - s[t]);
          s[t] += n * (i || X);
        } else s[t] = e;
      }
    }
    const tt = 0.05;
    const et = 0.15;
    function it(t, e, i) {
      t.x = (e.x + i.x) / 2;
      t.y = (e.y + i.y) / 2;
      return t;
    }
    class nt {
      constructor(t) {
        this.gestures = t;
        this._startPan = { x: 0, y: 0 };
        this._startZoomPoint = { x: 0, y: 0 };
        this._zoomPoint = { x: 0, y: 0 };
        this._wasOverFitZoomLevel = false;
        this._startZoomLevel = 1;
      }
      start() {
        const { currSlide: t } = this.gestures.pswp;
        if (t) {
          this._startZoomLevel = t.currZoomLevel;
          S(this._startPan, t.pan);
        }
        this.gestures.pswp.animations.stopAllPan();
        this._wasOverFitZoomLevel = false;
      }
      change() {
        const { p1: t, startP1: e, p2: i, startP2: n, pswp: s } = this.gestures;
        const { currSlide: r } = s;
        if (!r) return;
        const o = r.zoomLevels.min;
        const a = r.zoomLevels.max;
        if (!r.isZoomable() || s.mainScroll.isShifted()) return;
        it(this._startZoomPoint, e, n);
        it(this._zoomPoint, t, i);
        let l = (1 / E(e, n)) * E(t, i) * this._startZoomLevel;
        if (l > r.zoomLevels.initial + r.zoomLevels.initial / 15) this._wasOverFitZoomLevel = true;
        if (l < o)
          if (
            s.options.pinchToClose &&
            !this._wasOverFitZoomLevel &&
            this._startZoomLevel <= r.zoomLevels.initial
          ) {
            const t = 1 - (o - l) / (o / 1.2);
            if (!s.dispatch('pinchClose', { bgOpacity: t }).defaultPrevented) s.applyBgOpacity(t);
          } else l = o - (o - l) * et;
        else if (l > a) l = a + (l - a) * tt;
        r.pan.x = this._calculatePanForZoomLevel('x', l);
        r.pan.y = this._calculatePanForZoomLevel('y', l);
        r.setZoomLevel(l);
        r.applyCurrentZoomPan();
      }
      end() {
        const { pswp: t } = this.gestures;
        const { currSlide: e } = t;
        if (
          (!e || e.currZoomLevel < e.zoomLevels.initial) &&
          !this._wasOverFitZoomLevel &&
          t.options.pinchToClose
        )
          t.close();
        else this.correctZoomPan();
      }
      _calculatePanForZoomLevel(t, e) {
        const i = e / this._startZoomLevel;
        return this._zoomPoint[t] - (this._startZoomPoint[t] - this._startPan[t]) * i;
      }
      correctZoomPan(t) {
        const { pswp: e } = this.gestures;
        const { currSlide: i } = e;
        if (!(i !== null && i !== void 0 && i.isZoomable())) return;
        if (this._zoomPoint.x === 0) t = true;
        const n = i.currZoomLevel;
        let s;
        let r = true;
        if (n < i.zoomLevels.initial) s = i.zoomLevels.initial;
        else if (n > i.zoomLevels.max) s = i.zoomLevels.max;
        else {
          r = false;
          s = n;
        }
        const o = e.bgOpacity;
        const a = e.bgOpacity < 1;
        const l = S({ x: 0, y: 0 }, i.pan);
        let c = S({ x: 0, y: 0 }, l);
        if (t) {
          this._zoomPoint.x = 0;
          this._zoomPoint.y = 0;
          this._startZoomPoint.x = 0;
          this._startZoomPoint.y = 0;
          this._startZoomLevel = n;
          S(this._startPan, l);
        }
        if (r)
          c = {
            x: this._calculatePanForZoomLevel('x', s),
            y: this._calculatePanForZoomLevel('y', s),
          };
        i.setZoomLevel(s);
        c = { x: i.bounds.correctPan('x', c.x), y: i.bounds.correctPan('y', c.y) };
        i.setZoomLevel(n);
        const h = !P(c, l);
        if (!h && !r && !a) {
          i._setResolution(s);
          i.applyCurrentZoomPan();
          return;
        }
        e.animations.stopAllPan();
        e.animations.startSpring({
          isPan: true,
          start: 0,
          end: 1e3,
          velocity: 0,
          dampingRatio: 1,
          naturalFrequency: 40,
          onUpdate: (t) => {
            t /= 1e3;
            if (h || r) {
              if (h) {
                i.pan.x = l.x + (c.x - l.x) * t;
                i.pan.y = l.y + (c.y - l.y) * t;
              }
              if (r) {
                const e = n + (s - n) * t;
                i.setZoomLevel(e);
              }
              i.applyCurrentZoomPan();
            }
            if (a && e.bgOpacity < 1) e.applyBgOpacity(A(o + (1 - o) * t, 0, 1));
          },
          onComplete: () => {
            i._setResolution(s);
            i.applyCurrentZoomPan();
          },
        });
      }
    }
    function st(t) {
      return !!t.target.closest('.pswp__container');
    }
    class rt {
      constructor(t) {
        this.gestures = t;
      }
      click(t, e) {
        const i = e.target.classList;
        const n = i.contains('pswp__img');
        const s = i.contains('pswp__item') || i.contains('pswp__zoom-wrap');
        if (n) this._doClickOrTapAction('imageClick', t, e);
        else if (s) this._doClickOrTapAction('bgClick', t, e);
      }
      tap(t, e) {
        if (st(e)) this._doClickOrTapAction('tap', t, e);
      }
      doubleTap(t, e) {
        if (st(e)) this._doClickOrTapAction('doubleTap', t, e);
      }
      _doClickOrTapAction(t, e, i) {
        let n;
        const { pswp: s } = this.gestures;
        const { currSlide: r } = s;
        const o = t + 'Action';
        const a = s.options[o];
        if (s.dispatch(o, { point: e, originalEvent: i }).defaultPrevented) return;
        if (typeof a === 'function') {
          a.call(s, e, i);
          return;
        }
        switch (a) {
          case 'close':
          case 'next':
            s[a]();
            break;
          case 'zoom':
            r === null || r === void 0 || r.toggleZoom(e);
            break;
          case 'zoom-or-close':
            if (
              r !== null &&
              r !== void 0 &&
              r.isZoomable() &&
              r.zoomLevels.secondary !== r.zoomLevels.initial
            )
              r.toggleZoom(e);
            else if (s.options.clickToCloseNonZoomable) s.close();
            break;
          case 'toggle-controls':
            (n = this.gestures.pswp.element) === null ||
              n === void 0 ||
              n.classList.toggle('pswp--ui-visible');
            break;
        }
      }
    }
    const ot = 10;
    const at = 300;
    const lt = 25;
    class ct {
      constructor(t) {
        this.pswp = t;
        this.dragAxis = null;
        this.p1 = { x: 0, y: 0 };
        this.p2 = { x: 0, y: 0 };
        this.prevP1 = { x: 0, y: 0 };
        this.prevP2 = { x: 0, y: 0 };
        this.startP1 = { x: 0, y: 0 };
        this.startP2 = { x: 0, y: 0 };
        this.velocity = { x: 0, y: 0 };
        this._lastStartP1 = { x: 0, y: 0 };
        this._intervalP1 = { x: 0, y: 0 };
        this._numActivePoints = 0;
        this._ongoingPointers = [];
        this._touchEventEnabled = 'ontouchstart' in window;
        this._pointerEventEnabled = !!window.PointerEvent;
        this.supportsTouch =
          this._touchEventEnabled || (this._pointerEventEnabled && navigator.maxTouchPoints > 1);
        this._numActivePoints = 0;
        this._intervalTime = 0;
        this._velocityCalculated = false;
        this.isMultitouch = false;
        this.isDragging = false;
        this.isZooming = false;
        this.raf = null;
        this._tapTimer = null;
        if (!this.supportsTouch) t.options.allowPanToNext = false;
        this.drag = new J(this);
        this.zoomLevels = new nt(this);
        this.tapHandler = new rt(this);
        t.on('bindEvents', () => {
          t.events.add(t.scrollWrap, 'click', this._onClick.bind(this));
          if (this._pointerEventEnabled) this._bindEvents('pointer', 'down', 'up', 'cancel');
          else if (this._touchEventEnabled) {
            this._bindEvents('touch', 'start', 'end', 'cancel');
            if (t.scrollWrap) {
              t.scrollWrap.ontouchmove = () => {};
              t.scrollWrap.ontouchend = () => {};
            }
          } else this._bindEvents('mouse', 'down', 'up');
        });
      }
      _bindEvents(t, e, i, n) {
        const { pswp: s } = this;
        const { events: r } = s;
        const o = n ? t + n : '';
        r.add(s.scrollWrap, t + e, this.onPointerDown.bind(this));
        r.add(window, t + 'move', this.onPointerMove.bind(this));
        r.add(window, t + i, this.onPointerUp.bind(this));
        if (o) r.add(s.scrollWrap, o, this.onPointerUp.bind(this));
      }
      onPointerDown(t) {
        const e = t.type === 'mousedown' || t.pointerType === 'mouse';
        if (e && t.button > 0) return;
        const { pswp: i } = this;
        if (!i.opener.isOpen) {
          t.preventDefault();
          return;
        }
        if (i.dispatch('pointerDown', { originalEvent: t }).defaultPrevented) return;
        if (e) {
          i.mouseDetected();
          this._preventPointerEventBehaviour(t, 'down');
        }
        i.animations.stopAll();
        this._updatePoints(t, 'down');
        if (this._numActivePoints === 1) {
          this.dragAxis = null;
          S(this.startP1, this.p1);
        }
        if (this._numActivePoints > 1) {
          this._clearTapTimer();
          this.isMultitouch = true;
        } else this.isMultitouch = false;
      }
      onPointerMove(t) {
        this._preventPointerEventBehaviour(t, 'move');
        if (!this._numActivePoints) return;
        this._updatePoints(t, 'move');
        if (this.pswp.dispatch('pointerMove', { originalEvent: t }).defaultPrevented) return;
        if (this._numActivePoints === 1 && !this.isDragging) {
          if (!this.dragAxis) this._calculateDragDirection();
          if (this.dragAxis && !this.isDragging) {
            if (this.isZooming) {
              this.isZooming = false;
              this.zoomLevels.end();
            }
            this.isDragging = true;
            this._clearTapTimer();
            this._updateStartPoints();
            this._intervalTime = Date.now();
            this._velocityCalculated = false;
            S(this._intervalP1, this.p1);
            this.velocity.x = 0;
            this.velocity.y = 0;
            this.drag.start();
            this._rafStopLoop();
            this._rafRenderLoop();
          }
        } else if (this._numActivePoints > 1 && !this.isZooming) {
          this._finishDrag();
          this.isZooming = true;
          this._updateStartPoints();
          this.zoomLevels.start();
          this._rafStopLoop();
          this._rafRenderLoop();
        }
      }
      _finishDrag() {
        if (this.isDragging) {
          this.isDragging = false;
          if (!this._velocityCalculated) this._updateVelocity(true);
          this.drag.end();
          this.dragAxis = null;
        }
      }
      onPointerUp(t) {
        if (!this._numActivePoints) return;
        this._updatePoints(t, 'up');
        if (this.pswp.dispatch('pointerUp', { originalEvent: t }).defaultPrevented) return;
        if (this._numActivePoints === 0) {
          this._rafStopLoop();
          if (this.isDragging) this._finishDrag();
          else if (!this.isZooming && !this.isMultitouch) this._finishTap(t);
        }
        if (this._numActivePoints < 2 && this.isZooming) {
          this.isZooming = false;
          this.zoomLevels.end();
          if (this._numActivePoints === 1) {
            this.dragAxis = null;
            this._updateStartPoints();
          }
        }
      }
      _rafRenderLoop() {
        if (this.isDragging || this.isZooming) {
          this._updateVelocity();
          if (this.isDragging) {
            if (!P(this.p1, this.prevP1)) this.drag.change();
          } else if (!P(this.p1, this.prevP1) || !P(this.p2, this.prevP2)) this.zoomLevels.change();
          this._updatePrevPoints();
          this.raf = requestAnimationFrame(this._rafRenderLoop.bind(this));
        }
      }
      _updateVelocity(t) {
        const e = Date.now();
        const i = e - this._intervalTime;
        if (i < 50 && !t) return;
        this.velocity.x = this._getVelocity('x', i);
        this.velocity.y = this._getVelocity('y', i);
        this._intervalTime = e;
        S(this._intervalP1, this.p1);
        this._velocityCalculated = true;
      }
      _finishTap(t) {
        const { mainScroll: e } = this.pswp;
        if (e.isShifted()) {
          e.moveIndexBy(0, true);
          return;
        }
        if (t.type.indexOf('cancel') > 0) return;
        if (t.type === 'mouseup' || t.pointerType === 'mouse') {
          this.tapHandler.click(this.startP1, t);
          return;
        }
        const i = this.pswp.options.doubleTapAction ? at : 0;
        if (this._tapTimer) {
          this._clearTapTimer();
          if (E(this._lastStartP1, this.startP1) < lt) this.tapHandler.doubleTap(this.startP1, t);
        } else {
          S(this._lastStartP1, this.startP1);
          this._tapTimer = setTimeout(() => {
            this.tapHandler.tap(this.startP1, t);
            this._clearTapTimer();
          }, i);
        }
      }
      _clearTapTimer() {
        if (this._tapTimer) {
          clearTimeout(this._tapTimer);
          this._tapTimer = null;
        }
      }
      _getVelocity(t, e) {
        const i = this.p1[t] - this._intervalP1[t];
        if (Math.abs(i) > 1 && e > 5) return i / e;
        return 0;
      }
      _rafStopLoop() {
        if (this.raf) {
          cancelAnimationFrame(this.raf);
          this.raf = null;
        }
      }
      _preventPointerEventBehaviour(t, e) {
        const i = this.pswp.applyFilters('preventPointerEvent', true, t, e);
        if (i) t.preventDefault();
      }
      _updatePoints(t, e) {
        if (this._pointerEventEnabled) {
          const i = t;
          const n = this._ongoingPointers.findIndex((t) => t.id === i.pointerId);
          if (e === 'up' && n > -1) this._ongoingPointers.splice(n, 1);
          else if (e === 'down' && n === -1)
            this._ongoingPointers.push(this._convertEventPosToPoint(i, { x: 0, y: 0 }));
          else if (n > -1) this._convertEventPosToPoint(i, this._ongoingPointers[n]);
          this._numActivePoints = this._ongoingPointers.length;
          if (this._numActivePoints > 0) S(this.p1, this._ongoingPointers[0]);
          if (this._numActivePoints > 1) S(this.p2, this._ongoingPointers[1]);
        } else {
          const i = t;
          this._numActivePoints = 0;
          if (i.type.indexOf('touch') > -1) {
            if (i.touches && i.touches.length > 0) {
              this._convertEventPosToPoint(i.touches[0], this.p1);
              this._numActivePoints++;
              if (i.touches.length > 1) {
                this._convertEventPosToPoint(i.touches[1], this.p2);
                this._numActivePoints++;
              }
            }
          } else {
            this._convertEventPosToPoint(t, this.p1);
            if (e === 'up') this._numActivePoints = 0;
            else this._numActivePoints++;
          }
        }
      }
      _updatePrevPoints() {
        S(this.prevP1, this.p1);
        S(this.prevP2, this.p2);
      }
      _updateStartPoints() {
        S(this.startP1, this.p1);
        S(this.startP2, this.p2);
        this._updatePrevPoints();
      }
      _calculateDragDirection() {
        if (this.pswp.mainScroll.isShifted()) this.dragAxis = 'x';
        else {
          const t = Math.abs(this.p1.x - this.startP1.x) - Math.abs(this.p1.y - this.startP1.y);
          if (t !== 0) {
            const e = t > 0 ? 'x' : 'y';
            if (Math.abs(this.p1[e] - this.startP1[e]) >= ot) this.dragAxis = e;
          }
        }
      }
      _convertEventPosToPoint(t, e) {
        e.x = t.pageX - this.pswp.offset.x;
        e.y = t.pageY - this.pswp.offset.y;
        if ('pointerId' in t) e.id = t.pointerId;
        else if (t.identifier !== void 0) e.id = t.identifier;
        return e;
      }
      _onClick(t) {
        if (this.pswp.mainScroll.isShifted()) {
          t.preventDefault();
          t.stopPropagation();
        }
      }
    }
    const ht = 0.35;
    class ut {
      constructor(t) {
        this.pswp = t;
        this.x = 0;
        this.slideWidth = 0;
        this._currPositionIndex = 0;
        this._prevPositionIndex = 0;
        this._containerShiftIndex = -1;
        this.itemHolders = [];
      }
      resize(t) {
        const { pswp: e } = this;
        const i = Math.round(e.viewportSize.x + e.viewportSize.x * e.options.spacing);
        const n = i !== this.slideWidth;
        if (n) {
          this.slideWidth = i;
          this.moveTo(this.getCurrSlideX());
        }
        this.itemHolders.forEach((e, i) => {
          if (n) D(e.el, (i + this._containerShiftIndex) * this.slideWidth);
          if (t && e.slide) e.slide.resize();
        });
      }
      resetPosition() {
        this._currPositionIndex = 0;
        this._prevPositionIndex = 0;
        this.slideWidth = 0;
        this._containerShiftIndex = -1;
      }
      appendHolders() {
        this.itemHolders = [];
        for (let t = 0; t < 3; t++) {
          const e = _('pswp__item', 'div', this.pswp.container);
          e.setAttribute('role', 'group');
          e.setAttribute('aria-roledescription', 'slide');
          e.setAttribute('aria-hidden', 'true');
          e.style.display = t === 1 ? 'block' : 'none';
          this.itemHolders.push({ el: e });
        }
      }
      canBeSwiped() {
        return this.pswp.getNumItems() > 1;
      }
      moveIndexBy(t, e, i) {
        const { pswp: n } = this;
        let s = n.potentialIndex + t;
        const r = n.getNumItems();
        if (n.canLoop()) {
          s = n.getLoopedIndex(s);
          const e = (t + r) % r;
          if (e <= r / 2) t = e;
          else t = e - r;
        } else {
          if (s < 0) s = 0;
          else if (s >= r) s = r - 1;
          t = s - n.potentialIndex;
        }
        n.potentialIndex = s;
        this._currPositionIndex -= t;
        n.animations.stopMainScroll();
        const o = this.getCurrSlideX();
        if (!e) {
          this.moveTo(o);
          this.updateCurrItem();
        } else {
          n.animations.startSpring({
            isMainScroll: true,
            start: this.x,
            end: o,
            velocity: i || 0,
            naturalFrequency: 30,
            dampingRatio: 1,
            onUpdate: (t) => {
              this.moveTo(t);
            },
            onComplete: () => {
              this.updateCurrItem();
              n.appendHeavy();
            },
          });
          let t = n.potentialIndex - n.currIndex;
          if (n.canLoop()) {
            const e = (t + r) % r;
            if (e <= r / 2) t = e;
            else t = e - r;
          }
          if (Math.abs(t) > 1) this.updateCurrItem();
        }
        return Boolean(t);
      }
      getCurrSlideX() {
        return this.slideWidth * this._currPositionIndex;
      }
      isShifted() {
        return this.x !== this.getCurrSlideX();
      }
      updateCurrItem() {
        let t;
        const { pswp: e } = this;
        const i = this._prevPositionIndex - this._currPositionIndex;
        if (!i) return;
        this._prevPositionIndex = this._currPositionIndex;
        e.currIndex = e.potentialIndex;
        let n = Math.abs(i);
        let s;
        if (n >= 3) {
          this._containerShiftIndex += i + (i > 0 ? -3 : 3);
          n = 3;
          this.itemHolders.forEach((t) => {
            let e;
            (e = t.slide) === null || e === void 0 || e.destroy();
            t.slide = void 0;
          });
        }
        for (let t = 0; t < n; t++)
          if (i > 0) {
            s = this.itemHolders.shift();
            if (s) {
              this.itemHolders[2] = s;
              this._containerShiftIndex++;
              D(s.el, (this._containerShiftIndex + 2) * this.slideWidth);
              e.setContent(s, e.currIndex - n + t + 2);
            }
          } else {
            s = this.itemHolders.pop();
            if (s) {
              this.itemHolders.unshift(s);
              this._containerShiftIndex--;
              D(s.el, this._containerShiftIndex * this.slideWidth);
              e.setContent(s, e.currIndex + n - t - 2);
            }
          }
        if (Math.abs(this._containerShiftIndex) > 50 && !this.isShifted()) {
          this.resetPosition();
          this.resize();
        }
        e.animations.stopAllPan();
        this.itemHolders.forEach((t, e) => {
          if (t.slide) t.slide.setIsActive(e === 1);
        });
        e.currSlide = (t = this.itemHolders[1]) === null || t === void 0 ? void 0 : t.slide;
        e.contentLoader.updateLazy(i);
        if (e.currSlide) e.currSlide.applyCurrentZoomPan();
        e.dispatch('change');
      }
      moveTo(t, e) {
        if (!this.pswp.canLoop() && e) {
          let e = (this.slideWidth * this._currPositionIndex - t) / this.slideWidth;
          e += this.pswp.currIndex;
          const i = Math.round(t - this.x);
          if ((e < 0 && i > 0) || (e >= this.pswp.getNumItems() - 1 && i < 0)) t = this.x + i * ht;
        }
        this.x = t;
        if (this.pswp.container) D(this.pswp.container, t);
        this.pswp.dispatch('moveMainScroll', {
          x: t,
          dragging: e !== null && e !== void 0 ? e : false,
        });
      }
    }
    const dt = {
      Escape: 27,
      z: 90,
      ArrowLeft: 37,
      ArrowUp: 38,
      ArrowRight: 39,
      ArrowDown: 40,
      Tab: 9,
    };
    const ft = (t, e) => (e ? t : dt[t]);
    class pt {
      constructor(t) {
        this.pswp = t;
        this._wasFocused = false;
        t.on('bindEvents', () => {
          if (t.options.trapFocus) {
            if (!t.options.initialPointerPos) this._focusRoot();
            t.events.add(document, 'focusin', this._onFocusIn.bind(this));
          }
          t.events.add(document, 'keydown', this._onKeyDown.bind(this));
        });
        const e = document.activeElement;
        t.on('destroy', () => {
          if (t.options.returnFocus && e && this._wasFocused) e.focus();
        });
      }
      _focusRoot() {
        if (!this._wasFocused && this.pswp.element) {
          this.pswp.element.focus();
          this._wasFocused = true;
        }
      }
      _onKeyDown(t) {
        const { pswp: e } = this;
        if (e.dispatch('keydown', { originalEvent: t }).defaultPrevented) return;
        if (F(t)) return;
        let i;
        let n;
        let s = false;
        const r = 'key' in t;
        switch (r ? t.key : t.keyCode) {
          case ft('Escape', r):
            if (e.options.escKey) i = 'close';
            break;
          case ft('z', r):
            i = 'toggleZoom';
            break;
          case ft('ArrowLeft', r):
            n = 'x';
            break;
          case ft('ArrowUp', r):
            n = 'y';
            break;
          case ft('ArrowRight', r):
            n = 'x';
            s = true;
            break;
          case ft('ArrowDown', r):
            s = true;
            n = 'y';
            break;
          case ft('Tab', r):
            this._focusRoot();
            break;
        }
        if (n) {
          t.preventDefault();
          const { currSlide: r } = e;
          if (e.options.arrowKeys && n === 'x' && e.getNumItems() > 1) i = s ? 'next' : 'prev';
          else if (r && r.currZoomLevel > r.zoomLevels.fit) {
            r.pan[n] += s ? -80 : 80;
            r.panTo(r.pan.x, r.pan.y);
          }
        }
        if (i) {
          t.preventDefault();
          e[i]();
        }
      }
      _onFocusIn(t) {
        const { template: e } = this.pswp;
        if (e && document !== t.target && e !== t.target && !e.contains(t.target)) e.focus();
      }
    }
    const vt = 'cubic-bezier(.4,0,.22,1)';
    class mt {
      constructor(t) {
        let e;
        this.props = t;
        const {
          target: i,
          onComplete: n,
          transform: s,
          onFinish: r = () => {},
          duration: o = 333,
          easing: a = vt,
        } = t;
        this.onFinish = r;
        const l = s ? 'transform' : 'opacity';
        const c = (e = t[l]) !== null && e !== void 0 ? e : '';
        this._target = i;
        this._onComplete = n;
        this._finished = false;
        this._onTransitionEnd = this._onTransitionEnd.bind(this);
        this._helperTimeout = setTimeout(() => {
          O(i, l, o, a);
          this._helperTimeout = setTimeout(() => {
            i.addEventListener('transitionend', this._onTransitionEnd, false);
            i.addEventListener('transitioncancel', this._onTransitionEnd, false);
            this._helperTimeout = setTimeout(() => {
              this._finalizeAnimation();
            }, o + 500);
            i.style[l] = c;
          }, 30);
        }, 0);
      }
      _onTransitionEnd(t) {
        if (t.target === this._target) this._finalizeAnimation();
      }
      _finalizeAnimation() {
        if (!this._finished) {
          this._finished = true;
          this.onFinish();
          if (this._onComplete) this._onComplete();
        }
      }
      destroy() {
        if (this._helperTimeout) clearTimeout(this._helperTimeout);
        M(this._target);
        this._target.removeEventListener('transitionend', this._onTransitionEnd, false);
        this._target.removeEventListener('transitioncancel', this._onTransitionEnd, false);
        if (!this._finished) this._finalizeAnimation();
      }
    }
    const gt = 12;
    const yt = 0.75;
    class wt {
      constructor(t, e, i) {
        this.velocity = t * 1e3;
        this._dampingRatio = e || yt;
        this._naturalFrequency = i || gt;
        this._dampedFrequency = this._naturalFrequency;
        if (this._dampingRatio < 1)
          this._dampedFrequency *= Math.sqrt(1 - this._dampingRatio * this._dampingRatio);
      }
      easeFrame(t, e) {
        let i = 0;
        let n;
        e /= 1e3;
        const s = Math.E ** (-this._dampingRatio * this._naturalFrequency * e);
        if (this._dampingRatio === 1) {
          n = this.velocity + this._naturalFrequency * t;
          i = (t + n * e) * s;
          this.velocity = i * -this._naturalFrequency + n * s;
        } else if (this._dampingRatio < 1) {
          n =
            (1 / this._dampedFrequency) *
            (this._dampingRatio * this._naturalFrequency * t + this.velocity);
          const r = Math.cos(this._dampedFrequency * e);
          const o = Math.sin(this._dampedFrequency * e);
          i = s * (t * r + n * o);
          this.velocity =
            i * -this._naturalFrequency * this._dampingRatio +
            s * (-this._dampedFrequency * t * o + this._dampedFrequency * n * r);
        }
        return i;
      }
    }
    class bt {
      constructor(t) {
        this.props = t;
        this._raf = 0;
        const {
          start: e,
          end: i,
          velocity: n,
          onUpdate: s,
          onComplete: r,
          onFinish: o = () => {},
          dampingRatio: a,
          naturalFrequency: l,
        } = t;
        this.onFinish = o;
        const c = new wt(n, a, l);
        let h = Date.now();
        let u = e - i;
        const d = () => {
          if (this._raf) {
            u = c.easeFrame(u, Date.now() - h);
            if (Math.abs(u) < 1 && Math.abs(c.velocity) < 50) {
              s(i);
              if (r) r();
              this.onFinish();
            } else {
              h = Date.now();
              s(u + i);
              this._raf = requestAnimationFrame(d);
            }
          }
        };
        this._raf = requestAnimationFrame(d);
      }
      destroy() {
        if (this._raf >= 0) cancelAnimationFrame(this._raf);
        this._raf = 0;
      }
    }
    class xt {
      constructor() {
        this.activeAnimations = [];
      }
      startSpring(t) {
        this._start(t, true);
      }
      startTransition(t) {
        this._start(t);
      }
      _start(t, e) {
        const i = e ? new bt(t) : new mt(t);
        this.activeAnimations.push(i);
        i.onFinish = () => this.stop(i);
        return i;
      }
      stop(t) {
        t.destroy();
        const e = this.activeAnimations.indexOf(t);
        if (e > -1) this.activeAnimations.splice(e, 1);
      }
      stopAll() {
        this.activeAnimations.forEach((t) => {
          t.destroy();
        });
        this.activeAnimations = [];
      }
      stopAllPan() {
        this.activeAnimations = this.activeAnimations.filter((t) => {
          if (t.props.isPan) {
            t.destroy();
            return false;
          }
          return true;
        });
      }
      stopMainScroll() {
        this.activeAnimations = this.activeAnimations.filter((t) => {
          if (t.props.isMainScroll) {
            t.destroy();
            return false;
          }
          return true;
        });
      }
      isPanRunning() {
        return this.activeAnimations.some((t) => t.props.isPan);
      }
    }
    class _t {
      constructor(t) {
        this.pswp = t;
        t.events.add(t.element, 'wheel', this._onWheel.bind(this));
      }
      _onWheel(t) {
        t.preventDefault();
        const { currSlide: e } = this.pswp;
        let { deltaX: i, deltaY: n } = t;
        if (!e) return;
        if (this.pswp.dispatch('wheel', { originalEvent: t }).defaultPrevented) return;
        if (t.ctrlKey || this.pswp.options.wheelToZoom) {
          if (e.isZoomable()) {
            let i = -n;
            if (t.deltaMode === 1) i *= 0.05;
            else i *= t.deltaMode ? 1 : 0.002;
            i = 2 ** i;
            const s = e.currZoomLevel * i;
            e.zoomTo(s, { x: t.clientX, y: t.clientY });
          }
        } else if (e.isPannable()) {
          if (t.deltaMode === 1) {
            i *= 18;
            n *= 18;
          }
          e.panTo(e.pan.x - i, e.pan.y - n);
        }
      }
    }
    function St(t) {
      if (typeof t === 'string') return t;
      if (!t || !t.isCustomSVG) return '';
      const e = t;
      let i =
        '<svg aria-hidden="true" class="pswp__icn" viewBox="0 0 %d %d" width="%d" height="%d">';
      i = i.split('%d').join(e.size || 32);
      if (e.outlineID) i += '<use class="pswp__icn-shadow" xlink:href="#' + e.outlineID + '"/>';
      i += e.inner;
      i += '</svg>';
      return i;
    }
    class Ct {
      constructor(t, e) {
        let i;
        const n = e.name || e.className;
        let s = e.html;
        if (t.options[n] === false) return;
        if (typeof t.options[n + 'SVG'] === 'string') s = t.options[n + 'SVG'];
        t.dispatch('uiElementCreate', { data: e });
        let r = '';
        if (e.isButton) {
          r += 'pswp__button ';
          r += e.className || `pswp__button--${e.name}`;
        } else r += e.className || `pswp__${e.name}`;
        let o = e.isButton ? e.tagName || 'button' : e.tagName || 'div';
        o = o.toLowerCase();
        const a = _(r, o);
        if (e.isButton) {
          if (o === 'button') a.type = 'button';
          let { title: i } = e;
          const { ariaLabel: s } = e;
          if (typeof t.options[n + 'Title'] === 'string') i = t.options[n + 'Title'];
          if (i) a.title = i;
          const r = s || i;
          if (r) a.setAttribute('aria-label', r);
        }
        a.innerHTML = St(s);
        if (e.onInit) e.onInit(a, t);
        if (e.onClick)
          a.onclick = (i) => {
            if (typeof e.onClick === 'string') t[e.onClick]();
            else if (typeof e.onClick === 'function') e.onClick(i, a, t);
          };
        const l = e.appendTo || 'bar';
        let c = t.element;
        if (l === 'bar') {
          if (!t.topBar) t.topBar = _('pswp__top-bar pswp__hide-on-close', 'div', t.scrollWrap);
          c = t.topBar;
        } else {
          a.classList.add('pswp__hide-on-close');
          if (l === 'wrapper') c = t.scrollWrap;
        }
        (i = c) === null || i === void 0 || i.appendChild(t.applyFilters('uiElement', a, e));
      }
    }
    function Et(t, e, i) {
      t.classList.add('pswp__button--arrow');
      t.setAttribute('aria-controls', 'pswp__items');
      e.on('change', () => {
        if (!e.options.loop)
          if (i) t.disabled = !(e.currIndex < e.getNumItems() - 1);
          else t.disabled = !(e.currIndex > 0);
      });
    }
    const Pt = {
      name: 'arrowPrev',
      className: 'pswp__button--arrow--prev',
      title: 'Previous',
      order: 10,
      isButton: true,
      appendTo: 'wrapper',
      html: {
        isCustomSVG: true,
        size: 60,
        inner: '<path d="M29 43l-3 3-16-16 16-16 3 3-13 13 13 13z" id="pswp__icn-arrow"/>',
        outlineID: 'pswp__icn-arrow',
      },
      onClick: 'prev',
      onInit: Et,
    };
    const At = {
      name: 'arrowNext',
      className: 'pswp__button--arrow--next',
      title: 'Next',
      order: 11,
      isButton: true,
      appendTo: 'wrapper',
      html: {
        isCustomSVG: true,
        size: 60,
        inner: '<use xlink:href="#pswp__icn-arrow"/>',
        outlineID: 'pswp__icn-arrow',
      },
      onClick: 'next',
      onInit: (t, e) => {
        Et(t, e, true);
      },
    };
    const Tt = {
      name: 'close',
      title: 'Close',
      order: 20,
      isButton: true,
      html: {
        isCustomSVG: true,
        inner:
          '<path d="M24 10l-2-2-6 6-6-6-2 2 6 6-6 6 2 2 6-6 6 6 2-2-6-6z" id="pswp__icn-close"/>',
        outlineID: 'pswp__icn-close',
      },
      onClick: 'close',
    };
    const Dt = {
      name: 'zoom',
      title: 'Zoom',
      order: 10,
      isButton: true,
      html: {
        isCustomSVG: true,
        inner:
          '<path d="M17.426 19.926a6 6 0 1 1 1.5-1.5L23 22.5 21.5 24l-4.074-4.074z" id="pswp__icn-zoom"/>' +
          '<path fill="currentColor" class="pswp__zoom-icn-bar-h" d="M11 16v-2h6v2z"/>' +
          '<path fill="currentColor" class="pswp__zoom-icn-bar-v" d="M13 12h2v6h-2z"/>',
        outlineID: 'pswp__icn-zoom',
      },
      onClick: 'toggleZoom',
    };
    const Lt = {
      name: 'preloader',
      appendTo: 'bar',
      order: 7,
      html: {
        isCustomSVG: true,
        inner:
          '<path fill-rule="evenodd" clip-rule="evenodd" d="M21.2 16a5.2 5.2 0 1 1-5.2-5.2V8a8 8 0 1 0 8 8h-2.8Z" id="pswp__icn-loading"/>',
        outlineID: 'pswp__icn-loading',
      },
      onInit: (t, e) => {
        let i;
        let n = null;
        const s = (e, i) => {
          t.classList.toggle('pswp__preloader--' + e, i);
        };
        const r = (t) => {
          if (i !== t) {
            i = t;
            s('active', t);
          }
        };
        const o = () => {
          let t;
          if (!((t = e.currSlide) !== null && t !== void 0 && t.content.isLoading())) {
            r(false);
            if (n) {
              clearTimeout(n);
              n = null;
            }
            return;
          }
          if (!n)
            n = setTimeout(() => {
              let t;
              r(
                Boolean((t = e.currSlide) === null || t === void 0 ? void 0 : t.content.isLoading())
              );
              n = null;
            }, e.options.preloaderDelay);
        };
        e.on('change', o);
        e.on('loadComplete', (t) => {
          if (e.currSlide === t.slide) o();
        });
        if (e.ui) e.ui.updatePreloaderVisibility = o;
      },
    };
    const Ot = {
      name: 'counter',
      order: 5,
      onInit: (t, e) => {
        e.on('change', () => {
          t.innerText = e.currIndex + 1 + e.options.indexIndicatorSep + e.getNumItems();
        });
      },
    };
    function It(t, e) {
      t.classList.toggle('pswp--zoomed-in', e);
    }
    class Mt {
      constructor(t) {
        this.pswp = t;
        this.isRegistered = false;
        this.uiElementsData = [];
        this.items = [];
        this.updatePreloaderVisibility = () => {};
        this._lastUpdatedZoomLevel = void 0;
      }
      init() {
        const { pswp: t } = this;
        this.isRegistered = false;
        this.uiElementsData = [Tt, Pt, At, Dt, Lt, Ot];
        t.dispatch('uiRegister');
        this.uiElementsData.sort((t, e) => (t.order || 0) - (e.order || 0));
        this.items = [];
        this.isRegistered = true;
        this.uiElementsData.forEach((t) => {
          this.registerElement(t);
        });
        t.on('change', () => {
          let e;
          (e = t.element) === null ||
            e === void 0 ||
            e.classList.toggle('pswp--one-slide', t.getNumItems() === 1);
        });
        t.on('zoomPanUpdate', () => this._onZoomPanUpdate());
      }
      registerElement(t) {
        if (this.isRegistered) this.items.push(new Ct(this.pswp, t));
        else this.uiElementsData.push(t);
      }
      _onZoomPanUpdate() {
        const { template: t, currSlide: e, options: i } = this.pswp;
        if (this.pswp.opener.isClosing || !t || !e) return;
        let { currZoomLevel: n } = e;
        if (!this.pswp.opener.isOpen) n = e.zoomLevels.initial;
        if (n === this._lastUpdatedZoomLevel) return;
        this._lastUpdatedZoomLevel = n;
        const s = e.zoomLevels.initial - e.zoomLevels.secondary;
        if (Math.abs(s) < 0.01 || !e.isZoomable()) {
          It(t, false);
          t.classList.remove('pswp--zoom-allowed');
          return;
        }
        t.classList.add('pswp--zoom-allowed');
        const r = n === e.zoomLevels.initial ? e.zoomLevels.secondary : e.zoomLevels.initial;
        It(t, r <= n);
        if (i.imageClickAction === 'zoom' || i.imageClickAction === 'zoom-or-close')
          t.classList.add('pswp--click-to-zoom');
      }
    }
    function kt(t) {
      const e = t.getBoundingClientRect();
      return { x: e.left, y: e.top, w: e.width };
    }
    function zt(t, e, i) {
      const n = t.getBoundingClientRect();
      const s = n.width / e;
      const r = n.height / i;
      const o = s > r ? s : r;
      const a = (n.width - e * o) / 2;
      const l = (n.height - i * o) / 2;
      const c = { x: n.left + a, y: n.top + l, w: e * o };
      c.innerRect = { w: n.width, h: n.height, x: a, y: l };
      return c;
    }
    function Ft(t, e, i) {
      const n = i.dispatch('thumbBounds', { index: t, itemData: e, instance: i });
      if (n.thumbBounds) return n.thumbBounds;
      const { element: s } = e;
      let r;
      let o;
      if (s && i.options.thumbSelector !== false) {
        const t = i.options.thumbSelector || 'img';
        o = s.matches(t) ? s : s.querySelector(t);
      }
      o = i.applyFilters('thumbEl', o, e, t);
      if (o)
        if (!e.thumbCropped) r = kt(o);
        else r = zt(o, e.width || e.w || 0, e.height || e.h || 0);
      return i.applyFilters('thumbBounds', r, e, t);
    }
    class Rt {
      constructor(t, e) {
        this.type = t;
        this.defaultPrevented = false;
        if (e) Object.assign(this, e);
      }
      preventDefault() {
        this.defaultPrevented = true;
      }
    }
    class Vt {
      constructor() {
        this._listeners = {};
        this._filters = {};
        this.pswp = void 0;
        this.options = void 0;
      }
      addFilter(t, e, i = 100) {
        let n, s, r;
        if (!this._filters[t]) this._filters[t] = [];
        (n = this._filters[t]) === null || n === void 0 || n.push({ fn: e, priority: i });
        (s = this._filters[t]) === null ||
          s === void 0 ||
          s.sort((t, e) => t.priority - e.priority);
        (r = this.pswp) === null || r === void 0 || r.addFilter(t, e, i);
      }
      removeFilter(t, e) {
        if (this._filters[t]) this._filters[t] = this._filters[t].filter((t) => t.fn !== e);
        if (this.pswp) this.pswp.removeFilter(t, e);
      }
      applyFilters(t, ...e) {
        let i;
        (i = this._filters[t]) === null ||
          i === void 0 ||
          i.forEach((t) => {
            e[0] = t.fn.apply(this, e);
          });
        return e[0];
      }
      on(t, e) {
        let i, n;
        if (!this._listeners[t]) this._listeners[t] = [];
        (i = this._listeners[t]) === null || i === void 0 || i.push(e);
        (n = this.pswp) === null || n === void 0 || n.on(t, e);
      }
      off(t, e) {
        let i;
        if (this._listeners[t]) this._listeners[t] = this._listeners[t].filter((t) => e !== t);
        (i = this.pswp) === null || i === void 0 || i.off(t, e);
      }
      dispatch(t, e) {
        let i;
        if (this.pswp) return this.pswp.dispatch(t, e);
        const n = new Rt(t, e);
        (i = this._listeners[t]) === null ||
          i === void 0 ||
          i.forEach((t) => {
            t.call(this, n);
          });
        return n;
      }
    }
    class Bt {
      constructor(t, e) {
        this.element = _('pswp__img pswp__img--placeholder', t ? 'img' : 'div', e);
        if (t) {
          const e = this.element;
          e.decoding = 'async';
          e.alt = '';
          e.src = t;
          e.setAttribute('role', 'presentation');
        }
        this.element.setAttribute('aria-hidden', 'true');
      }
      setDisplayedSize(t, e) {
        if (!this.element) return;
        if (this.element.tagName === 'IMG') {
          I(this.element, 250, 'auto');
          this.element.style.transformOrigin = '0 0';
          this.element.style.transform = T(0, 0, t / 250);
        } else I(this.element, t, e);
      }
      destroy() {
        let t;
        if ((t = this.element) !== null && t !== void 0 && t.parentNode) this.element.remove();
        this.element = null;
      }
    }
    class Nt {
      constructor(t, e, i) {
        this.instance = e;
        this.data = t;
        this.index = i;
        this.element = void 0;
        this.placeholder = void 0;
        this.slide = void 0;
        this.displayedImageWidth = 0;
        this.displayedImageHeight = 0;
        this.width = Number(this.data.w) || Number(this.data.width) || 0;
        this.height = Number(this.data.h) || Number(this.data.height) || 0;
        this.isAttached = false;
        this.hasSlide = false;
        this.isDecoding = false;
        this.state = z.IDLE;
        if (this.data.type) this.type = this.data.type;
        else if (this.data.src) this.type = 'image';
        else this.type = 'html';
        this.instance.dispatch('contentInit', { content: this });
      }
      removePlaceholder() {
        if (this.placeholder && !this.keepPlaceholder())
          setTimeout(() => {
            if (this.placeholder) {
              this.placeholder.destroy();
              this.placeholder = void 0;
            }
          }, 1e3);
      }
      load(t, e) {
        if (this.slide && this.usePlaceholder())
          if (!this.placeholder) {
            const t = this.instance.applyFilters(
              'placeholderSrc',
              this.data.msrc && this.slide.isFirstSlide ? this.data.msrc : false,
              this
            );
            this.placeholder = new Bt(t, this.slide.container);
          } else {
            const t = this.placeholder.element;
            if (t && !t.parentElement) this.slide.container.prepend(t);
          }
        if (this.element && !e) return;
        if (this.instance.dispatch('contentLoad', { content: this, isLazy: t }).defaultPrevented)
          return;
        if (this.isImageContent()) {
          this.element = _('pswp__img', 'img');
          if (this.displayedImageWidth) this.loadImage(t);
        } else {
          this.element = _('pswp__content', 'div');
          this.element.innerHTML = this.data.html || '';
        }
        if (e && this.slide) this.slide.updateContentSize(true);
      }
      loadImage(t) {
        let e, i;
        if (
          !this.isImageContent() ||
          !this.element ||
          this.instance.dispatch('contentLoadImage', { content: this, isLazy: t }).defaultPrevented
        )
          return;
        const n = this.element;
        this.updateSrcsetSizes();
        if (this.data.srcset) n.srcset = this.data.srcset;
        n.src = (e = this.data.src) !== null && e !== void 0 ? e : '';
        n.alt = (i = this.data.alt) !== null && i !== void 0 ? i : '';
        this.state = z.LOADING;
        if (n.complete) this.onLoaded();
        else {
          n.onload = () => {
            this.onLoaded();
          };
          n.onerror = () => {
            this.onError();
          };
        }
      }
      setSlide(t) {
        this.slide = t;
        this.hasSlide = true;
        this.instance = t.pswp;
      }
      onLoaded() {
        this.state = z.LOADED;
        if (this.slide && this.element) {
          this.instance.dispatch('loadComplete', { slide: this.slide, content: this });
          if (this.slide.isActive && this.slide.heavyAppended && !this.element.parentNode) {
            this.append();
            this.slide.updateContentSize(true);
          }
          if (this.state === z.LOADED || this.state === z.ERROR) this.removePlaceholder();
        }
      }
      onError() {
        this.state = z.ERROR;
        if (this.slide) {
          this.displayError();
          this.instance.dispatch('loadComplete', {
            slide: this.slide,
            isError: true,
            content: this,
          });
          this.instance.dispatch('loadError', { slide: this.slide, content: this });
        }
      }
      isLoading() {
        return this.instance.applyFilters('isContentLoading', this.state === z.LOADING, this);
      }
      isError() {
        return this.state === z.ERROR;
      }
      isImageContent() {
        return this.type === 'image';
      }
      setDisplayedSize(t, e) {
        if (!this.element) return;
        if (this.placeholder) this.placeholder.setDisplayedSize(t, e);
        if (
          this.instance.dispatch('contentResize', { content: this, width: t, height: e })
            .defaultPrevented
        )
          return;
        I(this.element, t, e);
        if (this.isImageContent() && !this.isError()) {
          const i = !this.displayedImageWidth && t;
          this.displayedImageWidth = t;
          this.displayedImageHeight = e;
          if (i) this.loadImage(false);
          else this.updateSrcsetSizes();
          if (this.slide)
            this.instance.dispatch('imageSizeChange', {
              slide: this.slide,
              width: t,
              height: e,
              content: this,
            });
        }
      }
      isZoomable() {
        return this.instance.applyFilters(
          'isContentZoomable',
          this.isImageContent() && this.state !== z.ERROR,
          this
        );
      }
      updateSrcsetSizes() {
        if (!this.isImageContent() || !this.element || !this.data.srcset) return;
        const t = this.element;
        const e = this.instance.applyFilters('srcsetSizesWidth', this.displayedImageWidth, this);
        if (!t.dataset.largestUsedSize || e > parseInt(t.dataset.largestUsedSize, 10)) {
          t.sizes = e + 'px';
          t.dataset.largestUsedSize = String(e);
        }
      }
      usePlaceholder() {
        return this.instance.applyFilters('useContentPlaceholder', this.isImageContent(), this);
      }
      lazyLoad() {
        if (this.instance.dispatch('contentLazyLoad', { content: this }).defaultPrevented) return;
        this.load(true);
      }
      keepPlaceholder() {
        return this.instance.applyFilters('isKeepingPlaceholder', this.isLoading(), this);
      }
      destroy() {
        this.hasSlide = false;
        this.slide = void 0;
        if (this.instance.dispatch('contentDestroy', { content: this }).defaultPrevented) return;
        this.remove();
        if (this.placeholder) {
          this.placeholder.destroy();
          this.placeholder = void 0;
        }
        if (this.isImageContent() && this.element) {
          this.element.onload = null;
          this.element.onerror = null;
          this.element = void 0;
        }
      }
      displayError() {
        if (this.slide) {
          let t, e;
          let i = _('pswp__error-msg', 'div');
          i.innerText =
            (t = (e = this.instance.options) === null || e === void 0 ? void 0 : e.errorMsg) !==
              null && t !== void 0
              ? t
              : '';
          i = this.instance.applyFilters('contentErrorElement', i, this);
          this.element = _('pswp__content pswp__error-msg-container', 'div');
          this.element.appendChild(i);
          this.slide.container.innerText = '';
          this.slide.container.appendChild(this.element);
          this.slide.updateContentSize(true);
          this.removePlaceholder();
        }
      }
      append() {
        if (this.isAttached || !this.element) return;
        this.isAttached = true;
        if (this.state === z.ERROR) {
          this.displayError();
          return;
        }
        if (this.instance.dispatch('contentAppend', { content: this }).defaultPrevented) return;
        const t = 'decode' in this.element;
        if (this.isImageContent())
          if (t && this.slide && (!this.slide.isActive || V())) {
            this.isDecoding = true;
            this.element
              .decode()
              .catch(() => {})
              .finally(() => {
                this.isDecoding = false;
                this.appendImage();
              });
          } else this.appendImage();
        else if (this.slide && !this.element.parentNode)
          this.slide.container.appendChild(this.element);
      }
      activate() {
        if (
          this.instance.dispatch('contentActivate', { content: this }).defaultPrevented ||
          !this.slide
        )
          return;
        if (this.isImageContent() && this.isDecoding && !V()) this.appendImage();
        else if (this.isError()) this.load(false, true);
        if (this.slide.holderElement) this.slide.holderElement.setAttribute('aria-hidden', 'false');
      }
      deactivate() {
        this.instance.dispatch('contentDeactivate', { content: this });
        if (this.slide && this.slide.holderElement)
          this.slide.holderElement.setAttribute('aria-hidden', 'true');
      }
      remove() {
        this.isAttached = false;
        if (this.instance.dispatch('contentRemove', { content: this }).defaultPrevented) return;
        if (this.element && this.element.parentNode) this.element.remove();
        if (this.placeholder && this.placeholder.element) this.placeholder.element.remove();
      }
      appendImage() {
        if (!this.isAttached) return;
        if (this.instance.dispatch('contentAppendImage', { content: this }).defaultPrevented)
          return;
        if (this.slide && this.element && !this.element.parentNode)
          this.slide.container.appendChild(this.element);
        if (this.state === z.LOADED || this.state === z.ERROR) this.removePlaceholder();
      }
    }
    const Wt = 5;
    function Zt(t, e, i) {
      const n = e.createContentFromData(t, i);
      let s;
      const { options: r } = e;
      if (r) {
        s = new q(r, t, -1);
        let o;
        if (e.pswp) o = e.pswp.viewportSize;
        else o = W(r, e);
        const a = H(r, o, t, i);
        s.update(n.width, n.height, a);
      }
      n.lazyLoad();
      if (s) n.setDisplayedSize(Math.ceil(n.width * s.initial), Math.ceil(n.height * s.initial));
      return n;
    }
    function Ht(t, e) {
      const i = e.getItemData(t);
      if (e.dispatch('lazyLoadSlide', { index: t, itemData: i }).defaultPrevented) return;
      return Zt(i, e, t);
    }
    class jt {
      constructor(t) {
        this.pswp = t;
        this.limit = Math.max(t.options.preload[0] + t.options.preload[1] + 1, Wt);
        this._cachedItems = [];
      }
      updateLazy(t) {
        const { pswp: e } = this;
        if (e.dispatch('lazyLoad').defaultPrevented) return;
        const { preload: i } = e.options;
        const n = t === void 0 ? true : t >= 0;
        let s;
        for (s = 0; s <= i[1]; s++) this.loadSlideByIndex(e.currIndex + (n ? s : -s));
        for (s = 1; s <= i[0]; s++) this.loadSlideByIndex(e.currIndex + (n ? -s : s));
      }
      loadSlideByIndex(t) {
        const e = this.pswp.getLoopedIndex(t);
        let i = this.getContentByIndex(e);
        if (!i) {
          i = Ht(e, this.pswp);
          if (i) this.addToCache(i);
        }
      }
      getContentBySlide(t) {
        let e = this.getContentByIndex(t.index);
        if (!e) {
          e = this.pswp.createContentFromData(t.data, t.index);
          this.addToCache(e);
        }
        e.setSlide(t);
        return e;
      }
      addToCache(t) {
        this.removeByIndex(t.index);
        this._cachedItems.push(t);
        if (this._cachedItems.length > this.limit) {
          const t = this._cachedItems.findIndex((t) => !t.isAttached && !t.hasSlide);
          if (t !== -1) {
            const e = this._cachedItems.splice(t, 1)[0];
            e.destroy();
          }
        }
      }
      removeByIndex(t) {
        const e = this._cachedItems.findIndex((e) => e.index === t);
        if (e !== -1) this._cachedItems.splice(e, 1);
      }
      getContentByIndex(t) {
        return this._cachedItems.find((e) => e.index === t);
      }
      destroy() {
        this._cachedItems.forEach((t) => t.destroy());
        this._cachedItems = [];
      }
    }
    class Ut extends Vt {
      getNumItems() {
        let t;
        let e = 0;
        const i = (t = this.options) === null || t === void 0 ? void 0 : t.dataSource;
        if (i && 'length' in i) e = i.length;
        else if (i && 'gallery' in i) {
          if (!i.items) i.items = this._getGalleryDOMElements(i.gallery);
          if (i.items) e = i.items.length;
        }
        const n = this.dispatch('numItems', { dataSource: i, numItems: e });
        return this.applyFilters('numItems', n.numItems, i);
      }
      createContentFromData(t, e) {
        return new Nt(t, this, e);
      }
      getItemData(t) {
        let e;
        const i = (e = this.options) === null || e === void 0 ? void 0 : e.dataSource;
        let n = {};
        if (Array.isArray(i)) n = i[t];
        else if (i && 'gallery' in i) {
          if (!i.items) i.items = this._getGalleryDOMElements(i.gallery);
          n = i.items[t];
        }
        let s = n;
        if (s instanceof Element) s = this._domElementToItemData(s);
        const r = this.dispatch('itemData', { itemData: s || {}, index: t });
        return this.applyFilters('itemData', r.itemData, t);
      }
      _getGalleryDOMElements(t) {
        let e, i;
        if (
          ((e = this.options) !== null && e !== void 0 && e.children) ||
          ((i = this.options) !== null && i !== void 0 && i.childSelector)
        )
          return R(this.options.children, this.options.childSelector, t) || [];
        return [t];
      }
      _domElementToItemData(t) {
        const e = { element: t };
        const i = t.tagName === 'A' ? t : t.querySelector('a');
        if (i) {
          e.src = i.dataset.pswpSrc || i.href;
          if (i.dataset.pswpSrcset) e.srcset = i.dataset.pswpSrcset;
          e.width = i.dataset.pswpWidth ? parseInt(i.dataset.pswpWidth, 10) : 0;
          e.height = i.dataset.pswpHeight ? parseInt(i.dataset.pswpHeight, 10) : 0;
          e.w = e.width;
          e.h = e.height;
          if (i.dataset.pswpType) e.type = i.dataset.pswpType;
          const s = t.querySelector('img');
          if (s) {
            let n;
            e.msrc = s.currentSrc || s.src;
            e.alt = (n = s.getAttribute('alt')) !== null && n !== void 0 ? n : '';
          }
          if (i.dataset.pswpCropped || i.dataset.cropped) e.thumbCropped = true;
        }
        return this.applyFilters('domItemData', e, t, i);
      }
      lazyLoadData(t, e) {
        return Zt(t, this, e);
      }
    }
    const qt = 0.003;
    class $t {
      constructor(t) {
        this.pswp = t;
        this.isClosed = true;
        this.isOpen = false;
        this.isClosing = false;
        this.isOpening = false;
        this._duration = void 0;
        this._useAnimation = false;
        this._croppedZoom = false;
        this._animateRootOpacity = false;
        this._animateBgOpacity = false;
        this._placeholder = void 0;
        this._opacityElement = void 0;
        this._cropContainer1 = void 0;
        this._cropContainer2 = void 0;
        this._thumbBounds = void 0;
        this._prepareOpen = this._prepareOpen.bind(this);
        t.on('firstZoomPan', this._prepareOpen);
      }
      open() {
        this._prepareOpen();
        this._start();
      }
      close() {
        if (this.isClosed || this.isClosing || this.isOpening) return;
        const t = this.pswp.currSlide;
        this.isOpen = false;
        this.isOpening = false;
        this.isClosing = true;
        this._duration = this.pswp.options.hideAnimationDuration;
        if (t && t.currZoomLevel * t.width >= this.pswp.options.maxWidthToAnimate)
          this._duration = 0;
        this._applyStartProps();
        setTimeout(
          () => {
            this._start();
          },
          this._croppedZoom ? 30 : 0
        );
      }
      _prepareOpen() {
        this.pswp.off('firstZoomPan', this._prepareOpen);
        if (!this.isOpening) {
          const t = this.pswp.currSlide;
          this.isOpening = true;
          this.isClosing = false;
          this._duration = this.pswp.options.showAnimationDuration;
          if (t && t.zoomLevels.initial * t.width >= this.pswp.options.maxWidthToAnimate)
            this._duration = 0;
          this._applyStartProps();
        }
      }
      _applyStartProps() {
        const { pswp: t } = this;
        const e = this.pswp.currSlide;
        const { options: i } = t;
        if (i.showHideAnimationType === 'fade') {
          i.showHideOpacity = true;
          this._thumbBounds = void 0;
        } else if (i.showHideAnimationType === 'none') {
          i.showHideOpacity = false;
          this._duration = 0;
          this._thumbBounds = void 0;
        } else if (this.isOpening && t._initialThumbBounds)
          this._thumbBounds = t._initialThumbBounds;
        else this._thumbBounds = this.pswp.getThumbBounds();
        this._placeholder = e === null || e === void 0 ? void 0 : e.getPlaceholderElement();
        t.animations.stopAll();
        this._useAnimation = Boolean(this._duration && this._duration > 50);
        this._animateZoom =
          Boolean(this._thumbBounds) &&
          (e === null || e === void 0 ? void 0 : e.content.usePlaceholder()) &&
          (!this.isClosing || !t.mainScroll.isShifted());
        if (!this._animateZoom) {
          this._animateRootOpacity = true;
          if (this.isOpening && e) {
            e.zoomAndPanToInitial();
            e.applyCurrentZoomPan();
          }
        } else {
          let n;
          this._animateRootOpacity = (n = i.showHideOpacity) !== null && n !== void 0 ? n : false;
        }
        this._animateBgOpacity = !this._animateRootOpacity && this.pswp.options.bgOpacity > qt;
        this._opacityElement = this._animateRootOpacity ? t.element : t.bg;
        if (!this._useAnimation) {
          this._duration = 0;
          this._animateZoom = false;
          this._animateBgOpacity = false;
          this._animateRootOpacity = true;
          if (this.isOpening) {
            if (t.element) t.element.style.opacity = String(qt);
            t.applyBgOpacity(1);
          }
          return;
        }
        if (this._animateZoom && this._thumbBounds && this._thumbBounds.innerRect) {
          let s;
          this._croppedZoom = true;
          this._cropContainer1 = this.pswp.container;
          this._cropContainer2 =
            (s = this.pswp.currSlide) === null || s === void 0 ? void 0 : s.holderElement;
          if (t.container) {
            t.container.style.overflow = 'hidden';
            t.container.style.width = t.viewportSize.x + 'px';
          }
        } else this._croppedZoom = false;
        if (this.isOpening) {
          if (this._animateRootOpacity) {
            if (t.element) t.element.style.opacity = String(qt);
            t.applyBgOpacity(1);
          } else {
            if (this._animateBgOpacity && t.bg) t.bg.style.opacity = String(qt);
            if (t.element) t.element.style.opacity = '1';
          }
          if (this._animateZoom) {
            this._setClosedStateZoomPan();
            if (this._placeholder) {
              this._placeholder.style.willChange = 'transform';
              this._placeholder.style.opacity = String(qt);
            }
          }
        } else if (this.isClosing) {
          if (t.mainScroll.itemHolders[0]) t.mainScroll.itemHolders[0].el.style.display = 'none';
          if (t.mainScroll.itemHolders[2]) t.mainScroll.itemHolders[2].el.style.display = 'none';
          if (this._croppedZoom)
            if (t.mainScroll.x !== 0) {
              t.mainScroll.resetPosition();
              t.mainScroll.resize();
            }
        }
      }
      _start() {
        if (
          this.isOpening &&
          this._useAnimation &&
          this._placeholder &&
          this._placeholder.tagName === 'IMG'
        )
          new Promise((t) => {
            let e = false;
            let i = true;
            k(this._placeholder).finally(() => {
              e = true;
              if (!i) t(true);
            });
            setTimeout(() => {
              i = false;
              if (e) t(true);
            }, 50);
            setTimeout(t, 250);
          }).finally(() => this._initiate());
        else this._initiate();
      }
      _initiate() {
        let t, e;
        (t = this.pswp.element) === null ||
          t === void 0 ||
          t.style.setProperty('--pswp-transition-duration', this._duration + 'ms');
        this.pswp.dispatch(this.isOpening ? 'openingAnimationStart' : 'closingAnimationStart');
        this.pswp.dispatch('initialZoom' + (this.isOpening ? 'In' : 'Out'));
        (e = this.pswp.element) === null ||
          e === void 0 ||
          e.classList.toggle('pswp--ui-visible', this.isOpening);
        if (this.isOpening) {
          if (this._placeholder) this._placeholder.style.opacity = '1';
          this._animateToOpenState();
        } else if (this.isClosing) this._animateToClosedState();
        if (!this._useAnimation) this._onAnimationComplete();
      }
      _onAnimationComplete() {
        const { pswp: t } = this;
        this.isOpen = this.isOpening;
        this.isClosed = this.isClosing;
        this.isOpening = false;
        this.isClosing = false;
        t.dispatch(this.isOpen ? 'openingAnimationEnd' : 'closingAnimationEnd');
        t.dispatch('initialZoom' + (this.isOpen ? 'InEnd' : 'OutEnd'));
        if (this.isClosed) t.destroy();
        else if (this.isOpen) {
          let e;
          if (this._animateZoom && t.container) {
            t.container.style.overflow = 'visible';
            t.container.style.width = '100%';
          }
          (e = t.currSlide) === null || e === void 0 || e.applyCurrentZoomPan();
        }
      }
      _animateToOpenState() {
        const { pswp: t } = this;
        if (this._animateZoom) {
          if (this._croppedZoom && this._cropContainer1 && this._cropContainer2) {
            this._animateTo(this._cropContainer1, 'transform', 'translate3d(0,0,0)');
            this._animateTo(this._cropContainer2, 'transform', 'none');
          }
          if (t.currSlide) {
            t.currSlide.zoomAndPanToInitial();
            this._animateTo(t.currSlide.container, 'transform', t.currSlide.getCurrentTransform());
          }
        }
        if (this._animateBgOpacity && t.bg)
          this._animateTo(t.bg, 'opacity', String(t.options.bgOpacity));
        if (this._animateRootOpacity && t.element) this._animateTo(t.element, 'opacity', '1');
      }
      _animateToClosedState() {
        const { pswp: t } = this;
        if (this._animateZoom) this._setClosedStateZoomPan(true);
        if (this._animateBgOpacity && t.bgOpacity > 0.01 && t.bg)
          this._animateTo(t.bg, 'opacity', '0');
        if (this._animateRootOpacity && t.element) this._animateTo(t.element, 'opacity', '0');
      }
      _setClosedStateZoomPan(t) {
        if (!this._thumbBounds) return;
        const { pswp: e } = this;
        const { innerRect: i } = this._thumbBounds;
        const { currSlide: n, viewportSize: s } = e;
        if (this._croppedZoom && i && this._cropContainer1 && this._cropContainer2) {
          const e = -s.x + (this._thumbBounds.x - i.x) + i.w;
          const n = -s.y + (this._thumbBounds.y - i.y) + i.h;
          const r = s.x - i.w;
          const o = s.y - i.h;
          if (t) {
            this._animateTo(this._cropContainer1, 'transform', T(e, n));
            this._animateTo(this._cropContainer2, 'transform', T(r, o));
          } else {
            D(this._cropContainer1, e, n);
            D(this._cropContainer2, r, o);
          }
        }
        if (n) {
          S(n.pan, i || this._thumbBounds);
          n.currZoomLevel = this._thumbBounds.w / n.width;
          if (t) this._animateTo(n.container, 'transform', n.getCurrentTransform());
          else n.applyCurrentZoomPan();
        }
      }
      _animateTo(t, e, i) {
        if (!this._duration) {
          t.style[e] = i;
          return;
        }
        const { animations: n } = this.pswp;
        const s = {
          duration: this._duration,
          easing: this.pswp.options.easing,
          onComplete: () => {
            if (!n.activeAnimations.length) this._onAnimationComplete();
          },
          target: t,
        };
        s[e] = i;
        n.startTransition(s);
      }
    }
    const Xt = {
      allowPanToNext: true,
      spacing: 0.1,
      loop: true,
      pinchToClose: true,
      closeOnVerticalDrag: true,
      hideAnimationDuration: 333,
      showAnimationDuration: 333,
      zoomAnimationDuration: 333,
      escKey: true,
      arrowKeys: true,
      trapFocus: true,
      returnFocus: true,
      maxWidthToAnimate: 4e3,
      clickToCloseNonZoomable: true,
      imageClickAction: 'zoom-or-close',
      bgClickAction: 'close',
      tapAction: 'toggle-controls',
      doubleTapAction: 'zoom',
      indexIndicatorSep: ' / ',
      preloaderDelay: 2e3,
      bgOpacity: 0.8,
      index: 0,
      errorMsg: 'The image cannot be loaded',
      preload: [1, 2],
      easing: 'cubic-bezier(.4,0,.22,1)',
    };
    class Gt extends Ut {
      constructor(t) {
        super();
        this.options = this._prepareOptions(t || {});
        this.offset = { x: 0, y: 0 };
        this._prevViewportSize = { x: 0, y: 0 };
        this.viewportSize = { x: 0, y: 0 };
        this.bgOpacity = 1;
        this.currIndex = 0;
        this.potentialIndex = 0;
        this.isOpen = false;
        this.isDestroying = false;
        this.hasMouse = false;
        this._initialItemData = {};
        this._initialThumbBounds = void 0;
        this.topBar = void 0;
        this.element = void 0;
        this.template = void 0;
        this.container = void 0;
        this.scrollWrap = void 0;
        this.currSlide = void 0;
        this.events = new N();
        this.animations = new xt();
        this.mainScroll = new ut(this);
        this.gestures = new ct(this);
        this.opener = new $t(this);
        this.keyboard = new pt(this);
        this.contentLoader = new jt(this);
      }
      init() {
        if (this.isOpen || this.isDestroying) return false;
        this.isOpen = true;
        this.dispatch('init');
        this.dispatch('beforeOpen');
        this._createMainStructure();
        let t = 'pswp--open';
        if (this.gestures.supportsTouch) t += ' pswp--touch';
        if (this.options.mainClass) t += ' ' + this.options.mainClass;
        if (this.element) this.element.className += ' ' + t;
        this.currIndex = this.options.index || 0;
        this.potentialIndex = this.currIndex;
        this.dispatch('firstUpdate');
        this.scrollWheel = new _t(this);
        if (
          Number.isNaN(this.currIndex) ||
          this.currIndex < 0 ||
          this.currIndex >= this.getNumItems()
        )
          this.currIndex = 0;
        if (!this.gestures.supportsTouch) this.mouseDetected();
        this.updateSize();
        this.offset.y = window.pageYOffset;
        this._initialItemData = this.getItemData(this.currIndex);
        this.dispatch('gettingData', {
          index: this.currIndex,
          data: this._initialItemData,
          slide: void 0,
        });
        this._initialThumbBounds = this.getThumbBounds();
        this.dispatch('initialLayout');
        this.on('openingAnimationEnd', () => {
          const { itemHolders: t } = this.mainScroll;
          if (t[0]) {
            t[0].el.style.display = 'block';
            this.setContent(t[0], this.currIndex - 1);
          }
          if (t[2]) {
            t[2].el.style.display = 'block';
            this.setContent(t[2], this.currIndex + 1);
          }
          this.appendHeavy();
          this.contentLoader.updateLazy();
          this.events.add(window, 'resize', this._handlePageResize.bind(this));
          this.events.add(window, 'scroll', this._updatePageScrollOffset.bind(this));
          this.dispatch('bindEvents');
        });
        if (this.mainScroll.itemHolders[1])
          this.setContent(this.mainScroll.itemHolders[1], this.currIndex);
        this.dispatch('change');
        this.opener.open();
        this.dispatch('afterInit');
        return true;
      }
      getLoopedIndex(t) {
        const e = this.getNumItems();
        if (this.options.loop) {
          if (t > e - 1) t -= e;
          if (t < 0) t += e;
        }
        return A(t, 0, e - 1);
      }
      appendHeavy() {
        this.mainScroll.itemHolders.forEach((t) => {
          let e;
          (e = t.slide) === null || e === void 0 || e.appendHeavy();
        });
      }
      goTo(t) {
        this.mainScroll.moveIndexBy(this.getLoopedIndex(t) - this.potentialIndex);
      }
      next() {
        this.goTo(this.potentialIndex + 1);
      }
      prev() {
        this.goTo(this.potentialIndex - 1);
      }
      zoomTo(...t) {
        let e;
        (e = this.currSlide) === null || e === void 0 || e.zoomTo(...t);
      }
      toggleZoom() {
        let t;
        (t = this.currSlide) === null || t === void 0 || t.toggleZoom();
      }
      close() {
        if (!this.opener.isOpen || this.isDestroying) return;
        this.isDestroying = true;
        this.dispatch('close');
        this.events.removeAll();
        this.opener.close();
      }
      destroy() {
        let t;
        if (!this.isDestroying) {
          this.options.showHideAnimationType = 'none';
          this.close();
          return;
        }
        this.dispatch('destroy');
        this._listeners = {};
        if (this.scrollWrap) {
          this.scrollWrap.ontouchmove = null;
          this.scrollWrap.ontouchend = null;
        }
        (t = this.element) === null || t === void 0 || t.remove();
        this.mainScroll.itemHolders.forEach((t) => {
          let e;
          (e = t.slide) === null || e === void 0 || e.destroy();
        });
        this.contentLoader.destroy();
        this.events.removeAll();
      }
      refreshSlideContent(t) {
        this.contentLoader.removeByIndex(t);
        this.mainScroll.itemHolders.forEach((e, i) => {
          let n, s;
          let r =
            ((n = (s = this.currSlide) === null || s === void 0 ? void 0 : s.index) !== null &&
            n !== void 0
              ? n
              : 0) -
            1 +
            i;
          if (this.canLoop()) r = this.getLoopedIndex(r);
          if (r === t) {
            this.setContent(e, t, true);
            if (i === 1) {
              let o;
              this.currSlide = e.slide;
              (o = e.slide) === null || o === void 0 || o.setIsActive(true);
            }
          }
        });
        this.dispatch('change');
      }
      setContent(t, e, i) {
        if (this.canLoop()) e = this.getLoopedIndex(e);
        if (t.slide) {
          if (t.slide.index === e && !i) return;
          t.slide.destroy();
          t.slide = void 0;
        }
        if (!this.canLoop() && (e < 0 || e >= this.getNumItems())) return;
        const n = this.getItemData(e);
        t.slide = new $(n, e, this);
        if (e === this.currIndex) this.currSlide = t.slide;
        t.slide.append(t.el);
      }
      getViewportCenterPoint() {
        return { x: this.viewportSize.x / 2, y: this.viewportSize.y / 2 };
      }
      updateSize(t) {
        if (this.isDestroying) return;
        const e = W(this.options, this);
        if (!t && P(e, this._prevViewportSize)) return;
        S(this._prevViewportSize, e);
        this.dispatch('beforeResize');
        S(this.viewportSize, this._prevViewportSize);
        this._updatePageScrollOffset();
        this.dispatch('viewportSize');
        this.mainScroll.resize(this.opener.isOpen);
        if (!this.hasMouse && window.matchMedia('(any-hover: hover)').matches) this.mouseDetected();
        this.dispatch('resize');
      }
      applyBgOpacity(t) {
        this.bgOpacity = Math.max(t, 0);
        if (this.bg) this.bg.style.opacity = String(this.bgOpacity * this.options.bgOpacity);
      }
      mouseDetected() {
        if (!this.hasMouse) {
          let t;
          this.hasMouse = true;
          (t = this.element) === null || t === void 0 || t.classList.add('pswp--has_mouse');
        }
      }
      _handlePageResize() {
        this.updateSize();
        if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent))
          setTimeout(() => {
            this.updateSize();
          }, 500);
      }
      _updatePageScrollOffset() {
        this.setScrollOffset(0, window.pageYOffset);
      }
      setScrollOffset(t, e) {
        this.offset.x = t;
        this.offset.y = e;
        this.dispatch('updateScrollOffset');
      }
      _createMainStructure() {
        this.element = _('pswp', 'div');
        this.element.setAttribute('tabindex', '-1');
        this.element.setAttribute('role', 'dialog');
        this.template = this.element;
        this.bg = _('pswp__bg', 'div', this.element);
        this.scrollWrap = _('pswp__scroll-wrap', 'section', this.element);
        this.container = _('pswp__container', 'div', this.scrollWrap);
        this.scrollWrap.setAttribute('aria-roledescription', 'carousel');
        this.container.setAttribute('aria-live', 'off');
        this.container.setAttribute('id', 'pswp__items');
        this.mainScroll.appendHolders();
        this.ui = new Mt(this);
        this.ui.init();
        (this.options.appendToEl || document.body).appendChild(this.element);
      }
      getThumbBounds() {
        return Ft(
          this.currIndex,
          this.currSlide ? this.currSlide.data : this._initialItemData,
          this
        );
      }
      canLoop() {
        return this.options.loop && this.getNumItems() > 2;
      }
      _prepareOptions(t) {
        if (window.matchMedia('(prefers-reduced-motion), (update: slow)').matches) {
          t.showHideAnimationType = 'none';
          t.zoomAnimationDuration = 0;
        }
        return { ...Xt, ...t };
      }
    }
    function Kt(t, e, i) {
      const n = document.createElement(e);
      if (t) n.className = t;
      if (i) i.appendChild(n);
      return n;
    }
    function Yt(t, e, i) {
      let n = `translate3d(${t}px,${e || 0}px,0)`;
      if (i !== void 0) n += ` scale3d(${i},${i},1)`;
      return n;
    }
    function Qt(t, e, i) {
      t.style.width = typeof e === 'number' ? `${e}px` : e;
      t.style.height = typeof i === 'number' ? `${i}px` : i;
    }
    const Jt = { IDLE: 'idle', LOADING: 'loading', LOADED: 'loaded', ERROR: 'error' };
    function te(t) {
      return ('button' in t && t.button === 1) || t.ctrlKey || t.metaKey || t.altKey || t.shiftKey;
    }
    function ee(t, e, i = document) {
      let n = [];
      if (t instanceof Element) n = [t];
      else if (t instanceof NodeList || Array.isArray(t)) n = Array.from(t);
      else {
        const s = typeof t === 'string' ? t : e;
        if (s) n = Array.from(i.querySelectorAll(s));
      }
      return n;
    }
    function ie(t) {
      return typeof t === 'function' && t.prototype && t.prototype.goTo;
    }
    function ne() {
      return !!(navigator.vendor && navigator.vendor.match(/apple/i));
    }
    class se {
      constructor(t, e) {
        this.type = t;
        this.defaultPrevented = false;
        if (e) Object.assign(this, e);
      }
      preventDefault() {
        this.defaultPrevented = true;
      }
    }
    class re {
      constructor() {
        this._listeners = {};
        this._filters = {};
        this.pswp = void 0;
        this.options = void 0;
      }
      addFilter(t, e, i = 100) {
        let n, s, r;
        if (!this._filters[t]) this._filters[t] = [];
        (n = this._filters[t]) === null || n === void 0 || n.push({ fn: e, priority: i });
        (s = this._filters[t]) === null ||
          s === void 0 ||
          s.sort((t, e) => t.priority - e.priority);
        (r = this.pswp) === null || r === void 0 || r.addFilter(t, e, i);
      }
      removeFilter(t, e) {
        if (this._filters[t]) this._filters[t] = this._filters[t].filter((t) => t.fn !== e);
        if (this.pswp) this.pswp.removeFilter(t, e);
      }
      applyFilters(t, ...e) {
        let i;
        (i = this._filters[t]) === null ||
          i === void 0 ||
          i.forEach((t) => {
            e[0] = t.fn.apply(this, e);
          });
        return e[0];
      }
      on(t, e) {
        let i, n;
        if (!this._listeners[t]) this._listeners[t] = [];
        (i = this._listeners[t]) === null || i === void 0 || i.push(e);
        (n = this.pswp) === null || n === void 0 || n.on(t, e);
      }
      off(t, e) {
        let i;
        if (this._listeners[t]) this._listeners[t] = this._listeners[t].filter((t) => e !== t);
        (i = this.pswp) === null || i === void 0 || i.off(t, e);
      }
      dispatch(t, e) {
        let i;
        if (this.pswp) return this.pswp.dispatch(t, e);
        const n = new se(t, e);
        (i = this._listeners[t]) === null ||
          i === void 0 ||
          i.forEach((t) => {
            t.call(this, n);
          });
        return n;
      }
    }
    class oe {
      constructor(t, e) {
        this.element = Kt('pswp__img pswp__img--placeholder', t ? 'img' : 'div', e);
        if (t) {
          const e = this.element;
          e.decoding = 'async';
          e.alt = '';
          e.src = t;
          e.setAttribute('role', 'presentation');
        }
        this.element.setAttribute('aria-hidden', 'true');
      }
      setDisplayedSize(t, e) {
        if (!this.element) return;
        if (this.element.tagName === 'IMG') {
          Qt(this.element, 250, 'auto');
          this.element.style.transformOrigin = '0 0';
          this.element.style.transform = Yt(0, 0, t / 250);
        } else Qt(this.element, t, e);
      }
      destroy() {
        let t;
        if ((t = this.element) !== null && t !== void 0 && t.parentNode) this.element.remove();
        this.element = null;
      }
    }
    class ae {
      constructor(t, e, i) {
        this.instance = e;
        this.data = t;
        this.index = i;
        this.element = void 0;
        this.placeholder = void 0;
        this.slide = void 0;
        this.displayedImageWidth = 0;
        this.displayedImageHeight = 0;
        this.width = Number(this.data.w) || Number(this.data.width) || 0;
        this.height = Number(this.data.h) || Number(this.data.height) || 0;
        this.isAttached = false;
        this.hasSlide = false;
        this.isDecoding = false;
        this.state = Jt.IDLE;
        if (this.data.type) this.type = this.data.type;
        else if (this.data.src) this.type = 'image';
        else this.type = 'html';
        this.instance.dispatch('contentInit', { content: this });
      }
      removePlaceholder() {
        if (this.placeholder && !this.keepPlaceholder())
          setTimeout(() => {
            if (this.placeholder) {
              this.placeholder.destroy();
              this.placeholder = void 0;
            }
          }, 1e3);
      }
      load(t, e) {
        if (this.slide && this.usePlaceholder())
          if (!this.placeholder) {
            const t = this.instance.applyFilters(
              'placeholderSrc',
              this.data.msrc && this.slide.isFirstSlide ? this.data.msrc : false,
              this
            );
            this.placeholder = new oe(t, this.slide.container);
          } else {
            const t = this.placeholder.element;
            if (t && !t.parentElement) this.slide.container.prepend(t);
          }
        if (this.element && !e) return;
        if (this.instance.dispatch('contentLoad', { content: this, isLazy: t }).defaultPrevented)
          return;
        if (this.isImageContent()) {
          this.element = Kt('pswp__img', 'img');
          if (this.displayedImageWidth) this.loadImage(t);
        } else {
          this.element = Kt('pswp__content', 'div');
          this.element.innerHTML = this.data.html || '';
        }
        if (e && this.slide) this.slide.updateContentSize(true);
      }
      loadImage(t) {
        let e, i;
        if (
          !this.isImageContent() ||
          !this.element ||
          this.instance.dispatch('contentLoadImage', { content: this, isLazy: t }).defaultPrevented
        )
          return;
        const n = this.element;
        this.updateSrcsetSizes();
        if (this.data.srcset) n.srcset = this.data.srcset;
        n.src = (e = this.data.src) !== null && e !== void 0 ? e : '';
        n.alt = (i = this.data.alt) !== null && i !== void 0 ? i : '';
        this.state = Jt.LOADING;
        if (n.complete) this.onLoaded();
        else {
          n.onload = () => {
            this.onLoaded();
          };
          n.onerror = () => {
            this.onError();
          };
        }
      }
      setSlide(t) {
        this.slide = t;
        this.hasSlide = true;
        this.instance = t.pswp;
      }
      onLoaded() {
        this.state = Jt.LOADED;
        if (this.slide && this.element) {
          this.instance.dispatch('loadComplete', { slide: this.slide, content: this });
          if (this.slide.isActive && this.slide.heavyAppended && !this.element.parentNode) {
            this.append();
            this.slide.updateContentSize(true);
          }
          if (this.state === Jt.LOADED || this.state === Jt.ERROR) this.removePlaceholder();
        }
      }
      onError() {
        this.state = Jt.ERROR;
        if (this.slide) {
          this.displayError();
          this.instance.dispatch('loadComplete', {
            slide: this.slide,
            isError: true,
            content: this,
          });
          this.instance.dispatch('loadError', { slide: this.slide, content: this });
        }
      }
      isLoading() {
        return this.instance.applyFilters('isContentLoading', this.state === Jt.LOADING, this);
      }
      isError() {
        return this.state === Jt.ERROR;
      }
      isImageContent() {
        return this.type === 'image';
      }
      setDisplayedSize(t, e) {
        if (!this.element) return;
        if (this.placeholder) this.placeholder.setDisplayedSize(t, e);
        if (
          this.instance.dispatch('contentResize', { content: this, width: t, height: e })
            .defaultPrevented
        )
          return;
        Qt(this.element, t, e);
        if (this.isImageContent() && !this.isError()) {
          const i = !this.displayedImageWidth && t;
          this.displayedImageWidth = t;
          this.displayedImageHeight = e;
          if (i) this.loadImage(false);
          else this.updateSrcsetSizes();
          if (this.slide)
            this.instance.dispatch('imageSizeChange', {
              slide: this.slide,
              width: t,
              height: e,
              content: this,
            });
        }
      }
      isZoomable() {
        return this.instance.applyFilters(
          'isContentZoomable',
          this.isImageContent() && this.state !== Jt.ERROR,
          this
        );
      }
      updateSrcsetSizes() {
        if (!this.isImageContent() || !this.element || !this.data.srcset) return;
        const t = this.element;
        const e = this.instance.applyFilters('srcsetSizesWidth', this.displayedImageWidth, this);
        if (!t.dataset.largestUsedSize || e > parseInt(t.dataset.largestUsedSize, 10)) {
          t.sizes = e + 'px';
          t.dataset.largestUsedSize = String(e);
        }
      }
      usePlaceholder() {
        return this.instance.applyFilters('useContentPlaceholder', this.isImageContent(), this);
      }
      lazyLoad() {
        if (this.instance.dispatch('contentLazyLoad', { content: this }).defaultPrevented) return;
        this.load(true);
      }
      keepPlaceholder() {
        return this.instance.applyFilters('isKeepingPlaceholder', this.isLoading(), this);
      }
      destroy() {
        this.hasSlide = false;
        this.slide = void 0;
        if (this.instance.dispatch('contentDestroy', { content: this }).defaultPrevented) return;
        this.remove();
        if (this.placeholder) {
          this.placeholder.destroy();
          this.placeholder = void 0;
        }
        if (this.isImageContent() && this.element) {
          this.element.onload = null;
          this.element.onerror = null;
          this.element = void 0;
        }
      }
      displayError() {
        if (this.slide) {
          let t, e;
          let i = Kt('pswp__error-msg', 'div');
          i.innerText =
            (t = (e = this.instance.options) === null || e === void 0 ? void 0 : e.errorMsg) !==
              null && t !== void 0
              ? t
              : '';
          i = this.instance.applyFilters('contentErrorElement', i, this);
          this.element = Kt('pswp__content pswp__error-msg-container', 'div');
          this.element.appendChild(i);
          this.slide.container.innerText = '';
          this.slide.container.appendChild(this.element);
          this.slide.updateContentSize(true);
          this.removePlaceholder();
        }
      }
      append() {
        if (this.isAttached || !this.element) return;
        this.isAttached = true;
        if (this.state === Jt.ERROR) {
          this.displayError();
          return;
        }
        if (this.instance.dispatch('contentAppend', { content: this }).defaultPrevented) return;
        const t = 'decode' in this.element;
        if (this.isImageContent())
          if (t && this.slide && (!this.slide.isActive || ne())) {
            this.isDecoding = true;
            this.element
              .decode()
              .catch(() => {})
              .finally(() => {
                this.isDecoding = false;
                this.appendImage();
              });
          } else this.appendImage();
        else if (this.slide && !this.element.parentNode)
          this.slide.container.appendChild(this.element);
      }
      activate() {
        if (
          this.instance.dispatch('contentActivate', { content: this }).defaultPrevented ||
          !this.slide
        )
          return;
        if (this.isImageContent() && this.isDecoding && !ne()) this.appendImage();
        else if (this.isError()) this.load(false, true);
        if (this.slide.holderElement) this.slide.holderElement.setAttribute('aria-hidden', 'false');
      }
      deactivate() {
        this.instance.dispatch('contentDeactivate', { content: this });
        if (this.slide && this.slide.holderElement)
          this.slide.holderElement.setAttribute('aria-hidden', 'true');
      }
      remove() {
        this.isAttached = false;
        if (this.instance.dispatch('contentRemove', { content: this }).defaultPrevented) return;
        if (this.element && this.element.parentNode) this.element.remove();
        if (this.placeholder && this.placeholder.element) this.placeholder.element.remove();
      }
      appendImage() {
        if (!this.isAttached) return;
        if (this.instance.dispatch('contentAppendImage', { content: this }).defaultPrevented)
          return;
        if (this.slide && this.element && !this.element.parentNode)
          this.slide.container.appendChild(this.element);
        if (this.state === Jt.LOADED || this.state === Jt.ERROR) this.removePlaceholder();
      }
    }
    function le(t, e) {
      if (t.getViewportSizeFn) {
        const i = t.getViewportSizeFn(t, e);
        if (i) return i;
      }
      return { x: document.documentElement.clientWidth, y: window.innerHeight };
    }
    function ce(t, e, i, n, s) {
      let r = 0;
      if (e.paddingFn) r = e.paddingFn(i, n, s)[t];
      else if (e.padding) r = e.padding[t];
      else {
        const i = 'padding' + t[0].toUpperCase() + t.slice(1);
        if (e[i]) r = e[i];
      }
      return Number(r) || 0;
    }
    function he(t, e, i, n) {
      return {
        x: e.x - ce('left', t, e, i, n) - ce('right', t, e, i, n),
        y: e.y - ce('top', t, e, i, n) - ce('bottom', t, e, i, n),
      };
    }
    const ue = 4e3;
    class de {
      constructor(t, e, i, n) {
        this.pswp = n;
        this.options = t;
        this.itemData = e;
        this.index = i;
        this.panAreaSize = null;
        this.elementSize = null;
        this.fit = 1;
        this.fill = 1;
        this.vFill = 1;
        this.initial = 1;
        this.secondary = 1;
        this.max = 1;
        this.min = 1;
      }
      update(t, e, i) {
        const n = { x: t, y: e };
        this.elementSize = n;
        this.panAreaSize = i;
        const s = i.x / n.x;
        const r = i.y / n.y;
        this.fit = Math.min(1, s < r ? s : r);
        this.fill = Math.min(1, s > r ? s : r);
        this.vFill = Math.min(1, r);
        this.initial = this._getInitial();
        this.secondary = this._getSecondary();
        this.max = Math.max(this.initial, this.secondary, this._getMax());
        this.min = Math.min(this.fit, this.initial, this.secondary);
        if (this.pswp)
          this.pswp.dispatch('zoomLevelsUpdate', { zoomLevels: this, slideData: this.itemData });
      }
      _parseZoomLevelOption(t) {
        const e = t + 'ZoomLevel';
        const i = this.options[e];
        if (!i) return;
        if (typeof i === 'function') return i(this);
        if (i === 'fill') return this.fill;
        if (i === 'fit') return this.fit;
        return Number(i);
      }
      _getSecondary() {
        let t = this._parseZoomLevelOption('secondary');
        if (t) return t;
        t = Math.min(1, this.fit * 3);
        if (this.elementSize && t * this.elementSize.x > ue) t = ue / this.elementSize.x;
        return t;
      }
      _getInitial() {
        return this._parseZoomLevelOption('initial') || this.fit;
      }
      _getMax() {
        return this._parseZoomLevelOption('max') || Math.max(1, this.fit * 4);
      }
    }
    function fe(t, e, i) {
      const n = e.createContentFromData(t, i);
      let s;
      const { options: r } = e;
      if (r) {
        s = new de(r, t, -1);
        let o;
        if (e.pswp) o = e.pswp.viewportSize;
        else o = le(r, e);
        const a = he(r, o, t, i);
        s.update(n.width, n.height, a);
      }
      n.lazyLoad();
      if (s) n.setDisplayedSize(Math.ceil(n.width * s.initial), Math.ceil(n.height * s.initial));
      return n;
    }
    function pe(t, e) {
      const i = e.getItemData(t);
      if (e.dispatch('lazyLoadSlide', { index: t, itemData: i }).defaultPrevented) return;
      return fe(i, e, t);
    }
    class ve extends re {
      getNumItems() {
        let t;
        let e = 0;
        const i = (t = this.options) === null || t === void 0 ? void 0 : t.dataSource;
        if (i && 'length' in i) e = i.length;
        else if (i && 'gallery' in i) {
          if (!i.items) i.items = this._getGalleryDOMElements(i.gallery);
          if (i.items) e = i.items.length;
        }
        const n = this.dispatch('numItems', { dataSource: i, numItems: e });
        return this.applyFilters('numItems', n.numItems, i);
      }
      createContentFromData(t, e) {
        return new ae(t, this, e);
      }
      getItemData(t) {
        let e;
        const i = (e = this.options) === null || e === void 0 ? void 0 : e.dataSource;
        let n = {};
        if (Array.isArray(i)) n = i[t];
        else if (i && 'gallery' in i) {
          if (!i.items) i.items = this._getGalleryDOMElements(i.gallery);
          n = i.items[t];
        }
        let s = n;
        if (s instanceof Element) s = this._domElementToItemData(s);
        const r = this.dispatch('itemData', { itemData: s || {}, index: t });
        return this.applyFilters('itemData', r.itemData, t);
      }
      _getGalleryDOMElements(t) {
        let e, i;
        if (
          ((e = this.options) !== null && e !== void 0 && e.children) ||
          ((i = this.options) !== null && i !== void 0 && i.childSelector)
        )
          return ee(this.options.children, this.options.childSelector, t) || [];
        return [t];
      }
      _domElementToItemData(t) {
        const e = { element: t };
        const i = t.tagName === 'A' ? t : t.querySelector('a');
        if (i) {
          e.src = i.dataset.pswpSrc || i.href;
          if (i.dataset.pswpSrcset) e.srcset = i.dataset.pswpSrcset;
          e.width = i.dataset.pswpWidth ? parseInt(i.dataset.pswpWidth, 10) : 0;
          e.height = i.dataset.pswpHeight ? parseInt(i.dataset.pswpHeight, 10) : 0;
          e.w = e.width;
          e.h = e.height;
          if (i.dataset.pswpType) e.type = i.dataset.pswpType;
          const s = t.querySelector('img');
          if (s) {
            let n;
            e.msrc = s.currentSrc || s.src;
            e.alt = (n = s.getAttribute('alt')) !== null && n !== void 0 ? n : '';
          }
          if (i.dataset.pswpCropped || i.dataset.cropped) e.thumbCropped = true;
        }
        return this.applyFilters('domItemData', e, t, i);
      }
      lazyLoadData(t, e) {
        return fe(t, this, e);
      }
    }
    class me extends ve {
      constructor(t) {
        super();
        this.options = t || {};
        this._uid = 0;
        this.shouldOpen = false;
        this._preloadedContent = void 0;
        this.onThumbnailsClick = this.onThumbnailsClick.bind(this);
      }
      init() {
        ee(this.options.gallery, this.options.gallerySelector).forEach((t) => {
          t.addEventListener('click', this.onThumbnailsClick, false);
        });
      }
      onThumbnailsClick(t) {
        if (te(t) || window.pswp) return;
        let e = { x: t.clientX, y: t.clientY };
        if (!e.x && !e.y) e = null;
        let i = this.getClickedIndex(t);
        i = this.applyFilters('clickedIndex', i, t, this);
        const n = { gallery: t.currentTarget };
        if (i >= 0) {
          t.preventDefault();
          this.loadAndOpen(i, n, e);
        }
      }
      getClickedIndex(t) {
        if (this.options.getClickedIndexFn) return this.options.getClickedIndexFn.call(this, t);
        const e = t.target;
        const i = ee(this.options.children, this.options.childSelector, t.currentTarget);
        const n = i.findIndex((t) => t === e || t.contains(e));
        if (n !== -1) return n;
        else if (this.options.children || this.options.childSelector) return -1;
        return 0;
      }
      loadAndOpen(t, e, i) {
        if (window.pswp || !this.options) return false;
        if (!e && this.options.gallery && this.options.children) {
          const t = ee(this.options.gallery);
          if (t[0]) e = { gallery: t[0] };
        }
        this.options.index = t;
        this.options.initialPointerPos = i;
        this.shouldOpen = true;
        this.preload(t, e);
        return true;
      }
      preload(t, e) {
        const { options: i } = this;
        if (e) i.dataSource = e;
        const n = [];
        const s = typeof i.pswpModule;
        if (ie(i.pswpModule)) n.push(Promise.resolve(i.pswpModule));
        else if (s === 'string') throw new Error('pswpModule as string is no longer supported');
        else if (s === 'function') n.push(i.pswpModule());
        else throw new Error('pswpModule is not valid');
        if (typeof i.openPromise === 'function') n.push(i.openPromise());
        if (i.preloadFirstSlide !== false && t >= 0) this._preloadedContent = pe(t, this);
        const r = ++this._uid;
        Promise.all(n).then((t) => {
          if (this.shouldOpen) {
            const e = t[0];
            this._openPhotoswipe(e, r);
          }
        });
      }
      _openPhotoswipe(t, e) {
        if (e !== this._uid && this.shouldOpen) return;
        this.shouldOpen = false;
        if (window.pswp) return;
        const i = typeof t === 'object' ? new t.default(this.options) : new t(this.options);
        this.pswp = i;
        window.pswp = i;
        Object.keys(this._listeners).forEach((t) => {
          let e;
          (e = this._listeners[t]) === null ||
            e === void 0 ||
            e.forEach((e) => {
              i.on(t, e);
            });
        });
        Object.keys(this._filters).forEach((t) => {
          let e;
          (e = this._filters[t]) === null ||
            e === void 0 ||
            e.forEach((e) => {
              i.addFilter(t, e.fn, e.priority);
            });
        });
        if (this._preloadedContent) {
          i.contentLoader.addToCache(this._preloadedContent);
          this._preloadedContent = void 0;
        }
        i.on('destroy', () => {
          this.pswp = void 0;
          delete window.pswp;
        });
        i.init();
      }
      destroy() {
        let t;
        (t = this.pswp) === null || t === void 0 || t.destroy();
        this.shouldOpen = false;
        this._listeners = {};
        ee(this.options.gallery, this.options.gallerySelector).forEach((t) => {
          t.removeEventListener('click', this.onThumbnailsClick, false);
        });
      }
    }
    function ge(t) {
      if (t == null) return window;
      if (t.toString() !== '[object Window]') {
        const e = t.ownerDocument;
        return e ? e.defaultView || window : window;
      }
      return t;
    }
    function ye(t) {
      const e = ge(t).Element;
      return t instanceof e || t instanceof Element;
    }
    function we(t) {
      const e = ge(t).HTMLElement;
      return t instanceof e || t instanceof HTMLElement;
    }
    function be(t) {
      if (typeof ShadowRoot === 'undefined') return false;
      const e = ge(t).ShadowRoot;
      return t instanceof e || t instanceof ShadowRoot;
    }
    const xe = Math.max;
    const _e = Math.min;
    const Se = Math.round;
    function Ce() {
      const t = navigator.userAgentData;
      if (t != null && t.brands && Array.isArray(t.brands))
        return t.brands
          .map(function (t) {
            return t.brand + '/' + t.version;
          })
          .join(' ');
      return navigator.userAgent;
    }
    function Ee() {
      return !/^((?!chrome|android).)*safari/i.test(Ce());
    }
    function Pe(t, e, i) {
      if (e === void 0) e = false;
      if (i === void 0) i = false;
      const n = t.getBoundingClientRect();
      let s = 1;
      let r = 1;
      if (e && we(t)) {
        s = t.offsetWidth > 0 ? Se(n.width) / t.offsetWidth || 1 : 1;
        r = t.offsetHeight > 0 ? Se(n.height) / t.offsetHeight || 1 : 1;
      }
      const o = ye(t) ? ge(t) : window,
        a = o.visualViewport;
      const l = !Ee() && i;
      const c = (n.left + (l && a ? a.offsetLeft : 0)) / s;
      const h = (n.top + (l && a ? a.offsetTop : 0)) / r;
      const u = n.width / s;
      const d = n.height / r;
      return { width: u, height: d, top: h, right: c + u, bottom: h + d, left: c, x: c, y: h };
    }
    function Ae(t) {
      const e = ge(t);
      const i = e.pageXOffset;
      const n = e.pageYOffset;
      return { scrollLeft: i, scrollTop: n };
    }
    function Te(t) {
      return { scrollLeft: t.scrollLeft, scrollTop: t.scrollTop };
    }
    function De(t) {
      if (t === ge(t) || !we(t)) return Ae(t);
      else return Te(t);
    }
    function Le(t) {
      return t ? (t.nodeName || '').toLowerCase() : null;
    }
    function Oe(t) {
      return ((ye(t) ? t.ownerDocument : t.document) || window.document).documentElement;
    }
    function Ie(t) {
      return Pe(Oe(t)).left + Ae(t).scrollLeft;
    }
    function Me(t) {
      return ge(t).getComputedStyle(t);
    }
    function ke(t) {
      const e = Me(t),
        i = e.overflow,
        n = e.overflowX,
        s = e.overflowY;
      return /auto|scroll|overlay|hidden/.test(i + s + n);
    }
    function ze(t) {
      const e = t.getBoundingClientRect();
      const i = Se(e.width) / t.offsetWidth || 1;
      const n = Se(e.height) / t.offsetHeight || 1;
      return i !== 1 || n !== 1;
    }
    function Fe(t, e, i) {
      if (i === void 0) i = false;
      const n = we(e);
      const s = we(e) && ze(e);
      const r = Oe(e);
      const o = Pe(t, s, i);
      let a = { scrollLeft: 0, scrollTop: 0 };
      let l = { x: 0, y: 0 };
      if (n || (!n && !i)) {
        if (Le(e) !== 'body' || ke(r)) a = De(e);
        if (we(e)) {
          l = Pe(e, true);
          l.x += e.clientLeft;
          l.y += e.clientTop;
        } else if (r) l.x = Ie(r);
      }
      return {
        x: o.left + a.scrollLeft - l.x,
        y: o.top + a.scrollTop - l.y,
        width: o.width,
        height: o.height,
      };
    }
    function Re(t) {
      const e = Pe(t);
      let i = t.offsetWidth;
      let n = t.offsetHeight;
      if (Math.abs(e.width - i) <= 1) i = e.width;
      if (Math.abs(e.height - n) <= 1) n = e.height;
      return { x: t.offsetLeft, y: t.offsetTop, width: i, height: n };
    }
    function Ve(t) {
      if (Le(t) === 'html') return t;
      return t.assignedSlot || t.parentNode || (be(t) ? t.host : null) || Oe(t);
    }
    function Be(t) {
      if (['html', 'body', '#document'].indexOf(Le(t)) >= 0) return t.ownerDocument.body;
      if (we(t) && ke(t)) return t;
      return Be(Ve(t));
    }
    function Ne(t, e) {
      let i;
      if (e === void 0) e = [];
      const n = Be(t);
      const s = n === ((i = t.ownerDocument) == null ? void 0 : i.body);
      const r = ge(n);
      const o = s ? [r].concat(r.visualViewport || [], ke(n) ? n : []) : n;
      const a = e.concat(o);
      return s ? a : a.concat(Ne(Ve(o)));
    }
    function We(t) {
      return ['table', 'td', 'th'].indexOf(Le(t)) >= 0;
    }
    function Ze(t) {
      if (!we(t) || Me(t).position === 'fixed') return null;
      return t.offsetParent;
    }
    function He(t) {
      const e = /firefox/i.test(Ce());
      const i = /Trident/i.test(Ce());
      if (i && we(t)) {
        const n = Me(t);
        if (n.position === 'fixed') return null;
      }
      let s = Ve(t);
      if (be(s)) s = s.host;
      while (we(s) && ['html', 'body'].indexOf(Le(s)) < 0) {
        const r = Me(s);
        if (
          r.transform !== 'none' ||
          r.perspective !== 'none' ||
          r.contain === 'paint' ||
          ['transform', 'perspective'].indexOf(r.willChange) !== -1 ||
          (e && r.willChange === 'filter') ||
          (e && r.filter && r.filter !== 'none')
        )
          return s;
        else s = s.parentNode;
      }
      return null;
    }
    function je(t) {
      const e = ge(t);
      let i = Ze(t);
      while (i && We(i) && Me(i).position === 'static') i = Ze(i);
      if (i && (Le(i) === 'html' || (Le(i) === 'body' && Me(i).position === 'static'))) return e;
      return i || He(t) || e;
    }
    const Ue = 'top';
    const qe = 'bottom';
    const $e = 'right';
    const Xe = 'left';
    const Ge = 'auto';
    const Ke = [Ue, qe, $e, Xe];
    const Ye = 'start';
    const Qe = 'end';
    const Je = 'clippingParents';
    const ti = 'viewport';
    const ei = 'popper';
    const ii = 'reference';
    const ni = Ke.reduce(function (t, e) {
      return t.concat([e + '-' + Ye, e + '-' + Qe]);
    }, []);
    const si = [].concat(Ke, [Ge]).reduce(function (t, e) {
      return t.concat([e, e + '-' + Ye, e + '-' + Qe]);
    }, []);
    const ri = 'beforeRead';
    const oi = 'read';
    const ai = 'afterRead';
    const li = 'beforeMain';
    const ci = 'main';
    const hi = 'afterMain';
    const ui = 'beforeWrite';
    const di = 'write';
    const fi = 'afterWrite';
    const pi = [ri, oi, ai, li, ci, hi, ui, di, fi];
    function vi(t) {
      const e = new Map();
      const i = new Set();
      const n = [];
      t.forEach(function (t) {
        e.set(t.name, t);
      });
      function s(t) {
        i.add(t.name);
        const r = [].concat(t.requires || [], t.requiresIfExists || []);
        r.forEach(function (t) {
          if (!i.has(t)) {
            const n = e.get(t);
            if (n) s(n);
          }
        });
        n.push(t);
      }
      t.forEach(function (t) {
        if (!i.has(t.name)) s(t);
      });
      return n;
    }
    function mi(t) {
      const e = vi(t);
      return pi.reduce(function (t, i) {
        return t.concat(
          e.filter(function (t) {
            return t.phase === i;
          })
        );
      }, []);
    }
    function gi(t) {
      let e;
      return function () {
        if (!e)
          e = new Promise(function (i) {
            Promise.resolve().then(function () {
              e = void 0;
              i(t());
            });
          });
        return e;
      };
    }
    function yi(t) {
      const e = t.reduce(function (t, e) {
        const i = t[e.name];
        t[e.name] = i
          ? Object.assign({}, i, e, {
              options: Object.assign({}, i.options, e.options),
              data: Object.assign({}, i.data, e.data),
            })
          : e;
        return t;
      }, {});
      return Object.keys(e).map(function (t) {
        return e[t];
      });
    }
    const wi = { placement: 'bottom', modifiers: [], strategy: 'absolute' };
    function bi() {
      for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++) e[i] = arguments[i];
      return !e.some(function (t) {
        return !(t && typeof t.getBoundingClientRect === 'function');
      });
    }
    function xi(t) {
      if (t === void 0) t = {};
      const e = t,
        i = e.defaultModifiers,
        n = i === void 0 ? [] : i,
        s = e.defaultOptions,
        r = s === void 0 ? wi : s;
      return function t(e, i, s) {
        if (s === void 0) s = r;
        let o = {
          placement: 'bottom',
          orderedModifiers: [],
          options: Object.assign({}, wi, r),
          modifiersData: {},
          elements: { reference: e, popper: i },
          attributes: {},
          styles: {},
        };
        let a = [];
        let l = false;
        var c = {
          state: o,
          setOptions: function t(s) {
            const a = typeof s === 'function' ? s(o.options) : s;
            u();
            o.options = Object.assign({}, r, o.options, a);
            o.scrollParents = {
              reference: ye(e) ? Ne(e) : e.contextElement ? Ne(e.contextElement) : [],
              popper: Ne(i),
            };
            const l = mi(yi([].concat(n, o.options.modifiers)));
            o.orderedModifiers = l.filter(function (t) {
              return t.enabled;
            });
            h();
            return c.update();
          },
          forceUpdate: function t() {
            if (l) return;
            const e = o.elements,
              i = e.reference,
              n = e.popper;
            if (!bi(i, n)) return;
            o.rects = { reference: Fe(i, je(n), o.options.strategy === 'fixed'), popper: Re(n) };
            o.reset = false;
            o.placement = o.options.placement;
            o.orderedModifiers.forEach(function (t) {
              return (o.modifiersData[t.name] = Object.assign({}, t.data));
            });
            for (let s = 0; s < o.orderedModifiers.length; s++) {
              if (o.reset === true) {
                o.reset = false;
                s = -1;
                continue;
              }
              const r = o.orderedModifiers[s],
                a = r.fn,
                h = r.options,
                u = h === void 0 ? {} : h,
                d = r.name;
              if (typeof a === 'function')
                o = a({ state: o, options: u, name: d, instance: c }) || o;
            }
          },
          update: gi(function () {
            return new Promise(function (t) {
              c.forceUpdate();
              t(o);
            });
          }),
          destroy: function t() {
            u();
            l = true;
          },
        };
        if (!bi(e, i)) return c;
        c.setOptions(s).then(function (t) {
          if (!l && s.onFirstUpdate) s.onFirstUpdate(t);
        });
        function h() {
          o.orderedModifiers.forEach(function (t) {
            const e = t.name,
              i = t.options,
              n = i === void 0 ? {} : i,
              s = t.effect;
            if (typeof s === 'function') {
              const r = s({ state: o, name: e, instance: c, options: n });
              const l = function t() {};
              a.push(r || l);
            }
          });
        }
        function u() {
          a.forEach(function (t) {
            return t();
          });
          a = [];
        }
        return c;
      };
    }
    const _i = null && xi();
    const Si = { passive: true };
    function Ci(t) {
      const e = t.state,
        i = t.instance,
        n = t.options;
      const s = n.scroll,
        r = s === void 0 ? true : s,
        o = n.resize,
        a = o === void 0 ? true : o;
      const l = ge(e.elements.popper);
      const c = [].concat(e.scrollParents.reference, e.scrollParents.popper);
      if (r)
        c.forEach(function (t) {
          t.addEventListener('scroll', i.update, Si);
        });
      if (a) l.addEventListener('resize', i.update, Si);
      return function () {
        if (r)
          c.forEach(function (t) {
            t.removeEventListener('scroll', i.update, Si);
          });
        if (a) l.removeEventListener('resize', i.update, Si);
      };
    }
    const Ei = {
      name: 'eventListeners',
      enabled: true,
      phase: 'write',
      fn: function t() {},
      effect: Ci,
      data: {},
    };
    function Pi(t) {
      return t.split('-')[0];
    }
    function Ai(t) {
      return t.split('-')[1];
    }
    function Ti(t) {
      return ['top', 'bottom'].indexOf(t) >= 0 ? 'x' : 'y';
    }
    function Di(t) {
      const e = t.reference,
        i = t.element,
        n = t.placement;
      const s = n ? Pi(n) : null;
      const r = n ? Ai(n) : null;
      const o = e.x + e.width / 2 - i.width / 2;
      const a = e.y + e.height / 2 - i.height / 2;
      let l;
      switch (s) {
        case Ue:
          l = { x: o, y: e.y - i.height };
          break;
        case qe:
          l = { x: o, y: e.y + e.height };
          break;
        case $e:
          l = { x: e.x + e.width, y: a };
          break;
        case Xe:
          l = { x: e.x - i.width, y: a };
          break;
        default:
          l = { x: e.x, y: e.y };
      }
      const c = s ? Ti(s) : null;
      if (c != null) {
        const h = c === 'y' ? 'height' : 'width';
        switch (r) {
          case Ye:
            l[c] = l[c] - (e[h] / 2 - i[h] / 2);
            break;
          case Qe:
            l[c] = l[c] + (e[h] / 2 - i[h] / 2);
            break;
          default:
        }
      }
      return l;
    }
    function Li(t) {
      const e = t.state,
        i = t.name;
      e.modifiersData[i] = Di({
        reference: e.rects.reference,
        element: e.rects.popper,
        strategy: 'absolute',
        placement: e.placement,
      });
    }
    const Oi = { name: 'popperOffsets', enabled: true, phase: 'read', fn: Li, data: {} };
    const Ii = { top: 'auto', right: 'auto', bottom: 'auto', left: 'auto' };
    function Mi(t, e) {
      const i = t.x,
        n = t.y;
      const s = e.devicePixelRatio || 1;
      return { x: Se(i * s) / s || 0, y: Se(n * s) / s || 0 };
    }
    function ki(t) {
      let e;
      const i = t.popper,
        n = t.popperRect,
        s = t.placement,
        r = t.variation,
        o = t.offsets,
        a = t.position,
        l = t.gpuAcceleration,
        c = t.adaptive,
        h = t.roundOffsets,
        u = t.isFixed;
      let d = o.x,
        f = d === void 0 ? 0 : d,
        p = o.y,
        v = p === void 0 ? 0 : p;
      const m = typeof h === 'function' ? h({ x: f, y: v }) : { x: f, y: v };
      f = m.x;
      v = m.y;
      const g = o.hasOwnProperty('x');
      const y = o.hasOwnProperty('y');
      let w = Xe;
      let b = Ue;
      const x = window;
      if (c) {
        let _ = je(i);
        let S = 'clientHeight';
        let C = 'clientWidth';
        if (_ === ge(i)) {
          _ = Oe(i);
          if (Me(_).position !== 'static' && a === 'absolute') {
            S = 'scrollHeight';
            C = 'scrollWidth';
          }
        }
        _;
        if (s === Ue || ((s === Xe || s === $e) && r === Qe)) {
          b = qe;
          const E = u && _ === x && x.visualViewport ? x.visualViewport.height : _[S];
          v -= E - n.height;
          v *= l ? 1 : -1;
        }
        if (s === Xe || ((s === Ue || s === qe) && r === Qe)) {
          w = $e;
          const P = u && _ === x && x.visualViewport ? x.visualViewport.width : _[C];
          f -= P - n.width;
          f *= l ? 1 : -1;
        }
      }
      const A = Object.assign({ position: a }, c && Ii);
      const T = h === true ? Mi({ x: f, y: v }, ge(i)) : { x: f, y: v };
      f = T.x;
      v = T.y;
      if (l) {
        let D;
        return Object.assign(
          {},
          A,
          ((D = {}),
          (D[b] = y ? '0' : ''),
          (D[w] = g ? '0' : ''),
          (D.transform =
            (x.devicePixelRatio || 1) <= 1
              ? 'translate(' + f + 'px, ' + v + 'px)'
              : 'translate3d(' + f + 'px, ' + v + 'px, 0)'),
          D)
        );
      }
      return Object.assign(
        {},
        A,
        ((e = {}), (e[b] = y ? v + 'px' : ''), (e[w] = g ? f + 'px' : ''), (e.transform = ''), e)
      );
    }
    function zi(t) {
      const e = t.state,
        i = t.options;
      const n = i.gpuAcceleration,
        s = n === void 0 ? true : n,
        r = i.adaptive,
        o = r === void 0 ? true : r,
        a = i.roundOffsets,
        l = a === void 0 ? true : a;
      const c = {
        placement: Pi(e.placement),
        variation: Ai(e.placement),
        popper: e.elements.popper,
        popperRect: e.rects.popper,
        gpuAcceleration: s,
        isFixed: e.options.strategy === 'fixed',
      };
      if (e.modifiersData.popperOffsets != null)
        e.styles.popper = Object.assign(
          {},
          e.styles.popper,
          ki(
            Object.assign({}, c, {
              offsets: e.modifiersData.popperOffsets,
              position: e.options.strategy,
              adaptive: o,
              roundOffsets: l,
            })
          )
        );
      if (e.modifiersData.arrow != null)
        e.styles.arrow = Object.assign(
          {},
          e.styles.arrow,
          ki(
            Object.assign({}, c, {
              offsets: e.modifiersData.arrow,
              position: 'absolute',
              adaptive: false,
              roundOffsets: l,
            })
          )
        );
      e.attributes.popper = Object.assign({}, e.attributes.popper, {
        'data-popper-placement': e.placement,
      });
    }
    const Fi = { name: 'computeStyles', enabled: true, phase: 'beforeWrite', fn: zi, data: {} };
    function Ri(t) {
      const e = t.state;
      Object.keys(e.elements).forEach(function (t) {
        const i = e.styles[t] || {};
        const n = e.attributes[t] || {};
        const s = e.elements[t];
        if (!we(s) || !Le(s)) return;
        Object.assign(s.style, i);
        Object.keys(n).forEach(function (t) {
          const e = n[t];
          if (e === false) s.removeAttribute(t);
          else s.setAttribute(t, e === true ? '' : e);
        });
      });
    }
    function Vi(t) {
      const e = t.state;
      const i = {
        popper: { position: e.options.strategy, left: '0', top: '0', margin: '0' },
        arrow: { position: 'absolute' },
        reference: {},
      };
      Object.assign(e.elements.popper.style, i.popper);
      e.styles = i;
      if (e.elements.arrow) Object.assign(e.elements.arrow.style, i.arrow);
      return function () {
        Object.keys(e.elements).forEach(function (t) {
          const n = e.elements[t];
          const s = e.attributes[t] || {};
          const r = Object.keys(e.styles.hasOwnProperty(t) ? e.styles[t] : i[t]);
          const o = r.reduce(function (t, e) {
            t[e] = '';
            return t;
          }, {});
          if (!we(n) || !Le(n)) return;
          Object.assign(n.style, o);
          Object.keys(s).forEach(function (t) {
            n.removeAttribute(t);
          });
        });
      };
    }
    const Bi = {
      name: 'applyStyles',
      enabled: true,
      phase: 'write',
      fn: Ri,
      effect: Vi,
      requires: ['computeStyles'],
    };
    function Ni(t, e, i) {
      const n = Pi(t);
      const s = [Xe, Ue].indexOf(n) >= 0 ? -1 : 1;
      let r = typeof i === 'function' ? i(Object.assign({}, e, { placement: t })) : i,
        o = r[0],
        a = r[1];
      o = o || 0;
      a = (a || 0) * s;
      return [Xe, $e].indexOf(n) >= 0 ? { x: a, y: o } : { x: o, y: a };
    }
    function Wi(t) {
      const e = t.state,
        i = t.options,
        n = t.name;
      const s = i.offset,
        r = s === void 0 ? [0, 0] : s;
      const o = si.reduce(function (t, i) {
        t[i] = Ni(i, e.rects, r);
        return t;
      }, {});
      const a = o[e.placement],
        l = a.x,
        c = a.y;
      if (e.modifiersData.popperOffsets != null) {
        e.modifiersData.popperOffsets.x += l;
        e.modifiersData.popperOffsets.y += c;
      }
      e.modifiersData[n] = o;
    }
    const Zi = {
      name: 'offset',
      enabled: true,
      phase: 'main',
      requires: ['popperOffsets'],
      fn: Wi,
    };
    const Hi = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
    function ji(t) {
      return t.replace(/left|right|bottom|top/g, function (t) {
        return Hi[t];
      });
    }
    const Ui = { start: 'end', end: 'start' };
    function qi(t) {
      return t.replace(/start|end/g, function (t) {
        return Ui[t];
      });
    }
    function $i(t, e) {
      const i = ge(t);
      const n = Oe(t);
      const s = i.visualViewport;
      let r = n.clientWidth;
      let o = n.clientHeight;
      let a = 0;
      let l = 0;
      if (s) {
        r = s.width;
        o = s.height;
        const c = Ee();
        if (c || (!c && e === 'fixed')) {
          a = s.offsetLeft;
          l = s.offsetTop;
        }
      }
      return { width: r, height: o, x: a + Ie(t), y: l };
    }
    function Xi(t) {
      let e;
      const i = Oe(t);
      const n = Ae(t);
      const s = (e = t.ownerDocument) == null ? void 0 : e.body;
      const r = xe(i.scrollWidth, i.clientWidth, s ? s.scrollWidth : 0, s ? s.clientWidth : 0);
      const o = xe(i.scrollHeight, i.clientHeight, s ? s.scrollHeight : 0, s ? s.clientHeight : 0);
      let a = -n.scrollLeft + Ie(t);
      const l = -n.scrollTop;
      if (Me(s || i).direction === 'rtl') a += xe(i.clientWidth, s ? s.clientWidth : 0) - r;
      return { width: r, height: o, x: a, y: l };
    }
    function Gi(t, e) {
      const i = e.getRootNode && e.getRootNode();
      if (t.contains(e)) return true;
      else if (i && be(i)) {
        let n = e;
        do {
          if (n && t.isSameNode(n)) return true;
          n = n.parentNode || n.host;
        } while (n);
      }
      return false;
    }
    function Ki(t) {
      return Object.assign({}, t, {
        left: t.x,
        top: t.y,
        right: t.x + t.width,
        bottom: t.y + t.height,
      });
    }
    function Yi(t, e) {
      const i = Pe(t, false, e === 'fixed');
      i.top = i.top + t.clientTop;
      i.left = i.left + t.clientLeft;
      i.bottom = i.top + t.clientHeight;
      i.right = i.left + t.clientWidth;
      i.width = t.clientWidth;
      i.height = t.clientHeight;
      i.x = i.left;
      i.y = i.top;
      return i;
    }
    function Qi(t, e, i) {
      return e === ti ? Ki($i(t, i)) : ye(e) ? Yi(e, i) : Ki(Xi(Oe(t)));
    }
    function Ji(t) {
      const e = Ne(Ve(t));
      const i = ['absolute', 'fixed'].indexOf(Me(t).position) >= 0;
      const n = i && we(t) ? je(t) : t;
      if (!ye(n)) return [];
      return e.filter(function (t) {
        return ye(t) && Gi(t, n) && Le(t) !== 'body';
      });
    }
    function tn(t, e, i, n) {
      const s = e === 'clippingParents' ? Ji(t) : [].concat(e);
      const r = [].concat(s, [i]);
      const o = r[0];
      const a = r.reduce(
        function (e, i) {
          const s = Qi(t, i, n);
          e.top = xe(s.top, e.top);
          e.right = _e(s.right, e.right);
          e.bottom = _e(s.bottom, e.bottom);
          e.left = xe(s.left, e.left);
          return e;
        },
        Qi(t, o, n)
      );
      a.width = a.right - a.left;
      a.height = a.bottom - a.top;
      a.x = a.left;
      a.y = a.top;
      return a;
    }
    function en() {
      return { top: 0, right: 0, bottom: 0, left: 0 };
    }
    function nn(t) {
      return Object.assign({}, en(), t);
    }
    function sn(t, e) {
      return e.reduce(function (e, i) {
        e[i] = t;
        return e;
      }, {});
    }
    function rn(t, e) {
      if (e === void 0) e = {};
      const i = e,
        n = i.placement,
        s = n === void 0 ? t.placement : n,
        r = i.strategy,
        o = r === void 0 ? t.strategy : r,
        a = i.boundary,
        l = a === void 0 ? Je : a,
        c = i.rootBoundary,
        h = c === void 0 ? ti : c,
        u = i.elementContext,
        d = u === void 0 ? ei : u,
        f = i.altBoundary,
        p = f === void 0 ? false : f,
        v = i.padding,
        m = v === void 0 ? 0 : v;
      const g = nn(typeof m !== 'number' ? m : sn(m, Ke));
      const y = d === ei ? ii : ei;
      const w = t.rects.popper;
      const b = t.elements[p ? y : d];
      const x = tn(ye(b) ? b : b.contextElement || Oe(t.elements.popper), l, h, o);
      const _ = Pe(t.elements.reference);
      const S = Di({ reference: _, element: w, strategy: 'absolute', placement: s });
      const C = Ki(Object.assign({}, w, S));
      const E = d === ei ? C : _;
      const P = {
        top: x.top - E.top + g.top,
        bottom: E.bottom - x.bottom + g.bottom,
        left: x.left - E.left + g.left,
        right: E.right - x.right + g.right,
      };
      const A = t.modifiersData.offset;
      if (d === ei && A) {
        const T = A[s];
        Object.keys(P).forEach(function (t) {
          const e = [$e, qe].indexOf(t) >= 0 ? 1 : -1;
          const i = [Ue, qe].indexOf(t) >= 0 ? 'y' : 'x';
          P[t] += T[i] * e;
        });
      }
      return P;
    }
    function on(t, e) {
      if (e === void 0) e = {};
      const i = e,
        n = i.placement,
        s = i.boundary,
        r = i.rootBoundary,
        o = i.padding,
        a = i.flipVariations,
        l = i.allowedAutoPlacements,
        c = l === void 0 ? si : l;
      const h = Ai(n);
      const u = h
        ? a
          ? ni
          : ni.filter(function (t) {
              return Ai(t) === h;
            })
        : Ke;
      let d = u.filter(function (t) {
        return c.indexOf(t) >= 0;
      });
      if (d.length === 0) d = u;
      const f = d.reduce(function (e, i) {
        e[i] = rn(t, { placement: i, boundary: s, rootBoundary: r, padding: o })[Pi(i)];
        return e;
      }, {});
      return Object.keys(f).sort(function (t, e) {
        return f[t] - f[e];
      });
    }
    function an(t) {
      if (Pi(t) === Ge) return [];
      const e = ji(t);
      return [qi(t), e, qi(e)];
    }
    function ln(t) {
      const e = t.state,
        i = t.options,
        n = t.name;
      if (e.modifiersData[n]._skip) return;
      const s = i.mainAxis,
        r = s === void 0 ? true : s,
        o = i.altAxis,
        a = o === void 0 ? true : o,
        l = i.fallbackPlacements,
        c = i.padding,
        h = i.boundary,
        u = i.rootBoundary,
        d = i.altBoundary,
        f = i.flipVariations,
        p = f === void 0 ? true : f,
        v = i.allowedAutoPlacements;
      const m = e.options.placement;
      const g = Pi(m);
      const y = g === m;
      const w = l || (y || !p ? [ji(m)] : an(m));
      const b = [m].concat(w).reduce(function (t, i) {
        return t.concat(
          Pi(i) === Ge
            ? on(e, {
                placement: i,
                boundary: h,
                rootBoundary: u,
                padding: c,
                flipVariations: p,
                allowedAutoPlacements: v,
              })
            : i
        );
      }, []);
      const x = e.rects.reference;
      const _ = e.rects.popper;
      const S = new Map();
      let C = true;
      let E = b[0];
      for (let P = 0; P < b.length; P++) {
        const A = b[P];
        const T = Pi(A);
        const D = Ai(A) === Ye;
        const L = [Ue, qe].indexOf(T) >= 0;
        const O = L ? 'width' : 'height';
        const I = rn(e, { placement: A, boundary: h, rootBoundary: u, altBoundary: d, padding: c });
        let M = L ? (D ? $e : Xe) : D ? qe : Ue;
        if (x[O] > _[O]) M = ji(M);
        const k = ji(M);
        const z = [];
        if (r) z.push(I[T] <= 0);
        if (a) z.push(I[M] <= 0, I[k] <= 0);
        if (
          z.every(function (t) {
            return t;
          })
        ) {
          E = A;
          C = false;
          break;
        }
        S.set(A, z);
      }
      if (C) {
        const F = p ? 3 : 1;
        const R = function t(e) {
          const i = b.find(function (t) {
            const i = S.get(t);
            if (i)
              return i.slice(0, e).every(function (t) {
                return t;
              });
          });
          if (i) {
            E = i;
            return 'break';
          }
        };
        for (let V = F; V > 0; V--) {
          const B = R(V);
          if (B === 'break') break;
        }
      }
      if (e.placement !== E) {
        e.modifiersData[n]._skip = true;
        e.placement = E;
        e.reset = true;
      }
    }
    const cn = {
      name: 'flip',
      enabled: true,
      phase: 'main',
      fn: ln,
      requiresIfExists: ['offset'],
      data: { _skip: false },
    };
    function hn(t) {
      return t === 'x' ? 'y' : 'x';
    }
    function un(t, e, i) {
      return xe(t, _e(e, i));
    }
    function dn(t, e, i) {
      const n = un(t, e, i);
      return n > i ? i : n;
    }
    function fn(t) {
      const e = t.state,
        i = t.options,
        n = t.name;
      const s = i.mainAxis,
        r = s === void 0 ? true : s,
        o = i.altAxis,
        a = o === void 0 ? false : o,
        l = i.boundary,
        c = i.rootBoundary,
        h = i.altBoundary,
        u = i.padding,
        d = i.tether,
        f = d === void 0 ? true : d,
        p = i.tetherOffset,
        v = p === void 0 ? 0 : p;
      const m = rn(e, { boundary: l, rootBoundary: c, padding: u, altBoundary: h });
      const g = Pi(e.placement);
      const y = Ai(e.placement);
      const w = !y;
      const b = Ti(g);
      const x = hn(b);
      const _ = e.modifiersData.popperOffsets;
      const S = e.rects.reference;
      const C = e.rects.popper;
      const E =
        typeof v === 'function' ? v(Object.assign({}, e.rects, { placement: e.placement })) : v;
      const P =
        typeof E === 'number'
          ? { mainAxis: E, altAxis: E }
          : Object.assign({ mainAxis: 0, altAxis: 0 }, E);
      const A = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null;
      const T = { x: 0, y: 0 };
      if (!_) return;
      if (r) {
        let D;
        const L = b === 'y' ? Ue : Xe;
        const O = b === 'y' ? qe : $e;
        const I = b === 'y' ? 'height' : 'width';
        const M = _[b];
        const k = M + m[L];
        const z = M - m[O];
        const F = f ? -C[I] / 2 : 0;
        const R = y === Ye ? S[I] : C[I];
        const V = y === Ye ? -C[I] : -S[I];
        const B = e.elements.arrow;
        const N = f && B ? Re(B) : { width: 0, height: 0 };
        const W = e.modifiersData['arrow#persistent']
          ? e.modifiersData['arrow#persistent'].padding
          : en();
        const Z = W[L];
        const H = W[O];
        const j = un(0, S[I], N[I]);
        const U = w ? S[I] / 2 - F - j - Z - P.mainAxis : R - j - Z - P.mainAxis;
        const q = w ? -S[I] / 2 + F + j + H + P.mainAxis : V + j + H + P.mainAxis;
        const $ = e.elements.arrow && je(e.elements.arrow);
        const X = $ ? (b === 'y' ? $.clientTop || 0 : $.clientLeft || 0) : 0;
        const G = (D = A == null ? void 0 : A[b]) != null ? D : 0;
        const K = M + U - G - X;
        const Y = M + q - G;
        const Q = un(f ? _e(k, K) : k, M, f ? xe(z, Y) : z);
        _[b] = Q;
        T[b] = Q - M;
      }
      if (a) {
        let J;
        const tt = b === 'x' ? Ue : Xe;
        const et = b === 'x' ? qe : $e;
        const it = _[x];
        const nt = x === 'y' ? 'height' : 'width';
        const st = it + m[tt];
        const rt = it - m[et];
        const ot = [Ue, Xe].indexOf(g) !== -1;
        const at = (J = A == null ? void 0 : A[x]) != null ? J : 0;
        const lt = ot ? st : it - S[nt] - C[nt] - at + P.altAxis;
        const ct = ot ? it + S[nt] + C[nt] - at - P.altAxis : rt;
        const ht = f && ot ? dn(lt, it, ct) : un(f ? lt : st, it, f ? ct : rt);
        _[x] = ht;
        T[x] = ht - it;
      }
      e.modifiersData[n] = T;
    }
    const pn = {
      name: 'preventOverflow',
      enabled: true,
      phase: 'main',
      fn,
      requiresIfExists: ['offset'],
    };
    const vn = function t(e, i) {
      e = typeof e === 'function' ? e(Object.assign({}, i.rects, { placement: i.placement })) : e;
      return nn(typeof e !== 'number' ? e : sn(e, Ke));
    };
    function mn(t) {
      let e;
      const i = t.state,
        n = t.name,
        s = t.options;
      const r = i.elements.arrow;
      const o = i.modifiersData.popperOffsets;
      const a = Pi(i.placement);
      const l = Ti(a);
      const c = [Xe, $e].indexOf(a) >= 0;
      const h = c ? 'height' : 'width';
      if (!r || !o) return;
      const u = vn(s.padding, i);
      const d = Re(r);
      const f = l === 'y' ? Ue : Xe;
      const p = l === 'y' ? qe : $e;
      const v = i.rects.reference[h] + i.rects.reference[l] - o[l] - i.rects.popper[h];
      const m = o[l] - i.rects.reference[l];
      const g = je(r);
      const y = g ? (l === 'y' ? g.clientHeight || 0 : g.clientWidth || 0) : 0;
      const w = v / 2 - m / 2;
      const b = u[f];
      const x = y - d[h] - u[p];
      const _ = y / 2 - d[h] / 2 + w;
      const S = un(b, _, x);
      const C = l;
      i.modifiersData[n] = ((e = {}), (e[C] = S), (e.centerOffset = S - _), e);
    }
    function gn(t) {
      const e = t.state,
        i = t.options;
      let n = i.element,
        s = n === void 0 ? '[data-popper-arrow]' : n;
      if (s == null) return;
      if (typeof s === 'string') {
        s = e.elements.popper.querySelector(s);
        if (!s) return;
      }
      if (!Gi(e.elements.popper, s)) return;
      e.elements.arrow = s;
    }
    const yn = {
      name: 'arrow',
      enabled: true,
      phase: 'main',
      fn: mn,
      effect: gn,
      requires: ['popperOffsets'],
      requiresIfExists: ['preventOverflow'],
    };
    function wn(t, e, i) {
      if (i === void 0) i = { x: 0, y: 0 };
      return {
        top: t.top - e.height - i.y,
        right: t.right - e.width + i.x,
        bottom: t.bottom - e.height + i.y,
        left: t.left - e.width - i.x,
      };
    }
    function bn(t) {
      return [Ue, $e, qe, Xe].some(function (e) {
        return t[e] >= 0;
      });
    }
    function xn(t) {
      const e = t.state,
        i = t.name;
      const n = e.rects.reference;
      const s = e.rects.popper;
      const r = e.modifiersData.preventOverflow;
      const o = rn(e, { elementContext: 'reference' });
      const a = rn(e, { altBoundary: true });
      const l = wn(o, n);
      const c = wn(a, s, r);
      const h = bn(l);
      const u = bn(c);
      e.modifiersData[i] = {
        referenceClippingOffsets: l,
        popperEscapeOffsets: c,
        isReferenceHidden: h,
        hasPopperEscaped: u,
      };
      e.attributes.popper = Object.assign({}, e.attributes.popper, {
        'data-popper-reference-hidden': h,
        'data-popper-escaped': u,
      });
    }
    const _n = {
      name: 'hide',
      enabled: true,
      phase: 'main',
      requiresIfExists: ['preventOverflow'],
      fn: xn,
    };
    const Sn = [Ei, Oi, Fi, Bi, Zi, cn, pn, yn, _n];
    const Cn = xi({ defaultModifiers: Sn });
    const En =
      '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
    const Pn = 'tippy-box';
    const An = 'tippy-content';
    const Tn = 'tippy-backdrop';
    const Dn = 'tippy-arrow';
    const Ln = 'tippy-svg-arrow';
    const On = { passive: true, capture: true };
    const In = function t() {
      return document.body;
    };
    function Mn(t, e) {
      return {}.hasOwnProperty.call(t, e);
    }
    function kn(t, e, i) {
      if (Array.isArray(t)) {
        const n = t[e];
        return n == null ? (Array.isArray(i) ? i[e] : i) : n;
      }
      return t;
    }
    function zn(t, e) {
      const i = {}.toString.call(t);
      return i.indexOf('[object') === 0 && i.indexOf(e + ']') > -1;
    }
    function Fn(t, e) {
      return typeof t === 'function' ? t.apply(void 0, e) : t;
    }
    function Rn(t, e) {
      if (e === 0) return t;
      let i;
      return function (n) {
        clearTimeout(i);
        i = setTimeout(function () {
          t(n);
        }, e);
      };
    }
    function Vn(t, e) {
      const i = Object.assign({}, t);
      e.forEach(function (t) {
        delete i[t];
      });
      return i;
    }
    function Bn(t) {
      return t.split(/\s+/).filter(Boolean);
    }
    function Nn(t) {
      return [].concat(t);
    }
    function Wn(t, e) {
      if (t.indexOf(e) === -1) t.push(e);
    }
    function Zn(t) {
      return t.filter(function (e, i) {
        return t.indexOf(e) === i;
      });
    }
    function Hn(t) {
      return t.split('-')[0];
    }
    function jn(t) {
      return [].slice.call(t);
    }
    function Un(t) {
      return Object.keys(t).reduce(function (e, i) {
        if (t[i] !== void 0) e[i] = t[i];
        return e;
      }, {});
    }
    function qn() {
      return document.createElement('div');
    }
    function $n(t) {
      return ['Element', 'Fragment'].some(function (e) {
        return zn(t, e);
      });
    }
    function Xn(t) {
      return zn(t, 'NodeList');
    }
    function Gn(t) {
      return zn(t, 'MouseEvent');
    }
    function Kn(t) {
      return !!(t && t._tippy && t._tippy.reference === t);
    }
    function Yn(t) {
      if ($n(t)) return [t];
      if (Xn(t)) return jn(t);
      if (Array.isArray(t)) return t;
      return jn(document.querySelectorAll(t));
    }
    function Qn(t, e) {
      t.forEach(function (t) {
        if (t) t.style.transitionDuration = e + 'ms';
      });
    }
    function Jn(t, e) {
      t.forEach(function (t) {
        if (t) t.setAttribute('data-state', e);
      });
    }
    function ts(t) {
      let e;
      const i = Nn(t),
        n = i[0];
      return n != null && (e = n.ownerDocument) != null && e.body ? n.ownerDocument : document;
    }
    function es(t, e) {
      const i = e.clientX,
        n = e.clientY;
      return t.every(function (t) {
        const e = t.popperRect,
          s = t.popperState,
          r = t.props;
        const o = r.interactiveBorder;
        const a = Hn(s.placement);
        const l = s.modifiersData.offset;
        if (!l) return true;
        const c = a === 'bottom' ? l.top.y : 0;
        const h = a === 'top' ? l.bottom.y : 0;
        const u = a === 'right' ? l.left.x : 0;
        const d = a === 'left' ? l.right.x : 0;
        const f = e.top - n + c > o;
        const p = n - e.bottom - h > o;
        const v = e.left - i + u > o;
        const m = i - e.right - d > o;
        return f || p || v || m;
      });
    }
    function is(t, e, i) {
      const n = e + 'EventListener';
      ['transitionend', 'webkitTransitionEnd'].forEach(function (e) {
        t[n](e, i);
      });
    }
    function ns(t, e) {
      let i = e;
      while (i) {
        var n;
        if (t.contains(i)) return true;
        i = i.getRootNode == null ? void 0 : (n = i.getRootNode()) == null ? void 0 : n.host;
      }
      return false;
    }
    const ss = { isTouch: false };
    let rs = 0;
    function os() {
      if (ss.isTouch) return;
      ss.isTouch = true;
      if (window.performance) document.addEventListener('mousemove', as);
    }
    function as() {
      const t = performance.now();
      if (t - rs < 20) {
        ss.isTouch = false;
        document.removeEventListener('mousemove', as);
      }
      rs = t;
    }
    function ls() {
      const t = document.activeElement;
      if (Kn(t)) {
        const e = t._tippy;
        if (t.blur && !e.state.isVisible) t.blur();
      }
    }
    function cs() {
      document.addEventListener('touchstart', os, On);
      window.addEventListener('blur', ls);
    }
    const hs = typeof window !== 'undefined' && typeof document !== 'undefined';
    const us = hs ? !!window.msCrypto : false;
    function ds(t) {
      const e = t === 'destroy' ? 'n already-' : ' ';
      return [
        t + '() was called on a' + e + 'destroyed instance. This is a no-op but',
        'indicates a potential memory leak.',
      ].join(' ');
    }
    function fs(t) {
      const e = /[ \t]{2,}/g;
      const i = /^[ \t]*/gm;
      return t.replace(e, ' ').replace(i, '').trim();
    }
    function ps(t) {
      return fs(
        '\n  %ctippy.js\n\n  %c' +
          fs(t) +
          '\n\n  %c👷‍ This is a development-only message. It will be removed in production.\n  '
      );
    }
    function vs(t) {
      return [
        ps(t),
        'color: #00C584; font-size: 1.3em; font-weight: bold;',
        'line-height: 1.5',
        'color: #a6a095;',
      ];
    }
    let ms;
    if (false);
    function gs() {
      ms = new Set();
    }
    function ys(t, e) {
      if (t && !ms.has(e)) {
        let i;
        ms.add(e);
        (i = console).warn.apply(i, vs(e));
      }
    }
    function ws(t, e) {
      if (t && !ms.has(e)) {
        let i;
        ms.add(e);
        (i = console).error.apply(i, vs(e));
      }
    }
    function bs(t) {
      const e = !t;
      const i = Object.prototype.toString.call(t) === '[object Object]' && !t.addEventListener;
      ws(
        e,
        [
          'tippy() was passed',
          '`' + String(t) + '`',
          'as its targets (first) argument. Valid types are: String, Element,',
          'Element[], or NodeList.',
        ].join(' ')
      );
      ws(
        i,
        [
          'tippy() was passed a plain object which is not supported as an argument',
          'for virtual positioning. Use props.getReferenceClientRect instead.',
        ].join(' ')
      );
    }
    const xs = { animateFill: false, followCursor: false, inlinePositioning: false, sticky: false };
    const _s = {
      allowHTML: false,
      animation: 'fade',
      arrow: true,
      content: '',
      inertia: false,
      maxWidth: 350,
      role: 'tooltip',
      theme: '',
      zIndex: 9999,
    };
    const Ss = Object.assign(
      {
        appendTo: In,
        aria: { content: 'auto', expanded: 'auto' },
        delay: 0,
        duration: [300, 250],
        getReferenceClientRect: null,
        hideOnClick: true,
        ignoreAttributes: false,
        interactive: false,
        interactiveBorder: 2,
        interactiveDebounce: 0,
        moveTransition: '',
        offset: [0, 10],
        onAfterUpdate: function t() {},
        onBeforeUpdate: function t() {},
        onCreate: function t() {},
        onDestroy: function t() {},
        onHidden: function t() {},
        onHide: function t() {},
        onMount: function t() {},
        onShow: function t() {},
        onShown: function t() {},
        onTrigger: function t() {},
        onUntrigger: function t() {},
        onClickOutside: function t() {},
        placement: 'top',
        plugins: [],
        popperOptions: {},
        render: null,
        showOnCreate: false,
        touch: true,
        trigger: 'mouseenter focus',
        triggerTarget: null,
      },
      xs,
      _s
    );
    const Cs = Object.keys(Ss);
    const Es = function t(e) {
      if (false);
      const i = Object.keys(e);
      i.forEach(function (t) {
        Ss[t] = e[t];
      });
    };
    function Ps(t) {
      const e = t.plugins || [];
      const i = e.reduce(function (e, i) {
        const n = i.name,
          s = i.defaultValue;
        if (n) {
          let r;
          e[n] = t[n] !== void 0 ? t[n] : (r = Ss[n]) != null ? r : s;
        }
        return e;
      }, {});
      return Object.assign({}, t, i);
    }
    function As(t, e) {
      const i = e ? Object.keys(Ps(Object.assign({}, Ss, { plugins: e }))) : Cs;
      const n = i.reduce(function (e, i) {
        const n = (t.getAttribute('data-tippy-' + i) || '').trim();
        if (!n) return e;
        if (i === 'content') e[i] = n;
        else
          try {
            e[i] = JSON.parse(n);
          } catch (t) {
            e[i] = n;
          }
        return e;
      }, {});
      return n;
    }
    function Ts(t, e) {
      const i = Object.assign(
        {},
        e,
        { content: Fn(e.content, [t]) },
        e.ignoreAttributes ? {} : As(t, e.plugins)
      );
      i.aria = Object.assign({}, Ss.aria, i.aria);
      i.aria = {
        expanded: i.aria.expanded === 'auto' ? e.interactive : i.aria.expanded,
        content:
          i.aria.content === 'auto' ? (e.interactive ? null : 'describedby') : i.aria.content,
      };
      return i;
    }
    function Ds(t, e) {
      if (t === void 0) t = {};
      if (e === void 0) e = [];
      const i = Object.keys(t);
      i.forEach(function (t) {
        const i = Vn(Ss, Object.keys(xs));
        let n = !Mn(i, t);
        if (n)
          n =
            e.filter(function (e) {
              return e.name === t;
            }).length === 0;
        ys(
          n,
          [
            '`' + t + '`',
            "is not a valid prop. You may have spelled it incorrectly, or if it's",
            'a plugin, forgot to pass it in an array as props.plugins.',
            '\n\n',
            'All props: https://atomiks.github.io/tippyjs/v6/all-props/\n',
            'Plugins: https://atomiks.github.io/tippyjs/v6/plugins/',
          ].join(' ')
        );
      });
    }
    const Ls = function t() {
      return 'innerHTML';
    };
    function Os(t, e) {
      t[Ls()] = e;
    }
    function Is(t) {
      const e = qn();
      if (t === true) e.className = Dn;
      else {
        e.className = Ln;
        if ($n(t)) e.appendChild(t);
        else Os(e, t);
      }
      return e;
    }
    function Ms(t, e) {
      if ($n(e.content)) {
        Os(t, '');
        t.appendChild(e.content);
      } else if (typeof e.content !== 'function')
        if (e.allowHTML) Os(t, e.content);
        else t.textContent = e.content;
    }
    function ks(t) {
      const e = t.firstElementChild;
      const i = jn(e.children);
      return {
        box: e,
        content: i.find(function (t) {
          return t.classList.contains(An);
        }),
        arrow: i.find(function (t) {
          return t.classList.contains(Dn) || t.classList.contains(Ln);
        }),
        backdrop: i.find(function (t) {
          return t.classList.contains(Tn);
        }),
      };
    }
    function zs(t) {
      const e = qn();
      const i = qn();
      i.className = Pn;
      i.setAttribute('data-state', 'hidden');
      i.setAttribute('tabindex', '-1');
      const n = qn();
      n.className = An;
      n.setAttribute('data-state', 'hidden');
      Ms(n, t.props);
      e.appendChild(i);
      i.appendChild(n);
      s(t.props, t.props);
      function s(i, n) {
        const s = ks(e),
          r = s.box,
          o = s.content,
          a = s.arrow;
        if (n.theme) r.setAttribute('data-theme', n.theme);
        else r.removeAttribute('data-theme');
        if (typeof n.animation === 'string') r.setAttribute('data-animation', n.animation);
        else r.removeAttribute('data-animation');
        if (n.inertia) r.setAttribute('data-inertia', '');
        else r.removeAttribute('data-inertia');
        r.style.maxWidth = typeof n.maxWidth === 'number' ? n.maxWidth + 'px' : n.maxWidth;
        if (n.role) r.setAttribute('role', n.role);
        else r.removeAttribute('role');
        if (i.content !== n.content || i.allowHTML !== n.allowHTML) Ms(o, t.props);
        if (n.arrow) {
          if (!a) r.appendChild(Is(n.arrow));
          else if (i.arrow !== n.arrow) {
            r.removeChild(a);
            r.appendChild(Is(n.arrow));
          }
        } else if (a) r.removeChild(a);
      }
      return { popper: e, onUpdate: s };
    }
    zs.$$tippy = true;
    let Fs = 1;
    let Rs = [];
    let Vs = [];
    function Bs(t, e) {
      const i = Ts(t, Object.assign({}, Ss, Ps(Un(e))));
      let n;
      let s;
      let r;
      let o = false;
      let a = false;
      let l = false;
      let c = false;
      let h;
      let u;
      let d;
      let f = [];
      let p = Rn(K, i.interactiveDebounce);
      let v;
      const m = Fs++;
      const g = null;
      const y = Zn(i.plugins);
      const w = {
        isEnabled: true,
        isVisible: false,
        isDestroyed: false,
        isMounted: false,
        isShown: false,
      };
      const b = {
        id: m,
        reference: t,
        popper: qn(),
        popperInstance: g,
        props: i,
        state: w,
        plugins: y,
        clearDelayTimeouts: lt,
        setProps: ct,
        setContent: ht,
        show: ut,
        hide: dt,
        hideWithInteractivity: ft,
        enable: ot,
        disable: at,
        unmount: pt,
        destroy: vt,
      };
      if (!i.render) {
        if (false);
        return b;
      }
      const x = i.render(b),
        _ = x.popper,
        S = x.onUpdate;
      _.setAttribute('data-tippy-root', '');
      _.id = 'tippy-' + b.id;
      b.popper = _;
      t._tippy = b;
      _._tippy = b;
      const C = y.map(function (t) {
        return t.fn(b);
      });
      const E = t.hasAttribute('aria-expanded');
      $();
      F();
      M();
      k('onCreate', [b]);
      if (i.showOnCreate) st();
      _.addEventListener('mouseenter', function () {
        if (b.props.interactive && b.state.isVisible) b.clearDelayTimeouts();
      });
      _.addEventListener('mouseleave', function () {
        if (b.props.interactive && b.props.trigger.indexOf('mouseenter') >= 0)
          L().addEventListener('mousemove', p);
      });
      return b;
      function P() {
        const t = b.props.touch;
        return Array.isArray(t) ? t : [t, 0];
      }
      function A() {
        return P()[0] === 'hold';
      }
      function T() {
        let t;
        return !!((t = b.props.render) != null && t.$$tippy);
      }
      function D() {
        return v || t;
      }
      function L() {
        const t = D().parentNode;
        return t ? ts(t) : document;
      }
      function O() {
        return ks(_);
      }
      function I(t) {
        if ((b.state.isMounted && !b.state.isVisible) || ss.isTouch || (h && h.type === 'focus'))
          return 0;
        return kn(b.props.delay, t ? 0 : 1, Ss.delay);
      }
      function M(t) {
        if (t === void 0) t = false;
        _.style.pointerEvents = b.props.interactive && !t ? '' : 'none';
        _.style.zIndex = '' + b.props.zIndex;
      }
      function k(t, e, i) {
        if (i === void 0) i = true;
        C.forEach(function (i) {
          if (i[t]) i[t].apply(i, e);
        });
        if (i) {
          let n;
          (n = b.props)[t].apply(n, e);
        }
      }
      function z() {
        const e = b.props.aria;
        if (!e.content) return;
        const i = 'aria-' + e.content;
        const n = _.id;
        const s = Nn(b.props.triggerTarget || t);
        s.forEach(function (t) {
          const e = t.getAttribute(i);
          if (b.state.isVisible) t.setAttribute(i, e ? e + ' ' + n : n);
          else {
            const s = e && e.replace(n, '').trim();
            if (s) t.setAttribute(i, s);
            else t.removeAttribute(i);
          }
        });
      }
      function F() {
        if (E || !b.props.aria.expanded) return;
        const e = Nn(b.props.triggerTarget || t);
        e.forEach(function (t) {
          if (b.props.interactive)
            t.setAttribute('aria-expanded', b.state.isVisible && t === D() ? 'true' : 'false');
          else t.removeAttribute('aria-expanded');
        });
      }
      function R() {
        L().removeEventListener('mousemove', p);
        Rs = Rs.filter(function (t) {
          return t !== p;
        });
      }
      function V(e) {
        if (ss.isTouch) if (l || e.type === 'mousedown') return;
        const i = (e.composedPath && e.composedPath()[0]) || e.target;
        if (b.props.interactive && ns(_, i)) return;
        if (
          Nn(b.props.triggerTarget || t).some(function (t) {
            return ns(t, i);
          })
        ) {
          if (ss.isTouch) return;
          if (b.state.isVisible && b.props.trigger.indexOf('click') >= 0) return;
        } else k('onClickOutside', [b, e]);
        if (b.props.hideOnClick === true) {
          b.clearDelayTimeouts();
          b.hide();
          a = true;
          setTimeout(function () {
            a = false;
          });
          if (!b.state.isMounted) Z();
        }
      }
      function B() {
        l = true;
      }
      function N() {
        l = false;
      }
      function W() {
        const t = L();
        t.addEventListener('mousedown', V, true);
        t.addEventListener('touchend', V, On);
        t.addEventListener('touchstart', N, On);
        t.addEventListener('touchmove', B, On);
      }
      function Z() {
        const t = L();
        t.removeEventListener('mousedown', V, true);
        t.removeEventListener('touchend', V, On);
        t.removeEventListener('touchstart', N, On);
        t.removeEventListener('touchmove', B, On);
      }
      function H(t, e) {
        U(t, function () {
          if (!b.state.isVisible && _.parentNode && _.parentNode.contains(_)) e();
        });
      }
      function j(t, e) {
        U(t, e);
      }
      function U(t, e) {
        const i = O().box;
        function n(t) {
          if (t.target === i) {
            is(i, 'remove', n);
            e();
          }
        }
        if (t === 0) return e();
        is(i, 'remove', u);
        is(i, 'add', n);
        u = n;
      }
      function q(e, i, n) {
        if (n === void 0) n = false;
        const s = Nn(b.props.triggerTarget || t);
        s.forEach(function (t) {
          t.addEventListener(e, i, n);
          f.push({ node: t, eventType: e, handler: i, options: n });
        });
      }
      function $() {
        if (A()) {
          q('touchstart', G, { passive: true });
          q('touchend', Y, { passive: true });
        }
        Bn(b.props.trigger).forEach(function (t) {
          if (t === 'manual') return;
          q(t, G);
          switch (t) {
            case 'mouseenter':
              q('mouseleave', Y);
              break;
            case 'focus':
              q(us ? 'focusout' : 'blur', Q);
              break;
            case 'focusin':
              q('focusout', Q);
              break;
          }
        });
      }
      function X() {
        f.forEach(function (t) {
          const e = t.node,
            i = t.eventType,
            n = t.handler,
            s = t.options;
          e.removeEventListener(i, n, s);
        });
        f = [];
      }
      function G(t) {
        let e;
        let i = false;
        if (!b.state.isEnabled || J(t) || a) return;
        const n = ((e = h) == null ? void 0 : e.type) === 'focus';
        h = t;
        v = t.currentTarget;
        F();
        if (!b.state.isVisible && Gn(t))
          Rs.forEach(function (e) {
            return e(t);
          });
        if (
          t.type === 'click' &&
          (b.props.trigger.indexOf('mouseenter') < 0 || o) &&
          b.props.hideOnClick !== false &&
          b.state.isVisible
        )
          i = true;
        else st(t);
        if (t.type === 'click') o = !i;
        if (i && !n) rt(t);
      }
      function K(t) {
        const e = t.target;
        const n = D().contains(e) || _.contains(e);
        if (t.type === 'mousemove' && n) return;
        const s = nt()
          .concat(_)
          .map(function (t) {
            let e;
            const n = t._tippy;
            const s = (e = n.popperInstance) == null ? void 0 : e.state;
            if (s) return { popperRect: t.getBoundingClientRect(), popperState: s, props: i };
            return null;
          })
          .filter(Boolean);
        if (es(s, t)) {
          R();
          rt(t);
        }
      }
      function Y(t) {
        const e = J(t) || (b.props.trigger.indexOf('click') >= 0 && o);
        if (e) return;
        if (b.props.interactive) {
          b.hideWithInteractivity(t);
          return;
        }
        rt(t);
      }
      function Q(t) {
        if (b.props.trigger.indexOf('focusin') < 0 && t.target !== D()) return;
        if (b.props.interactive && t.relatedTarget && _.contains(t.relatedTarget)) return;
        rt(t);
      }
      function J(t) {
        return ss.isTouch ? A() !== t.type.indexOf('touch') >= 0 : false;
      }
      function tt() {
        et();
        const e = b.props,
          i = e.popperOptions,
          n = e.placement,
          s = e.offset,
          r = e.getReferenceClientRect,
          o = e.moveTransition;
        const a = T() ? ks(_).arrow : null;
        const l = r ? { getBoundingClientRect: r, contextElement: r.contextElement || D() } : t;
        const c = {
          name: '$$tippy',
          enabled: true,
          phase: 'beforeWrite',
          requires: ['computeStyles'],
          fn: function t(e) {
            const i = e.state;
            if (T()) {
              const n = O(),
                s = n.box;
              ['placement', 'reference-hidden', 'escaped'].forEach(function (t) {
                if (t === 'placement') s.setAttribute('data-placement', i.placement);
                else if (i.attributes.popper['data-popper-' + t]) s.setAttribute('data-' + t, '');
                else s.removeAttribute('data-' + t);
              });
              i.attributes.popper = {};
            }
          },
        };
        const h = [
          { name: 'offset', options: { offset: s } },
          {
            name: 'preventOverflow',
            options: { padding: { top: 2, bottom: 2, left: 5, right: 5 } },
          },
          { name: 'flip', options: { padding: 5 } },
          { name: 'computeStyles', options: { adaptive: !o } },
          c,
        ];
        if (T() && a) h.push({ name: 'arrow', options: { element: a, padding: 3 } });
        h.push.apply(h, (i == null ? void 0 : i.modifiers) || []);
        b.popperInstance = Cn(
          l,
          _,
          Object.assign({}, i, { placement: n, onFirstUpdate: d, modifiers: h })
        );
      }
      function et() {
        if (b.popperInstance) {
          b.popperInstance.destroy();
          b.popperInstance = null;
        }
      }
      function it() {
        const t = b.props.appendTo;
        let e;
        const i = D();
        if ((b.props.interactive && t === In) || t === 'parent') e = i.parentNode;
        else e = Fn(t, [i]);
        if (!e.contains(_)) e.appendChild(_);
        b.state.isMounted = true;
        tt();
        if (false);
      }
      function nt() {
        return jn(_.querySelectorAll('[data-tippy-root]'));
      }
      function st(t) {
        b.clearDelayTimeouts();
        if (t) k('onTrigger', [b, t]);
        W();
        let e = I(true);
        const i = P(),
          s = i[0],
          r = i[1];
        if (ss.isTouch && s === 'hold' && r) e = r;
        if (e)
          n = setTimeout(function () {
            b.show();
          }, e);
        else b.show();
      }
      function rt(t) {
        b.clearDelayTimeouts();
        k('onUntrigger', [b, t]);
        if (!b.state.isVisible) {
          Z();
          return;
        }
        if (
          b.props.trigger.indexOf('mouseenter') >= 0 &&
          b.props.trigger.indexOf('click') >= 0 &&
          ['mouseleave', 'mousemove'].indexOf(t.type) >= 0 &&
          o
        )
          return;
        const e = I(false);
        if (e)
          s = setTimeout(function () {
            if (b.state.isVisible) b.hide();
          }, e);
        else
          r = requestAnimationFrame(function () {
            b.hide();
          });
      }
      function ot() {
        b.state.isEnabled = true;
      }
      function at() {
        b.hide();
        b.state.isEnabled = false;
      }
      function lt() {
        clearTimeout(n);
        clearTimeout(s);
        cancelAnimationFrame(r);
      }
      function ct(e) {
        if (false);
        if (b.state.isDestroyed) return;
        k('onBeforeUpdate', [b, e]);
        X();
        const i = b.props;
        const n = Ts(t, Object.assign({}, i, Un(e), { ignoreAttributes: true }));
        b.props = n;
        $();
        if (i.interactiveDebounce !== n.interactiveDebounce) {
          R();
          p = Rn(K, n.interactiveDebounce);
        }
        if (i.triggerTarget && !n.triggerTarget)
          Nn(i.triggerTarget).forEach(function (t) {
            t.removeAttribute('aria-expanded');
          });
        else if (n.triggerTarget) t.removeAttribute('aria-expanded');
        F();
        M();
        if (S) S(i, n);
        if (b.popperInstance) {
          tt();
          nt().forEach(function (t) {
            requestAnimationFrame(t._tippy.popperInstance.forceUpdate);
          });
        }
        k('onAfterUpdate', [b, e]);
      }
      function ht(t) {
        b.setProps({ content: t });
      }
      function ut() {
        if (false);
        const t = b.state.isVisible;
        const e = b.state.isDestroyed;
        const i = !b.state.isEnabled;
        const n = ss.isTouch && !b.props.touch;
        const s = kn(b.props.duration, 0, Ss.duration);
        if (t || e || i || n) return;
        if (D().hasAttribute('disabled')) return;
        k('onShow', [b], false);
        if (b.props.onShow(b) === false) return;
        b.state.isVisible = true;
        if (T()) _.style.visibility = 'visible';
        M();
        W();
        if (!b.state.isMounted) _.style.transition = 'none';
        if (T()) {
          const r = O(),
            o = r.box,
            a = r.content;
          Qn([o, a], 0);
        }
        d = function t() {
          let e;
          if (!b.state.isVisible || c) return;
          c = true;
          void _.offsetHeight;
          _.style.transition = b.props.moveTransition;
          if (T() && b.props.animation) {
            const i = O(),
              n = i.box,
              r = i.content;
            Qn([n, r], s);
            Jn([n, r], 'visible');
          }
          z();
          F();
          Wn(Vs, b);
          (e = b.popperInstance) == null ? void 0 : e.forceUpdate();
          k('onMount', [b]);
          if (b.props.animation && T())
            j(s, function () {
              b.state.isShown = true;
              k('onShown', [b]);
            });
        };
        it();
      }
      function dt() {
        if (false);
        const t = !b.state.isVisible;
        const e = b.state.isDestroyed;
        const i = !b.state.isEnabled;
        const n = kn(b.props.duration, 1, Ss.duration);
        if (t || e || i) return;
        k('onHide', [b], false);
        if (b.props.onHide(b) === false) return;
        b.state.isVisible = false;
        b.state.isShown = false;
        c = false;
        o = false;
        if (T()) _.style.visibility = 'hidden';
        R();
        Z();
        M(true);
        if (T()) {
          const s = O(),
            r = s.box,
            a = s.content;
          if (b.props.animation) {
            Qn([r, a], n);
            Jn([r, a], 'hidden');
          }
        }
        z();
        F();
        if (b.props.animation) {
          if (T()) H(n, b.unmount);
        } else b.unmount();
      }
      function ft(t) {
        if (false);
        L().addEventListener('mousemove', p);
        Wn(Rs, p);
        p(t);
      }
      function pt() {
        if (false);
        if (b.state.isVisible) b.hide();
        if (!b.state.isMounted) return;
        et();
        nt().forEach(function (t) {
          t._tippy.unmount();
        });
        if (_.parentNode) _.parentNode.removeChild(_);
        Vs = Vs.filter(function (t) {
          return t !== b;
        });
        b.state.isMounted = false;
        k('onHidden', [b]);
      }
      function vt() {
        if (false);
        if (b.state.isDestroyed) return;
        b.clearDelayTimeouts();
        b.unmount();
        X();
        delete t._tippy;
        b.state.isDestroyed = true;
        k('onDestroy', [b]);
      }
    }
    function Ns(t, e) {
      if (e === void 0) e = {};
      const i = Ss.plugins.concat(e.plugins || []);
      if (false);
      cs();
      const n = Object.assign({}, e, { plugins: i });
      const s = Yn(t);
      if (false) var r, o;
      const a = s.reduce(function (t, e) {
        const i = e && Bs(e, n);
        if (i) t.push(i);
        return t;
      }, []);
      return $n(t) ? a[0] : a;
    }
    Ns.defaultProps = Ss;
    Ns.setDefaultProps = Es;
    Ns.currentInput = ss;
    const Ws = function t(e) {
      const i = e === void 0 ? {} : e,
        n = i.exclude,
        s = i.duration;
      Vs.forEach(function (t) {
        let e = false;
        if (n) e = Kn(n) ? t.reference === n : t.popper === n.popper;
        if (!e) {
          const i = t.props.duration;
          t.setProps({ duration: s });
          t.hide();
          if (!t.state.isDestroyed) t.setProps({ duration: i });
        }
      });
    };
    const Zs = Object.assign({}, Bi, {
      effect: function t(e) {
        const i = e.state;
        const n = {
          popper: { position: i.options.strategy, left: '0', top: '0', margin: '0' },
          arrow: { position: 'absolute' },
          reference: {},
        };
        Object.assign(i.elements.popper.style, n.popper);
        i.styles = n;
        if (i.elements.arrow) Object.assign(i.elements.arrow.style, n.arrow);
      },
    });
    const Hs = function t(e, i) {
      let n;
      if (i === void 0) i = {};
      if (false);
      let s = e;
      let r = [];
      let o = [];
      let a;
      let l = i.overrides;
      let c = [];
      let h = false;
      function u() {
        o = s
          .map(function (t) {
            return Nn(t.props.triggerTarget || t.reference);
          })
          .reduce(function (t, e) {
            return t.concat(e);
          }, []);
      }
      function d() {
        r = s.map(function (t) {
          return t.reference;
        });
      }
      function f(t) {
        s.forEach(function (e) {
          if (t) e.enable();
          else e.disable();
        });
      }
      function p(t) {
        return s.map(function (e) {
          const i = e.setProps;
          e.setProps = function (n) {
            i(n);
            if (e.reference === a) t.setProps(n);
          };
          return function () {
            e.setProps = i;
          };
        });
      }
      function v(t, e) {
        const i = o.indexOf(e);
        if (e === a) return;
        a = e;
        const n = (l || []).concat('content').reduce(function (t, e) {
          t[e] = s[i].props[e];
          return t;
        }, {});
        t.setProps(
          Object.assign({}, n, {
            getReferenceClientRect:
              typeof n.getReferenceClientRect === 'function'
                ? n.getReferenceClientRect
                : function () {
                    let t;
                    return (t = r[i]) == null ? void 0 : t.getBoundingClientRect();
                  },
          })
        );
      }
      f(false);
      d();
      u();
      const m = {
        fn: function t() {
          return {
            onDestroy: function t() {
              f(true);
            },
            onHidden: function t() {
              a = null;
            },
            onClickOutside: function t(e) {
              if (e.props.showOnCreate && !h) {
                h = true;
                a = null;
              }
            },
            onShow: function t(e) {
              if (e.props.showOnCreate && !h) {
                h = true;
                v(e, r[0]);
              }
            },
            onTrigger: function t(e, i) {
              v(e, i.currentTarget);
            },
          };
        },
      };
      const g = Ns(
        qn(),
        Object.assign({}, Vn(i, ['overrides']), {
          plugins: [m].concat(i.plugins || []),
          triggerTarget: o,
          popperOptions: Object.assign({}, i.popperOptions, {
            modifiers: [].concat(((n = i.popperOptions) == null ? void 0 : n.modifiers) || [], [
              Zs,
            ]),
          }),
        })
      );
      const y = g.show;
      g.show = function (t) {
        y();
        if (!a && t == null) return v(g, r[0]);
        if (a && t == null) return;
        if (typeof t === 'number') return r[t] && v(g, r[t]);
        if (s.indexOf(t) >= 0) {
          const e = t.reference;
          return v(g, e);
        }
        if (r.indexOf(t) >= 0) return v(g, t);
      };
      g.showNext = function () {
        const t = r[0];
        if (!a) return g.show(0);
        const e = r.indexOf(a);
        g.show(r[e + 1] || t);
      };
      g.showPrevious = function () {
        const t = r[r.length - 1];
        if (!a) return g.show(t);
        const e = r.indexOf(a);
        const i = r[e - 1] || t;
        g.show(i);
      };
      const w = g.setProps;
      g.setProps = function (t) {
        l = t.overrides || l;
        w(t);
      };
      g.setInstances = function (t) {
        f(true);
        c.forEach(function (t) {
          return t();
        });
        s = t;
        f(false);
        d();
        u();
        c = p(g);
        g.setProps({ triggerTarget: o });
      };
      c = p(g);
      return g;
    };
    const js = { mouseover: 'mouseenter', focusin: 'focus', click: 'click' };
    function Us(t, e) {
      if (false);
      let i = [];
      let n = [];
      let s = false;
      const r = e.target;
      const o = Vn(e, ['target']);
      const a = Object.assign({}, o, { trigger: 'manual', touch: false });
      const l = Object.assign({ touch: Ss.touch }, o, { showOnCreate: true });
      const c = Ns(t, a);
      const h = Nn(c);
      function u(t) {
        if (!t.target || s) return;
        const i = t.target.closest(r);
        if (!i) return;
        const o = i.getAttribute('data-tippy-trigger') || e.trigger || Ss.trigger;
        if (i._tippy) return;
        if (t.type === 'touchstart' && typeof l.touch === 'boolean') return;
        if (t.type !== 'touchstart' && o.indexOf(js[t.type]) < 0) return;
        const a = Ns(i, l);
        if (a) n = n.concat(a);
      }
      function d(t, e, n, s) {
        if (s === void 0) s = false;
        t.addEventListener(e, n, s);
        i.push({ node: t, eventType: e, handler: n, options: s });
      }
      function f(t) {
        const e = t.reference;
        d(e, 'touchstart', u, On);
        d(e, 'mouseover', u);
        d(e, 'focusin', u);
        d(e, 'click', u);
      }
      function p() {
        i.forEach(function (t) {
          const e = t.node,
            i = t.eventType,
            n = t.handler,
            s = t.options;
          e.removeEventListener(i, n, s);
        });
        i = [];
      }
      function v(t) {
        const e = t.destroy;
        const i = t.enable;
        const r = t.disable;
        t.destroy = function (t) {
          if (t === void 0) t = true;
          if (t)
            n.forEach(function (t) {
              t.destroy();
            });
          n = [];
          p();
          e();
        };
        t.enable = function () {
          i();
          n.forEach(function (t) {
            return t.enable();
          });
          s = false;
        };
        t.disable = function () {
          r();
          n.forEach(function (t) {
            return t.disable();
          });
          s = true;
        };
        f(t);
      }
      h.forEach(v);
      return c;
    }
    const qs = {
      name: 'animateFill',
      defaultValue: false,
      fn: function t(e) {
        let i;
        if (!((i = e.props.render) != null && i.$$tippy)) {
          if (false);
          return {};
        }
        const n = ks(e.popper),
          s = n.box,
          r = n.content;
        const o = e.props.animateFill ? $s() : null;
        return {
          onCreate: function t() {
            if (o) {
              s.insertBefore(o, s.firstElementChild);
              s.setAttribute('data-animatefill', '');
              s.style.overflow = 'hidden';
              e.setProps({ arrow: false, animation: 'shift-away' });
            }
          },
          onMount: function t() {
            if (o) {
              const e = s.style.transitionDuration;
              const i = Number(e.replace('ms', ''));
              r.style.transitionDelay = Math.round(i / 10) + 'ms';
              o.style.transitionDuration = e;
              Jn([o], 'visible');
            }
          },
          onShow: function t() {
            if (o) o.style.transitionDuration = '0ms';
          },
          onHide: function t() {
            if (o) Jn([o], 'hidden');
          },
        };
      },
    };
    function $s() {
      const t = qn();
      t.className = Tn;
      Jn([t], 'hidden');
      return t;
    }
    let Xs = { clientX: 0, clientY: 0 };
    let Gs = [];
    function Ks(t) {
      const e = t.clientX,
        i = t.clientY;
      Xs = { clientX: e, clientY: i };
    }
    function Ys(t) {
      t.addEventListener('mousemove', Ks);
    }
    function Qs(t) {
      t.removeEventListener('mousemove', Ks);
    }
    const Js = {
      name: 'followCursor',
      defaultValue: false,
      fn: function t(e) {
        const i = e.reference;
        const n = ts(e.props.triggerTarget || i);
        let s = false;
        let r = false;
        let o = true;
        let a = e.props;
        function l() {
          return e.props.followCursor === 'initial' && e.state.isVisible;
        }
        function c() {
          n.addEventListener('mousemove', d);
        }
        function h() {
          n.removeEventListener('mousemove', d);
        }
        function u() {
          s = true;
          e.setProps({ getReferenceClientRect: null });
          s = false;
        }
        function d(t) {
          const n = t.target ? i.contains(t.target) : true;
          const s = e.props.followCursor;
          const r = t.clientX,
            o = t.clientY;
          const a = i.getBoundingClientRect();
          const l = r - a.left;
          const c = o - a.top;
          if (n || !e.props.interactive)
            e.setProps({
              getReferenceClientRect: function t() {
                const e = i.getBoundingClientRect();
                let n = r;
                let a = o;
                if (s === 'initial') {
                  n = e.left + l;
                  a = e.top + c;
                }
                const h = s === 'horizontal' ? e.top : a;
                const u = s === 'vertical' ? e.right : n;
                const d = s === 'horizontal' ? e.bottom : a;
                const f = s === 'vertical' ? e.left : n;
                return { width: u - f, height: d - h, top: h, right: u, bottom: d, left: f };
              },
            });
        }
        function f() {
          if (e.props.followCursor) {
            Gs.push({ instance: e, doc: n });
            Ys(n);
          }
        }
        function p() {
          Gs = Gs.filter(function (t) {
            return t.instance !== e;
          });
          if (
            Gs.filter(function (t) {
              return t.doc === n;
            }).length === 0
          )
            Qs(n);
        }
        return {
          onCreate: f,
          onDestroy: p,
          onBeforeUpdate: function t() {
            a = e.props;
          },
          onAfterUpdate: function t(i, n) {
            const o = n.followCursor;
            if (s) return;
            if (o !== void 0 && a.followCursor !== o) {
              p();
              if (o) {
                f();
                if (e.state.isMounted && !r && !l()) c();
              } else {
                h();
                u();
              }
            }
          },
          onMount: function t() {
            if (e.props.followCursor && !r) {
              if (o) {
                d(Xs);
                o = false;
              }
              if (!l()) c();
            }
          },
          onTrigger: function t(e, i) {
            if (Gn(i)) Xs = { clientX: i.clientX, clientY: i.clientY };
            r = i.type === 'focus';
          },
          onHidden: function t() {
            if (e.props.followCursor) {
              u();
              h();
              o = true;
            }
          },
        };
      },
    };
    function tr(t, e) {
      let i;
      return {
        popperOptions: Object.assign({}, t.popperOptions, {
          modifiers: [].concat(
            (((i = t.popperOptions) == null ? void 0 : i.modifiers) || []).filter(function (t) {
              const i = t.name;
              return i !== e.name;
            }),
            [e]
          ),
        }),
      };
    }
    const er = {
      name: 'inlinePositioning',
      defaultValue: false,
      fn: function t(e) {
        const i = e.reference;
        function n() {
          return !!e.props.inlinePositioning;
        }
        let s;
        let r = -1;
        let o = false;
        let a = [];
        const l = {
          name: 'tippyInlinePositioning',
          enabled: true,
          phase: 'afterWrite',
          fn: function t(i) {
            const r = i.state;
            if (n()) {
              if (a.indexOf(r.placement) !== -1) a = [];
              if (s !== r.placement && a.indexOf(r.placement) === -1) {
                a.push(r.placement);
                e.setProps({
                  getReferenceClientRect: function t() {
                    return c(r.placement);
                  },
                });
              }
              s = r.placement;
            }
          },
        };
        function c(t) {
          return ir(Hn(t), i.getBoundingClientRect(), jn(i.getClientRects()), r);
        }
        function h(t) {
          o = true;
          e.setProps(t);
          o = false;
        }
        function u() {
          if (!o) h(tr(e.props, l));
        }
        return {
          onCreate: u,
          onAfterUpdate: u,
          onTrigger: function t(i, n) {
            if (Gn(n)) {
              const s = jn(e.reference.getClientRects());
              const o = s.find(function (t) {
                return (
                  t.left - 2 <= n.clientX &&
                  t.right + 2 >= n.clientX &&
                  t.top - 2 <= n.clientY &&
                  t.bottom + 2 >= n.clientY
                );
              });
              const a = s.indexOf(o);
              r = a > -1 ? a : r;
            }
          },
          onHidden: function t() {
            r = -1;
          },
        };
      },
    };
    function ir(t, e, i, n) {
      if (i.length < 2 || t === null) return e;
      if (i.length === 2 && n >= 0 && i[0].left > i[1].right) return i[n] || e;
      switch (t) {
        case 'top':
        case 'bottom':
          var s = i[0];
          var r = i[i.length - 1];
          var o = t === 'top';
          var a = s.top;
          var l = r.bottom;
          var c = o ? s.left : r.left;
          var h = o ? s.right : r.right;
          var u = h - c;
          var d = l - a;
          return { top: a, bottom: l, left: c, right: h, width: u, height: d };
        case 'left':
        case 'right':
          var f = Math.min.apply(
            Math,
            i.map(function (t) {
              return t.left;
            })
          );
          var p = Math.max.apply(
            Math,
            i.map(function (t) {
              return t.right;
            })
          );
          var v = i.filter(function (e) {
            return t === 'left' ? e.left === f : e.right === p;
          });
          var m = v[0].top;
          var g = v[v.length - 1].bottom;
          var y = f;
          var w = p;
          var b = w - y;
          var x = g - m;
          return { top: m, bottom: g, left: y, right: w, width: b, height: x };
        default:
          return e;
      }
    }
    const nr = {
      name: 'sticky',
      defaultValue: false,
      fn: function t(e) {
        const i = e.reference,
          n = e.popper;
        function s() {
          return e.popperInstance ? e.popperInstance.state.elements.reference : i;
        }
        function r(t) {
          return e.props.sticky === true || e.props.sticky === t;
        }
        let o = null;
        let a = null;
        function l() {
          const t = r('reference') ? s().getBoundingClientRect() : null;
          const i = r('popper') ? n.getBoundingClientRect() : null;
          if ((t && sr(o, t)) || (i && sr(a, i))) if (e.popperInstance) e.popperInstance.update();
          o = t;
          a = i;
          if (e.state.isMounted) requestAnimationFrame(l);
        }
        return {
          onMount: function t() {
            if (e.props.sticky) l();
          },
        };
      },
    };
    function sr(t, e) {
      if (t && e)
        return t.top !== e.top || t.right !== e.right || t.bottom !== e.bottom || t.left !== e.left;
      return true;
    }
    Ns.setDefaultProps({ render: zs });
    const rr = Ns;
    function or(t) {
      let e;
      return () => {
        if (e === void 0) e = t();
        return e;
      };
    }
    const ar = or(() => window.ScrollTimeline !== void 0);
    class lr {
      constructor(t) {
        this.stop = () => this.runAll('stop');
        this.animations = t.filter(Boolean);
      }
      get finished() {
        return Promise.all(this.animations.map((t) => ('finished' in t ? t.finished : t)));
      }
      getAll(t) {
        return this.animations[0][t];
      }
      setAll(t, e) {
        for (let i = 0; i < this.animations.length; i++) this.animations[i][t] = e;
      }
      attachTimeline(t, e) {
        const i = this.animations.map((i) => {
          if (ar() && i.attachTimeline) return i.attachTimeline(t);
          else if (typeof e === 'function') return e(i);
        });
        return () => {
          i.forEach((t, e) => {
            t && t();
            this.animations[e].stop();
          });
        };
      }
      get time() {
        return this.getAll('time');
      }
      set time(t) {
        this.setAll('time', t);
      }
      get speed() {
        return this.getAll('speed');
      }
      set speed(t) {
        this.setAll('speed', t);
      }
      get startTime() {
        return this.getAll('startTime');
      }
      get duration() {
        let t = 0;
        for (let e = 0; e < this.animations.length; e++)
          t = Math.max(t, this.animations[e].duration);
        return t;
      }
      runAll(t) {
        this.animations.forEach((e) => e[t]());
      }
      flatten() {
        this.runAll('flatten');
      }
      play() {
        this.runAll('play');
      }
      pause() {
        this.runAll('pause');
      }
      cancel() {
        this.runAll('cancel');
      }
      complete() {
        this.runAll('complete');
      }
    }
    class cr extends lr {
      then(t, e) {
        return Promise.all(this.animations).then(t).catch(e);
      }
    }
    const hr = (t) => t * 1e3;
    const ur = (t) => t / 1e3;
    const dr = 2e4;
    function fr(t) {
      let e = 0;
      const i = 50;
      let n = t.next(e);
      while (!n.done && e < dr) {
        e += i;
        n = t.next(e);
      }
      return e >= dr ? 1 / 0 : e;
    }
    const pr = (t, e, i) => {
      const n = e - t;
      return n === 0 ? 1 : (i - t) / n;
    };
    const vr = (t, e, i = 10) => {
      let n = '';
      const s = Math.max(Math.round(e / i), 2);
      for (let e = 0; e < s; e++) n += t(pr(0, s - 1, e)) + ', ';
      return `linear(${n.substring(0, n.length - 2)})`;
    };
    const mr = (t, e, i) => {
      if (i > e) return e;
      if (i < t) return t;
      return i;
    };
    function gr(t, e) {
      return e ? t * (1e3 / e) : 0;
    }
    const yr = 5;
    function wr(t, e, i) {
      const n = Math.max(e - yr, 0);
      return gr(i - t(n), e - n);
    }
    const br = {
      stiffness: 100,
      damping: 10,
      mass: 1,
      velocity: 0,
      duration: 800,
      bounce: 0.3,
      visualDuration: 0.3,
      restSpeed: { granular: 0.01, default: 2 },
      restDelta: { granular: 0.005, default: 0.5 },
      minDuration: 0.01,
      maxDuration: 10,
      minDamping: 0.05,
      maxDamping: 1,
    };
    const xr = (t) => t;
    const _r = xr;
    const Sr = xr;
    if (false);
    const Cr = 0.001;
    function Er({
      duration: t = br.duration,
      bounce: e = br.bounce,
      velocity: i = br.velocity,
      mass: n = br.mass,
    }) {
      let s;
      let r;
      _r(t <= hr(br.maxDuration), 'Spring duration must be 10 seconds or less');
      let o = 1 - e;
      o = mr(br.minDamping, br.maxDamping, o);
      t = mr(br.minDuration, br.maxDuration, ur(t));
      if (o < 1) {
        s = (e) => {
          const n = e * o;
          const s = n * t;
          const r = n - i;
          const a = Tr(e, o);
          const l = Math.exp(-s);
          return Cr - (r / a) * l;
        };
        r = (e) => {
          const n = e * o;
          const r = n * t;
          const a = r * i + i;
          const l = Math.pow(o, 2) * Math.pow(e, 2) * t;
          const c = Math.exp(-r);
          const h = Tr(Math.pow(e, 2), o);
          const u = -s(e) + Cr > 0 ? -1 : 1;
          return (u * ((a - l) * c)) / h;
        };
      } else {
        s = (e) => {
          const n = Math.exp(-e * t);
          const s = (e - i) * t + 1;
          return -Cr + n * s;
        };
        r = (e) => {
          const n = Math.exp(-e * t);
          const s = (i - e) * (t * t);
          return n * s;
        };
      }
      const a = 5 / t;
      const l = Ar(s, r, a);
      t = hr(t);
      if (isNaN(l)) return { stiffness: br.stiffness, damping: br.damping, duration: t };
      else {
        const e = Math.pow(l, 2) * n;
        return { stiffness: e, damping: o * 2 * Math.sqrt(n * e), duration: t };
      }
    }
    const Pr = 12;
    function Ar(t, e, i) {
      let n = i;
      for (let i = 1; i < Pr; i++) n -= t(n) / e(n);
      return n;
    }
    function Tr(t, e) {
      return t * Math.sqrt(1 - e * e);
    }
    const Dr = ['duration', 'bounce'];
    const Lr = ['stiffness', 'damping', 'mass'];
    function Or(t, e) {
      return e.some((e) => t[e] !== void 0);
    }
    function Ir(t) {
      let e = {
        velocity: br.velocity,
        stiffness: br.stiffness,
        damping: br.damping,
        mass: br.mass,
        isResolvedFromDuration: false,
        ...t,
      };
      if (!Or(t, Lr) && Or(t, Dr))
        if (t.visualDuration) {
          const i = t.visualDuration;
          const n = (2 * Math.PI) / (i * 1.2);
          const s = n * n;
          const r = 2 * mr(0.05, 1, 1 - (t.bounce || 0)) * Math.sqrt(s);
          e = { ...e, mass: br.mass, stiffness: s, damping: r };
        } else {
          const i = Er(t);
          e = { ...e, ...i, mass: br.mass };
          e.isResolvedFromDuration = true;
        }
      return e;
    }
    function Mr(t = br.visualDuration, e = br.bounce) {
      const i = typeof t !== 'object' ? { visualDuration: t, keyframes: [0, 1], bounce: e } : t;
      let { restSpeed: n, restDelta: s } = i;
      const r = i.keyframes[0];
      const o = i.keyframes[i.keyframes.length - 1];
      const a = { done: false, value: r };
      const {
        stiffness: l,
        damping: c,
        mass: h,
        duration: u,
        velocity: d,
        isResolvedFromDuration: f,
      } = Ir({ ...i, velocity: -ur(i.velocity || 0) });
      const p = d || 0;
      const v = c / (2 * Math.sqrt(l * h));
      const m = o - r;
      const g = ur(Math.sqrt(l / h));
      const y = Math.abs(m) < 5;
      n || (n = y ? br.restSpeed.granular : br.restSpeed.default);
      s || (s = y ? br.restDelta.granular : br.restDelta.default);
      let w;
      if (v < 1) {
        const t = Tr(g, v);
        w = (e) => {
          const i = Math.exp(-v * g * e);
          return o - i * (((p + v * g * m) / t) * Math.sin(t * e) + m * Math.cos(t * e));
        };
      } else if (v === 1) w = (t) => o - Math.exp(-g * t) * (m + (p + g * m) * t);
      else {
        const t = g * Math.sqrt(v * v - 1);
        w = (e) => {
          const i = Math.exp(-v * g * e);
          const n = Math.min(t * e, 300);
          return o - (i * ((p + v * g * m) * Math.sinh(n) + t * m * Math.cosh(n))) / t;
        };
      }
      const b = {
        calculatedDuration: f ? u || null : null,
        next: (t) => {
          const e = w(t);
          if (!f) {
            let i = 0;
            if (v < 1) i = t === 0 ? hr(p) : wr(w, t, e);
            const r = Math.abs(i) <= n;
            const l = Math.abs(o - e) <= s;
            a.done = r && l;
          } else a.done = t >= u;
          a.value = a.done ? o : e;
          return a;
        },
        toString: () => {
          const t = Math.min(fr(b), dr);
          const e = vr((e) => b.next(t * e).value, t, 30);
          return t + 'ms ' + e;
        },
      };
      return b;
    }
    function kr(t, e = 100, i) {
      const n = i({ ...t, keyframes: [0, e] });
      const s = Math.min(fr(n), dr);
      return { type: 'keyframes', ease: (t) => n.next(s * t).value / e, duration: ur(s) };
    }
    function zr(t) {
      return typeof t === 'function';
    }
    const Fr = (t, e, i) => {
      const n = e - t;
      return ((((i - t) % n) + n) % n) + t;
    };
    const Rr = (t) => Array.isArray(t) && typeof t[0] !== 'number';
    function Vr(t, e) {
      return Rr(t) ? t[Fr(0, t.length, e)] : t;
    }
    const Br = (t, e, i) => t + (e - t) * i;
    function Nr(t, e) {
      const i = t[t.length - 1];
      for (let n = 1; n <= e; n++) {
        const s = pr(0, e, n);
        t.push(Br(i, 1, s));
      }
    }
    function Wr(t) {
      const e = [0];
      Nr(e, t.length - 1);
      return e;
    }
    const Zr = (t) => Boolean(t && t.getVelocity);
    function Hr(t, e, i) {
      let n;
      if (t instanceof EventTarget) return [t];
      else if (typeof t === 'string') {
        let s = document;
        if (e) s = e.current;
        const r =
          (n = i === null || i === void 0 ? void 0 : i[t]) !== null && n !== void 0
            ? n
            : s.querySelectorAll(t);
        return r ? Array.from(r) : [];
      }
      return Array.from(t);
    }
    function jr(t) {
      return typeof t === 'object' && !Array.isArray(t);
    }
    function Ur(t, e, i, n) {
      if (typeof t === 'string' && jr(e)) return Hr(t, i, n);
      else if (t instanceof NodeList) return Array.from(t);
      else if (Array.isArray(t)) return t;
      else return [t];
    }
    function qr(t, e, i) {
      return t * (e + 1);
    }
    function $r(t, e, i, n) {
      let s;
      if (typeof e === 'number') return e;
      else if (e.startsWith('-') || e.startsWith('+')) return Math.max(0, t + parseFloat(e));
      else if (e === '<') return i;
      else return (s = n.get(e)) !== null && s !== void 0 ? s : t;
    }
    function Xr(t, e) {
      if (t.indexOf(e) === -1) t.push(e);
    }
    function Gr(t, e) {
      const i = t.indexOf(e);
      if (i > -1) t.splice(i, 1);
    }
    function Kr([...t], e, i) {
      const n = e < 0 ? t.length + e : e;
      if (n >= 0 && n < t.length) {
        const n = i < 0 ? t.length + i : i;
        const [s] = t.splice(e, 1);
        t.splice(n, 0, s);
      }
      return t;
    }
    function Yr(t, e, i) {
      for (let n = 0; n < t.length; n++) {
        const s = t[n];
        if (s.at > e && s.at < i) {
          Gr(t, s);
          n--;
        }
      }
    }
    function Qr(t, e, i, n, s, r) {
      Yr(t, s, r);
      for (let o = 0; o < e.length; o++)
        t.push({ value: e[o], at: Br(s, r, n[o]), easing: Vr(i, o) });
    }
    function Jr(t, e) {
      for (let i = 0; i < t.length; i++) t[i] = t[i] / (e + 1);
    }
    function to(t, e) {
      if (t.at === e.at) {
        if (t.value === null) return 1;
        if (e.value === null) return -1;
        return 0;
      } else return t.at - e.at;
    }
    const eo = 'easeInOut';
    const io = 20;
    function no(t, { defaultTransition: e = {}, ...i } = {}, n, s) {
      const r = e.duration || 0.3;
      const o = new Map();
      const a = new Map();
      const l = {};
      const c = new Map();
      let h = 0;
      let u = 0;
      let d = 0;
      for (let i = 0; i < t.length; i++) {
        const o = t[i];
        if (typeof o === 'string') {
          c.set(o, u);
          continue;
        } else if (!Array.isArray(o)) {
          c.set(o.name, $r(u, o.at, h, c));
          continue;
        }
        const [f, p, v = {}] = o;
        if (v.at !== void 0) u = $r(u, v.at, h, c);
        let m = 0;
        const g = (t, i, n, o = 0, a = 0) => {
          const l = oo(t);
          const {
            delay: c = 0,
            times: h = Wr(l),
            type: f = 'keyframes',
            repeat: p,
            repeatType: v,
            repeatDelay: g = 0,
            ...y
          } = i;
          let { ease: w = e.ease || 'easeOut', duration: b } = i;
          const x = typeof c === 'function' ? c(o, a) : c;
          const _ = l.length;
          const S = zr(f) ? f : s === null || s === void 0 ? void 0 : s[f];
          if (_ <= 2 && S) {
            let t = 100;
            if (_ === 2 && co(l)) {
              const e = l[1] - l[0];
              t = Math.abs(e);
            }
            const e = { ...y };
            if (b !== void 0) e.duration = hr(b);
            const i = kr(e, t, S);
            w = i.ease;
            b = i.duration;
          }
          b !== null && b !== void 0 ? b : (b = r);
          const C = u + x;
          if (h.length === 1 && h[0] === 0) h[1] = 1;
          const E = h.length - l.length;
          E > 0 && Nr(h, E);
          l.length === 1 && l.unshift(null);
          if (p) {
            Sr(p < io, 'Repeat count too high, must be less than 20');
            b = qr(b, p);
            const t = [...l];
            const e = [...h];
            w = Array.isArray(w) ? [...w] : [w];
            const i = [...w];
            for (let n = 0; n < p; n++) {
              l.push(...t);
              for (let s = 0; s < t.length; s++) {
                h.push(e[s] + (n + 1));
                w.push(s === 0 ? 'linear' : Vr(i, s - 1));
              }
            }
            Jr(h, p);
          }
          const P = C + b;
          Qr(n, l, w, h, C, P);
          m = Math.max(x + b, m);
          d = Math.max(P, d);
        };
        if (Zr(f)) {
          const t = so(f, a);
          g(p, v, ro('default', t));
        } else {
          const t = Ur(f, p, n, l);
          const e = t.length;
          for (let i = 0; i < e; i++) {
            p;
            v;
            const n = t[i];
            const s = so(n, a);
            for (const t in p) g(p[t], ao(v, t), ro(t, s), i, e);
          }
        }
        h = u;
        u += m;
      }
      a.forEach((t, n) => {
        for (const s in t) {
          const r = t[s];
          r.sort(to);
          const a = [];
          const l = [];
          const c = [];
          for (let t = 0; t < r.length; t++) {
            const { at: e, value: i, easing: n } = r[t];
            a.push(i);
            l.push(pr(0, d, e));
            c.push(n || 'easeOut');
          }
          if (l[0] !== 0) {
            l.unshift(0);
            a.unshift(a[0]);
            c.unshift(eo);
          }
          if (l[l.length - 1] !== 1) {
            l.push(1);
            a.push(null);
          }
          if (!o.has(n)) o.set(n, { keyframes: {}, transition: {} });
          const h = o.get(n);
          h.keyframes[s] = a;
          h.transition[s] = { ...e, duration: d, ease: c, times: l, ...i };
        }
      });
      return o;
    }
    function so(t, e) {
      !e.has(t) && e.set(t, {});
      return e.get(t);
    }
    function ro(t, e) {
      if (!e[t]) e[t] = [];
      return e[t];
    }
    function oo(t) {
      return Array.isArray(t) ? t : [t];
    }
    function ao(t, e) {
      return t && t[e] ? { ...t, ...t[e] } : { ...t };
    }
    const lo = (t) => typeof t === 'number';
    const co = (t) => t.every(lo);
    const ho = new WeakMap();
    function uo(t, e) {
      return t ? t[e] || t['default'] || t : void 0;
    }
    const fo = [
      'transformPerspective',
      'x',
      'y',
      'z',
      'translateX',
      'translateY',
      'translateZ',
      'scale',
      'scaleX',
      'scaleY',
      'rotate',
      'rotateX',
      'rotateY',
      'rotateZ',
      'skew',
      'skewX',
      'skewY',
    ];
    const po = new Set(fo);
    const vo = new Set(['width', 'height', 'top', 'left', 'right', 'bottom', ...fo]);
    const mo = (t) => Array.isArray(t);
    const go = (t) => Boolean(t && typeof t === 'object' && t.mix && t.toValue);
    const yo = (t) => (mo(t) ? t[t.length - 1] || 0 : t);
    const wo = { skipAnimations: false, useManualTiming: false };
    const bo = ['read', 'resolveKeyframes', 'update', 'preRender', 'render', 'postRender'];
    const xo = { value: null, addProjectionMetrics: null };
    function _o(t, e) {
      let i = new Set();
      let n = new Set();
      let s = false;
      let r = false;
      const o = new WeakSet();
      let a = { delta: 0, timestamp: 0, isProcessing: false };
      let l = 0;
      function c(e) {
        if (o.has(e)) {
          h.schedule(e);
          t();
        }
        l++;
        e(a);
      }
      const h = {
        schedule: (t, e = false, r = false) => {
          const a = r && s;
          const l = a ? i : n;
          if (e) o.add(t);
          if (!l.has(t)) l.add(t);
          return t;
        },
        cancel: (t) => {
          n.delete(t);
          o.delete(t);
        },
        process: (t) => {
          a = t;
          if (s) {
            r = true;
            return;
          }
          s = true;
          [i, n] = [n, i];
          i.forEach(c);
          if (e && xo.value) xo.value.frameloop[e].push(l);
          l = 0;
          i.clear();
          s = false;
          if (r) {
            r = false;
            h.process(t);
          }
        },
      };
      return h;
    }
    const So = 40;
    function Co(t, e) {
      let i = false;
      let n = true;
      const s = { delta: 0, timestamp: 0, isProcessing: false };
      const r = () => (i = true);
      const o = bo.reduce((t, i) => {
        t[i] = _o(r, e ? i : void 0);
        return t;
      }, {});
      const { read: a, resolveKeyframes: l, update: c, preRender: h, render: u, postRender: d } = o;
      const f = () => {
        const r = wo.useManualTiming ? s.timestamp : performance.now();
        i = false;
        if (!wo.useManualTiming)
          s.delta = n ? 1e3 / 60 : Math.max(Math.min(r - s.timestamp, So), 1);
        s.timestamp = r;
        s.isProcessing = true;
        a.process(s);
        l.process(s);
        c.process(s);
        h.process(s);
        u.process(s);
        d.process(s);
        s.isProcessing = false;
        if (i && e) {
          n = false;
          t(f);
        }
      };
      const p = () => {
        i = true;
        n = true;
        if (!s.isProcessing) t(f);
      };
      const v = bo.reduce((t, e) => {
        const n = o[e];
        t[e] = (t, e = false, s = false) => {
          if (!i) p();
          return n.schedule(t, e, s);
        };
        return t;
      }, {});
      const m = (t) => {
        for (let e = 0; e < bo.length; e++) o[bo[e]].cancel(t);
      };
      return { schedule: v, cancel: m, state: s, steps: o };
    }
    const {
      schedule: Eo,
      cancel: Po,
      state: Ao,
      steps: To,
    } = Co(typeof requestAnimationFrame !== 'undefined' ? requestAnimationFrame : xr, true);
    let Do;
    function Lo() {
      Do = void 0;
    }
    const Oo = {
      now: () => {
        if (Do === void 0)
          Oo.set(Ao.isProcessing || wo.useManualTiming ? Ao.timestamp : performance.now());
        return Do;
      },
      set: (t) => {
        Do = t;
        queueMicrotask(Lo);
      },
    };
    class Io {
      constructor() {
        this.subscriptions = [];
      }
      add(t) {
        Xr(this.subscriptions, t);
        return () => Gr(this.subscriptions, t);
      }
      notify(t, e, i) {
        const n = this.subscriptions.length;
        if (!n) return;
        if (n === 1) this.subscriptions[0](t, e, i);
        else
          for (let s = 0; s < n; s++) {
            const n = this.subscriptions[s];
            n && n(t, e, i);
          }
      }
      getSize() {
        return this.subscriptions.length;
      }
      clear() {
        this.subscriptions.length = 0;
      }
    }
    const Mo = 30;
    const ko = (t) => !isNaN(parseFloat(t));
    const zo = { current: void 0 };
    class Fo {
      constructor(t, e = {}) {
        this.version = '12.4.11';
        this.canTrackVelocity = null;
        this.events = {};
        this.updateAndNotify = (t, e = true) => {
          const i = Oo.now();
          if (this.updatedAt !== i) this.setPrevFrameValue();
          this.prev = this.current;
          this.setCurrent(t);
          if (this.current !== this.prev && this.events.change)
            this.events.change.notify(this.current);
          if (e && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        this.hasAnimated = false;
        this.setCurrent(t);
        this.owner = e.owner;
      }
      setCurrent(t) {
        this.current = t;
        this.updatedAt = Oo.now();
        if (this.canTrackVelocity === null && t !== void 0)
          this.canTrackVelocity = ko(this.current);
      }
      setPrevFrameValue(t = this.current) {
        this.prevFrameValue = t;
        this.prevUpdatedAt = this.updatedAt;
      }
      onChange(t) {
        if (false);
        return this.on('change', t);
      }
      on(t, e) {
        if (!this.events[t]) this.events[t] = new Io();
        const i = this.events[t].add(e);
        if (t === 'change')
          return () => {
            i();
            Eo.read(() => {
              if (!this.events.change.getSize()) this.stop();
            });
          };
        return i;
      }
      clearListeners() {
        for (const t in this.events) this.events[t].clear();
      }
      attach(t, e) {
        this.passiveEffect = t;
        this.stopPassiveEffect = e;
      }
      set(t, e = true) {
        if (!e || !this.passiveEffect) this.updateAndNotify(t, e);
        else this.passiveEffect(t, this.updateAndNotify);
      }
      setWithVelocity(t, e, i) {
        this.set(e);
        this.prev = void 0;
        this.prevFrameValue = t;
        this.prevUpdatedAt = this.updatedAt - i;
      }
      jump(t, e = true) {
        this.updateAndNotify(t);
        this.prev = t;
        this.prevUpdatedAt = this.prevFrameValue = void 0;
        e && this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
      }
      get() {
        if (zo.current) zo.current.push(this);
        return this.current;
      }
      getPrevious() {
        return this.prev;
      }
      getVelocity() {
        const t = Oo.now();
        if (!this.canTrackVelocity || this.prevFrameValue === void 0 || t - this.updatedAt > Mo)
          return 0;
        const e = Math.min(this.updatedAt - this.prevUpdatedAt, Mo);
        return gr(parseFloat(this.current) - parseFloat(this.prevFrameValue), e);
      }
      start(t) {
        this.stop();
        return new Promise((e) => {
          this.hasAnimated = true;
          this.animation = t(e);
          if (this.events.animationStart) this.events.animationStart.notify();
        }).then(() => {
          if (this.events.animationComplete) this.events.animationComplete.notify();
          this.clearAnimation();
        });
      }
      stop() {
        if (this.animation) {
          this.animation.stop();
          if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
      }
      isAnimating() {
        return !!this.animation;
      }
      clearAnimation() {
        delete this.animation;
      }
      destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
      }
    }
    function Ro(t, e) {
      return new Fo(t, e);
    }
    function Vo(t) {
      const e = [{}, {}];
      t === null || t === void 0
        ? void 0
        : t.values.forEach((t, i) => {
            e[0][i] = t.get();
            e[1][i] = t.getVelocity();
          });
      return e;
    }
    function Bo(t, e, i, n) {
      if (typeof e === 'function') {
        const [s, r] = Vo(n);
        e = e(i !== void 0 ? i : t.custom, s, r);
      }
      if (typeof e === 'string') e = t.variants && t.variants[e];
      if (typeof e === 'function') {
        const [s, r] = Vo(n);
        e = e(i !== void 0 ? i : t.custom, s, r);
      }
      return e;
    }
    function No(t, e, i) {
      const n = t.getProps();
      return Bo(n, e, i !== void 0 ? i : n.custom, t);
    }
    function Wo(t, e, i) {
      if (t.hasValue(e)) t.getValue(e).set(i);
      else t.addValue(e, Ro(i));
    }
    function Zo(t, e) {
      const i = No(t, e);
      let { transitionEnd: n = {}, transition: s = {}, ...r } = i || {};
      r = { ...r, ...n };
      for (const e in r) {
        const i = yo(r[e]);
        Wo(t, e, i);
      }
    }
    function Ho(t) {
      return Boolean(Zr(t) && t.add);
    }
    function jo(t, e) {
      const i = t.getValue('willChange');
      if (Ho(i)) return i.add(e);
    }
    const Uo = (t) => t.replace(/([a-z])([A-Z])/gu, '$1-$2').toLowerCase();
    const qo = 'framerAppearId';
    const $o = 'data-' + Uo(qo);
    function Xo(t) {
      return t.props[$o];
    }
    const Go = { current: false };
    function Ko(t, e) {
      t.timeline = e;
      t.onfinish = null;
    }
    const Yo = (t) => Array.isArray(t) && typeof t[0] === 'number';
    const Qo = { linearEasing: void 0 };
    function Jo(t, e) {
      const i = or(t);
      return () => {
        let t;
        return (t = Qo[e]) !== null && t !== void 0 ? t : i();
      };
    }
    const ta = Jo(() => {
      try {
        document.createElement('div').animate({ opacity: 0 }, { easing: 'linear(0, 1)' });
      } catch (t) {
        return false;
      }
      return true;
    }, 'linearEasing');
    function ea(t) {
      return Boolean(
        (typeof t === 'function' && ta()) ||
        !t ||
        (typeof t === 'string' && (t in na || ta())) ||
        Yo(t) ||
        (Array.isArray(t) && t.every(ea))
      );
    }
    const ia = ([t, e, i, n]) => `cubic-bezier(${t}, ${e}, ${i}, ${n})`;
    const na = {
      linear: 'linear',
      ease: 'ease',
      easeIn: 'ease-in',
      easeOut: 'ease-out',
      easeInOut: 'ease-in-out',
      circIn: ia([0, 0.65, 0.55, 1]),
      circOut: ia([0.55, 0, 1, 0.45]),
      backIn: ia([0.31, 0.01, 0.66, -0.59]),
      backOut: ia([0.33, 1.53, 0.69, 0.99]),
    };
    function sa(t, e) {
      if (!t) return;
      else if (typeof t === 'function' && ta()) return vr(t, e);
      else if (Yo(t)) return ia(t);
      else if (Array.isArray(t)) return t.map((t) => sa(t, e) || na.easeOut);
      else return na[t];
    }
    const ra = (t, e, i) => (((1 - 3 * i + 3 * e) * t + (3 * i - 6 * e)) * t + 3 * e) * t;
    const oa = 1e-7;
    const aa = 12;
    function la(t, e, i, n, s) {
      let r;
      let o;
      let a = 0;
      do {
        o = e + (i - e) / 2;
        r = ra(o, n, s) - t;
        if (r > 0) i = o;
        else e = o;
      } while (Math.abs(r) > oa && ++a < aa);
      return o;
    }
    function ca(t, e, i, n) {
      if (t === e && i === n) return xr;
      const s = (e) => la(e, 0, 1, t, i);
      return (t) => (t === 0 || t === 1 ? t : ra(s(t), e, n));
    }
    const ha = (t) => (e) => (e <= 0.5 ? t(2 * e) / 2 : (2 - t(2 * (1 - e))) / 2);
    const ua = (t) => (e) => 1 - t(1 - e);
    const da = ca(0.33, 1.53, 0.69, 0.99);
    const fa = ua(da);
    const pa = ha(fa);
    const va = (t) => ((t *= 2) < 1 ? 0.5 * fa(t) : 0.5 * (2 - Math.pow(2, -10 * (t - 1))));
    const ma = (t) => 1 - Math.sin(Math.acos(t));
    const ga = ua(ma);
    const ya = ha(ma);
    const wa = (t) => /^0[^.\s]+$/u.test(t);
    function ba(t) {
      if (typeof t === 'number') return t === 0;
      else if (t !== null) return t === 'none' || t === '0' || wa(t);
      else return true;
    }
    const xa = { test: (t) => typeof t === 'number', parse: parseFloat, transform: (t) => t };
    const _a = { ...xa, transform: (t) => mr(0, 1, t) };
    const Sa = { ...xa, default: 1 };
    const Ca = (t) => Math.round(t * 1e5) / 1e5;
    const Ea = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
    function Pa(t) {
      return t == null;
    }
    const Aa =
      /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;
    const Ta = (t, e) => (i) =>
      Boolean(
        (typeof i === 'string' && Aa.test(i) && i.startsWith(t)) ||
        (e && !Pa(i) && Object.prototype.hasOwnProperty.call(i, e))
      );
    const Da = (t, e, i) => (n) => {
      if (typeof n !== 'string') return n;
      const [s, r, o, a] = n.match(Ea);
      return {
        [t]: parseFloat(s),
        [e]: parseFloat(r),
        [i]: parseFloat(o),
        alpha: a !== void 0 ? parseFloat(a) : 1,
      };
    };
    const La = (t) => mr(0, 255, t);
    const Oa = { ...xa, transform: (t) => Math.round(La(t)) };
    const Ia = {
      test: Ta('rgb', 'red'),
      parse: Da('red', 'green', 'blue'),
      transform: ({ red: t, green: e, blue: i, alpha: n = 1 }) =>
        'rgba(' +
        Oa.transform(t) +
        ', ' +
        Oa.transform(e) +
        ', ' +
        Oa.transform(i) +
        ', ' +
        Ca(_a.transform(n)) +
        ')',
    };
    function Ma(t) {
      let e = '';
      let i = '';
      let n = '';
      let s = '';
      if (t.length > 5) {
        e = t.substring(1, 3);
        i = t.substring(3, 5);
        n = t.substring(5, 7);
        s = t.substring(7, 9);
      } else {
        e = t.substring(1, 2);
        i = t.substring(2, 3);
        n = t.substring(3, 4);
        s = t.substring(4, 5);
        e += e;
        i += i;
        n += n;
        s += s;
      }
      return {
        red: parseInt(e, 16),
        green: parseInt(i, 16),
        blue: parseInt(n, 16),
        alpha: s ? parseInt(s, 16) / 255 : 1,
      };
    }
    const ka = { test: Ta('#'), parse: Ma, transform: Ia.transform };
    const za = (t) => ({
      test: (e) => typeof e === 'string' && e.endsWith(t) && e.split(' ').length === 1,
      parse: parseFloat,
      transform: (e) => `${e}${t}`,
    });
    const Fa = za('deg');
    const Ra = za('%');
    const Va = za('px');
    const Ba = za('vh');
    const Na = za('vw');
    const Wa = { ...Ra, parse: (t) => Ra.parse(t) / 100, transform: (t) => Ra.transform(t * 100) };
    const Za = {
      test: Ta('hsl', 'hue'),
      parse: Da('hue', 'saturation', 'lightness'),
      transform: ({ hue: t, saturation: e, lightness: i, alpha: n = 1 }) =>
        'hsla(' +
        Math.round(t) +
        ', ' +
        Ra.transform(Ca(e)) +
        ', ' +
        Ra.transform(Ca(i)) +
        ', ' +
        Ca(_a.transform(n)) +
        ')',
    };
    const Ha = {
      test: (t) => Ia.test(t) || ka.test(t) || Za.test(t),
      parse: (t) => {
        if (Ia.test(t)) return Ia.parse(t);
        else if (Za.test(t)) return Za.parse(t);
        else return ka.parse(t);
      },
      transform: (t) =>
        typeof t === 'string' ? t : t.hasOwnProperty('red') ? Ia.transform(t) : Za.transform(t),
    };
    const ja =
      /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
    function Ua(t) {
      let e, i;
      return (
        isNaN(t) &&
        typeof t === 'string' &&
        (((e = t.match(Ea)) === null || e === void 0 ? void 0 : e.length) || 0) +
          (((i = t.match(ja)) === null || i === void 0 ? void 0 : i.length) || 0) >
          0
      );
    }
    const qa = 'number';
    const $a = 'color';
    const Xa = 'var';
    const Ga = 'var(';
    const Ka = '${}';
    const Ya =
      /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
    function Qa(t) {
      const e = t.toString();
      const i = [];
      const n = { color: [], number: [], var: [] };
      const s = [];
      let r = 0;
      const o = e.replace(Ya, (t) => {
        if (Ha.test(t)) {
          n.color.push(r);
          s.push($a);
          i.push(Ha.parse(t));
        } else if (t.startsWith(Ga)) {
          n.var.push(r);
          s.push(Xa);
          i.push(t);
        } else {
          n.number.push(r);
          s.push(qa);
          i.push(parseFloat(t));
        }
        ++r;
        return Ka;
      });
      const a = o.split(Ka);
      return { values: i, split: a, indexes: n, types: s };
    }
    function Ja(t) {
      return Qa(t).values;
    }
    function tl(t) {
      const { split: e, types: i } = Qa(t);
      const n = e.length;
      return (t) => {
        let s = '';
        for (let r = 0; r < n; r++) {
          s += e[r];
          if (t[r] !== void 0) {
            const e = i[r];
            if (e === qa) s += Ca(t[r]);
            else if (e === $a) s += Ha.transform(t[r]);
            else s += t[r];
          }
        }
        return s;
      };
    }
    const el = (t) => (typeof t === 'number' ? 0 : t);
    function il(t) {
      const e = Ja(t);
      const i = tl(t);
      return i(e.map(el));
    }
    const nl = { test: Ua, parse: Ja, createTransformer: tl, getAnimatableNone: il };
    const sl = new Set(['brightness', 'contrast', 'saturate', 'opacity']);
    function rl(t) {
      const [e, i] = t.slice(0, -1).split('(');
      if (e === 'drop-shadow') return t;
      const [n] = i.match(Ea) || [];
      if (!n) return t;
      const s = i.replace(n, '');
      let r = sl.has(e) ? 1 : 0;
      if (n !== i) r *= 100;
      return e + '(' + r + s + ')';
    }
    const ol = /\b([a-z-]*)\(.*?\)/gu;
    const al = {
      ...nl,
      getAnimatableNone: (t) => {
        const e = t.match(ol);
        return e ? e.map(rl).join(' ') : t;
      },
    };
    const ll = {
      borderWidth: Va,
      borderTopWidth: Va,
      borderRightWidth: Va,
      borderBottomWidth: Va,
      borderLeftWidth: Va,
      borderRadius: Va,
      radius: Va,
      borderTopLeftRadius: Va,
      borderTopRightRadius: Va,
      borderBottomRightRadius: Va,
      borderBottomLeftRadius: Va,
      width: Va,
      maxWidth: Va,
      height: Va,
      maxHeight: Va,
      top: Va,
      right: Va,
      bottom: Va,
      left: Va,
      padding: Va,
      paddingTop: Va,
      paddingRight: Va,
      paddingBottom: Va,
      paddingLeft: Va,
      margin: Va,
      marginTop: Va,
      marginRight: Va,
      marginBottom: Va,
      marginLeft: Va,
      backgroundPositionX: Va,
      backgroundPositionY: Va,
    };
    const cl = {
      rotate: Fa,
      rotateX: Fa,
      rotateY: Fa,
      rotateZ: Fa,
      scale: Sa,
      scaleX: Sa,
      scaleY: Sa,
      scaleZ: Sa,
      skew: Fa,
      skewX: Fa,
      skewY: Fa,
      distance: Va,
      translateX: Va,
      translateY: Va,
      translateZ: Va,
      x: Va,
      y: Va,
      z: Va,
      perspective: Va,
      transformPerspective: Va,
      opacity: _a,
      originX: Wa,
      originY: Wa,
      originZ: Va,
    };
    const hl = { ...xa, transform: Math.round };
    const ul = {
      ...ll,
      ...cl,
      zIndex: hl,
      size: Va,
      fillOpacity: _a,
      strokeOpacity: _a,
      numOctaves: hl,
    };
    const dl = {
      ...ul,
      color: Ha,
      backgroundColor: Ha,
      outlineColor: Ha,
      fill: Ha,
      stroke: Ha,
      borderColor: Ha,
      borderTopColor: Ha,
      borderRightColor: Ha,
      borderBottomColor: Ha,
      borderLeftColor: Ha,
      filter: al,
      WebkitFilter: al,
    };
    const fl = (t) => dl[t];
    function pl(t, e) {
      let i = fl(t);
      if (i !== al) i = nl;
      return i.getAnimatableNone ? i.getAnimatableNone(e) : void 0;
    }
    const vl = new Set(['auto', 'none', '0']);
    function ml(t, e, i) {
      let n = 0;
      let s;
      while (n < t.length && !s) {
        const e = t[n];
        if (typeof e === 'string' && !vl.has(e) && Qa(e).values.length) s = t[n];
        n++;
      }
      if (s && i) for (const n of e) t[n] = pl(i, s);
    }
    const gl = (t) => t === xa || t === Va;
    const yl = (t, e) => parseFloat(t.split(', ')[e]);
    const wl =
      (t, e) =>
      (i, { transform: n }) => {
        if (n === 'none' || !n) return 0;
        const s = n.match(/^matrix3d\((.+)\)$/u);
        if (s) return yl(s[1], e);
        else {
          const e = n.match(/^matrix\((.+)\)$/u);
          if (e) return yl(e[1], t);
          else return 0;
        }
      };
    const bl = new Set(['x', 'y', 'z']);
    const xl = fo.filter((t) => !bl.has(t));
    function _l(t) {
      const e = [];
      xl.forEach((i) => {
        const n = t.getValue(i);
        if (n !== void 0) {
          e.push([i, n.get()]);
          n.set(i.startsWith('scale') ? 1 : 0);
        }
      });
      return e;
    }
    const Sl = {
      width: ({ x: t }, { paddingLeft: e = '0', paddingRight: i = '0' }) =>
        t.max - t.min - parseFloat(e) - parseFloat(i),
      height: ({ y: t }, { paddingTop: e = '0', paddingBottom: i = '0' }) =>
        t.max - t.min - parseFloat(e) - parseFloat(i),
      top: (t, { top: e }) => parseFloat(e),
      left: (t, { left: e }) => parseFloat(e),
      bottom: ({ y: t }, { top: e }) => parseFloat(e) + (t.max - t.min),
      right: ({ x: t }, { left: e }) => parseFloat(e) + (t.max - t.min),
      x: wl(4, 13),
      y: wl(5, 14),
    };
    Sl.translateX = Sl.x;
    Sl.translateY = Sl.y;
    const Cl = new Set();
    let El = false;
    let Pl = false;
    function Al() {
      if (Pl) {
        const t = Array.from(Cl).filter((t) => t.needsMeasurement);
        const e = new Set(t.map((t) => t.element));
        const i = new Map();
        e.forEach((t) => {
          const e = _l(t);
          if (!e.length) return;
          i.set(t, e);
          t.render();
        });
        t.forEach((t) => t.measureInitialState());
        e.forEach((t) => {
          t.render();
          const e = i.get(t);
          if (e)
            e.forEach(([e, i]) => {
              let n;
              (n = t.getValue(e)) === null || n === void 0 ? void 0 : n.set(i);
            });
        });
        t.forEach((t) => t.measureEndState());
        t.forEach((t) => {
          if (t.suspendedScrollY !== void 0) window.scrollTo(0, t.suspendedScrollY);
        });
      }
      Pl = false;
      El = false;
      Cl.forEach((t) => t.complete());
      Cl.clear();
    }
    function Tl() {
      Cl.forEach((t) => {
        t.readKeyframes();
        if (t.needsMeasurement) Pl = true;
      });
    }
    function Dl() {
      Tl();
      Al();
    }
    class Ll {
      constructor(t, e, i, n, s, r = false) {
        this.isComplete = false;
        this.isAsync = false;
        this.needsMeasurement = false;
        this.isScheduled = false;
        this.unresolvedKeyframes = [...t];
        this.onComplete = e;
        this.name = i;
        this.motionValue = n;
        this.element = s;
        this.isAsync = r;
      }
      scheduleResolve() {
        this.isScheduled = true;
        if (this.isAsync) {
          Cl.add(this);
          if (!El) {
            El = true;
            Eo.read(Tl);
            Eo.resolveKeyframes(Al);
          }
        } else {
          this.readKeyframes();
          this.complete();
        }
      }
      readKeyframes() {
        const { unresolvedKeyframes: t, name: e, element: i, motionValue: n } = this;
        for (let s = 0; s < t.length; s++)
          if (t[s] === null)
            if (s === 0) {
              const s = n === null || n === void 0 ? void 0 : n.get();
              const r = t[t.length - 1];
              if (s !== void 0) t[0] = s;
              else if (i && e) {
                const n = i.readValue(e, r);
                if (n !== void 0 && n !== null) t[0] = n;
              }
              if (t[0] === void 0) t[0] = r;
              if (n && s === void 0) n.set(t[0]);
            } else t[s] = t[s - 1];
      }
      setFinalKeyframe() {}
      measureInitialState() {}
      renderEndStyles() {}
      measureEndState() {}
      complete() {
        this.isComplete = true;
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe);
        Cl.delete(this);
      }
      cancel() {
        if (!this.isComplete) {
          this.isScheduled = false;
          Cl.delete(this);
        }
      }
      resume() {
        if (!this.isComplete) this.scheduleResolve();
      }
    }
    const Ol = (t) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(t);
    const Il = (t) => (e) => typeof e === 'string' && e.startsWith(t);
    const Ml = Il('--');
    const kl = Il('var(--');
    const zl = (t) => {
      const e = kl(t);
      if (!e) return false;
      return Fl.test(t.split('/*')[0].trim());
    };
    const Fl =
      /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;
    const Rl = /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
    function Vl(t) {
      const e = Rl.exec(t);
      if (!e) return [,];
      const [, i, n, s] = e;
      return [`--${i !== null && i !== void 0 ? i : n}`, s];
    }
    const Bl = 4;
    function Nl(t, e, i = 1) {
      Sr(
        i <= Bl,
        `Max CSS variable fallback depth detected in property "${t}". This may indicate a circular fallback dependency.`
      );
      const [n, s] = Vl(t);
      if (!n) return;
      const r = window.getComputedStyle(e).getPropertyValue(n);
      if (r) {
        const t = r.trim();
        return Ol(t) ? parseFloat(t) : t;
      }
      return zl(s) ? Nl(s, e, i + 1) : s;
    }
    const Wl = (t) => (e) => e.test(t);
    const Zl = { test: (t) => t === 'auto', parse: (t) => t };
    const Hl = [xa, Va, Ra, Fa, Na, Ba, Zl];
    const jl = (t) => Hl.find(Wl(t));
    class Ul extends Ll {
      constructor(t, e, i, n, s) {
        super(t, e, i, n, s, true);
      }
      readKeyframes() {
        const { unresolvedKeyframes: t, element: e, name: i } = this;
        if (!e || !e.current) return;
        super.readKeyframes();
        for (let i = 0; i < t.length; i++) {
          let n = t[i];
          if (typeof n === 'string') {
            n = n.trim();
            if (zl(n)) {
              const s = Nl(n, e.current);
              if (s !== void 0) t[i] = s;
              if (i === t.length - 1) this.finalKeyframe = n;
            }
          }
        }
        this.resolveNoneKeyframes();
        if (!vo.has(i) || t.length !== 2) return;
        const [n, s] = t;
        const r = jl(n);
        const o = jl(s);
        if (r === o) return;
        if (gl(r) && gl(o))
          for (let e = 0; e < t.length; e++) {
            const i = t[e];
            if (typeof i === 'string') t[e] = parseFloat(i);
          }
        else this.needsMeasurement = true;
      }
      resolveNoneKeyframes() {
        const { unresolvedKeyframes: t, name: e } = this;
        const i = [];
        for (let e = 0; e < t.length; e++) if (ba(t[e])) i.push(e);
        if (i.length) ml(t, i, e);
      }
      measureInitialState() {
        const { element: t, unresolvedKeyframes: e, name: i } = this;
        if (!t || !t.current) return;
        if (i === 'height') this.suspendedScrollY = window.pageYOffset;
        this.measuredOrigin = Sl[i](t.measureViewportBox(), window.getComputedStyle(t.current));
        e[0] = this.measuredOrigin;
        const n = e[e.length - 1];
        if (n !== void 0) t.getValue(i, n).jump(n, false);
      }
      measureEndState() {
        let t;
        const { element: e, name: i, unresolvedKeyframes: n } = this;
        if (!e || !e.current) return;
        const s = e.getValue(i);
        s && s.jump(this.measuredOrigin, false);
        const r = n.length - 1;
        const o = n[r];
        n[r] = Sl[i](e.measureViewportBox(), window.getComputedStyle(e.current));
        if (o !== null && this.finalKeyframe === void 0) this.finalKeyframe = o;
        if ((t = this.removedTransforms) === null || t === void 0 ? void 0 : t.length)
          this.removedTransforms.forEach(([t, i]) => {
            e.getValue(t).set(i);
          });
        this.resolveNoneKeyframes();
      }
    }
    const ql = (t, e) => {
      if (e === 'zIndex') return false;
      if (typeof t === 'number' || Array.isArray(t)) return true;
      if (typeof t === 'string' && (nl.test(t) || t === '0') && !t.startsWith('url(')) return true;
      return false;
    };
    function $l(t) {
      const e = t[0];
      if (t.length === 1) return true;
      for (let i = 0; i < t.length; i++) if (t[i] !== e) return true;
    }
    function Xl(t, e, i, n) {
      const s = t[0];
      if (s === null) return false;
      if (e === 'display' || e === 'visibility') return true;
      const r = t[t.length - 1];
      const o = ql(s, e);
      const a = ql(r, e);
      _r(
        o === a,
        `You are trying to animate ${e} from "${s}" to "${r}". ${s} is not an animatable value - to enable this animation set ${s} to a value animatable to ${r} via the \`style\` property.`
      );
      if (!o || !a) return false;
      return $l(t) || ((i === 'spring' || zr(i)) && n);
    }
    const Gl = (t) => t !== null;
    function Kl(t, { repeat: e, repeatType: i = 'loop' }, n) {
      const s = t.filter(Gl);
      const r = e && i !== 'loop' && e % 2 === 1 ? 0 : s.length - 1;
      return !r || n === void 0 ? s[r] : n;
    }
    const Yl = 40;
    class Ql {
      constructor({
        autoplay: t = true,
        delay: e = 0,
        type: i = 'keyframes',
        repeat: n = 0,
        repeatDelay: s = 0,
        repeatType: r = 'loop',
        ...o
      }) {
        this.isStopped = false;
        this.hasAttemptedResolve = false;
        this.createdAt = Oo.now();
        this.options = {
          autoplay: t,
          delay: e,
          type: i,
          repeat: n,
          repeatDelay: s,
          repeatType: r,
          ...o,
        };
        this.updateFinishedPromise();
      }
      calcStartTime() {
        if (!this.resolvedAt) return this.createdAt;
        return this.resolvedAt - this.createdAt > Yl ? this.resolvedAt : this.createdAt;
      }
      get resolved() {
        if (!this._resolved && !this.hasAttemptedResolve) Dl();
        return this._resolved;
      }
      onKeyframesResolved(t, e) {
        this.resolvedAt = Oo.now();
        this.hasAttemptedResolve = true;
        const {
          name: i,
          type: n,
          velocity: s,
          delay: r,
          onComplete: o,
          onUpdate: a,
          isGenerator: l,
        } = this.options;
        if (!l && !Xl(t, i, n, s))
          if (Go.current || !r) {
            a && a(Kl(t, this.options, e));
            o && o();
            this.resolveFinishedPromise();
            return;
          } else this.options.duration = 0;
        const c = this.initPlayback(t, e);
        if (c === false) return;
        this._resolved = { keyframes: t, finalKeyframe: e, ...c };
        this.onPostResolved();
      }
      onPostResolved() {}
      then(t, e) {
        return this.currentFinishedPromise.then(t, e);
      }
      flatten() {
        if (!this.options.allowFlatten) return;
        this.options.type = 'keyframes';
        this.options.ease = 'linear';
      }
      updateFinishedPromise() {
        this.currentFinishedPromise = new Promise((t) => {
          this.resolveFinishedPromise = t;
        });
      }
    }
    const Jl = { layout: 0, mainThread: 0, waapi: 0 };
    function tc(t, e, i) {
      if (i < 0) i += 1;
      if (i > 1) i -= 1;
      if (i < 1 / 6) return t + (e - t) * 6 * i;
      if (i < 1 / 2) return e;
      if (i < 2 / 3) return t + (e - t) * (2 / 3 - i) * 6;
      return t;
    }
    function ec({ hue: t, saturation: e, lightness: i, alpha: n }) {
      t /= 360;
      e /= 100;
      i /= 100;
      let s = 0;
      let r = 0;
      let o = 0;
      if (!e) s = r = o = i;
      else {
        const n = i < 0.5 ? i * (1 + e) : i + e - i * e;
        const a = 2 * i - n;
        s = tc(a, n, t + 1 / 3);
        r = tc(a, n, t);
        o = tc(a, n, t - 1 / 3);
      }
      return {
        red: Math.round(s * 255),
        green: Math.round(r * 255),
        blue: Math.round(o * 255),
        alpha: n,
      };
    }
    function ic(t, e) {
      return (i) => (i > 0 ? e : t);
    }
    const nc = (t, e, i) => {
      const n = t * t;
      const s = i * (e * e - n) + n;
      return s < 0 ? 0 : Math.sqrt(s);
    };
    const sc = [ka, Ia, Za];
    const rc = (t) => sc.find((e) => e.test(t));
    function oc(t) {
      const e = rc(t);
      _r(Boolean(e), `'${t}' is not an animatable color. Use the equivalent color code instead.`);
      if (!e) return false;
      let i = e.parse(t);
      if (e === Za) i = ec(i);
      return i;
    }
    const ac = (t, e) => {
      const i = oc(t);
      const n = oc(e);
      if (!i || !n) return ic(t, e);
      const s = { ...i };
      return (t) => {
        s.red = nc(i.red, n.red, t);
        s.green = nc(i.green, n.green, t);
        s.blue = nc(i.blue, n.blue, t);
        s.alpha = Br(i.alpha, n.alpha, t);
        return Ia.transform(s);
      };
    };
    const lc = (t, e) => (i) => e(t(i));
    const cc = (...t) => t.reduce(lc);
    const hc = new Set(['none', 'hidden']);
    function uc(t, e) {
      if (hc.has(t)) return (i) => (i <= 0 ? t : e);
      else return (i) => (i >= 1 ? e : t);
    }
    function dc(t, e) {
      return (i) => Br(t, e, i);
    }
    function fc(t) {
      if (typeof t === 'number') return dc;
      else if (typeof t === 'string') return zl(t) ? ic : Ha.test(t) ? ac : gc;
      else if (Array.isArray(t)) return pc;
      else if (typeof t === 'object') return Ha.test(t) ? ac : vc;
      return ic;
    }
    function pc(t, e) {
      const i = [...t];
      const n = i.length;
      const s = t.map((t, i) => fc(t)(t, e[i]));
      return (t) => {
        for (let e = 0; e < n; e++) i[e] = s[e](t);
        return i;
      };
    }
    function vc(t, e) {
      const i = { ...t, ...e };
      const n = {};
      for (const s in i) if (t[s] !== void 0 && e[s] !== void 0) n[s] = fc(t[s])(t[s], e[s]);
      return (t) => {
        for (const e in n) i[e] = n[e](t);
        return i;
      };
    }
    function mc(t, e) {
      let i;
      const n = [];
      const s = { color: 0, var: 0, number: 0 };
      for (let r = 0; r < e.values.length; r++) {
        const o = e.types[r];
        const a = t.indexes[o][s[o]];
        const l = (i = t.values[a]) !== null && i !== void 0 ? i : 0;
        n[r] = l;
        s[o]++;
      }
      return n;
    }
    const gc = (t, e) => {
      const i = nl.createTransformer(e);
      const n = Qa(t);
      const s = Qa(e);
      const r =
        n.indexes.var.length === s.indexes.var.length &&
        n.indexes.color.length === s.indexes.color.length &&
        n.indexes.number.length >= s.indexes.number.length;
      if (r) {
        if ((hc.has(t) && !s.values.length) || (hc.has(e) && !n.values.length)) return uc(t, e);
        return cc(pc(mc(n, s), s.values), i);
      } else {
        _r(
          true,
          `Complex values '${t}' and '${e}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`
        );
        return ic(t, e);
      }
    };
    function yc(t, e, i) {
      if (typeof t === 'number' && typeof e === 'number' && typeof i === 'number')
        return Br(t, e, i);
      const n = fc(t);
      return n(t, e);
    }
    function wc({
      keyframes: t,
      velocity: e = 0,
      power: i = 0.8,
      timeConstant: n = 325,
      bounceDamping: s = 10,
      bounceStiffness: r = 500,
      modifyTarget: o,
      min: a,
      max: l,
      restDelta: c = 0.5,
      restSpeed: h,
    }) {
      const u = t[0];
      const d = { done: false, value: u };
      const f = (t) => (a !== void 0 && t < a) || (l !== void 0 && t > l);
      const p = (t) => {
        if (a === void 0) return l;
        if (l === void 0) return a;
        return Math.abs(a - t) < Math.abs(l - t) ? a : l;
      };
      let v = i * e;
      const m = u + v;
      const g = o === void 0 ? m : o(m);
      if (g !== m) v = g - u;
      const y = (t) => -v * Math.exp(-t / n);
      const w = (t) => g + y(t);
      const b = (t) => {
        const e = y(t);
        const i = w(t);
        d.done = Math.abs(e) <= c;
        d.value = d.done ? g : i;
      };
      let x;
      let _;
      const S = (t) => {
        if (!f(d.value)) return;
        x = t;
        _ = Mr({
          keyframes: [d.value, p(d.value)],
          velocity: wr(w, t, d.value),
          damping: s,
          stiffness: r,
          restDelta: c,
          restSpeed: h,
        });
      };
      S(0);
      return {
        calculatedDuration: null,
        next: (t) => {
          let e = false;
          if (!_ && x === void 0) {
            e = true;
            b(t);
            S(t);
          }
          if (x !== void 0 && t >= x) return _.next(t - x);
          else {
            !e && b(t);
            return d;
          }
        },
      };
    }
    const bc = ca(0.42, 0, 1, 1);
    const xc = ca(0, 0, 0.58, 1);
    const _c = ca(0.42, 0, 0.58, 1);
    const Sc = {
      linear: xr,
      easeIn: bc,
      easeInOut: _c,
      easeOut: xc,
      circIn: ma,
      circInOut: ya,
      circOut: ga,
      backIn: fa,
      backInOut: pa,
      backOut: da,
      anticipate: va,
    };
    const Cc = (t) => {
      if (Yo(t)) {
        Sr(t.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [e, i, n, s] = t;
        return ca(e, i, n, s);
      } else if (typeof t === 'string') {
        Sr(Sc[t] !== void 0, `Invalid easing type '${t}'`);
        return Sc[t];
      }
      return t;
    };
    function Ec(t, e, i) {
      const n = [];
      const s = i || yc;
      const r = t.length - 1;
      for (let i = 0; i < r; i++) {
        let r = s(t[i], t[i + 1]);
        if (e) {
          const t = Array.isArray(e) ? e[i] || xr : e;
          r = cc(t, r);
        }
        n.push(r);
      }
      return n;
    }
    function Pc(t, e, { clamp: i = true, ease: n, mixer: s } = {}) {
      const r = t.length;
      Sr(r === e.length, 'Both input and output ranges must be the same length');
      if (r === 1) return () => e[0];
      if (r === 2 && e[0] === e[1]) return () => e[1];
      const o = t[0] === t[1];
      if (t[0] > t[r - 1]) {
        t = [...t].reverse();
        e = [...e].reverse();
      }
      const a = Ec(e, n, s);
      const l = a.length;
      const c = (i) => {
        if (o && i < t[0]) return e[0];
        let n = 0;
        if (l > 1) for (; n < t.length - 2; n++) if (i < t[n + 1]) break;
        const s = pr(t[n], t[n + 1], i);
        return a[n](s);
      };
      return i ? (e) => c(mr(t[0], t[r - 1], e)) : c;
    }
    function Ac(t, e) {
      return t.map((t) => t * e);
    }
    function Tc(t, e) {
      return t.map(() => e || _c).splice(0, t.length - 1);
    }
    function Dc({ duration: t = 300, keyframes: e, times: i, ease: n = 'easeInOut' }) {
      const s = Rr(n) ? n.map(Cc) : Cc(n);
      const r = { done: false, value: e[0] };
      const o = Ac(i && i.length === e.length ? i : Wr(e), t);
      const a = Pc(o, e, { ease: Array.isArray(s) ? s : Tc(e, s) });
      return {
        calculatedDuration: t,
        next: (e) => {
          r.value = a(e);
          r.done = e >= t;
          return r;
        },
      };
    }
    const Lc = (t) => {
      const e = ({ timestamp: e }) => t(e);
      return {
        start: () => Eo.update(e, true),
        stop: () => Po(e),
        now: () => (Ao.isProcessing ? Ao.timestamp : Oo.now()),
      };
    };
    const Oc = { decay: wc, inertia: wc, tween: Dc, keyframes: Dc, spring: Mr };
    const Ic = (t) => t / 100;
    class Mc extends Ql {
      constructor(t) {
        super(t);
        this.holdTime = null;
        this.cancelTime = null;
        this.currentTime = 0;
        this.playbackSpeed = 1;
        this.pendingPlayState = 'running';
        this.startTime = null;
        this.state = 'idle';
        this.stop = () => {
          this.resolver.cancel();
          this.isStopped = true;
          if (this.state === 'idle') return;
          this.teardown();
          const { onStop: t } = this.options;
          t && t();
        };
        const { name: e, motionValue: i, element: n, keyframes: s } = this.options;
        const r = (n === null || n === void 0 ? void 0 : n.KeyframeResolver) || Ll;
        const o = (t, e) => this.onKeyframesResolved(t, e);
        this.resolver = new r(s, o, e, i, n);
        this.resolver.scheduleResolve();
      }
      flatten() {
        super.flatten();
        if (this._resolved)
          Object.assign(this._resolved, this.initPlayback(this._resolved.keyframes));
      }
      initPlayback(t) {
        const {
          type: e = 'keyframes',
          repeat: i = 0,
          repeatDelay: n = 0,
          repeatType: s,
          velocity: r = 0,
        } = this.options;
        const o = zr(e) ? e : Oc[e] || Dc;
        let a;
        let l;
        if (false);
        if (o !== Dc && typeof t[0] !== 'number') {
          a = cc(Ic, yc(t[0], t[1]));
          t = [0, 100];
        }
        const c = o({ ...this.options, keyframes: t });
        if (s === 'mirror') l = o({ ...this.options, keyframes: [...t].reverse(), velocity: -r });
        if (c.calculatedDuration === null) c.calculatedDuration = fr(c);
        const { calculatedDuration: h } = c;
        const u = h + n;
        const d = u * (i + 1) - n;
        return {
          generator: c,
          mirroredGenerator: l,
          mapPercentToKeyframes: a,
          calculatedDuration: h,
          resolvedDuration: u,
          totalDuration: d,
        };
      }
      onPostResolved() {
        const { autoplay: t = true } = this.options;
        Jl.mainThread++;
        this.play();
        if (this.pendingPlayState === 'paused' || !t) this.pause();
        else this.state = this.pendingPlayState;
      }
      tick(t, e = false) {
        const { resolved: i } = this;
        if (!i) {
          const { keyframes: t } = this.options;
          return { done: true, value: t[t.length - 1] };
        }
        const {
          finalKeyframe: n,
          generator: s,
          mirroredGenerator: r,
          mapPercentToKeyframes: o,
          keyframes: a,
          calculatedDuration: l,
          totalDuration: c,
          resolvedDuration: h,
        } = i;
        if (this.startTime === null) return s.next(0);
        const { delay: u, repeat: d, repeatType: f, repeatDelay: p, onUpdate: v } = this.options;
        if (this.speed > 0) this.startTime = Math.min(this.startTime, t);
        else if (this.speed < 0) this.startTime = Math.min(t - c / this.speed, this.startTime);
        if (e) this.currentTime = t;
        else if (this.holdTime !== null) this.currentTime = this.holdTime;
        else this.currentTime = Math.round(t - this.startTime) * this.speed;
        const m = this.currentTime - u * (this.speed >= 0 ? 1 : -1);
        const g = this.speed >= 0 ? m < 0 : m > c;
        this.currentTime = Math.max(m, 0);
        if (this.state === 'finished' && this.holdTime === null) this.currentTime = c;
        let y = this.currentTime;
        let w = s;
        if (d) {
          const t = Math.min(this.currentTime, c) / h;
          let e = Math.floor(t);
          let i = t % 1;
          if (!i && t >= 1) i = 1;
          i === 1 && e--;
          e = Math.min(e, d + 1);
          const n = Boolean(e % 2);
          if (n)
            if (f === 'reverse') {
              i = 1 - i;
              if (p) i -= p / h;
            } else if (f === 'mirror') w = r;
          y = mr(0, 1, i) * h;
        }
        const b = g ? { done: false, value: a[0] } : w.next(y);
        if (o) b.value = o(b.value);
        let { done: x } = b;
        if (!g && l !== null) x = this.speed >= 0 ? this.currentTime >= c : this.currentTime <= 0;
        const _ =
          this.holdTime === null && (this.state === 'finished' || (this.state === 'running' && x));
        if (_ && n !== void 0) b.value = Kl(a, this.options, n);
        if (v) v(b.value);
        if (_) this.finish();
        return b;
      }
      get duration() {
        const { resolved: t } = this;
        return t ? ur(t.calculatedDuration) : 0;
      }
      get time() {
        return ur(this.currentTime);
      }
      set time(t) {
        t = hr(t);
        this.currentTime = t;
        if (this.holdTime !== null || this.speed === 0) this.holdTime = t;
        else if (this.driver) this.startTime = this.driver.now() - t / this.speed;
      }
      get speed() {
        return this.playbackSpeed;
      }
      set speed(t) {
        const e = this.playbackSpeed !== t;
        this.playbackSpeed = t;
        if (e) this.time = ur(this.currentTime);
      }
      play() {
        if (!this.resolver.isScheduled) this.resolver.resume();
        if (!this._resolved) {
          this.pendingPlayState = 'running';
          return;
        }
        if (this.isStopped) return;
        const { driver: t = Lc, onPlay: e, startTime: i } = this.options;
        if (!this.driver) this.driver = t((t) => this.tick(t));
        e && e();
        const n = this.driver.now();
        if (this.holdTime !== null) this.startTime = n - this.holdTime;
        else if (!this.startTime)
          this.startTime = i !== null && i !== void 0 ? i : this.calcStartTime();
        else if (this.state === 'finished') this.startTime = n;
        if (this.state === 'finished') this.updateFinishedPromise();
        this.cancelTime = this.startTime;
        this.holdTime = null;
        this.state = 'running';
        this.driver.start();
      }
      pause() {
        let t;
        if (!this._resolved) {
          this.pendingPlayState = 'paused';
          return;
        }
        this.state = 'paused';
        this.holdTime = (t = this.currentTime) !== null && t !== void 0 ? t : 0;
      }
      complete() {
        if (this.state !== 'running') this.play();
        this.pendingPlayState = this.state = 'finished';
        this.holdTime = null;
      }
      finish() {
        this.teardown();
        this.state = 'finished';
        const { onComplete: t } = this.options;
        t && t();
      }
      cancel() {
        if (this.cancelTime !== null) this.tick(this.cancelTime);
        this.teardown();
        this.updateFinishedPromise();
      }
      teardown() {
        this.state = 'idle';
        this.stopDriver();
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        this.startTime = this.cancelTime = null;
        this.resolver.cancel();
        Jl.mainThread--;
      }
      stopDriver() {
        if (!this.driver) return;
        this.driver.stop();
        this.driver = void 0;
      }
      sample(t) {
        this.startTime = 0;
        return this.tick(t, true);
      }
    }
    function kc(t) {
      return new Mc(t);
    }
    const zc = new Set(['opacity', 'clipPath', 'filter', 'transform']);
    function Fc(
      t,
      e,
      i,
      {
        delay: n = 0,
        duration: s = 300,
        repeat: r = 0,
        repeatType: o = 'loop',
        ease: a = 'easeInOut',
        times: l,
      } = {}
    ) {
      const c = { [e]: i };
      if (l) c.offset = l;
      const h = sa(a, s);
      if (Array.isArray(h)) c.easing = h;
      if (xo.value) Jl.waapi++;
      const u = t.animate(c, {
        delay: n,
        duration: s,
        easing: !Array.isArray(h) ? h : 'linear',
        fill: 'both',
        iterations: r + 1,
        direction: o === 'reverse' ? 'alternate' : 'normal',
      });
      if (xo.value)
        u.finished.finally(() => {
          Jl.waapi--;
        });
      return u;
    }
    const Rc = or(() => Object.hasOwnProperty.call(Element.prototype, 'animate'));
    const Vc = 10;
    const Bc = 2e4;
    function Nc(t) {
      return zr(t.type) || t.type === 'spring' || !ea(t.ease);
    }
    function Wc(t, e) {
      const i = new Mc({ ...e, keyframes: t, repeat: 0, delay: 0, isGenerator: true });
      let n = { done: false, value: t[0] };
      const s = [];
      let r = 0;
      while (!n.done && r < Bc) {
        n = i.sample(r);
        s.push(n.value);
        r += Vc;
      }
      return { times: void 0, keyframes: s, duration: r - Vc, ease: 'linear' };
    }
    const Zc = { anticipate: va, backInOut: pa, circInOut: ya };
    function Hc(t) {
      return t in Zc;
    }
    class jc extends Ql {
      constructor(t) {
        super(t);
        const { name: e, motionValue: i, element: n, keyframes: s } = this.options;
        this.resolver = new Ul(s, (t, e) => this.onKeyframesResolved(t, e), e, i, n);
        this.resolver.scheduleResolve();
      }
      initPlayback(t, e) {
        let {
          duration: i = 300,
          times: n,
          ease: s,
          type: r,
          motionValue: o,
          name: a,
          startTime: l,
        } = this.options;
        if (!o.owner || !o.owner.current) return false;
        if (typeof s === 'string' && ta() && Hc(s)) s = Zc[s];
        if (Nc(this.options)) {
          const { onComplete: e, onUpdate: o, motionValue: a, element: l, ...c } = this.options;
          const h = Wc(t, c);
          t = h.keyframes;
          if (t.length === 1) t[1] = t[0];
          i = h.duration;
          n = h.times;
          s = h.ease;
          r = 'keyframes';
        }
        const c = Fc(o.owner.current, a, t, { ...this.options, duration: i, times: n, ease: s });
        c.startTime = l !== null && l !== void 0 ? l : this.calcStartTime();
        if (this.pendingTimeline) {
          Ko(c, this.pendingTimeline);
          this.pendingTimeline = void 0;
        } else
          c.onfinish = () => {
            const { onComplete: i } = this.options;
            o.set(Kl(t, this.options, e));
            i && i();
            this.cancel();
            this.resolveFinishedPromise();
          };
        return { animation: c, duration: i, times: n, type: r, ease: s, keyframes: t };
      }
      get duration() {
        const { resolved: t } = this;
        if (!t) return 0;
        const { duration: e } = t;
        return ur(e);
      }
      get time() {
        const { resolved: t } = this;
        if (!t) return 0;
        const { animation: e } = t;
        return ur(e.currentTime || 0);
      }
      set time(t) {
        const { resolved: e } = this;
        if (!e) return;
        const { animation: i } = e;
        i.currentTime = hr(t);
      }
      get speed() {
        const { resolved: t } = this;
        if (!t) return 1;
        const { animation: e } = t;
        return e.playbackRate;
      }
      set speed(t) {
        const { resolved: e } = this;
        if (!e) return;
        const { animation: i } = e;
        i.playbackRate = t;
      }
      get state() {
        const { resolved: t } = this;
        if (!t) return 'idle';
        const { animation: e } = t;
        return e.playState;
      }
      get startTime() {
        const { resolved: t } = this;
        if (!t) return null;
        const { animation: e } = t;
        return e.startTime;
      }
      attachTimeline(t) {
        if (!this._resolved) this.pendingTimeline = t;
        else {
          const { resolved: e } = this;
          if (!e) return xr;
          const { animation: i } = e;
          Ko(i, t);
        }
        return xr;
      }
      play() {
        if (this.isStopped) return;
        const { resolved: t } = this;
        if (!t) return;
        const { animation: e } = t;
        if (e.playState === 'finished') this.updateFinishedPromise();
        e.play();
      }
      pause() {
        const { resolved: t } = this;
        if (!t) return;
        const { animation: e } = t;
        e.pause();
      }
      stop() {
        this.resolver.cancel();
        this.isStopped = true;
        if (this.state === 'idle') return;
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        const { resolved: t } = this;
        if (!t) return;
        const { animation: e, keyframes: i, duration: n, type: s, ease: r, times: o } = t;
        if (e.playState === 'idle' || e.playState === 'finished') return;
        if (this.time) {
          const { motionValue: t, onUpdate: e, onComplete: a, element: l, ...c } = this.options;
          const h = new Mc({
            ...c,
            keyframes: i,
            duration: n,
            type: s,
            ease: r,
            times: o,
            isGenerator: true,
          });
          const u = hr(this.time);
          t.setWithVelocity(h.sample(u - Vc).value, h.sample(u).value, Vc);
        }
        const { onStop: a } = this.options;
        a && a();
        this.cancel();
      }
      complete() {
        const { resolved: t } = this;
        if (!t) return;
        t.animation.finish();
      }
      cancel() {
        const { resolved: t } = this;
        if (!t) return;
        t.animation.cancel();
      }
      static supports(t) {
        const { motionValue: e, name: i, repeatDelay: n, repeatType: s, damping: r, type: o } = t;
        if (!e || !e.owner || !(e.owner.current instanceof HTMLElement)) return false;
        const { onUpdate: a, transformTemplate: l } = e.owner.getProps();
        return (
          Rc() && i && zc.has(i) && !a && !l && !n && s !== 'mirror' && r !== 0 && o !== 'inertia'
        );
      }
    }
    const Uc = { type: 'spring', stiffness: 500, damping: 25, restSpeed: 10 };
    const qc = (t) => ({
      type: 'spring',
      stiffness: 550,
      damping: t === 0 ? 2 * Math.sqrt(550) : 30,
      restSpeed: 10,
    });
    const $c = { type: 'keyframes', duration: 0.8 };
    const Xc = { type: 'keyframes', ease: [0.25, 0.1, 0.35, 1], duration: 0.3 };
    const Gc = (t, { keyframes: e }) => {
      if (e.length > 2) return $c;
      else if (po.has(t)) return t.startsWith('scale') ? qc(e[1]) : Uc;
      return Xc;
    };
    function Kc({
      when: t,
      delay: e,
      delayChildren: i,
      staggerChildren: n,
      staggerDirection: s,
      repeat: r,
      repeatType: o,
      repeatDelay: a,
      from: l,
      elapsed: c,
      ...h
    }) {
      return !!Object.keys(h).length;
    }
    const Yc =
      (t, e, i, n = {}, s, r) =>
      (o) => {
        const a = uo(n, t) || {};
        const l = a.delay || n.delay || 0;
        let { elapsed: c = 0 } = n;
        c -= hr(l);
        let h = {
          keyframes: Array.isArray(i) ? i : [null, i],
          ease: 'easeOut',
          velocity: e.getVelocity(),
          ...a,
          delay: -c,
          onUpdate: (t) => {
            e.set(t);
            a.onUpdate && a.onUpdate(t);
          },
          onComplete: () => {
            o();
            a.onComplete && a.onComplete();
          },
          name: t,
          motionValue: e,
          element: r ? void 0 : s,
        };
        if (!Kc(a)) h = { ...h, ...Gc(t, h) };
        if (h.duration) h.duration = hr(h.duration);
        if (h.repeatDelay) h.repeatDelay = hr(h.repeatDelay);
        if (h.from !== void 0) h.keyframes[0] = h.from;
        let u = false;
        if (h.type === false || (h.duration === 0 && !h.repeatDelay)) {
          h.duration = 0;
          if (h.delay === 0) u = true;
        }
        if (Go.current || wo.skipAnimations) {
          u = true;
          h.duration = 0;
          h.delay = 0;
        }
        h.allowFlatten = !a.type && !a.ease;
        if (u && !r && e.get() !== void 0) {
          const t = Kl(h.keyframes, a);
          if (t !== void 0) {
            Eo.update(() => {
              h.onUpdate(t);
              h.onComplete();
            });
            return new cr([]);
          }
        }
        if (!r && jc.supports(h)) return new jc(h);
        else return new Mc(h);
      };
    function Qc({ protectedKeys: t, needsAnimating: e }, i) {
      const n = t.hasOwnProperty(i) && e[i] !== true;
      e[i] = false;
      return n;
    }
    function Jc(t, e, { delay: i = 0, transitionOverride: n, type: s } = {}) {
      let r;
      let { transition: o = t.getDefaultTransition(), transitionEnd: a, ...l } = e;
      if (n) o = n;
      const c = [];
      const h = s && t.animationState && t.animationState.getState()[s];
      for (const e in l) {
        const n = t.getValue(e, (r = t.latestValues[e]) !== null && r !== void 0 ? r : null);
        const s = l[e];
        if (s === void 0 || (h && Qc(h, e))) continue;
        const a = { delay: i, ...uo(o || {}, e) };
        let u = false;
        if (window.MotionHandoffAnimation) {
          const i = Xo(t);
          if (i) {
            const t = window.MotionHandoffAnimation(i, e, Eo);
            if (t !== null) {
              a.startTime = t;
              u = true;
            }
          }
        }
        jo(t, e);
        n.start(Yc(e, n, s, t.shouldReduceMotion && vo.has(e) ? { type: false } : a, t, u));
        const d = n.animation;
        if (d) c.push(d);
      }
      if (a)
        Promise.all(c).then(() => {
          Eo.update(() => {
            a && Zo(t, a);
          });
        });
      return c;
    }
    function th(t) {
      return t instanceof SVGElement && t.tagName !== 'svg';
    }
    const eh = () => ({ translate: 0, scale: 1, origin: 0, originPoint: 0 });
    const ih = () => ({ x: eh(), y: eh() });
    const nh = () => ({ min: 0, max: 0 });
    const sh = () => ({ x: nh(), y: nh() });
    const rh = {
      animation: [
        'animate',
        'variants',
        'whileHover',
        'whileTap',
        'exit',
        'whileInView',
        'whileFocus',
        'whileDrag',
      ],
      exit: ['exit'],
      drag: ['drag', 'dragControls'],
      focus: ['whileFocus'],
      hover: ['whileHover', 'onHoverStart', 'onHoverEnd'],
      tap: ['whileTap', 'onTap', 'onTapStart', 'onTapCancel'],
      pan: ['onPan', 'onPanStart', 'onPanSessionStart', 'onPanEnd'],
      inView: ['whileInView', 'onViewportEnter', 'onViewportLeave'],
      layout: ['layout', 'layoutId'],
    };
    const oh = {};
    for (const t in rh) oh[t] = { isEnabled: (e) => rh[t].some((t) => !!e[t]) };
    const ah = typeof window !== 'undefined';
    const lh = { current: null };
    const ch = { current: false };
    function hh() {
      ch.current = true;
      if (!ah) return;
      if (window.matchMedia) {
        const t = window.matchMedia('(prefers-reduced-motion)');
        const e = () => (lh.current = t.matches);
        t.addListener(e);
        e();
      } else lh.current = false;
    }
    const uh = [...Hl, Ha, nl];
    const dh = (t) => uh.find(Wl(t));
    function fh(t) {
      return t !== null && typeof t === 'object' && typeof t.start === 'function';
    }
    function ph(t) {
      return typeof t === 'string' || Array.isArray(t);
    }
    const vh = [
      'animate',
      'whileInView',
      'whileFocus',
      'whileHover',
      'whileTap',
      'whileDrag',
      'exit',
    ];
    const mh = ['initial', ...vh];
    function gh(t) {
      return fh(t.animate) || mh.some((e) => ph(t[e]));
    }
    function yh(t) {
      return Boolean(gh(t) || t.variants);
    }
    function wh(t, e, i) {
      for (const n in e) {
        const s = e[n];
        const r = i[n];
        if (Zr(s)) {
          t.addValue(n, s);
          if (false);
        } else if (Zr(r)) t.addValue(n, Ro(s, { owner: t }));
        else if (r !== s)
          if (t.hasValue(n)) {
            const e = t.getValue(n);
            if (e.liveStyle === true) e.jump(s);
            else if (!e.hasAnimated) e.set(s);
          } else {
            const e = t.getStaticValue(n);
            t.addValue(n, Ro(e !== void 0 ? e : s, { owner: t }));
          }
      }
      for (const n in i) if (e[n] === void 0) t.removeValue(n);
      return e;
    }
    const bh = [
      'AnimationStart',
      'AnimationComplete',
      'Update',
      'BeforeLayoutMeasure',
      'LayoutMeasure',
      'LayoutAnimationStart',
      'LayoutAnimationComplete',
    ];
    class xh {
      scrapeMotionValuesFromProps(t, e, i) {
        return {};
      }
      constructor(
        {
          parent: t,
          props: e,
          presenceContext: i,
          reducedMotionConfig: n,
          blockInitialAnimation: s,
          visualState: r,
        },
        o = {}
      ) {
        this.current = null;
        this.children = new Set();
        this.isVariantNode = false;
        this.isControllingVariants = false;
        this.shouldReduceMotion = null;
        this.values = new Map();
        this.KeyframeResolver = Ll;
        this.features = {};
        this.valueSubscriptions = new Map();
        this.prevMotionValues = {};
        this.events = {};
        this.propEventSubscriptions = {};
        this.notifyUpdate = () => this.notify('Update', this.latestValues);
        this.render = () => {
          if (!this.current) return;
          this.triggerBuild();
          this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.renderScheduledAt = 0;
        this.scheduleRender = () => {
          const t = Oo.now();
          if (this.renderScheduledAt < t) {
            this.renderScheduledAt = t;
            Eo.render(this.render, false, true);
          }
        };
        const { latestValues: a, renderState: l, onUpdate: c } = r;
        this.onUpdate = c;
        this.latestValues = a;
        this.baseTarget = { ...a };
        this.initialValues = e.initial ? { ...a } : {};
        this.renderState = l;
        this.parent = t;
        this.props = e;
        this.presenceContext = i;
        this.depth = t ? t.depth + 1 : 0;
        this.reducedMotionConfig = n;
        this.options = o;
        this.blockInitialAnimation = Boolean(s);
        this.isControllingVariants = gh(e);
        this.isVariantNode = yh(e);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(t && t.current);
        const { willChange: h, ...u } = this.scrapeMotionValuesFromProps(e, {}, this);
        for (const t in u) {
          const e = u[t];
          if (a[t] !== void 0 && Zr(e)) e.set(a[t], false);
        }
      }
      mount(t) {
        this.current = t;
        ho.set(t, this);
        if (this.projection && !this.projection.instance) this.projection.mount(t);
        if (this.parent && this.isVariantNode && !this.isControllingVariants)
          this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((t, e) => this.bindToMotionValue(e, t));
        if (!ch.current) hh();
        this.shouldReduceMotion =
          this.reducedMotionConfig === 'never'
            ? false
            : this.reducedMotionConfig === 'always'
              ? true
              : lh.current;
        if (false);
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
      }
      unmount() {
        this.projection && this.projection.unmount();
        Po(this.notifyUpdate);
        Po(this.render);
        this.valueSubscriptions.forEach((t) => t());
        this.valueSubscriptions.clear();
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for (const t in this.events) this.events[t].clear();
        for (const t in this.features) {
          const e = this.features[t];
          if (e) {
            e.unmount();
            e.isMounted = false;
          }
        }
        this.current = null;
      }
      bindToMotionValue(t, e) {
        if (this.valueSubscriptions.has(t)) this.valueSubscriptions.get(t)();
        const i = po.has(t);
        if (i && this.onBindTransform) this.onBindTransform();
        const n = e.on('change', (e) => {
          this.latestValues[t] = e;
          this.props.onUpdate && Eo.preRender(this.notifyUpdate);
          if (i && this.projection) this.projection.isTransformDirty = true;
        });
        const s = e.on('renderRequest', this.scheduleRender);
        let r;
        if (window.MotionCheckAppearSync) r = window.MotionCheckAppearSync(this, t, e);
        this.valueSubscriptions.set(t, () => {
          n();
          s();
          if (r) r();
          if (e.owner) e.stop();
        });
      }
      sortNodePosition(t) {
        if (!this.current || !this.sortInstanceNodePosition || this.type !== t.type) return 0;
        return this.sortInstanceNodePosition(this.current, t.current);
      }
      updateFeatures() {
        let t = 'animation';
        for (t in oh) {
          const e = oh[t];
          if (!e) continue;
          const { isEnabled: i, Feature: n } = e;
          if (!this.features[t] && n && i(this.props)) this.features[t] = new n(this);
          if (this.features[t]) {
            const e = this.features[t];
            if (e.isMounted) e.update();
            else {
              e.mount();
              e.isMounted = true;
            }
          }
        }
      }
      triggerBuild() {
        this.build(this.renderState, this.latestValues, this.props);
      }
      measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : sh();
      }
      getStaticValue(t) {
        return this.latestValues[t];
      }
      setStaticValue(t, e) {
        this.latestValues[t] = e;
      }
      update(t, e) {
        if (t.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = t;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = e;
        for (let e = 0; e < bh.length; e++) {
          const i = bh[e];
          if (this.propEventSubscriptions[i]) {
            this.propEventSubscriptions[i]();
            delete this.propEventSubscriptions[i];
          }
          const n = 'on' + i;
          const s = t[n];
          if (s) this.propEventSubscriptions[i] = this.on(i, s);
        }
        this.prevMotionValues = wh(
          this,
          this.scrapeMotionValuesFromProps(t, this.prevProps, this),
          this.prevMotionValues
        );
        if (this.handleChildMotionValue) this.handleChildMotionValue();
        this.onUpdate && this.onUpdate(this);
      }
      getProps() {
        return this.props;
      }
      getVariant(t) {
        return this.props.variants ? this.props.variants[t] : void 0;
      }
      getDefaultTransition() {
        return this.props.transition;
      }
      getTransformPagePoint() {
        return this.props.transformPagePoint;
      }
      getClosestVariantNode() {
        return this.isVariantNode
          ? this
          : this.parent
            ? this.parent.getClosestVariantNode()
            : void 0;
      }
      addVariantChild(t) {
        const e = this.getClosestVariantNode();
        if (e) {
          e.variantChildren && e.variantChildren.add(t);
          return () => e.variantChildren.delete(t);
        }
      }
      addValue(t, e) {
        const i = this.values.get(t);
        if (e !== i) {
          if (i) this.removeValue(t);
          this.bindToMotionValue(t, e);
          this.values.set(t, e);
          this.latestValues[t] = e.get();
        }
      }
      removeValue(t) {
        this.values.delete(t);
        const e = this.valueSubscriptions.get(t);
        if (e) {
          e();
          this.valueSubscriptions.delete(t);
        }
        delete this.latestValues[t];
        this.removeValueFromRenderState(t, this.renderState);
      }
      hasValue(t) {
        return this.values.has(t);
      }
      getValue(t, e) {
        if (this.props.values && this.props.values[t]) return this.props.values[t];
        let i = this.values.get(t);
        if (i === void 0 && e !== void 0) {
          i = Ro(e === null ? void 0 : e, { owner: this });
          this.addValue(t, i);
        }
        return i;
      }
      readValue(t, e) {
        let i;
        let n =
          this.latestValues[t] !== void 0 || !this.current
            ? this.latestValues[t]
            : (i = this.getBaseTargetFromProps(this.props, t)) !== null && i !== void 0
              ? i
              : this.readValueFromInstance(this.current, t, this.options);
        if (n !== void 0 && n !== null) {
          if (typeof n === 'string' && (Ol(n) || wa(n))) n = parseFloat(n);
          else if (!dh(n) && nl.test(e)) n = pl(t, e);
          this.setBaseTarget(t, Zr(n) ? n.get() : n);
        }
        return Zr(n) ? n.get() : n;
      }
      setBaseTarget(t, e) {
        this.baseTarget[t] = e;
      }
      getBaseTarget(t) {
        let e;
        const { initial: i } = this.props;
        let n;
        if (typeof i === 'string' || typeof i === 'object') {
          const s = Bo(
            this.props,
            i,
            (e = this.presenceContext) === null || e === void 0 ? void 0 : e.custom
          );
          if (s) n = s[t];
        }
        if (i && n !== void 0) return n;
        const s = this.getBaseTargetFromProps(this.props, t);
        if (s !== void 0 && !Zr(s)) return s;
        return this.initialValues[t] !== void 0 && n === void 0 ? void 0 : this.baseTarget[t];
      }
      on(t, e) {
        if (!this.events[t]) this.events[t] = new Io();
        return this.events[t].add(e);
      }
      notify(t, ...e) {
        if (this.events[t]) this.events[t].notify(...e);
      }
    }
    class _h extends xh {
      constructor() {
        super(...arguments);
        this.KeyframeResolver = Ul;
      }
      sortInstanceNodePosition(t, e) {
        return t.compareDocumentPosition(e) & 2 ? 1 : -1;
      }
      getBaseTargetFromProps(t, e) {
        return t.style ? t.style[e] : void 0;
      }
      removeValueFromRenderState(t, { vars: e, style: i }) {
        delete e[t];
        delete i[t];
      }
      handleChildMotionValue() {
        if (this.childSubscription) {
          this.childSubscription();
          delete this.childSubscription;
        }
        const { children: t } = this.props;
        if (Zr(t))
          this.childSubscription = t.on('change', (t) => {
            if (this.current) this.current.textContent = `${t}`;
          });
      }
    }
    const Sh = (t, e) => (e && typeof t === 'number' ? e.transform(t) : t);
    const Ch = {
      x: 'translateX',
      y: 'translateY',
      z: 'translateZ',
      transformPerspective: 'perspective',
    };
    const Eh = fo.length;
    function Ph(t, e, i) {
      let n = '';
      let s = true;
      for (let r = 0; r < Eh; r++) {
        const o = fo[r];
        const a = t[o];
        if (a === void 0) continue;
        let l = true;
        if (typeof a === 'number') l = a === (o.startsWith('scale') ? 1 : 0);
        else l = parseFloat(a) === 0;
        if (!l || i) {
          const t = Sh(a, ul[o]);
          if (!l) {
            s = false;
            const e = Ch[o] || o;
            n += `${e}(${t}) `;
          }
          if (i) e[o] = t;
        }
      }
      n = n.trim();
      if (i) n = i(e, s ? '' : n);
      else if (s) n = 'none';
      return n;
    }
    function Ah(t, e, i) {
      const { style: n, vars: s, transformOrigin: r } = t;
      let o = false;
      let a = false;
      for (const t in e) {
        const i = e[t];
        if (po.has(t)) {
          o = true;
          continue;
        } else if (Ml(t)) {
          s[t] = i;
          continue;
        } else {
          const e = Sh(i, ul[t]);
          if (t.startsWith('origin')) {
            a = true;
            r[t] = e;
          } else n[t] = e;
        }
      }
      if (!e.transform)
        if (o || i) n.transform = Ph(e, t.transform, i);
        else if (n.transform) n.transform = 'none';
      if (a) {
        const { originX: t = '50%', originY: e = '50%', originZ: i = 0 } = r;
        n.transformOrigin = `${t} ${e} ${i}`;
      }
    }
    const Th = { offset: 'stroke-dashoffset', array: 'stroke-dasharray' };
    const Dh = { offset: 'strokeDashoffset', array: 'strokeDasharray' };
    function Lh(t, e, i = 1, n = 0, s = true) {
      t.pathLength = 1;
      const r = s ? Th : Dh;
      t[r.offset] = Va.transform(-n);
      const o = Va.transform(e);
      const a = Va.transform(i);
      t[r.array] = `${o} ${a}`;
    }
    function Oh(t, e, i) {
      return typeof t === 'string' ? t : Va.transform(e + i * t);
    }
    function Ih(t, e, i) {
      const n = Oh(e, t.x, t.width);
      const s = Oh(i, t.y, t.height);
      return `${n} ${s}`;
    }
    function Mh(
      t,
      {
        attrX: e,
        attrY: i,
        attrScale: n,
        originX: s,
        originY: r,
        pathLength: o,
        pathSpacing: a = 1,
        pathOffset: l = 0,
        ...c
      },
      h,
      u
    ) {
      Ah(t, c, u);
      if (h) {
        if (t.style.viewBox) t.attrs.viewBox = t.style.viewBox;
        return;
      }
      t.attrs = t.style;
      t.style = {};
      const { attrs: d, style: f, dimensions: p } = t;
      if (d.transform) {
        if (p) f.transform = d.transform;
        delete d.transform;
      }
      if (p && (s !== void 0 || r !== void 0 || f.transform))
        f.transformOrigin = Ih(p, s !== void 0 ? s : 0.5, r !== void 0 ? r : 0.5);
      if (e !== void 0) d.x = e;
      if (i !== void 0) d.y = i;
      if (n !== void 0) d.scale = n;
      if (o !== void 0) Lh(d, o, a, l, false);
    }
    const kh = new Set([
      'baseFrequency',
      'diffuseConstant',
      'kernelMatrix',
      'kernelUnitLength',
      'keySplines',
      'keyTimes',
      'limitingConeAngle',
      'markerHeight',
      'markerWidth',
      'numOctaves',
      'targetX',
      'targetY',
      'surfaceScale',
      'specularConstant',
      'specularExponent',
      'stdDeviation',
      'tableValues',
      'viewBox',
      'gradientTransform',
      'pathLength',
      'startOffset',
      'textLength',
      'lengthAdjust',
    ]);
    const zh = (t) => typeof t === 'string' && t.toLowerCase() === 'svg';
    function Fh(t, e) {
      try {
        e.dimensions = typeof t.getBBox === 'function' ? t.getBBox() : t.getBoundingClientRect();
      } catch (t) {
        e.dimensions = { x: 0, y: 0, width: 0, height: 0 };
      }
    }
    function Rh(t, { style: e, vars: i }, n, s) {
      Object.assign(t.style, e, s && s.getProjectionStyles(n));
      for (const e in i) t.style.setProperty(e, i[e]);
    }
    function Vh(t, e, i, n) {
      Rh(t, e, void 0, n);
      for (const i in e.attrs) t.setAttribute(!kh.has(i) ? Uo(i) : i, e.attrs[i]);
    }
    const Bh = {};
    function Nh(t) {
      for (const e in t) {
        Bh[e] = t[e];
        if (isCSSVariableName(e)) Bh[e].isCSSVariable = true;
      }
    }
    function Wh(t, { layout: e, layoutId: i }) {
      return (
        po.has(t) || t.startsWith('origin') || ((e || i !== void 0) && (!!Bh[t] || t === 'opacity'))
      );
    }
    function Zh(t, e, i) {
      let n;
      const { style: s } = t;
      const r = {};
      for (const o in s)
        if (
          Zr(s[o]) ||
          (e.style && Zr(e.style[o])) ||
          Wh(o, t) ||
          ((n = i === null || i === void 0 ? void 0 : i.getValue(o)) === null || n === void 0
            ? void 0
            : n.liveStyle) !== void 0
        )
          r[o] = s[o];
      return r;
    }
    function Hh(t, e, i) {
      const n = Zh(t, e, i);
      for (const i in t)
        if (Zr(t[i]) || Zr(e[i])) {
          const e = fo.indexOf(i) !== -1 ? 'attr' + i.charAt(0).toUpperCase() + i.substring(1) : i;
          n[e] = t[i];
        }
      return n;
    }
    class jh extends _h {
      constructor() {
        super(...arguments);
        this.type = 'svg';
        this.isSVGTag = false;
        this.measureInstanceViewportBox = sh;
        this.updateDimensions = () => {
          if (this.current && !this.renderState.dimensions) Fh(this.current, this.renderState);
        };
      }
      getBaseTargetFromProps(t, e) {
        return t[e];
      }
      readValueFromInstance(t, e) {
        if (po.has(e)) {
          const t = fl(e);
          return t ? t.default || 0 : 0;
        }
        e = !kh.has(e) ? Uo(e) : e;
        return t.getAttribute(e);
      }
      scrapeMotionValuesFromProps(t, e, i) {
        return Hh(t, e, i);
      }
      onBindTransform() {
        if (this.current && !this.renderState.dimensions) Eo.postRender(this.updateDimensions);
      }
      build(t, e, i) {
        Mh(t, e, this.isSVGTag, i.transformTemplate);
      }
      renderInstance(t, e, i, n) {
        Vh(t, e, i, n);
      }
      mount(t) {
        this.isSVGTag = zh(t.tagName);
        super.mount(t);
      }
    }
    function Uh({ top: t, left: e, right: i, bottom: n }) {
      return { x: { min: e, max: i }, y: { min: t, max: n } };
    }
    function qh({ x: t, y: e }) {
      return { top: e.min, right: t.max, bottom: e.max, left: t.min };
    }
    function $h(t, e) {
      if (!e) return t;
      const i = e({ x: t.left, y: t.top });
      const n = e({ x: t.right, y: t.bottom });
      return { top: i.y, left: i.x, bottom: n.y, right: n.x };
    }
    function Xh(t, e) {
      return Uh($h(t.getBoundingClientRect(), e));
    }
    function Gh(t, e, i) {
      const n = Xh(t, i);
      const { scroll: s } = e;
      if (s) {
        translateAxis(n.x, s.offset.x);
        translateAxis(n.y, s.offset.y);
      }
      return n;
    }
    function Kh(t) {
      return window.getComputedStyle(t);
    }
    class Yh extends _h {
      constructor() {
        super(...arguments);
        this.type = 'html';
        this.renderInstance = Rh;
      }
      readValueFromInstance(t, e) {
        if (po.has(e)) {
          const t = fl(e);
          return t ? t.default || 0 : 0;
        } else {
          const i = Kh(t);
          const n = (Ml(e) ? i.getPropertyValue(e) : i[e]) || 0;
          return typeof n === 'string' ? n.trim() : n;
        }
      }
      measureInstanceViewportBox(t, { transformPagePoint: e }) {
        return Xh(t, e);
      }
      build(t, e, i) {
        Ah(t, e, i.transformTemplate);
      }
      scrapeMotionValuesFromProps(t, e, i) {
        return Zh(t, e, i);
      }
    }
    function Qh(t, e) {
      return t in e;
    }
    class Jh extends xh {
      constructor() {
        super(...arguments);
        this.type = 'object';
      }
      readValueFromInstance(t, e) {
        if (Qh(e, t)) {
          const i = t[e];
          if (typeof i === 'string' || typeof i === 'number') return i;
        }
        return;
      }
      getBaseTargetFromProps() {
        return;
      }
      removeValueFromRenderState(t, e) {
        delete e.output[t];
      }
      measureInstanceViewportBox() {
        return sh();
      }
      build(t, e) {
        Object.assign(t.output, e);
      }
      renderInstance(t, { output: e }) {
        Object.assign(t, e);
      }
      sortInstanceNodePosition() {
        return 0;
      }
    }
    function tu(t) {
      const e = {
        presenceContext: null,
        props: {},
        visualState: {
          renderState: { transform: {}, transformOrigin: {}, style: {}, vars: {}, attrs: {} },
          latestValues: {},
        },
      };
      const i = th(t) ? new jh(e) : new Yh(e);
      i.mount(t);
      ho.set(t, i);
    }
    function eu(t) {
      const e = {
        presenceContext: null,
        props: {},
        visualState: { renderState: { output: {} }, latestValues: {} },
      };
      const i = new Jh(e);
      i.mount(t);
      ho.set(t, i);
    }
    function iu(t, e, i) {
      const n = Zr(t) ? t : Ro(t);
      n.start(Yc('', n, e, i));
      return n.animation;
    }
    function nu(t, e) {
      return Zr(t) || typeof t === 'number' || (typeof t === 'string' && !jr(e));
    }
    function su(t, e, i, n) {
      const s = [];
      if (nu(t, e)) s.push(iu(t, jr(e) ? e.default || e : e, i ? i.default || i : i));
      else {
        const r = Ur(t, e, n);
        const o = r.length;
        Sr(Boolean(o), 'No valid elements provided.');
        for (let t = 0; t < o; t++) {
          const n = r[t];
          const a = n instanceof Element ? tu : eu;
          if (!ho.has(n)) a(n);
          const l = ho.get(n);
          const c = { ...i };
          if ('delay' in c && typeof c.delay === 'function') c.delay = c.delay(t, o);
          s.push(...Jc(l, { ...e, transition: c }, {}));
        }
      }
      return s;
    }
    function ru(t, e, i) {
      const n = [];
      const s = no(t, e, i, { spring: Mr });
      s.forEach(({ keyframes: t, transition: e }, i) => {
        n.push(...su(i, t, e));
      });
      return n;
    }
    function ou(t) {
      return Array.isArray(t) && t.some(Array.isArray);
    }
    function au(t) {
      function e(e, i, n) {
        let s = [];
        if (ou(e)) s = ru(e, i, t);
        else s = su(e, i, n, t);
        const r = new cr(s);
        if (t) t.animations.push(r);
        return r;
      }
      return e;
    }
    const lu = au();
    const cu = { some: 0, all: 1 };
    function hu(t, e, { root: i, margin: n, amount: s = 'some' } = {}) {
      const r = Hr(t);
      const o = new WeakMap();
      const a = (t) => {
        t.forEach((t) => {
          const i = o.get(t.target);
          if (t.isIntersecting === Boolean(i)) return;
          if (t.isIntersecting) {
            const i = e(t.target, t);
            if (typeof i === 'function') o.set(t.target, i);
            else l.unobserve(t.target);
          } else if (typeof i === 'function') {
            i(t);
            o.delete(t.target);
          }
        });
      };
      const l = new IntersectionObserver(a, {
        root: i,
        rootMargin: n,
        threshold: typeof s === 'number' ? s : cu[s],
      });
      r.forEach((t) => l.observe(t));
      return () => l.disconnect();
    }
    function uu(t, e) {
      if (t === 'first') return 0;
      else {
        const i = e - 1;
        return t === 'last' ? i : i / 2;
      }
    }
    function du(t = 0.1, { startDelay: e = 0, from: i = 0, ease: n } = {}) {
      return (s, r) => {
        const o = typeof i === 'number' ? i : uu(i, r);
        const a = Math.abs(o - s);
        let l = t * a;
        if (n) {
          const e = r * t;
          const i = Cc(n);
          l = i(l / e) * e;
        }
        return e + l;
      };
    }
    function fu(t, e) {
      let i;
      const n = () => {
        const { currentTime: n } = e;
        const s = n === null ? 0 : n.value;
        const r = s / 100;
        if (i !== r) t(r);
        i = r;
      };
      Eo.update(n, true);
      return () => Po(n);
    }
    const pu = new WeakMap();
    let vu;
    function mu(t, e) {
      if (e) {
        const { inlineSize: t, blockSize: i } = e[0];
        return { width: t, height: i };
      } else if (t instanceof SVGElement && 'getBBox' in t) return t.getBBox();
      else return { width: t.offsetWidth, height: t.offsetHeight };
    }
    function gu({ target: t, contentRect: e, borderBoxSize: i }) {
      let n;
      (n = pu.get(t)) === null || n === void 0
        ? void 0
        : n.forEach((n) => {
            n({
              target: t,
              contentSize: e,
              get size() {
                return mu(t, i);
              },
            });
          });
    }
    function yu(t) {
      t.forEach(gu);
    }
    function wu() {
      if (typeof ResizeObserver === 'undefined') return;
      vu = new ResizeObserver(yu);
    }
    function bu(t, e) {
      if (!vu) wu();
      const i = Hr(t);
      i.forEach((t) => {
        let i = pu.get(t);
        if (!i) {
          i = new Set();
          pu.set(t, i);
        }
        i.add(e);
        vu === null || vu === void 0 ? void 0 : vu.observe(t);
      });
      return () => {
        i.forEach((t) => {
          const i = pu.get(t);
          i === null || i === void 0 ? void 0 : i.delete(e);
          if (!(i === null || i === void 0 ? void 0 : i.size))
            vu === null || vu === void 0 ? void 0 : vu.unobserve(t);
        });
      };
    }
    const xu = new Set();
    let _u;
    function Su() {
      _u = () => {
        const t = { width: window.innerWidth, height: window.innerHeight };
        const e = { target: window, size: t, contentSize: t };
        xu.forEach((t) => t(e));
      };
      window.addEventListener('resize', _u);
    }
    function Cu(t) {
      xu.add(t);
      if (!_u) Su();
      return () => {
        xu.delete(t);
        if (!xu.size && _u) _u = void 0;
      };
    }
    function Eu(t, e) {
      return typeof t === 'function' ? Cu(t) : bu(t, e);
    }
    const Pu = 50;
    const Au = () => ({
      current: 0,
      offset: [],
      progress: 0,
      scrollLength: 0,
      targetOffset: 0,
      targetLength: 0,
      containerLength: 0,
      velocity: 0,
    });
    const Tu = () => ({ time: 0, x: Au(), y: Au() });
    const Du = {
      x: { length: 'Width', position: 'Left' },
      y: { length: 'Height', position: 'Top' },
    };
    function Lu(t, e, i, n) {
      const s = i[e];
      const { length: r, position: o } = Du[e];
      const a = s.current;
      const l = i.time;
      s.current = t[`scroll${o}`];
      s.scrollLength = t[`scroll${r}`] - t[`client${r}`];
      s.offset.length = 0;
      s.offset[0] = 0;
      s.offset[1] = s.scrollLength;
      s.progress = pr(0, s.scrollLength, s.current);
      const c = n - l;
      s.velocity = c > Pu ? 0 : gr(s.current - a, c);
    }
    function Ou(t, e, i) {
      Lu(t, 'x', e, i);
      Lu(t, 'y', e, i);
      e.time = i;
    }
    function Iu(t, e) {
      const i = { x: 0, y: 0 };
      let n = t;
      while (n && n !== e)
        if (n instanceof HTMLElement) {
          i.x += n.offsetLeft;
          i.y += n.offsetTop;
          n = n.offsetParent;
        } else if (n.tagName === 'svg') {
          const t = n.getBoundingClientRect();
          n = n.parentElement;
          const e = n.getBoundingClientRect();
          i.x += t.left - e.left;
          i.y += t.top - e.top;
        } else if (n instanceof SVGGraphicsElement) {
          const { x: t, y: e } = n.getBBox();
          i.x += t;
          i.y += e;
          let s = null;
          let r = n.parentNode;
          while (!s) {
            if (r.tagName === 'svg') s = r;
            r = n.parentNode;
          }
          n = s;
        } else break;
      return i;
    }
    const Mu = { start: 0, center: 0.5, end: 1 };
    function ku(t, e, i = 0) {
      let n = 0;
      if (t in Mu) t = Mu[t];
      if (typeof t === 'string') {
        const e = parseFloat(t);
        if (t.endsWith('px')) n = e;
        else if (t.endsWith('%')) t = e / 100;
        else if (t.endsWith('vw')) n = (e / 100) * document.documentElement.clientWidth;
        else if (t.endsWith('vh')) n = (e / 100) * document.documentElement.clientHeight;
        else t = e;
      }
      if (typeof t === 'number') n = e * t;
      return i + n;
    }
    const zu = [0, 0];
    function Fu(t, e, i, n) {
      let s = Array.isArray(t) ? t : zu;
      let r = 0;
      let o = 0;
      if (typeof t === 'number') s = [t, t];
      else if (typeof t === 'string') {
        t = t.trim();
        if (t.includes(' ')) s = t.split(' ');
        else s = [t, Mu[t] ? t : `0`];
      }
      r = ku(s[0], i, n);
      o = ku(s[1], e);
      return r - o;
    }
    const Ru = {
      Enter: [
        [0, 1],
        [1, 1],
      ],
      Exit: [
        [0, 0],
        [1, 0],
      ],
      Any: [
        [1, 0],
        [0, 1],
      ],
      All: [
        [0, 0],
        [1, 1],
      ],
    };
    const Vu = { x: 0, y: 0 };
    function Bu(t) {
      return 'getBBox' in t && t.tagName !== 'svg'
        ? t.getBBox()
        : { width: t.clientWidth, height: t.clientHeight };
    }
    function Nu(t, e, i) {
      const { offset: n = Ru.All } = i;
      const { target: s = t, axis: r = 'y' } = i;
      const o = r === 'y' ? 'height' : 'width';
      const a = s !== t ? Iu(s, t) : Vu;
      const l = s === t ? { width: t.scrollWidth, height: t.scrollHeight } : Bu(s);
      const c = { width: t.clientWidth, height: t.clientHeight };
      e[r].offset.length = 0;
      let h = !e[r].interpolate;
      const u = n.length;
      for (let t = 0; t < u; t++) {
        const i = Fu(n[t], c[o], l[o], a[r]);
        if (!h && i !== e[r].interpolatorOffsets[t]) h = true;
        e[r].offset[t] = i;
      }
      if (h) {
        e[r].interpolate = Pc(e[r].offset, Wr(n), { clamp: false });
        e[r].interpolatorOffsets = [...e[r].offset];
      }
      e[r].progress = mr(0, 1, e[r].interpolate(e[r].current));
    }
    function Wu(t, e = t, i) {
      i.x.targetOffset = 0;
      i.y.targetOffset = 0;
      if (e !== t) {
        let n = e;
        while (n && n !== t) {
          i.x.targetOffset += n.offsetLeft;
          i.y.targetOffset += n.offsetTop;
          n = n.offsetParent;
        }
      }
      i.x.targetLength = e === t ? e.scrollWidth : e.clientWidth;
      i.y.targetLength = e === t ? e.scrollHeight : e.clientHeight;
      i.x.containerLength = t.clientWidth;
      i.y.containerLength = t.clientHeight;
      if (false);
    }
    function Zu(t, e, i, n = {}) {
      return {
        measure: () => Wu(t, n.target, i),
        update: (e) => {
          Ou(t, i, e);
          if (n.offset || n.target) Nu(t, i, n);
        },
        notify: () => e(i),
      };
    }
    const Hu = new WeakMap();
    const ju = new WeakMap();
    const Uu = new WeakMap();
    const qu = (t) => (t === document.documentElement ? window : t);
    function $u(t, { container: e = document.documentElement, ...i } = {}) {
      let n = Uu.get(e);
      if (!n) {
        n = new Set();
        Uu.set(e, n);
      }
      const s = Tu();
      const r = Zu(e, t, s, i);
      n.add(r);
      if (!Hu.has(e)) {
        const t = () => {
          for (const t of n) t.measure();
        };
        const i = () => {
          for (const t of n) t.update(Ao.timestamp);
        };
        const s = () => {
          for (const t of n) t.notify();
        };
        const r = () => {
          Eo.read(t, false, true);
          Eo.read(i, false, true);
          Eo.update(s, false, true);
        };
        Hu.set(e, r);
        const o = qu(e);
        window.addEventListener('resize', r, { passive: true });
        if (e !== document.documentElement) ju.set(e, Eu(e, r));
        o.addEventListener('scroll', r, { passive: true });
      }
      const o = Hu.get(e);
      Eo.read(o, false, true);
      return () => {
        let t;
        Po(o);
        const i = Uu.get(e);
        if (!i) return;
        i.delete(r);
        if (i.size) return;
        const n = Hu.get(e);
        Hu.delete(e);
        if (n) {
          qu(e).removeEventListener('scroll', n);
          (t = ju.get(e)) === null || t === void 0 ? void 0 : t();
          window.removeEventListener('resize', n);
        }
      };
    }
    function Xu({ source: t, container: e, axis: i = 'y' }) {
      if (t) e = t;
      const n = { value: 0 };
      const s = $u(
        (t) => {
          n.value = t[i].progress * 100;
        },
        { container: e, axis: i }
      );
      return { currentTime: n, cancel: s };
    }
    const Gu = new Map();
    function Ku({ source: t, container: e = document.documentElement, axis: i = 'y' } = {}) {
      if (t) e = t;
      if (!Gu.has(e)) Gu.set(e, {});
      const n = Gu.get(e);
      if (!n[i])
        n[i] = ar() ? new ScrollTimeline({ source: e, axis: i }) : Xu({ source: e, axis: i });
      return n[i];
    }
    function Yu(t) {
      return t.length === 2;
    }
    function Qu(t) {
      return t && (t.target || t.offset);
    }
    function Ju(t, e) {
      if (Yu(t) || Qu(e))
        return $u((i) => {
          t(i[e.axis].progress, i);
        }, e);
      else return fu(t, Ku(e));
    }
    function td(t, e) {
      t.flatten();
      if (Qu(e)) {
        t.pause();
        return $u((i) => {
          t.time = t.duration * i[e.axis].progress;
        }, e);
      } else {
        const i = Ku(e);
        if (t.attachTimeline)
          return t.attachTimeline(i, (t) => {
            t.pause();
            return fu((e) => {
              t.time = t.duration * e;
            }, i);
          });
        else return xr;
      }
    }
    function ed(t, { axis: e = 'y', ...i } = {}) {
      const n = { axis: e, ...i };
      return typeof t === 'function' ? Ju(t, n) : td(t, n);
    }
    const id = i(691);
    window.FoxTheme = window.FoxTheme || {};
    window.FoxTheme = {
      Flickity: s(),
      Slider: u,
      AnimateLoading: e(),
      Notification: new l(),
      ProductHelper: { getVariantFromOptionArray: v },
      Confetti: x,
      PhotoSwipe: Gt,
      PhotoSwipeLightbox: me,
    };
    window.FoxThemeEvents = window.FoxThemeEvents || new c();
    window.FoxTheme.loadjs = __loadjs;
    window.FoxTheme.Tooltip = rr;
    window.FoxTheme.Motion = { animate: lu, inView: hu, stagger: du, scroll: ed };
    window.addEventListener('load', function () {
      rr('[data-tippy-content]', {
        animation: 'shift-away',
        touch: false,
        onCreate(t) {
          const e = t.reference.dataset.tippyTheme || 'color-background-1';
          t.setProps({ theme: e });
        },
      });
    });
    (function t() {
      const { FoxThemeSettings: e } = window;
      try {
        e.colorSwatches = [];
        e.imageSwatches = [];
        e.custom_colors
          .split(',')
          .filter(Boolean)
          .forEach((t) => {
            const [i, n] = t.split(':');
            e.colorSwatches.push({ key: i.trim().toLowerCase(), value: n?.trim?.() || '' });
          });
        Object.keys(e).forEach((t) => {
          if (t.includes('custom_image') && !t.includes('.png'))
            if (e[`${t}.png`])
              e.imageSwatches.push({ key: e[t].toLowerCase(), value: e[`${t}.png`] });
        });
      } catch (t) {
        void 0;
      }
    })();
  })();
})();
